var bc = Object.defineProperty;
var _c = (e, n, t) => n in e ? bc(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var Se = (e, n, t) => _c(e, typeof n != "symbol" ? n + "" : n, t);
import * as Xa from "vue";
import { getCurrentInstance as su, inject as Ft, computed as k, isRef as zr, createElementBlock as w, openBlock as p, createElementVNode as _, defineComponent as Ce, createBlock as Pe, resolveDynamicComponent as Ln, normalizeClass as me, h as je, useCssVars as xc, withCtx as xe, createCommentVNode as X, renderSlot as ge, createVNode as Ae, useSlots as Qn, resolveComponent as fr, withDirectives as On, normalizeStyle as tt, unref as D, toDisplayString as he, createTextVNode as Qe, Fragment as _e, renderList as Ie, ref as ee, Transition as Pn, watchEffect as Zt, onMounted as He, cloneVNode as kc, provide as pn, onUnmounted as wt, watch as Be, shallowRef as mr, Teleport as Jr, reactive as qn, nextTick as it, toRaw as ln, withModifiers as ot, readonly as yl, TransitionGroup as Cc, onBeforeUnmount as Ao, vModelText as iu, toRef as Ea, mergeProps as xt, createSlots as It, normalizeProps as kt, guardReactiveProps as Yt, render as fs, useAttrs as Sc, getCurrentScope as uu, onScopeDispose as du, onBeforeUpdate as Mc, vShow as Qa, withKeys as Ec, Text as Pc } from "vue";
const Xt = {
  light: {
    background: {
      primary: "#FFFFFF",
      secondary: "#F3F3F3",
      card: "#F3F3F3"
    },
    text: {
      primary: "#000000",
      secondary: "#7D7D7D"
    },
    brand: {
      primary: "#0D45BF"
    },
    border: {
      default: "#E5E7EB",
      focus: "#0D45BF",
      error: "#EF4444",
      purple: "#6107A2"
    }
  },
  dark: {
    background: {
      primary: "#101214",
      secondary: "#181B20",
      card: "#22262D"
    },
    text: {
      primary: "#F4F7FB",
      secondary: "#A7B0BE"
    },
    brand: {
      primary: "#6EA3FF"
    },
    border: {
      default: "#2C333D",
      focus: "#6EA3FF",
      error: "#EF4444",
      purple: "#6107A2"
    }
  },
  products: {
    "e-hesap-ozeti": "#F58437",
    "e-pos": "#70C7AF",
    "e-odeme": "#1AB5CE",
    "e-dbs": "#139CC2",
    "e-rapor": "#2C6AAD",
    "e-tahsilat": "#EA2B2A",
    "brand-primary": "#0D45BF"
  }
}, $c = {
  fontFamily: {
    primary: ["Baloo 2", "sans-serif"],
    fallback: [
      "system-ui",
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Roboto",
      "sans-serif"
    ]
  },
  fontSize: {
    mini: "10px",
    // 0.625rem
    xs: "12px",
    // 0.75rem
    sm: "14px",
    // 0.875rem
    base: "15px",
    // 0.9375rem
    md: "16px",
    // 1rem
    lg: "18px",
    // 1.125rem
    xl: "22px",
    // 1.375rem
    "2xl": "46px"
    // 2.875rem
  },
  fontWeight: {
    regular: "400",
    medium: "500",
    semibold: "600",
    bold: "700"
  },
  lineHeight: {
    tight: "0.826em",
    normal: "1.5em",
    relaxed: "1.667em",
    loose: "2.143em"
  },
  letterSpacing: {
    normal: "0.01em"
    // 1%
  }
}, Ac = {
  0: "0",
  1: "4px",
  2: "8px",
  3: "12px",
  4: "16px",
  5: "20px",
  6: "24px",
  7: "28px",
  8: "32px",
  10: "40px",
  12: "48px",
  14: "56px",
  16: "64px",
  24: "96px"
}, Tc = {
  radius: {
    none: "0",
    sm: "4px",
    md: "8px",
    lg: "16px",
    xl: "24px",
    "2xl": "32px",
    full: "9999px",
    circle: "64px"
  },
  width: {
    none: "0",
    thin: "1px",
    medium: "2px",
    thick: "4px"
  }
}, Dc = {
  none: "none",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  card: "0 4px 12px rgba(0, 0, 0, 0.08)"
}, Ab = {
  colors: Xt,
  typography: $c,
  spacing: Ac,
  borders: Tc,
  shadows: Dc
}, Vt = {
  "e-dbs": {
    id: "e-dbs",
    guidId: "5bbb498a-b7a8-4489-9d52-ca22be9d1160",
    name: "e-DBS",
    code: "EDbs",
    aliases: ["EDBS", "DBS", "e-dbs"],
    url: "/e-dbs",
    primaryColor: Xt.products["e-dbs"],
    logo: new URL("/assets/images/e-dbs-icon.png", import.meta.url).href,
    logos: {
      light: new URL("/assets/images/logos/DBS.png", import.meta.url).href,
      dark: new URL("/assets/images/logos/DBS-white.png", import.meta.url).href
    },
    show: !0,
    comingSoon: !1,
    infoPath: "/urunler/e-dbs",
    platformProductName: "EDbs",
    accentImage: new URL("/assets/images/e-dbs-img.png", import.meta.url).href,
    description: "Bayilerinizin ödemelerini banka DBS yapısıyla otomatik olarak tahsil etmenizi sağlayan bayi–tedarikçi ödeme yönetim çözümüdür."
  },
  "e-odeme": {
    id: "e-odeme",
    guidId: "304b460b-4868-4c23-b554-5966875af5dc",
    name: "e-Ödeme",
    code: "e-odeme",
    url: "/e-tos",
    primaryColor: Xt.products["e-odeme"],
    logo: new URL("/assets/images/e-odeme-icon.png", import.meta.url).href,
    logos: {
      light: new URL("/assets/images/logos/%C3%B6deme.png", import.meta.url).href,
      dark: new URL("/assets/images/logos/%C3%B6deme-white.png", import.meta.url).href
    },
    show: !0,
    comingSoon: !1,
    infoPath: "/urunler/e-odeme",
    platformProductName: "EPayment",
    accentImage: new URL("/assets/images/e-odeme-img.png", import.meta.url).href,
    description: "Tedarikçi, çalışan veya çoklu ödeme gruplarına yapacağınız tüm ödemeleri bankalar üzerinden toplu ve güvenli şekilde gerçekleştirmenizi sağlayan toplu ödeme çözümüdür.”"
  },
  "e-rapor": {
    id: "e-rapor",
    guidId: "02f2f7ed-1c4f-4bd4-bde2-c70f56541ee5",
    name: "e-Rapor",
    code: "EReport",
    url: "/e-rapor",
    primaryColor: Xt.products["e-rapor"],
    logo: new URL("/assets/images/e-rapor-icon.png", import.meta.url).href,
    logos: {
      light: new URL("/assets/images/logos/rapor.png", import.meta.url).href,
      dark: new URL("/assets/images/logos/rapor-white.png", import.meta.url).href
    },
    show: !0,
    comingSoon: !0,
    infoPath: "/urunler/e-rapor",
    platformProductName: "EReport",
    accentImage: new URL("/assets/images/e-rapor-img.png", import.meta.url).href,
    description: "Tüm finansal verilerinizi tek yerde toplayarak yapay zeka destekli analizler, dashboardlar ve otomatik raporlamalar sunan gelişmiş finans raporlama çözümüdür."
  },
  "e-hesap-ozeti": {
    id: "e-hesap-ozeti",
    guidId: "7cf4fc4b-e2ff-44ce-b19b-3acadacdc5bd",
    name: "e-Hesap Özeti",
    code: "EBank",
    url: "",
    primaryColor: Xt.products["e-hesap-ozeti"],
    logo: new URL("/assets/images/e-hesap-ozeti-icon.png", import.meta.url).href,
    logos: {
      light: new URL("/assets/images/logos/hesap%20%C3%B6zeti.png", import.meta.url).href,
      dark: new URL("/assets/images/logos/hesap%20%C3%B6zeti-white.png", import.meta.url).href
    },
    show: !0,
    infoPath: "https://www.finmony.com/e-hesap-ozeti",
    platformProductName: "EBank",
    accentImage: new URL("/assets/images/e-banka-img.png", import.meta.url).href,
    description: "Bankalardaki tüm hesap hareketlerinizi tek ekrandan takip etmenizi sağlayan otomatik hesap özeti ve bakiye görüntüleme çözümüdür.”"
  },
  "e-tahsilat": {
    id: "e-tahsilat",
    guidId: "89768ebc-3185-431b-9741-1e038bf9fed5",
    name: "e-Kolay Tahsilat",
    code: "EPayment",
    url: "",
    primaryColor: Xt.products["e-tahsilat"],
    logo: new URL("/assets/images/e-tahsilat-icon.png", import.meta.url).href,
    logos: {
      light: new URL("/assets/images/logos/kolay%20tahsilat.png", import.meta.url).href,
      dark: new URL("/assets/images/logos/kolay%20tahsilat-white.png", import.meta.url).href
    },
    show: !0,
    infoPath: "https://www.finmony.com/e-kolay-tahsilat",
    platformProductName: "EPayment",
    accentImage: new URL("/assets/images/e-tahsilat-img.png", import.meta.url).href,
    description: "Müşterilerinize SMS, QR veya e-posta ile ödeme linki göndererek hızlı ve güvenli kredi kartı tahsilatı yapmanızı sağlayan dijital ödeme çözümüdür.”"
  },
  "e-kolay-tahsilat-invoice": {
    id: "e-kolay-tahsilat-invoice",
    guidId: "d8e6d9db-9ecb-4e2d-bc77-3e39df4b4c23",
    name: "e-Kolay Tahsilat Fatura",
    code: "EInvoicePayment",
    aliases: ["EInvoicePayment", "e-kolay-tahsilat-invoice", "e-kolay tahsilat fatura"],
    url: "",
    primaryColor: Xt.products["e-tahsilat"],
    logo: new URL("/assets/images/e-tahsilat-icon.png", import.meta.url).href,
    logos: {
      light: new URL("/assets/images/logos/kolay%20tahsilat.png", import.meta.url).href,
      dark: new URL("/assets/images/logos/kolay%20tahsilat-white.png", import.meta.url).href
    },
    show: !1,
    infoPath: "https://www.finmony.com/e-kolay-tahsilat",
    platformProductName: "EInvoicePayment",
    accentImage: new URL("/assets/images/e-tahsilat-img.png", import.meta.url).href,
    description: "ERP sisteminizdeki faturaları ödeme ekranına yansıtarak ve faturalarınıza link ekleyerek müşterilerinizden kredi kartıyla hızlı ve güvenli tahsilat yapabilmenizi sağlayan fatura bazlı ödeme çözümüdür."
  },
  "e-pos": {
    id: "e-pos",
    guidId: "5b3eb0fa-7e16-48ea-bdcb-68d1ad01c6c9",
    name: "Pos Mutabakat",
    code: "EPos",
    url: "/e-pos",
    primaryColor: Xt.products["e-pos"],
    logo: new URL("/assets/images/pos-mutabakat-icon.png", import.meta.url).href,
    logos: {
      light: new URL("/assets/images/logos/PosMutabakat.png", import.meta.url).href,
      dark: new URL("/assets/images/logos/PosMutabakat-WH%C4%B0TE.png", import.meta.url).href
    },
    show: !0,
    comingSoon: !1,
    infoPath: "https://www.finmony.com/pos-mutabakat",
    platformProductName: "EPos",
    accentImage: new URL("/assets/images/e-pos-img.png", import.meta.url).href,
    description: "Bankalardan gelen fiziksel ve sanal POS hareketlerinizi otomatik alarak komisyon, valör ve işlem mutabakatını tek ekranda yönetmenizi sağlayan POS raporlama ve mutabakat çözümüdür."
  },
  "brand-primary": {
    id: "brand-primary",
    name: "Finmony",
    code: "Finmony",
    url: "/",
    primaryColor: Xt.products["brand-primary"],
    logos: {
      light: new URL("/assets/images/finmony-logo-black.svg", import.meta.url).href,
      dark: new URL("/assets/images/finmony-logo-white.svg", import.meta.url).href
    },
    show: !1,
    platformProductName: "Finmony"
  }
}, Wa = (e) => (e || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, ""), Rc = (e) => {
  const n = e.url ? e.url.replace(/^\//, "") : "", t = e.infoPath ? e.infoPath.replace(/^\//, "") : "";
  return [
    e.id,
    e.guidId,
    e.code,
    e.name,
    n,
    t,
    ...e.aliases ?? []
  ];
}, ms = (e) => {
  const n = e == null ? void 0 : e.trim();
  if (!n) return null;
  const t = Object.values(Vt).find((r) => {
    var o;
    const l = (o = r.url) == null ? void 0 : o.trim();
    return l ? n.startsWith(l) : !1;
  });
  if (t) return t;
  const a = Wa(n);
  if (!a) return null;
  for (const r of Object.values(Vt))
    if (Rc(r).map(Wa).filter(Boolean).some((l) => l === a))
      return r;
  if (a === Wa(Vt["e-tahsilat"].platformProductName))
    return Vt["e-tahsilat"];
  for (const r of Object.values(Vt))
    if (Wa(r.platformProductName) === a)
      return r;
  return null;
}, wl = (e) => {
  if (!e) return null;
  if (typeof e == "string")
    return ms(e);
  const n = [
    e.productId,
    e.id,
    e.productCode,
    e.name,
    e.displayName,
    e.productName,
    e.platformProductName
  ];
  for (const t of n) {
    const a = ms(t);
    if (a) return a;
  }
  return null;
};
/*!
 * vue-router v4.6.3
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */
Symbol(process.env.NODE_ENV !== "production" ? "navigation failure" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view location matched" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view depth" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router" : "");
const Oc = Symbol(process.env.NODE_ENV !== "production" ? "route location" : "");
Symbol(process.env.NODE_ENV !== "production" ? "router view location" : "");
const ps = typeof window < "u", Ic = Symbol("finmony-current-product");
function gn() {
  const e = su(), n = Ft(Ic, null), t = e ? Ft(Oc, null) : null, a = k(() => t ? t.path : ps && window.location.pathname || ""), r = k(() => {
    const s = /* @__PURE__ */ new Set(), u = a.value;
    if (u && (s.add(u), s.add(u.replace(/^\//, "")), u.split("/").forEach((c) => {
      c && s.add(c);
    })), ps) {
      const c = window.location.hostname || "";
      c && (s.add(c), c.split(".").forEach((f) => {
        f && s.add(f);
      }));
    }
    return Array.from(s).filter(Boolean);
  }), l = k(() => {
    if (!n) return null;
    const s = zr(n) ? n.value : n;
    return wl(s);
  }), o = k(() => {
    if (l.value)
      return l.value;
    if (a.value && a.value.startsWith("/admin/"))
      return Vt["brand-primary"];
    for (const c of r.value) {
      const f = wl(c);
      if (f)
        return f;
    }
    const s = Wa(a.value), u = wl(s);
    return u || Vt["brand-primary"];
  }), i = k(() => o.value.primaryColor);
  return {
    currentProduct: o,
    currentProductColor: i
  };
}
function vs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M18.75 12.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM12 6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 6ZM12 18a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 18ZM3.75 6.75h1.5a.75.75 0 1 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM5.25 18.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5ZM3 12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 12ZM9 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM12.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM9 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z" })
  ]);
}
function gs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V3a.75.75 0 0 1 .75-.75Zm-9 13.5a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Fc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M11.03 3.97a.75.75 0 0 1 0 1.06l-6.22 6.22H21a.75.75 0 0 1 0 1.5H4.81l6.22 6.22a.75.75 0 1 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function bl(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53 7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035.75.75 0 0 0-.53-.918Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Lc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm10.72 4.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H9a.75.75 0 0 1 0-1.5h10.94l-1.72-1.72a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Nc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M12.97 3.97a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 1 1-1.06-1.06l6.22-6.22H3a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function hs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M15.75 2.25H21a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V4.81L8.03 17.03a.75.75 0 0 1-1.06-1.06L19.19 3.75h-3.44a.75.75 0 0 1 0-1.5Zm-10.5 4.5a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V10.5a.75.75 0 0 1 1.5 0v8.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V8.25a3 3 0 0 1 3-3h8.25a.75.75 0 0 1 0 1.5H5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Vc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M1.72 5.47a.75.75 0 0 1 1.06 0L9 11.69l3.756-3.756a.75.75 0 0 1 .985-.066 12.698 12.698 0 0 1 4.575 6.832l.308 1.149 2.277-3.943a.75.75 0 1 1 1.299.75l-3.182 5.51a.75.75 0 0 1-1.025.275l-5.511-3.181a.75.75 0 0 1 .75-1.3l3.943 2.277-.308-1.149a11.194 11.194 0 0 0-3.528-5.617l-3.809 3.81a.75.75 0 0 1-1.06 0L1.72 6.53a.75.75 0 0 1 0-1.061Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Bc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M15.22 6.268a.75.75 0 0 1 .968-.431l5.942 2.28a.75.75 0 0 1 .431.97l-2.28 5.94a.75.75 0 1 1-1.4-.537l1.63-4.251-1.086.484a11.2 11.2 0 0 0-5.45 5.173.75.75 0 0 1-1.199.19L9 12.312l-6.22 6.22a.75.75 0 0 1-1.06-1.061l6.75-6.75a.75.75 0 0 1 1.06 0l3.606 3.606a12.695 12.695 0 0 1 5.68-4.974l1.086-.483-4.251-1.632a.75.75 0 0 1-.432-.97Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Hc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M8.25 3.75H19.5a.75.75 0 0 1 .75.75v11.25a.75.75 0 0 1-1.5 0V6.31L5.03 20.03a.75.75 0 0 1-1.06-1.06L17.69 5.25H8.25a.75.75 0 0 1 0-1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ys(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M11.47 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06l-3.22-3.22V16.5a.75.75 0 0 1-1.5 0V4.81L8.03 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5ZM3 15.75a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 1.5 0v2.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function zc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M11.47 2.47a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06l-6.22-6.22V21a.75.75 0 0 1-1.5 0V4.81l-6.22 6.22a.75.75 0 1 1-1.06-1.06l7.5-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ws(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M3.22 3.22a.75.75 0 0 1 1.06 0l3.97 3.97V4.5a.75.75 0 0 1 1.5 0V9a.75.75 0 0 1-.75.75H4.5a.75.75 0 0 1 0-1.5h2.69L3.22 4.28a.75.75 0 0 1 0-1.06Zm17.56 0a.75.75 0 0 1 0 1.06l-3.97 3.97h2.69a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0ZM3.75 15a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-2.69l-3.97 3.97a.75.75 0 0 1-1.06-1.06l3.97-3.97H4.5a.75.75 0 0 1-.75-.75Zm10.5 0a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-2.69l3.97 3.97a.75.75 0 1 1-1.06 1.06l-3.97-3.97v2.69a.75.75 0 0 1-1.5 0V15Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function bs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-3.97 3.97a.75.75 0 1 1-1.06-1.06l3.97-3.97h-2.69a.75.75 0 0 1-.75-.75Zm-12 0A.75.75 0 0 1 3.75 3h4.5a.75.75 0 0 1 0 1.5H5.56l3.97 3.97a.75.75 0 0 1-1.06 1.06L4.5 5.56v2.69a.75.75 0 0 1-1.5 0v-4.5Zm11.47 11.78a.75.75 0 1 1 1.06-1.06l3.97 3.97v-2.69a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.69l-3.97-3.97Zm-4.94-1.06a.75.75 0 0 1 0 1.06L5.56 19.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Uc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M12 7.5a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z" }),
    _("path", {
      "fill-rule": "evenodd",
      d: "M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v9.75c0 1.036-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 0 1 1.5 14.625v-9.75ZM8.25 9.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM18.75 9a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V9.75a.75.75 0 0 0-.75-.75h-.008ZM4.5 9.75A.75.75 0 0 1 5.25 9h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75V9.75Z",
      "clip-rule": "evenodd"
    }),
    _("path", { d: "M2.25 18a.75.75 0 0 0 0 1.5c5.4 0 10.63.722 15.6 2.075 1.19.324 2.4-.558 2.4-1.82V18.75a.75.75 0 0 0-.75-.75H2.25Z" })
  ]);
}
function Yc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function jc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 1 1-7.48 0 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Zc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M7.5 5.25a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0 1 12 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 0 1 7.5 5.455V5.25Zm7.5 0v.09a49.488 49.488 0 0 0-6 0v-.09a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5Zm-3 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    }),
    _("path", { d: "M3 18.4v-2.796a4.3 4.3 0 0 0 .713.31A26.226 26.226 0 0 0 12 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 0 1-6.477-.427C4.047 21.128 3 19.852 3 18.4Z" })
  ]);
}
function Gc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M11.584 2.376a.75.75 0 0 1 .832 0l9 6a.75.75 0 1 1-.832 1.248L12 3.901 3.416 9.624a.75.75 0 0 1-.832-1.248l9-6Z" }),
    _("path", {
      "fill-rule": "evenodd",
      d: "M20.25 10.332v9.918H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5h.75v-9.918a.75.75 0 0 1 .634-.74A49.109 49.109 0 0 1 12 9c2.59 0 5.134.202 7.616.592a.75.75 0 0 1 .634.74Zm-7.5 2.418a.75.75 0 0 0-1.5 0v6.75a.75.75 0 0 0 1.5 0v-6.75Zm3-.75a.75.75 0 0 1 .75.75v6.75a.75.75 0 0 1-1.5 0v-6.75a.75.75 0 0 1 .75-.75ZM9 12.75a.75.75 0 0 0-1.5 0v6.75a.75.75 0 0 0 1.5 0v-6.75Z",
      "clip-rule": "evenodd"
    }),
    _("path", { d: "M12 7.875a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z" })
  ]);
}
function Wc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M3 2.25a.75.75 0 0 0 0 1.5v16.5h-.75a.75.75 0 0 0 0 1.5H15v-18a.75.75 0 0 0 0-1.5H3ZM6.75 19.5v-2.25a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75ZM6 6.75A.75.75 0 0 1 6.75 6h.75a.75.75 0 0 1 0 1.5h-.75A.75.75 0 0 1 6 6.75ZM6.75 9a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75ZM6 12.75a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 0 1.5h-.75a.75.75 0 0 1-.75-.75ZM10.5 6a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75Zm-.75 3.75A.75.75 0 0 1 10.5 9h.75a.75.75 0 0 1 0 1.5h-.75a.75.75 0 0 1-.75-.75ZM10.5 12a.75.75 0 0 0 0 1.5h.75a.75.75 0 0 0 0-1.5h-.75ZM16.5 6.75v15h5.25a.75.75 0 0 0 0-1.5H21v-12a.75.75 0 0 0 0-1.5h-4.5Zm1.5 4.5a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Zm.75 2.25a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75v-.008a.75.75 0 0 0-.75-.75h-.008ZM18 17.25a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75v-.008Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function qc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M4.5 2.25a.75.75 0 0 0 0 1.5v16.5h-.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5h-.75V3.75a.75.75 0 0 0 0-1.5h-15ZM9 6a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm-.75 3.75A.75.75 0 0 1 9 9h1.5a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM9 12a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H9Zm3.75-5.25A.75.75 0 0 1 13.5 6H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM13.5 9a.75.75 0 0 0 0 1.5H15A.75.75 0 0 0 15 9h-1.5Zm-.75 3.75a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75ZM9 19.5v-2.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.75.75h-4.5A.75.75 0 0 1 9 19.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Kc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" }),
    _("path", {
      "fill-rule": "evenodd",
      d: "M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Xc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function _l(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75ZM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 0 1-1.875-1.875V8.625ZM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 0 1 3 19.875v-6.75Z" })
  ]);
}
function Qc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M2.25 13.5a8.25 8.25 0 0 1 8.25-8.25.75.75 0 0 1 .75.75v6.75H18a.75.75 0 0 1 .75.75 8.25 8.25 0 0 1-16.5 0Z",
      "clip-rule": "evenodd"
    }),
    _("path", {
      "fill-rule": "evenodd",
      d: "M12.75 3a.75.75 0 0 1 .75-.75 8.25 8.25 0 0 1 8.25 8.25.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75V3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Jc(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function _s(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function xs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ks(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function e0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function t0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Cs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function n0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M21 6.375c0 2.692-4.03 4.875-9 4.875S3 9.067 3 6.375 7.03 1.5 12 1.5s9 2.183 9 4.875Z" }),
    _("path", { d: "M12 12.75c2.685 0 5.19-.586 7.078-1.609a8.283 8.283 0 0 0 1.897-1.384c.016.121.025.244.025.368C21 12.817 16.97 15 12 15s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.285 8.285 0 0 0 1.897 1.384C6.809 12.164 9.315 12.75 12 12.75Z" }),
    _("path", { d: "M12 16.5c2.685 0 5.19-.586 7.078-1.609a8.282 8.282 0 0 0 1.897-1.384c.016.121.025.244.025.368 0 2.692-4.03 4.875-9 4.875s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.284 8.284 0 0 0 1.897 1.384C6.809 15.914 9.315 16.5 12 16.5Z" }),
    _("path", { d: "M12 20.25c2.685 0 5.19-.586 7.078-1.609a8.282 8.282 0 0 0 1.897-1.384c.016.121.025.244.025.368 0 2.692-4.03 4.875-9 4.875s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.284 8.284 0 0 0 1.897 1.384C6.809 19.664 9.315 20.25 12 20.25Z" })
  ]);
}
function Ss(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function a0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M10.5 3.75a6 6 0 0 0-5.98 6.496A5.25 5.25 0 0 0 6.75 20.25H18a4.5 4.5 0 0 0 2.206-8.423 3.75 3.75 0 0 0-4.133-4.303A6.001 6.001 0 0 0 10.5 3.75Zm2.03 5.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.72-1.72v4.94a.75.75 0 0 0 1.5 0v-4.94l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function r0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567h-1.843ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function l0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M17.004 10.407c.138.435-.216.842-.672.842h-3.465a.75.75 0 0 1-.65-.375l-1.732-3c-.229-.396-.053-.907.393-1.004a5.252 5.252 0 0 1 6.126 3.537ZM8.12 8.464c.307-.338.838-.235 1.066.16l1.732 3a.75.75 0 0 1 0 .75l-1.732 3c-.229.397-.76.5-1.067.161A5.23 5.23 0 0 1 6.75 12a5.23 5.23 0 0 1 1.37-3.536ZM10.878 17.13c-.447-.098-.623-.608-.394-1.004l1.733-3.002a.75.75 0 0 1 .65-.375h3.465c.457 0 .81.407.672.842a5.252 5.252 0 0 1-6.126 3.539Z" }),
    _("path", {
      "fill-rule": "evenodd",
      d: "M21 12.75a.75.75 0 1 0 0-1.5h-.783a8.22 8.22 0 0 0-.237-1.357l.734-.267a.75.75 0 1 0-.513-1.41l-.735.268a8.24 8.24 0 0 0-.689-1.192l.6-.503a.75.75 0 1 0-.964-1.149l-.6.504a8.3 8.3 0 0 0-1.054-.885l.391-.678a.75.75 0 1 0-1.299-.75l-.39.676a8.188 8.188 0 0 0-1.295-.47l.136-.77a.75.75 0 0 0-1.477-.26l-.136.77a8.36 8.36 0 0 0-1.377 0l-.136-.77a.75.75 0 1 0-1.477.26l.136.77c-.448.121-.88.28-1.294.47l-.39-.676a.75.75 0 0 0-1.3.75l.392.678a8.29 8.29 0 0 0-1.054.885l-.6-.504a.75.75 0 1 0-.965 1.149l.6.503a8.243 8.243 0 0 0-.689 1.192L3.8 8.216a.75.75 0 1 0-.513 1.41l.735.267a8.222 8.222 0 0 0-.238 1.356h-.783a.75.75 0 0 0 0 1.5h.783c.042.464.122.917.238 1.356l-.735.268a.75.75 0 0 0 .513 1.41l.735-.268c.197.417.428.816.69 1.191l-.6.504a.75.75 0 0 0 .963 1.15l.601-.505c.326.323.679.62 1.054.885l-.392.68a.75.75 0 0 0 1.3.75l.39-.679c.414.192.847.35 1.294.471l-.136.77a.75.75 0 0 0 1.477.261l.137-.772a8.332 8.332 0 0 0 1.376 0l.136.772a.75.75 0 1 0 1.477-.26l-.136-.771a8.19 8.19 0 0 0 1.294-.47l.391.677a.75.75 0 0 0 1.3-.75l-.393-.679a8.29 8.29 0 0 0 1.054-.885l.601.504a.75.75 0 0 0 .964-1.15l-.6-.503c.261-.375.492-.774.69-1.191l.735.267a.75.75 0 1 0 .512-1.41l-.734-.267c.115-.439.195-.892.237-1.356h.784Zm-2.657-3.06a6.744 6.744 0 0 0-1.19-2.053 6.784 6.784 0 0 0-1.82-1.51A6.705 6.705 0 0 0 12 5.25a6.8 6.8 0 0 0-1.225.11 6.7 6.7 0 0 0-2.15.793 6.784 6.784 0 0 0-2.952 3.489.76.76 0 0 1-.036.098A6.74 6.74 0 0 0 5.251 12a6.74 6.74 0 0 0 3.366 5.842l.009.005a6.704 6.704 0 0 0 2.18.798l.022.003a6.792 6.792 0 0 0 2.368-.004 6.704 6.704 0 0 0 2.205-.811 6.785 6.785 0 0 0 1.762-1.484l.009-.01.009-.01a6.743 6.743 0 0 0 1.18-2.066c.253-.707.39-1.469.39-2.263a6.74 6.74 0 0 0-.408-2.309Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Ms(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M4.5 3.75a3 3 0 0 0-3 3v.75h21v-.75a3 3 0 0 0-3-3h-15Z" }),
    _("path", {
      "fill-rule": "evenodd",
      d: "M22.5 9.75h-21v7.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-7.5Zm-18 3.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function o0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M11.622 1.602a.75.75 0 0 1 .756 0l2.25 1.313a.75.75 0 0 1-.756 1.295L12 3.118 10.128 4.21a.75.75 0 1 1-.756-1.295l2.25-1.313ZM5.898 5.81a.75.75 0 0 1-.27 1.025l-1.14.665 1.14.665a.75.75 0 1 1-.756 1.295L3.75 8.806v.944a.75.75 0 0 1-1.5 0V7.5a.75.75 0 0 1 .372-.648l2.25-1.312a.75.75 0 0 1 1.026.27Zm12.204 0a.75.75 0 0 1 1.026-.27l2.25 1.312a.75.75 0 0 1 .372.648v2.25a.75.75 0 0 1-1.5 0v-.944l-1.122.654a.75.75 0 1 1-.756-1.295l1.14-.665-1.14-.665a.75.75 0 0 1-.27-1.025Zm-9 5.25a.75.75 0 0 1 1.026-.27L12 11.882l1.872-1.092a.75.75 0 1 1 .756 1.295l-1.878 1.096V15a.75.75 0 0 1-1.5 0v-1.82l-1.878-1.095a.75.75 0 0 1-.27-1.025ZM3 13.5a.75.75 0 0 1 .75.75v1.82l1.878 1.095a.75.75 0 1 1-.756 1.295l-2.25-1.312a.75.75 0 0 1-.372-.648v-2.25A.75.75 0 0 1 3 13.5Zm18 0a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-.372.648l-2.25 1.312a.75.75 0 1 1-.756-1.295l1.878-1.096V14.25a.75.75 0 0 1 .75-.75Zm-9 5.25a.75.75 0 0 1 .75.75v.944l1.122-.654a.75.75 0 1 1 .756 1.295l-2.25 1.313a.75.75 0 0 1-.756 0l-2.25-1.313a.75.75 0 1 1 .756-1.295l1.122.654V19.5a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Es(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M12.378 1.602a.75.75 0 0 0-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03ZM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 0 0 .372-.648V7.93ZM11.25 22.18v-9l-9-5.25v8.57a.75.75 0 0 0 .372.648l8.628 5.033Z" })
  ]);
}
function Ps(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 0 1-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004ZM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 0 1-.921.42Z" }),
    _("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v.816a3.836 3.836 0 0 0-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 0 1-.921-.421l-.879-.66a.75.75 0 0 0-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 0 0 1.5 0v-.81a4.124 4.124 0 0 0 1.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 0 0-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 0 0 .933-1.175l-.415-.33a3.836 3.836 0 0 0-1.719-.755V6Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function $s(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM9.75 17.25a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-.75Zm2.25-3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Zm3.75-1.5a.75.75 0 0 0-1.5 0V18a.75.75 0 0 0 1.5 0v-5.25Z",
      "clip-rule": "evenodd"
    }),
    _("path", { d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" })
  ]);
}
function s0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625ZM7.5 15a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7.5 15Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H8.25Z",
      "clip-rule": "evenodd"
    }),
    _("path", { d: "M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" })
  ]);
}
function As(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" }),
    _("path", { d: "M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" })
  ]);
}
function i0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Ts(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function u0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M3.53 2.47a.75.75 0 0 0-1.06 1.06l18 18a.75.75 0 1 0 1.06-1.06l-18-18ZM22.676 12.553a11.249 11.249 0 0 1-2.631 4.31l-3.099-3.099a5.25 5.25 0 0 0-6.71-6.71L7.759 4.577a11.217 11.217 0 0 1 4.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113Z" }),
    _("path", { d: "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0 1 15.75 12ZM12.53 15.713l-4.243-4.244a3.75 3.75 0 0 0 4.244 4.243Z" }),
    _("path", { d: "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 0 0-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 0 1 6.75 12Z" })
  ]);
}
function Ds(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }),
    _("path", {
      "fill-rule": "evenodd",
      d: "M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function d0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M9.375 3a1.875 1.875 0 0 0 0 3.75h1.875v4.5H3.375A1.875 1.875 0 0 1 1.5 9.375v-.75c0-1.036.84-1.875 1.875-1.875h3.193A3.375 3.375 0 0 1 12 2.753a3.375 3.375 0 0 1 5.432 3.997h3.943c1.035 0 1.875.84 1.875 1.875v.75c0 1.036-.84 1.875-1.875 1.875H12.75v-4.5h1.875a1.875 1.875 0 1 0-1.875-1.875V6.75h-1.5V4.875C11.25 3.839 10.41 3 9.375 3ZM11.25 12.75H3v6.75a2.25 2.25 0 0 0 2.25 2.25h6v-9ZM12.75 12.75v9h6.75a2.25 2.25 0 0 0 2.25-2.25v-6.75h-9Z" })
  ]);
}
function c0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" })
  ]);
}
function f0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z" }),
    _("path", { d: "m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z" })
  ]);
}
function m0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function p0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M15.75 1.5a6.75 6.75 0 0 0-6.651 7.906c.067.39-.032.717-.221.906l-6.5 6.499a3 3 0 0 0-.878 2.121v2.818c0 .414.336.75.75.75H6a.75.75 0 0 0 .75-.75v-1.5h1.5A.75.75 0 0 0 9 19.5V18h1.5a.75.75 0 0 0 .53-.22l2.658-2.658c.19-.189.517-.288.906-.22A6.75 6.75 0 1 0 15.75 1.5Zm0 3a.75.75 0 0 0 0 1.5A2.25 2.25 0 0 1 18 8.25a.75.75 0 0 0 1.5 0 3.75 3.75 0 0 0-3.75-3.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function v0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M9 2.25a.75.75 0 0 1 .75.75v1.506a49.384 49.384 0 0 1 5.343.371.75.75 0 1 1-.186 1.489c-.66-.083-1.323-.151-1.99-.206a18.67 18.67 0 0 1-2.97 6.323c.318.384.65.753 1 1.107a.75.75 0 0 1-1.07 1.052A18.902 18.902 0 0 1 9 13.687a18.823 18.823 0 0 1-5.656 4.482.75.75 0 0 1-.688-1.333 17.323 17.323 0 0 0 5.396-4.353A18.72 18.72 0 0 1 5.89 8.598a.75.75 0 0 1 1.388-.568A17.21 17.21 0 0 0 9 11.224a17.168 17.168 0 0 0 2.391-5.165 48.04 48.04 0 0 0-8.298.307.75.75 0 0 1-.186-1.489 49.159 49.159 0 0 1 5.343-.371V3A.75.75 0 0 1 9 2.25ZM15.75 9a.75.75 0 0 1 .68.433l5.25 11.25a.75.75 0 1 1-1.36.634l-1.198-2.567h-6.744l-1.198 2.567a.75.75 0 0 1-1.36-.634l5.25-11.25A.75.75 0 0 1 15.75 9Zm-2.672 8.25h5.344l-2.672-5.726-2.672 5.726Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Rs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M19.902 4.098a3.75 3.75 0 0 0-5.304 0l-4.5 4.5a3.75 3.75 0 0 0 1.035 6.037.75.75 0 0 1-.646 1.353 5.25 5.25 0 0 1-1.449-8.45l4.5-4.5a5.25 5.25 0 1 1 7.424 7.424l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.757-1.757a3.75 3.75 0 0 0 0-5.304Zm-7.389 4.267a.75.75 0 0 1 1-.353 5.25 5.25 0 0 1 1.449 8.45l-4.5 4.5a5.25 5.25 0 1 1-7.424-7.424l1.757-1.757a.75.75 0 1 1 1.06 1.06l-1.757 1.757a3.75 3.75 0 1 0 5.304 5.304l4.5-4.5a3.75 3.75 0 0 0-1.035-6.037.75.75 0 0 1-.354-1Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function cu(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function g0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 0 1-1.5 0V6.75a3.75 3.75 0 1 0-7.5 0v3a3 3 0 0 1 3 3v6.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-6.75a3 3 0 0 1 3-3h9v-3c0-2.9 2.35-5.25 5.25-5.25Z" })
  ]);
}
function xl(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Os(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Is(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M16.881 4.345A23.112 23.112 0 0 1 8.25 6H7.5a5.25 5.25 0 0 0-.88 10.427 21.593 21.593 0 0 0 1.378 3.94c.464 1.004 1.674 1.32 2.582.796l.657-.379c.88-.508 1.165-1.593.772-2.468a17.116 17.116 0 0 1-.628-1.607c1.918.258 3.76.75 5.5 1.446A21.727 21.727 0 0 0 18 11.25c0-2.414-.393-4.735-1.119-6.905ZM18.26 3.74a23.22 23.22 0 0 1 1.24 7.51 23.22 23.22 0 0 1-1.41 7.992.75.75 0 1 0 1.409.516 24.555 24.555 0 0 0 1.415-6.43 2.992 2.992 0 0 0 .836-2.078c0-.807-.319-1.54-.836-2.078a24.65 24.65 0 0 0-1.415-6.43.75.75 0 1 0-1.409.516c.059.16.116.321.17.483Z" })
  ]);
}
function h0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M4.25 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function y0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M9.528 1.718a.75.75 0 0 1 .162.819A8.97 8.97 0 0 0 9 6a9 9 0 0 0 9 9 8.97 8.97 0 0 0 3.463-.69.75.75 0 0 1 .981.98 10.503 10.503 0 0 1-9.694 6.46c-5.799 0-10.5-4.7-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 0 1 .818.162Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Fs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM9 8.25a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75h.75a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75H9Zm5.25 0a.75.75 0 0 0-.75.75v6c0 .414.336.75.75.75H15a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75h-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function w0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function b0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" }),
    _("path", { d: "M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" })
  ]);
}
function Ls(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L19.513 8.2Z" })
  ]);
}
function Ns(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function _0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Vs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm14.024-.983a1.125 1.125 0 0 1 0 1.966l-5.603 3.113A1.125 1.125 0 0 1 9 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function x0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Bs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function k0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M2.25 2.25a.75.75 0 0 0 0 1.5H3v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H18a3 3 0 0 0 3-3V3.75h.75a.75.75 0 0 0 0-1.5H2.25Zm6.04 16.5.5-1.5h6.42l.5 1.5H8.29Zm7.46-12a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0v-6Zm-3 2.25a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 1.5 0V9Zm-3 2.25a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function C0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M2.25 2.25a.75.75 0 0 0 0 1.5H3v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H18a3 3 0 0 0 3-3V3.75h.75a.75.75 0 0 0 0-1.5H2.25Zm6.54 15h6.42l.5 1.5H8.29l.5-1.5Zm8.085-8.995a.75.75 0 1 0-.75-1.299 12.81 12.81 0 0 0-3.558 3.05L11.03 8.47a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l2.47-2.47 1.617 1.618a.75.75 0 0 0 1.146-.102 11.312 11.312 0 0 1 3.612-3.321Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function S0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 0 1-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 0 1-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584ZM12 18a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function M0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M5.625 3.75a2.625 2.625 0 1 0 0 5.25h12.75a2.625 2.625 0 0 0 0-5.25H5.625ZM3.75 11.25a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75ZM3 15.75a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75ZM3.75 18.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Z" })
  ]);
}
function Hs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5c-1.921 0-3.816.111-5.68.327-1.497.174-2.57 1.46-2.57 2.93V21.75a.75.75 0 0 0 1.029.696l3.471-1.388 3.472 1.388a.75.75 0 0 0 .556 0l3.472-1.388 3.471 1.388a.75.75 0 0 0 1.029-.696V4.757c0-1.47-1.073-2.756-2.57-2.93A49.255 49.255 0 0 0 12 1.5Zm3.53 7.28a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06l6-6ZM8.625 9a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm5.625 3.375a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function zs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5c-1.921 0-3.816.111-5.68.327-1.497.174-2.57 1.46-2.57 2.93V21.75a.75.75 0 0 0 1.029.696l3.471-1.388 3.472 1.388a.75.75 0 0 0 .556 0l3.472-1.388 3.471 1.388a.75.75 0 0 0 1.029-.696V4.757c0-1.47-1.073-2.756-2.57-2.93A49.255 49.255 0 0 0 12 1.5Zm-.97 6.53a.75.75 0 1 0-1.06-1.06L7.72 9.22a.75.75 0 0 0 0 1.06l2.25 2.25a.75.75 0 1 0 1.06-1.06l-.97-.97h3.065a1.875 1.875 0 0 1 0 3.75H12a.75.75 0 0 0 0 1.5h1.125a3.375 3.375 0 1 0 0-6.75h-3.064l.97-.97Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function E0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M5.566 4.657A4.505 4.505 0 0 1 6.75 4.5h10.5c.41 0 .806.055 1.183.157A3 3 0 0 0 15.75 3h-7.5a3 3 0 0 0-2.684 1.657ZM2.25 12a3 3 0 0 1 3-3h13.5a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3v-6ZM5.25 7.5c-.41 0-.806.055-1.184.157A3 3 0 0 1 6.75 6h10.5a3 3 0 0 1 2.683 1.657A4.505 4.505 0 0 0 18.75 7.5H5.25Z" })
  ]);
}
function P0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M4.08 5.227A3 3 0 0 1 6.979 3H17.02a3 3 0 0 1 2.9 2.227l2.113 7.926A5.228 5.228 0 0 0 18.75 12H5.25a5.228 5.228 0 0 0-3.284 1.153L4.08 5.227Z" }),
    _("path", {
      "fill-rule": "evenodd",
      d: "M5.25 13.5a3.75 3.75 0 1 0 0 7.5h13.5a3.75 3.75 0 1 0 0-7.5H5.25Zm10.5 4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm3.75-.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function $0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M12.516 2.17a.75.75 0 0 0-1.032 0 11.209 11.209 0 0 1-7.877 3.08.75.75 0 0 0-.722.515A12.74 12.74 0 0 0 2.25 9.75c0 5.942 4.064 10.933 9.563 12.348a.749.749 0 0 0 .374 0c5.499-1.415 9.563-6.406 9.563-12.348 0-1.39-.223-2.73-.635-3.985a.75.75 0 0 0-.722-.516l-.143.001c-2.996 0-5.717-1.17-7.734-3.08Zm3.094 8.016a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function A0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M11.484 2.17a.75.75 0 0 1 1.032 0 11.209 11.209 0 0 0 7.877 3.08.75.75 0 0 1 .722.515 12.74 12.74 0 0 1 .635 3.985c0 5.942-4.064 10.933-9.563 12.348a.749.749 0 0 1-.374 0C6.314 20.683 2.25 15.692 2.25 9.75c0-1.39.223-2.73.635-3.985a.75.75 0 0 1 .722-.516l.143.001c2.996 0 5.718-1.17 7.734-3.08ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75ZM12 15a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75v-.008a.75.75 0 0 0-.75-.75H12Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function T0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M5.636 4.575a.75.75 0 0 1 0 1.061 9 9 0 0 0 0 12.728.75.75 0 1 1-1.06 1.06c-4.101-4.1-4.101-10.748 0-14.849a.75.75 0 0 1 1.06 0Zm12.728 0a.75.75 0 0 1 1.06 0c4.101 4.1 4.101 10.75 0 14.85a.75.75 0 1 1-1.06-1.061 9 9 0 0 0 0-12.728.75.75 0 0 1 0-1.06ZM7.757 6.697a.75.75 0 0 1 0 1.06 6 6 0 0 0 0 8.486.75.75 0 0 1-1.06 1.06 7.5 7.5 0 0 1 0-10.606.75.75 0 0 1 1.06 0Zm8.486 0a.75.75 0 0 1 1.06 0 7.5 7.5 0 0 1 0 10.606.75.75 0 0 1-1.06-1.06 6 6 0 0 0 0-8.486.75.75 0 0 1 0-1.06ZM9.879 8.818a.75.75 0 0 1 0 1.06 3 3 0 0 0 0 4.243.75.75 0 1 1-1.061 1.061 4.5 4.5 0 0 1 0-6.364.75.75 0 0 1 1.06 0Zm4.242 0a.75.75 0 0 1 1.061 0 4.5 4.5 0 0 1 0 6.364.75.75 0 0 1-1.06-1.06 3 3 0 0 0 0-4.243.75.75 0 0 1 0-1.061ZM10.875 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function D0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M11.644 1.59a.75.75 0 0 1 .712 0l9.75 5.25a.75.75 0 0 1 0 1.32l-9.75 5.25a.75.75 0 0 1-.712 0l-9.75-5.25a.75.75 0 0 1 0-1.32l9.75-5.25Z" }),
    _("path", { d: "m3.265 10.602 7.668 4.129a2.25 2.25 0 0 0 2.134 0l7.668-4.13 1.37.739a.75.75 0 0 1 0 1.32l-9.75 5.25a.75.75 0 0 1-.71 0l-9.75-5.25a.75.75 0 0 1 0-1.32l1.37-.738Z" }),
    _("path", { d: "m10.933 19.231-7.668-4.13-1.37.739a.75.75 0 0 0 0 1.32l9.75 5.25c.221.12.489.12.71 0l9.75-5.25a.75.75 0 0 0 0-1.32l-1.37-.738-7.668 4.13a2.25 2.25 0 0 1-2.134-.001Z" })
  ]);
}
function R0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M3 6a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3V6ZM3 15.75a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2.25Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3v-2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Us(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M6 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM15.75 3a3 3 0 0 0-3 3v2.25a3 3 0 0 0 3 3H18a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2.25ZM6 12.75a3 3 0 0 0-3 3V18a3 3 0 0 0 3 3h2.25a3 3 0 0 0 3-3v-2.25a3 3 0 0 0-3-3H6ZM17.625 13.5a.75.75 0 0 0-1.5 0v2.625H13.5a.75.75 0 0 0 0 1.5h2.625v2.625a.75.75 0 0 0 1.5 0v-2.625h2.625a.75.75 0 0 0 0-1.5h-2.625V13.5Z" })
  ]);
}
function O0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function I0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M12 2.25a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM7.5 12a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM18.894 6.166a.75.75 0 0 0-1.06-1.06l-1.591 1.59a.75.75 0 1 0 1.06 1.061l1.591-1.59ZM21.75 12a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1 0-1.5H21a.75.75 0 0 1 .75.75ZM17.834 18.894a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 1 0-1.061 1.06l1.59 1.591ZM12 18a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0v-2.25A.75.75 0 0 1 12 18ZM7.758 17.303a.75.75 0 0 0-1.061-1.06l-1.591 1.59a.75.75 0 0 0 1.06 1.061l1.591-1.59ZM6 12a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2.25A.75.75 0 0 1 6 12ZM6.697 7.757a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 0 0-1.061 1.06l1.59 1.591Z" })
  ]);
}
function Ys(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M5.25 2.25a3 3 0 0 0-3 3v4.318a3 3 0 0 0 .879 2.121l9.58 9.581c.92.92 2.39 1.186 3.548.428a18.849 18.849 0 0 0 5.441-5.44c.758-1.16.492-2.629-.428-3.548l-9.58-9.581a3 3 0 0 0-2.122-.879H5.25ZM6.375 7.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function js(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function F0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function L0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z",
      "clip-rule": "evenodd"
    }),
    _("path", { d: "M5.082 14.254a8.287 8.287 0 0 0-1.308 5.135 9.687 9.687 0 0 1-1.764-.44l-.115-.04a.563.563 0 0 1-.373-.487l-.01-.121a3.75 3.75 0 0 1 3.57-4.047ZM20.226 19.389a8.287 8.287 0 0 0-1.308-5.135 3.75 3.75 0 0 1 3.57 4.047l-.01.121a.563.563 0 0 1-.373.486l-.115.04c-.567.2-1.156.349-1.764.441Z" })
  ]);
}
function N0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M10.375 2.25a4.125 4.125 0 1 0 0 8.25 4.125 4.125 0 0 0 0-8.25ZM10.375 12a7.125 7.125 0 0 0-7.124 7.247.75.75 0 0 0 .363.63 13.067 13.067 0 0 0 6.761 1.873c2.472 0 4.786-.684 6.76-1.873a.75.75 0 0 0 .364-.63l.001-.12v-.002A7.125 7.125 0 0 0 10.375 12ZM16 9.75a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Z" })
  ]);
}
function V0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M5.25 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM2.25 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM18.75 7.5a.75.75 0 0 0-1.5 0v2.25H15a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H21a.75.75 0 0 0 0-1.5h-2.25V7.5Z" })
  ]);
}
function B0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Zs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M4.5 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM14.25 8.625a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0ZM1.5 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM17.25 19.128l-.001.144a2.25 2.25 0 0 1-.233.96 10.088 10.088 0 0 0 5.06-1.01.75.75 0 0 0 .42-.643 4.875 4.875 0 0 0-6.957-4.611 8.586 8.586 0 0 1 1.71 5.157v.003Z" })
  ]);
}
function H0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", { d: "M2.273 5.625A4.483 4.483 0 0 1 5.25 4.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0 0 18.75 3H5.25a3 3 0 0 0-2.977 2.625ZM2.273 8.625A4.483 4.483 0 0 1 5.25 7.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0 0 18.75 6H5.25a3 3 0 0 0-2.977 2.625ZM5.25 9a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h13.5a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3H15a.75.75 0 0 0-.75.75 2.25 2.25 0 0 1-4.5 0A.75.75 0 0 0 9 9H5.25Z" })
  ]);
}
function z0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Gs(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "fill-rule": "evenodd",
      d: "M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function U0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
    })
  ]);
}
function Y0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
    })
  ]);
}
function j0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function Z0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
    })
  ]);
}
function G0(e, n) {
  return p(), w("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    _("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 18 18 6M6 6l12 12"
    })
  ]);
}
const ar = /* @__PURE__ */ Ce({
  __name: "FIcon",
  props: {
    name: {},
    class: { default: "h-5 w-5" }
  },
  setup(e) {
    const n = e, t = k(() => n.class), a = (s, u) => Ce({
      name: `EmojiIcon${u.replace(/\s+/g, "")}`,
      inheritAttrs: !1,
      setup(c, { attrs: f }) {
        return () => {
          const { class: d, style: m, ...y } = f;
          return je(
            "span",
            {
              role: "img",
              "aria-label": u,
              class: ["inline-flex items-center justify-center align-middle", d].filter(Boolean),
              style: m,
              ...y
            },
            s
          );
        };
      }
    }), r = a("🇹🇷", "Turkey Flag"), l = a("🇺🇸", "United States Flag"), o = {
      // Solid Heroicons (20-solid)
      "heroicons:home-20-solid": f0,
      "heroicons:arrow-left-20-solid": Fc,
      "heroicons:arrow-right-20-solid": Nc,
      "heroicons:arrow-right-on-rectangle-20-solid": Lc,
      "heroicons:arrow-top-right-on-square-20-solid": hs,
      "heroicons:arrows-pointing-in-20-solid": ws,
      "heroicons:arrows-pointing-out-20-solid": bs,
      "heroicons:arrow-trending-up-20-solid": Bc,
      "heroicons:arrow-trending-down-20-solid": Vc,
      "heroicons:arrow-up-20-solid": zc,
      "heroicons:arrow-path-20-solid": bl,
      "heroicons:arrow-down-tray-20-solid": gs,
      "heroicons:arrow-up-tray-20-solid": ys,
      "heroicons:pencil-tray-20-solid": ys,
      "heroicons:banknotes-20-solid": Uc,
      "heroicons:bell-20-solid": jc,
      "heroicons:briefcase-20-solid": Zc,
      "heroicons:building-library-20-solid": Gc,
      "heroicons:building-office-20-solid": qc,
      "heroicons:building-office-2-20-solid": Wc,
      "heroicons:calendar-20-solid": Xc,
      "heroicons:calendar-days-20-solid": Kc,
      "heroicons:chart-bar-20-solid": _l,
      "heroicons:chart-pie-20-solid": Qc,
      "heroicons:presentation-chart-line-20-solid": C0,
      "heroicons:presentation-chart-bar-20-solid": k0,
      "heroicons:cloud-arrow-up-20-solid": a0,
      "heroicons:circle-stack-20-solid": n0,
      "heroicons:squares-2x2-20-solid": R0,
      "heroicons:check-20-solid": xs,
      "heroicons:check-badge-20-solid": Jc,
      "heroicons:check-circle-20-solid": _s,
      "heroicons:chevron-down-20-solid": ks,
      "heroicons:chevron-left-20-solid": e0,
      "heroicons:chevron-right-20-solid": t0,
      "heroicons:chevron-up-20-solid": Cs,
      "heroicons:clock-20-solid": Ss,
      "heroicons:cog-20-solid": l0,
      "heroicons:cog-6-tooth-20-solid": r0,
      "heroicons:credit-card-20-solid": Ms,
      "heroicons:cube-20-solid": Es,
      "heroicons:cube-transparent-20-solid": o0,
      "heroicons:currency-dollar-20-solid": Ps,
      "heroicons:document-chart-bar-20-solid": $s,
      "heroicons:document-text-20-solid": s0,
      "heroicons:envelope-20-solid": As,
      "heroicons:exclamation-circle-20-solid": i0,
      "heroicons:exclamation-triangle-20-solid": Ts,
      "heroicons:eye-20-solid": Ds,
      "heroicons:eye-slash-20-solid": u0,
      "heroicons:gift-20-solid": d0,
      "heroicons:heart-20-solid": c0,
      "heroicons:information-circle-20-solid": m0,
      "heroicons:key-20-solid": p0,
      "heroicons:link-20-solid": Rs,
      "heroicons:lock-closed-20-solid": cu,
      "heroicons:lock-open-20-solid": g0,
      "heroicons:magnifying-glass-20-solid": xl,
      "heroicons:map-pin-20-solid": Os,
      "heroicons:megaphone-20-solid": Is,
      "heroicons:pause-circle-20-solid": Fs,
      "heroicons:pencil-20-solid": Ls,
      "heroicons:pencil-square-20-solid": b0,
      "heroicons:phone-20-solid": Ns,
      "heroicons:play-circle-20-solid": Vs,
      "heroicons:play-20-solid": x0,
      "heroicons:pause-20-solid": w0,
      "heroicons:plus-20-solid": Bs,
      "heroicons:question-mark-circle-20-solid": S0,
      "heroicons:receipt-percent-20-solid": Hs,
      "heroicons:receipt-refund-20-solid": zs,
      "heroicons:rectangle-stack-20-solid": E0,
      "heroicons:server-20-solid": P0,
      "heroicons:shield-check-20-solid": $0,
      "heroicons:shield-exclamation-20-solid": A0,
      "heroicons:signal-20-solid": T0,
      "heroicons:square-3-stack-3d-20-solid": D0,
      "heroicons:squares-plus-20-solid": Us,
      "heroicons:star-20-solid": O0,
      "heroicons:tag-20-solid": Ys,
      "heroicons:trash-20-solid": js,
      "heroicons:user-20-solid": B0,
      "heroicons:user-circle-20-solid": F0,
      "heroicons:user-group-20-solid": L0,
      "heroicons:user-minus-20-solid": N0,
      "heroicons:user-plus-20-solid": V0,
      "heroicons:users-20-solid": Zs,
      "heroicons:wallet-20-solid": H0,
      "heroicons:x-circle-20-solid": z0,
      "heroicons:x-mark-20-solid": Gs,
      "heroicons:document-magnifying-glass-20-solid": xl,
      "heroicons:arrow-up-right-20-solid": Hc,
      "heroicons:queue-list-20-solid": M0,
      // Outline Heroicons
      "heroicons:x-mark-24-outline": G0,
      "heroicons:exclamation-triangle-24-outline": Z0,
      // Aliases and convenience names
      "heroicons:adjustments-horizontal": vs,
      "heroicons:adjustments-horizontal-20-solid": vs,
      "heroicons:arrow-clockwise-20-solid": bl,
      "heroicons:arrow-down-tray": gs,
      "heroicons:arrow-path": bl,
      "heroicons:arrow-top-right-on-square": hs,
      "heroicons:arrows-pointing-in": ws,
      "heroicons:arrows-pointing-out": bs,
      "heroicons:bars-3": Yc,
      "heroicons:chart-bar": _l,
      "heroicons:chart-line-20-solid": _l,
      "heroicons:check": xs,
      "heroicons:check-circle": _s,
      "heroicons:chevron-down": ks,
      "heroicons:chevron-up": Cs,
      "heroicons:clock": Ss,
      "heroicons:credit-card": Ms,
      "heroicons:currency-dollar": Ps,
      "heroicons:cube": Es,
      "heroicons:document-chart-bar": $s,
      "heroicons:envelope": As,
      "heroicons:eye": Ds,
      "heroicons:language": v0,
      "heroicons:link": Rs,
      "heroicons:magnifying-glass": xl,
      "heroicons:map-pin": Os,
      "heroicons:megaphone": Is,
      "heroicons:minus": h0,
      "heroicons:moon": y0,
      "heroicons:pause-circle": Fs,
      "heroicons:pencil": Ls,
      "heroicons:phone": Ns,
      "heroicons:photo": _0,
      "heroicons:play-circle": Vs,
      "heroicons:plus": Bs,
      "heroicons:receipt-percent": Hs,
      "heroicons:receipt-refund": zs,
      "heroicons:squares-plus": Us,
      "heroicons:sun": I0,
      "heroicons:tag": Ys,
      "heroicons:trash": js,
      "heroicons:users": Zs,
      "heroicons:exclamation-triangle": Ts,
      "heroicons:x-mark": Gs,
      // Custom emoji-based icons
      "twemoji:flag-turkey": r,
      "twemoji:flag-united-states": l
    }, i = k(() => {
      const s = o[n.name];
      return s || (console.warn(`[FIcon] Unsupported icon name: "${n.name}"`), null);
    });
    return (s, u) => (p(), Pe(Ln(i.value), {
      class: me(t.value)
    }, null, 8, ["class"]));
  }
}), W0 = { key: 0 }, q0 = { key: 1 }, K0 = { key: 2 }, X0 = /* @__PURE__ */ Ce({
  __name: "FButton",
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    to: {},
    product: {},
    leftIcon: {},
    rightIcon: {},
    id: {}
  },
  emits: ["click"],
  setup(e) {
    xc((o) => ({
      v266717b1: r.value
    }));
    const n = e, { currentProductColor: t } = gn(), a = k(() => n.to ? "a" : "button"), r = k(() => {
      if (n.product) {
        const o = Vt[n.product];
        return (o == null ? void 0 : o.primaryColor) || t.value;
      }
      return t.value;
    }), l = k(() => ({
      "inline-flex items-center justify-center font-semibold": !0,
      "!rounded-2xl transition-all duration-200": !0,
      "disabled:opacity-50 disabled:cursor-not-allowed space-x-2": !0,
      "px-3 py-2 text-sm": n.size === "sm",
      "px-4 py-2.5 text-base": n.size === "md",
      "px-6 py-3 text-lg": n.size === "lg",
      "w-full": n.fullWidth,
      "btn-primary text-text-tertiary": n.variant === "primary",
      "btn-secondary text-text-tertiary": n.variant === "secondary",
      "btn-outline": n.variant === "outline",
      "btn-ghost": n.variant === "ghost",
      "bg-red-600 hover:bg-red-700 text-white": n.variant === "danger"
    }));
    return (o, i) => (p(), Pe(Ln(a.value), {
      type: e.to ? void 0 : e.type,
      href: e.to,
      disabled: e.disabled || e.loading,
      class: me(l.value),
      onClick: i[0] || (i[0] = (s) => o.$emit("click", s)),
      id: e.id
    }, {
      default: xe(() => [
        e.loading ? (p(), w("span", W0, [...i[1] || (i[1] = [
          _("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 24 24"
          }, [
            _("path", {
              fill: "currentColor",
              d: "M12,23a9.63,9.63,0,0,1-8-9.5,9.51,9.51,0,0,1,6.79-9.1A1.66,1.66,0,0,0,12,2.81h0a1.67,1.67,0,0,0-1.94-1.64A11,11,0,0,0,12,23Z"
            }, [
              _("animateTransform", {
                attributeName: "transform",
                dur: "0.75s",
                repeatCount: "indefinite",
                type: "rotate",
                values: "0 12 12;360 12 12"
              })
            ])
          ], -1)
        ])])) : X("", !0),
        e.leftIcon && !e.loading ? (p(), w("span", q0, [
          Ae(ar, { name: e.leftIcon }, null, 8, ["name"])
        ])) : X("", !0),
        ge(o.$slots, "default", {}, void 0, !0),
        e.rightIcon ? (p(), w("span", K0, [
          Ae(ar, { name: e.rightIcon }, null, 8, ["name"])
        ])) : X("", !0)
      ]),
      _: 3
    }, 8, ["type", "href", "disabled", "class", "id"]));
  }
}), el = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [a, r] of n)
    t[a] = r;
  return t;
}, on = /* @__PURE__ */ el(X0, [["__scopeId", "data-v-605bdab4"]]);
var Q0 = Object.defineProperty, J0 = (e, n, t) => n in e ? Q0(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, Ja = (e, n, t) => J0(e, typeof n != "symbol" ? n + "" : n, t);
const Ws = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, qs = (e, n, t) => e.replaceAll(n, "").replace(t, ".").replace("..", ".").replace(/[^.\d]/g, ""), Ks = (e, n, t) => {
  var a;
  return new Intl.NumberFormat(((a = t.number) == null ? void 0 : a.locale) ?? "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: n,
    roundingMode: "trunc"
  });
}, ef = (e, n = !0, t) => {
  var a, r, l, o;
  const i = ((a = t.number) == null ? void 0 : a.unsigned) !== !0 && e.startsWith("-") ? "-" : "", s = ((r = t.number) == null ? void 0 : r.fraction) ?? 0;
  let u = Ks(0, s, t);
  const c = u.formatToParts(1000.12), f = ((l = c.find((S) => S.type === "group")) == null ? void 0 : l.value) ?? " ", d = ((o = c.find((S) => S.type === "decimal")) == null ? void 0 : o.value) ?? ".", m = qs(e, f, d);
  if (Number.isNaN(parseFloat(m))) return i;
  const y = m.split(".");
  if (y[1] != null && y[1].length >= 1) {
    const S = y[1].length <= s ? y[1].length : s;
    u = Ks(S, s, t);
  }
  let v = u.format(parseFloat(m));
  return n ? s > 0 && m.endsWith(".") && !m.slice(0, -1).includes(".") && (v += d) : v = qs(v, f, d), i + v;
}, fu = (e) => JSON.parse(e.replaceAll("'", '"')), tf = (e, n = {}) => {
  const t = { ...n };
  e.dataset.maska != null && e.dataset.maska !== "" && (t.mask = nf(e.dataset.maska)), e.dataset.maskaEager != null && (t.eager = kr(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (t.reversed = kr(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (t.tokensReplace = kr(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (t.tokens = af(e.dataset.maskaTokens));
  const a = {};
  return e.dataset.maskaNumberLocale != null && (a.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (a.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (a.unsigned = kr(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(a).length > 0) && (t.number = a), t;
}, kr = (e) => e !== "" ? !!JSON.parse(e) : !0, nf = (e) => e.startsWith("[") && e.endsWith("]") ? fu(e) : e, af = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return fu(e);
  const n = {};
  return e.split("|").forEach((t) => {
    const a = t.split(":");
    n[a[0]] = {
      pattern: mu() ? new RegExp(a[1], "u") : new RegExp(a[1]),
      optional: a[2] === "optional",
      multiple: a[2] === "multiple",
      repeated: a[2] === "repeated"
    };
  }), n;
}, mu = () => {
  try {
    return new RegExp("\\p{L}", "u"), !0;
  } catch {
    return !1;
  }
};
let rf = class {
  constructor(n = {}) {
    Ja(this, "opts", {}), Ja(this, "memo", /* @__PURE__ */ new Map());
    const t = { ...n };
    if (t.tokens != null) {
      t.tokens = t.tokensReplace ? { ...t.tokens } : { ...Ws, ...t.tokens };
      for (const a of Object.values(t.tokens))
        typeof a.pattern == "string" && (a.pattern = mu() ? new RegExp(a.pattern, "u") : new RegExp(a.pattern));
    } else
      t.tokens = Ws;
    Array.isArray(t.mask) && (t.mask.length > 1 ? t.mask = [...t.mask].sort((a, r) => a.length - r.length) : t.mask = t.mask[0] ?? ""), t.mask === "" && (t.mask = null), this.opts = t;
  }
  masked(n) {
    return this.process(String(n), this.findMask(String(n)));
  }
  unmasked(n) {
    return this.process(String(n), this.findMask(String(n)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(n) {
    const t = this.findMask(String(n));
    if (this.opts.mask == null || t == null) return !1;
    const a = this.process(String(n), t).length;
    return typeof this.opts.mask == "string" ? a >= this.opts.mask.length : a >= t.length;
  }
  findMask(n) {
    const t = this.opts.mask;
    if (t == null)
      return null;
    if (typeof t == "string")
      return t;
    if (typeof t == "function")
      return t(n);
    const a = this.process(n, t.slice(-1).pop() ?? "", !1);
    return t.find((r) => this.process(n, r, !1).length >= a.length) ?? "";
  }
  escapeMask(n) {
    const t = [], a = [];
    return n.split("").forEach((r, l) => {
      r === "!" && n[l - 1] !== "!" ? a.push(l - a.length) : t.push(r);
    }), { mask: t.join(""), escaped: a };
  }
  process(n, t, a = !0) {
    if (this.opts.number != null) return ef(n, a, this.opts);
    if (t == null) return n;
    const r = `v=${n},mr=${t},m=${a ? 1 : 0}`;
    if (this.memo.has(r)) return this.memo.get(r);
    const { mask: l, escaped: o } = this.escapeMask(t), i = [], s = this.opts.tokens != null ? this.opts.tokens : {}, u = this.isReversed() ? -1 : 1, c = this.isReversed() ? "unshift" : "push", f = this.isReversed() ? 0 : l.length - 1, d = this.isReversed() ? () => S > -1 && g > -1 : () => S < l.length && g < n.length, m = (h) => !this.isReversed() && h <= f || this.isReversed() && h >= f;
    let y, v = -1, S = this.isReversed() ? l.length - 1 : 0, g = this.isReversed() ? n.length - 1 : 0, b = !1;
    for (; d(); ) {
      const h = l.charAt(S), x = s[h], F = (x == null ? void 0 : x.transform) != null ? x.transform(n.charAt(g)) : n.charAt(g);
      if (!o.includes(S) && x != null ? (F.match(x.pattern) != null ? (i[c](F), x.repeated ? (v === -1 ? v = S : S === f && S !== v && (S = v - u), f === v && (S -= u)) : x.multiple && (b = !0, S -= u), S += u) : x.multiple ? b && (S += u, g -= u, b = !1) : F === y ? y = void 0 : x.optional && (S += u, g -= u), g += u) : (a && !this.isEager() && i[c](h), F === h && !this.isEager() ? g += u : y = h, this.isEager() || (S += u)), this.isEager())
        for (; m(S) && (s[l.charAt(S)] == null || o.includes(S)); ) {
          if (a) {
            if (i[c](l.charAt(S)), n.charAt(g) === l.charAt(S)) {
              S += u, g += u;
              continue;
            }
          } else l.charAt(S) === n.charAt(g) && (g += u);
          S += u;
        }
    }
    return this.memo.set(r, i.join("")), this.memo.get(r);
  }
};
class lf {
  constructor(n, t = {}) {
    Ja(this, "items", /* @__PURE__ */ new Map()), Ja(this, "eventAbortController"), Ja(this, "onInput", (a) => {
      if (a instanceof CustomEvent && a.type === "input" && !a.isTrusted && !a.bubbles)
        return;
      const r = a.target, l = this.items.get(r);
      if (l === void 0) return;
      const o = "inputType" in a && a.inputType.startsWith("delete"), i = l.isEager(), s = o && i && l.unmasked(r.value) === "" ? "" : r.value;
      this.fixCursor(r, o, () => this.setValue(r, s));
    }), this.options = t, this.eventAbortController = new AbortController(), this.init(this.getInputs(n));
  }
  update(n = {}) {
    this.options = { ...n }, this.init(Array.from(this.items.keys()));
  }
  updateValue(n) {
    var t;
    n.value !== "" && n.value !== ((t = this.processInput(n)) == null ? void 0 : t.masked) && this.setValue(n, n.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(n) {
    const t = this.getOptions(this.options);
    for (const a of n) {
      if (!this.items.has(a)) {
        const { signal: l } = this.eventAbortController;
        a.addEventListener("input", this.onInput, { capture: !0, signal: l });
      }
      const r = new rf(tf(a, t));
      this.items.set(a, r), queueMicrotask(() => this.updateValue(a)), a.selectionStart === null && r.isEager() && console.warn("Maska: input of `%s` type is not supported", a.type);
    }
  }
  getInputs(n) {
    return typeof n == "string" ? Array.from(document.querySelectorAll(n)) : "length" in n ? Array.from(n) : [n];
  }
  getOptions(n) {
    const { onMaska: t, preProcess: a, postProcess: r, ...l } = n;
    return l;
  }
  fixCursor(n, t, a) {
    var r, l;
    const o = n.selectionStart, i = n.value;
    if (a(), o === null || o === i.length && !t) return;
    const s = n.value, u = i.slice(0, o), c = s.slice(0, o), f = (r = this.processInput(n, u)) == null ? void 0 : r.unmasked, d = (l = this.processInput(n, c)) == null ? void 0 : l.unmasked;
    if (f === void 0 || d === void 0) return;
    let m = o;
    u !== c && (m += t ? s.length - i.length : f.length - d.length), n.setSelectionRange(m, m);
  }
  setValue(n, t) {
    const a = this.processInput(n, t);
    a !== void 0 && (n.value = a.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((r) => r(a)) : this.options.onMaska(a)), n.dispatchEvent(new CustomEvent("maska", { detail: a })), n.dispatchEvent(new CustomEvent("input", { detail: a.masked })));
  }
  processInput(n, t) {
    const a = this.items.get(n);
    if (a === void 0) return;
    let r = t ?? n.value;
    this.options.preProcess != null && (r = this.options.preProcess(r));
    let l = a.masked(r);
    return this.options.postProcess != null && (l = this.options.postProcess(l)), {
      masked: l,
      unmasked: a.unmasked(r),
      completed: a.completed(r)
    };
  }
}
const kl = /* @__PURE__ */ new WeakMap(), of = (e, n) => {
  if (e.arg == null || e.instance == null) return;
  const t = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = n : t && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, sf = (e, n) => {
  var t;
  const a = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (a == null || (a == null ? void 0 : a.type) === "file") return;
  let r = {};
  if (n.value != null && (r = typeof n.value == "string" ? { mask: n.value } : { ...n.value }), n.arg != null) {
    const l = (o) => {
      const i = n.modifiers.unmasked ? o.unmasked : n.modifiers.completed ? o.completed : o.masked;
      of(n, i);
    };
    r.onMaska = r.onMaska == null ? l : Array.isArray(r.onMaska) ? [...r.onMaska, l] : [r.onMaska, l];
  }
  kl.has(a) ? (t = kl.get(a)) == null || t.update(r) : kl.set(a, new lf(a, r));
}, uf = { class: "f-input-wrapper" }, df = { class: "relative" }, cf = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pointer-events-none pl-3"
}, ff = ["id", "name", "data-maska", "data-maska-unmasked", "type", "value", "placeholder", "disabled", "required", "minlength", "maxlength", "min", "max", "step", "pattern", "readonly", "autocomplete", "inputmode", "autofocus", "aria-describedby"], mf = {
  key: 1,
  class: "absolute inset-y-0 right-0 flex items-center pr-3 space-x-2"
}, pf = {
  key: 0,
  class: "flex items-center"
}, vf = {
  key: 1,
  class: "text-red-500 pointer-events-none"
}, gf = {
  key: 1,
  class: "mt-2 text-sm text-red-500"
}, hf = {
  key: 2,
  class: "mt-2 text-sm text-text-secondary"
}, Vr = /* @__PURE__ */ Ce({
  __name: "FInput",
  props: {
    modelValue: { default: "" },
    type: { default: "text" },
    label: {},
    placeholder: {},
    hint: {},
    error: { type: Boolean, default: !1 },
    errorMessage: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    size: { default: "md" },
    product: {},
    maska: {},
    minLength: {},
    maxLength: {},
    min: {},
    max: {},
    step: {},
    pattern: {},
    name: {},
    id: {},
    autocomplete: {},
    inputmode: {},
    readonly: { type: Boolean },
    autofocus: { type: Boolean },
    ariaDescribedBy: {},
    inputClass: {}
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e) {
    const n = e, { currentProductColor: t } = gn(), a = Qn(), r = k(
      () => n.id || `f-input-${Math.random().toString(36).slice(2, 11)}`
    ), l = k(() => {
      if (n.product) {
        const u = Vt[n.product];
        return (u == null ? void 0 : u.primaryColor) || t.value;
      }
      return t.value;
    }), o = k(() => !!a.prefix), i = k(() => !!a.suffix), s = k(() => {
      const u = [
        "block w-full rounded-2xl border transition-colors bg-bg-primary",
        "focus:outline-none focus:ring-0 focus:ring-offset-0",
        "disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:cursor-not-allowed disabled:opacity-60"
      ];
      return n.error ? u.push("border-red-500 focus:border-red-500") : (u.push("border-[#E6E6E6] dark:border-[#404040]"), u.push("focus:border-[var(--brand)]")), n.size === "sm" ? u.push("px-3 py-2 text-sm") : n.size === "lg" ? u.push("px-6 py-3 text-lg") : u.push("px-4 py-2.5 text-base"), o.value && u.push("pl-10"), (i.value || n.error) && u.push("pr-12"), n.inputClass && u.push(n.inputClass), u.join(" ");
    });
    return (u, c) => {
      const f = fr("FLabel");
      return p(), w("div", uf, [
        e.label ? (p(), Pe(f, {
          key: 0,
          "for-id": r.value,
          label: e.label,
          required: e.required,
          size: e.size,
          disabled: e.disabled
        }, null, 8, ["for-id", "label", "required", "size", "disabled"])) : X("", !0),
        _("div", df, [
          o.value ? (p(), w("div", cf, [
            ge(u.$slots, "prefix")
          ])) : X("", !0),
          On(_("input", {
            id: r.value,
            name: e.name,
            "data-maska": e.type === "tel" ? "(###) ### ####" : e.maska,
            "data-maska-unmasked": e.type === "tel",
            type: e.type,
            value: e.modelValue,
            placeholder: e.placeholder,
            disabled: e.disabled,
            required: e.required,
            minlength: e.minLength,
            maxlength: e.maxLength,
            min: e.min,
            max: e.max,
            step: e.step,
            pattern: e.pattern,
            readonly: e.readonly,
            autocomplete: e.autocomplete,
            inputmode: e.inputmode,
            autofocus: e.autofocus,
            "aria-describedby": e.ariaDescribedBy,
            class: me(s.value),
            style: tt({ "--brand": l.value }),
            onInput: c[0] || (c[0] = (d) => u.$emit("update:modelValue", d.target.value)),
            onBlur: c[1] || (c[1] = (d) => u.$emit("blur", d)),
            onFocus: c[2] || (c[2] = (d) => u.$emit("focus", d))
          }, null, 46, ff), [
            [D(sf)]
          ]),
          i.value || e.error ? (p(), w("div", mf, [
            i.value ? (p(), w("div", pf, [
              ge(u.$slots, "suffix")
            ])) : X("", !0),
            e.error ? (p(), w("span", vf, "⚠️")) : X("", !0)
          ])) : X("", !0)
        ]),
        e.error && e.errorMessage ? (p(), w("p", gf, he(e.errorMessage), 1)) : e.hint ? (p(), w("p", hf, he(e.hint), 1)) : X("", !0)
      ]);
    };
  }
}), Db = /* @__PURE__ */ Ce({
  __name: "FCard",
  props: {
    variant: { default: "default" },
    productColor: {},
    padding: { default: "md" },
    hoverable: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = e, t = k(() => ({
      "rounded-card transition-all duration-200": !0,
      "w-full": n.fullWidth,
      "w-fit": !n.fullWidth,
      "bg-bg-primary border border-gray-200 rounded-2xl": n.variant === "default",
      "hover:shadow-lg hover:scale-[1.02] cursor-pointer": n.hoverable,
      "p-0": n.padding === "none",
      "p-3": n.padding === "sm",
      "p-4": n.padding === "md",
      "p-6": n.padding === "lg"
    }));
    return (a, r) => (p(), w("div", {
      class: me(t.value)
    }, [
      ge(a.$slots, "default")
    ], 2));
  }
}), yf = ["for"], wf = {
  key: 0,
  class: "text-red-500 ml-1"
}, bf = /* @__PURE__ */ Ce({
  __name: "FLabel",
  props: {
    forId: {},
    label: {},
    required: { type: Boolean, default: !1 },
    size: { default: "md" },
    disabled: { type: Boolean, default: !1 },
    product: {}
  },
  setup(e) {
    const n = e, { currentProductColor: t } = gn(), a = k(() => n.product || t.value), r = k(() => ({
      "block font-medium transition-colors": !0,
      [`text-${a.value}`]: !n.disabled,
      "text-text-primary opacity-60": n.disabled,
      "mb-2": !0,
      "text-xs": n.size === "sm",
      "text-sm": n.size === "md",
      "text-base": n.size === "lg"
    }));
    return (l, o) => (p(), w("label", {
      for: e.forId,
      class: me(r.value)
    }, [
      ge(l.$slots, "default", {}, () => [
        Qe(he(e.label), 1)
      ]),
      e.required ? (p(), w("span", wf, "*")) : X("", !0)
    ], 10, yf));
  }
}), Rb = /* @__PURE__ */ Ce({
  __name: "FTitle",
  props: {
    variant: { default: "H7" },
    weight: { default: "bold" },
    extraClass: { default: "" }
  },
  setup(e) {
    const n = e, t = {
      H1: "text-[10px] leading-[12px]",
      H2: "text-[12px] leading-[12px]",
      H3: "text-[14px] leading-[14px]",
      H4: "text-[12px] leading-[16px]",
      H5: "text-[14px] leading-[16px]",
      H6: "text-[18px] leading-[20px]",
      H7: "text-[24px] leading-[26px]",
      H8: "text-[32px] leading-[32px]",
      H9: "text-[40px] leading-[44px]",
      sH1: "text-[9px]  leading-[9px]",
      sH2: "text-[9px]  leading-[10px]",
      sH4: "text-[10px] leading-[10px]"
    }, a = {
      H1: "h1",
      H2: "h2",
      H3: "h3",
      H4: "h4",
      H5: "h5",
      H6: "h6",
      H7: "h6",
      H8: "h6",
      H9: "h6",
      sH1: "h6",
      sH2: "h6",
      sH4: "h6"
    }, r = {
      regular: "font-normal",
      medium: "font-medium",
      semibold: "font-semibold",
      bold: "font-bold"
    }, l = k(() => a[n.variant]), o = k(() => t[n.variant]), i = k(() => r[n.weight]), s = k(() => `text-text-primary ${n.extraClass}`);
    return (u, c) => (p(), Pe(Ln(l.value), {
      class: me([o.value, i.value, s.value]),
      "data-variant": e.variant
    }, {
      default: xe(() => [
        ge(u.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "data-variant"]));
  }
}), _f = { class: "flex flex-wrap gap-2" }, xf = ["disabled", "onClick"], Ob = /* @__PURE__ */ Ce({
  __name: "FTab",
  props: {
    modelValue: {},
    tabs: {},
    product: {},
    color: { default: "" }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = n, { currentProductColor: r } = gn(), l = k(() => {
      if (t.color && t.color.trim().length > 0)
        return t.color;
      if (t.product) {
        const u = Vt[t.product];
        return (u == null ? void 0 : u.primaryColor) || r.value;
      }
      return r.value;
    }), o = k(() => ({
      "--ftab-color": l.value
    })), i = (u) => {
      const c = u.value === t.modelValue, f = "px-4 py-2 text-sm font-medium rounded-xl transition-colors border border-transparent focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed";
      return c ? `${f} bg-[var(--ftab-color)] text-white` : `${f} text-text-primary hover:bg-gray-100 focus-visible:ring-[var(--ftab-color)] focus-visible:ring-offset-bg-primary`;
    }, s = (u) => {
      u.disabled || u.value === t.modelValue || (a("update:modelValue", u.value), a("change", u.value));
    };
    return (u, c) => (p(), w("div", {
      class: "f-tab",
      style: tt(o.value)
    }, [
      _("div", _f, [
        (p(!0), w(_e, null, Ie(e.tabs, (f) => (p(), w("button", {
          key: f.value,
          type: "button",
          disabled: f.disabled,
          class: me(i(f)),
          onClick: (d) => s(f)
        }, [
          ge(u.$slots, "label", { tab: f }, () => [
            Qe(he(f.label), 1)
          ])
        ], 10, xf))), 128))
      ])
    ], 4));
  }
}), kf = ["disabled"], Cf = ["disabled", "aria-expanded"], Sf = {
  key: 0,
  class: "my-1 border-t border-slate-200"
}, Mf = ["disabled", "onClick"], Ib = /* @__PURE__ */ Ce({
  __name: "FSplitButton",
  props: {
    model: { default: () => [] },
    disabled: { type: Boolean, default: !1 },
    mainDisabled: { type: Boolean, default: !1 },
    menuDisabled: { type: Boolean, default: !1 },
    outlined: { type: Boolean, default: !1 },
    severity: { default: "primary" },
    size: { default: "md" },
    product: {},
    menuAlign: { default: "left" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, a = n, r = ee(!1), { currentProductColor: l } = gn(), o = k(() => {
      if (t.product) {
        const N = Vt[t.product];
        return (N == null ? void 0 : N.primaryColor) || l.value;
      }
      return l.value;
    }), i = k(() => ({
      primary: o.value,
      info: o.value,
      secondary: "#6b7280",
      success: "#16a34a",
      warning: "#f59e0b",
      danger: "#dc2626"
    })), s = k(() => i.value[t.severity]), u = k(
      () => (t.model ?? []).filter((N) => N && N.visible !== !1)
    ), c = k(() => u.value.length > 0), f = k(() => t.disabled || t.mainDisabled), d = k(() => t.disabled || t.menuDisabled || !c.value), m = k(() => t.size === "sm" ? "px-3 py-2" : t.size === "lg" ? "px-6 py-3" : "px-4 py-2.5"), y = k(() => t.size === "sm" ? "px-2 py-2" : t.size === "lg" ? "px-3 py-3" : "px-2.5 py-2.5"), v = k(
      () => t.outlined ? "hover:bg-slate-100 dark:hover:bg-slate-800" : "hover:opacity-90"
    ), S = k(() => [
      "f-split-button inline-flex relative items-stretch",
      t.size === "sm" ? "text-sm" : t.size === "lg" ? "text-lg" : "text-base"
    ]), g = k(() => [
      "f-split-button__main inline-flex items-center justify-center font-semibold transition-colors",
      "border rounded-l-2xl",
      m.value,
      v.value,
      f.value ? "opacity-50 cursor-not-allowed" : ""
    ]), b = k(() => [
      "f-split-button__menu inline-flex items-center justify-center font-semibold transition-colors",
      "border rounded-r-2xl",
      y.value,
      v.value,
      d.value ? "opacity-50 cursor-not-allowed" : ""
    ]), h = k(() => ({
      backgroundColor: t.outlined ? "transparent" : s.value,
      color: t.outlined ? s.value : "#ffffff",
      borderColor: s.value
    })), x = k(() => ({
      backgroundColor: t.outlined ? "transparent" : s.value,
      color: t.outlined ? s.value : "#ffffff",
      borderColor: s.value,
      borderLeftColor: t.outlined ? s.value : "rgba(255, 255, 255, 0.45)"
    })), F = k(() => [
      "absolute z-50 mt-2 min-w-[180px] rounded-lg border border-slate-200 bg-bg-secondary py-1 shadow-lg",
      t.menuAlign === "right" ? "right-0" : "left-0"
    ]), C = (N) => {
      f.value || a("click", N);
    }, A = () => {
      d.value || (r.value = !r.value);
    }, O = () => {
      r.value = !1;
    }, $ = (N, K) => {
      var ue;
      N.disabled || ((ue = N.command) == null || ue.call(N, { originalEvent: K, item: N }), O());
    }, L = {
      mounted(N, K) {
        N.__clickOutsideHandler__ = (ue) => {
          setTimeout(() => {
            N === ue.target || N.contains(ue.target) || K.value();
          }, 0);
        }, document.addEventListener("mousedown", N.__clickOutsideHandler__), document.addEventListener("touchstart", N.__clickOutsideHandler__);
      },
      unmounted(N) {
        document.removeEventListener("mousedown", N.__clickOutsideHandler__), document.removeEventListener("touchstart", N.__clickOutsideHandler__);
      }
    };
    return (N, K) => On((p(), w("div", {
      class: me(S.value)
    }, [
      _("button", {
        type: "button",
        class: me(g.value),
        style: tt(h.value),
        disabled: f.value,
        onClick: C
      }, [
        ge(N.$slots, "default")
      ], 14, kf),
      _("button", {
        type: "button",
        class: me(b.value),
        style: tt(x.value),
        disabled: d.value,
        "aria-haspopup": "menu",
        "aria-expanded": r.value,
        onClick: A
      }, [
        ge(N.$slots, "menubuttonicon", {}, () => [
          Ae(ar, {
            name: "heroicons:chevron-down",
            class: "h-4 w-4"
          })
        ])
      ], 14, Cf),
      Ae(Pn, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform opacity-0 scale-95",
        "enter-to-class": "transform opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "transform opacity-100 scale-100",
        "leave-to-class": "transform opacity-0 scale-95"
      }, {
        default: xe(() => [
          r.value ? (p(), w("div", {
            key: 0,
            class: me(F.value),
            role: "menu"
          }, [
            (p(!0), w(_e, null, Ie(u.value, (ue, B) => (p(), w(_e, { key: B }, [
              ue.separator ? (p(), w("div", Sf)) : (p(), w("button", {
                key: 1,
                type: "button",
                class: "flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-text-primary hover:bg-bg-primary disabled:cursor-not-allowed disabled:opacity-50",
                disabled: ue.disabled,
                onClick: (Z) => $(ue, Z)
              }, [
                ue.icon ? (p(), w("i", {
                  key: 0,
                  class: me(ue.icon)
                }, null, 2)) : X("", !0),
                _("span", null, he(ue.label), 1)
              ], 8, Mf))
            ], 64))), 128))
          ], 2)) : X("", !0)
        ]),
        _: 1
      })
    ], 2)), [
      [L, O]
    ]);
  }
});
function Ef(e, n, t) {
  let a = ee(t == null ? void 0 : t.value), r = k(() => e.value !== void 0);
  return [k(() => r.value ? e.value : a.value), function(l) {
    return r.value || (a.value = l), n == null ? void 0 : n(l);
  }];
}
function To(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((n) => setTimeout(() => {
    throw n;
  }));
}
function pr() {
  let e = [], n = { addEventListener(t, a, r, l) {
    return t.addEventListener(a, r, l), n.add(() => t.removeEventListener(a, r, l));
  }, requestAnimationFrame(...t) {
    let a = requestAnimationFrame(...t);
    n.add(() => cancelAnimationFrame(a));
  }, nextFrame(...t) {
    n.requestAnimationFrame(() => {
      n.requestAnimationFrame(...t);
    });
  }, setTimeout(...t) {
    let a = setTimeout(...t);
    n.add(() => clearTimeout(a));
  }, microTask(...t) {
    let a = { current: !0 };
    return To(() => {
      a.current && t[0]();
    }), n.add(() => {
      a.current = !1;
    });
  }, style(t, a, r) {
    let l = t.style.getPropertyValue(a);
    return Object.assign(t.style, { [a]: r }), this.add(() => {
      Object.assign(t.style, { [a]: l });
    });
  }, group(t) {
    let a = pr();
    return t(a), this.add(() => a.dispose());
  }, add(t) {
    return e.push(t), () => {
      let a = e.indexOf(t);
      if (a >= 0) for (let r of e.splice(a, 1)) r();
    };
  }, dispose() {
    for (let t of e.splice(0)) t();
  } };
  return n;
}
var Xs;
let Pf = Symbol("headlessui.useid"), $f = 0;
const hn = (Xs = Xa.useId) != null ? Xs : function() {
  return Xa.inject(Pf, () => `${++$f}`)();
};
function ze(e) {
  var n;
  if (e == null || e.value == null) return null;
  let t = (n = e.value.$el) != null ? n : e.value;
  return t instanceof Node ? t : null;
}
function Ct(e, n, ...t) {
  if (e in n) {
    let r = n[e];
    return typeof r == "function" ? r(...t) : r;
  }
  let a = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((r) => `"${r}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(a, Ct), a;
}
var Af = Object.defineProperty, Tf = (e, n, t) => n in e ? Af(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, Qs = (e, n, t) => (Tf(e, typeof n != "symbol" ? n + "" : n, t), t);
let Df = class {
  constructor() {
    Qs(this, "current", this.detect()), Qs(this, "currentId", 0);
  }
  set(n) {
    this.current !== n && (this.currentId = 0, this.current = n);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, vr = new Df();
function Fa(e) {
  if (vr.isServer) return null;
  if (e instanceof Node) return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let n = ze(e);
    if (n) return n.ownerDocument;
  }
  return document;
}
let Ql = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Un = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(Un || {}), pu = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(pu || {}), Rf = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Rf || {});
function Of(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Ql)).sort((n, t) => Math.sign((n.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Do = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Do || {});
function vu(e, n = 0) {
  var t;
  return e === ((t = Fa(e)) == null ? void 0 : t.body) ? !1 : Ct(n, { 0() {
    return e.matches(Ql);
  }, 1() {
    let a = e;
    for (; a !== null; ) {
      if (a.matches(Ql)) return !0;
      a = a.parentElement;
    }
    return !1;
  } });
}
var If = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(If || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function ca(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let Ff = ["textarea", "input"].join(",");
function Lf(e) {
  var n, t;
  return (t = (n = e == null ? void 0 : e.matches) == null ? void 0 : n.call(e, Ff)) != null ? t : !1;
}
function gu(e, n = (t) => t) {
  return e.slice().sort((t, a) => {
    let r = n(t), l = n(a);
    if (r === null || l === null) return 0;
    let o = r.compareDocumentPosition(l);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Br(e, n, { sorted: t = !0, relativeTo: a = null, skipElements: r = [] } = {}) {
  var l;
  let o = (l = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? l : document, i = Array.isArray(e) ? t ? gu(e) : e : Of(e);
  r.length > 0 && i.length > 1 && (i = i.filter((y) => !r.includes(y))), a = a ?? o.activeElement;
  let s = (() => {
    if (n & 5) return 1;
    if (n & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = (() => {
    if (n & 1) return 0;
    if (n & 2) return Math.max(0, i.indexOf(a)) - 1;
    if (n & 4) return Math.max(0, i.indexOf(a)) + 1;
    if (n & 8) return i.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = n & 32 ? { preventScroll: !0 } : {}, f = 0, d = i.length, m;
  do {
    if (f >= d || f + d <= 0) return 0;
    let y = u + f;
    if (n & 16) y = (y + d) % d;
    else {
      if (y < 0) return 3;
      if (y >= d) return 1;
    }
    m = i[y], m == null || m.focus(c), f += s;
  } while (m !== o.activeElement);
  return n & 6 && Lf(m) && m.select(), 2;
}
function hu() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Nf() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Vf() {
  return hu() || Nf();
}
function Cr(e, n, t) {
  vr.isServer || Zt((a) => {
    document.addEventListener(e, n, t), a(() => document.removeEventListener(e, n, t));
  });
}
function yu(e, n, t) {
  vr.isServer || Zt((a) => {
    window.addEventListener(e, n, t), a(() => window.removeEventListener(e, n, t));
  });
}
function wu(e, n, t = k(() => !0)) {
  function a(l, o) {
    if (!t.value || l.defaultPrevented) return;
    let i = o(l);
    if (i === null || !i.getRootNode().contains(i)) return;
    let s = function u(c) {
      return typeof c == "function" ? u(c()) : Array.isArray(c) || c instanceof Set ? c : [c];
    }(e);
    for (let u of s) {
      if (u === null) continue;
      let c = u instanceof HTMLElement ? u : ze(u);
      if (c != null && c.contains(i) || l.composed && l.composedPath().includes(c)) return;
    }
    return !vu(i, Do.Loose) && i.tabIndex !== -1 && l.preventDefault(), n(l, i);
  }
  let r = ee(null);
  Cr("pointerdown", (l) => {
    var o, i;
    t.value && (r.value = ((i = (o = l.composedPath) == null ? void 0 : o.call(l)) == null ? void 0 : i[0]) || l.target);
  }, !0), Cr("mousedown", (l) => {
    var o, i;
    t.value && (r.value = ((i = (o = l.composedPath) == null ? void 0 : o.call(l)) == null ? void 0 : i[0]) || l.target);
  }, !0), Cr("click", (l) => {
    Vf() || r.value && (a(l, () => r.value), r.value = null);
  }, !0), Cr("touchend", (l) => a(l, () => l.target instanceof HTMLElement ? l.target : null), !0), yu("blur", (l) => a(l, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Js(e, n) {
  if (e) return e;
  let t = n ?? "button";
  if (typeof t == "string" && t.toLowerCase() === "button") return "button";
}
function Bf(e, n) {
  let t = ee(Js(e.value.type, e.value.as));
  return He(() => {
    t.value = Js(e.value.type, e.value.as);
  }), Zt(() => {
    var a;
    t.value || ze(n) && ze(n) instanceof HTMLButtonElement && !((a = ze(n)) != null && a.hasAttribute("type")) && (t.value = "button");
  }), t;
}
function ei(e) {
  return [e.screenX, e.screenY];
}
function Hf() {
  let e = ee([-1, -1]);
  return { wasMoved(n) {
    let t = ei(n);
    return e.value[0] === t[0] && e.value[1] === t[1] ? !1 : (e.value = t, !0);
  }, update(n) {
    e.value = ei(n);
  } };
}
var Pa = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Pa || {}), Yn = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Yn || {});
function Mt({ visible: e = !0, features: n = 0, ourProps: t, theirProps: a, ...r }) {
  var l;
  let o = _u(a, t), i = Object.assign(r, { props: o });
  if (e || n & 2 && o.static) return Cl(i);
  if (n & 1) {
    let s = (l = o.unmount) == null || l ? 0 : 1;
    return Ct(s, { 0() {
      return null;
    }, 1() {
      return Cl({ ...r, props: { ...o, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Cl(i);
}
function Cl({ props: e, attrs: n, slots: t, slot: a, name: r }) {
  var l, o;
  let { as: i, ...s } = Ro(e, ["unmount", "static"]), u = (l = t.default) == null ? void 0 : l.call(t, a), c = {};
  if (a) {
    let f = !1, d = [];
    for (let [m, y] of Object.entries(a)) typeof y == "boolean" && (f = !0), y === !0 && d.push(m);
    f && (c["data-headlessui-state"] = d.join(" "));
  }
  if (i === "template") {
    if (u = bu(u ?? []), Object.keys(s).length > 0 || Object.keys(n).length > 0) {
      let [f, ...d] = u ?? [];
      if (!Uf(f) || d.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${r} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(s).concat(Object.keys(n)).map((v) => v.trim()).filter((v, S, g) => g.indexOf(v) === S).sort((v, S) => v.localeCompare(S)).map((v) => `  - ${v}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((v) => `  - ${v}`).join(`
`)].join(`
`));
      let m = _u((o = f.props) != null ? o : {}, s, c), y = kc(f, m, !0);
      for (let v in m) v.startsWith("on") && (y.props || (y.props = {}), y.props[v] = m[v]);
      return y;
    }
    return Array.isArray(u) && u.length === 1 ? u[0] : u;
  }
  return je(i, Object.assign({}, s, c), { default: () => u });
}
function bu(e) {
  return e.flatMap((n) => n.type === _e ? bu(n.children) : [n]);
}
function _u(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let n = {}, t = {};
  for (let a of e) for (let r in a) r.startsWith("on") && typeof a[r] == "function" ? (t[r] != null || (t[r] = []), t[r].push(a[r])) : n[r] = a[r];
  if (n.disabled || n["aria-disabled"]) return Object.assign(n, Object.fromEntries(Object.keys(t).map((a) => [a, void 0])));
  for (let a in t) Object.assign(n, { [a](r, ...l) {
    let o = t[a];
    for (let i of o) {
      if (r instanceof Event && r.defaultPrevented) return;
      i(r, ...l);
    }
  } });
  return n;
}
function zf(e) {
  let n = Object.assign({}, e);
  for (let t in n) n[t] === void 0 && delete n[t];
  return n;
}
function Ro(e, n = []) {
  let t = Object.assign({}, e);
  for (let a of n) a in t && delete t[a];
  return t;
}
function Uf(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var rr = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(rr || {});
let Ur = Ce({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: n, attrs: t }) {
  return () => {
    var a;
    let { features: r, ...l } = e, o = { "aria-hidden": (r & 2) === 2 ? !0 : (a = l["aria-hidden"]) != null ? a : void 0, hidden: (r & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
    return Mt({ ourProps: o, theirProps: l, slot: {}, attrs: t, slots: n, name: "Hidden" });
  };
} }), xu = Symbol("Context");
var $t = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($t || {});
function Yf() {
  return tl() !== null;
}
function tl() {
  return Ft(xu, null);
}
function ku(e) {
  pn(xu, e);
}
var ht = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(ht || {});
function jf(e) {
  function n() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", n));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", n), n());
}
let sa = [];
jf(() => {
  function e(n) {
    n.target instanceof HTMLElement && n.target !== document.body && sa[0] !== n.target && (sa.unshift(n.target), sa = sa.filter((t) => t != null && t.isConnected), sa.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function Zf(e) {
  throw new Error("Unexpected object: " + e);
}
var Nt = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Nt || {});
function Gf(e, n) {
  let t = n.resolveItems();
  if (t.length <= 0) return null;
  let a = n.resolveActiveIndex(), r = a ?? -1;
  switch (e.focus) {
    case 0: {
      for (let l = 0; l < t.length; ++l) if (!n.resolveDisabled(t[l], l, t)) return l;
      return a;
    }
    case 1: {
      r === -1 && (r = t.length);
      for (let l = r - 1; l >= 0; --l) if (!n.resolveDisabled(t[l], l, t)) return l;
      return a;
    }
    case 2: {
      for (let l = r + 1; l < t.length; ++l) if (!n.resolveDisabled(t[l], l, t)) return l;
      return a;
    }
    case 3: {
      for (let l = t.length - 1; l >= 0; --l) if (!n.resolveDisabled(t[l], l, t)) return l;
      return a;
    }
    case 4: {
      for (let l = 0; l < t.length; ++l) if (n.resolveId(t[l], l, t) === e.id) return l;
      return a;
    }
    case 5:
      return null;
    default:
      Zf(e);
  }
}
function Cu(e = {}, n = null, t = []) {
  for (let [a, r] of Object.entries(e)) Mu(t, Su(n, a), r);
  return t;
}
function Su(e, n) {
  return e ? e + "[" + n + "]" : n;
}
function Mu(e, n, t) {
  if (Array.isArray(t)) for (let [a, r] of t.entries()) Mu(e, Su(n, a.toString()), r);
  else t instanceof Date ? e.push([n, t.toISOString()]) : typeof t == "boolean" ? e.push([n, t ? "1" : "0"]) : typeof t == "string" ? e.push([n, t]) : typeof t == "number" ? e.push([n, `${t}`]) : t == null ? e.push([n, ""]) : Cu(t, n, e);
}
function Eu(e, n, t, a) {
  vr.isServer || Zt((r) => {
    e = e ?? window, e.addEventListener(n, t, a), r(() => e.removeEventListener(n, t, a));
  });
}
var qa = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(qa || {});
function Wf() {
  let e = ee(0);
  return yu("keydown", (n) => {
    n.key === "Tab" && (e.value = n.shiftKey ? 1 : 0);
  }), e;
}
function Pu(e) {
  if (!e) return /* @__PURE__ */ new Set();
  if (typeof e == "function") return new Set(e());
  let n = /* @__PURE__ */ new Set();
  for (let t of e.value) {
    let a = ze(t);
    a instanceof HTMLElement && n.add(a);
  }
  return n;
}
var $u = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))($u || {});
let Ha = Object.assign(Ce({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: ee(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(e, { attrs: n, slots: t, expose: a }) {
  let r = ee(null);
  a({ el: r, $el: r });
  let l = k(() => Fa(r)), o = ee(!1);
  He(() => o.value = !0), wt(() => o.value = !1), Kf({ ownerDocument: l }, k(() => o.value && !!(e.features & 16)));
  let i = Xf({ ownerDocument: l, container: r, initialFocus: k(() => e.initialFocus) }, k(() => o.value && !!(e.features & 2)));
  Qf({ ownerDocument: l, container: r, containers: e.containers, previousActiveElement: i }, k(() => o.value && !!(e.features & 8)));
  let s = Wf();
  function u(m) {
    let y = ze(r);
    y && ((v) => v())(() => {
      Ct(s.value, { [qa.Forwards]: () => {
        Br(y, Un.First, { skipElements: [m.relatedTarget] });
      }, [qa.Backwards]: () => {
        Br(y, Un.Last, { skipElements: [m.relatedTarget] });
      } });
    });
  }
  let c = ee(!1);
  function f(m) {
    m.key === "Tab" && (c.value = !0, requestAnimationFrame(() => {
      c.value = !1;
    }));
  }
  function d(m) {
    if (!o.value) return;
    let y = Pu(e.containers);
    ze(r) instanceof HTMLElement && y.add(ze(r));
    let v = m.relatedTarget;
    v instanceof HTMLElement && v.dataset.headlessuiFocusGuard !== "true" && (Au(y, v) || (c.value ? Br(ze(r), Ct(s.value, { [qa.Forwards]: () => Un.Next, [qa.Backwards]: () => Un.Previous }) | Un.WrapAround, { relativeTo: m.target }) : m.target instanceof HTMLElement && ca(m.target)));
  }
  return () => {
    let m = {}, y = { ref: r, onKeydown: f, onFocusout: d }, { features: v, initialFocus: S, containers: g, ...b } = e;
    return je(_e, [!!(v & 4) && je(Ur, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: rr.Focusable }), Mt({ ourProps: y, theirProps: { ...n, ...b }, slot: m, attrs: n, slots: t, name: "FocusTrap" }), !!(v & 4) && je(Ur, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: rr.Focusable })]);
  };
} }), { features: $u });
function qf(e) {
  let n = ee(sa.slice());
  return Be([e], ([t], [a]) => {
    a === !0 && t === !1 ? To(() => {
      n.value.splice(0);
    }) : a === !1 && t === !0 && (n.value = sa.slice());
  }, { flush: "post" }), () => {
    var t;
    return (t = n.value.find((a) => a != null && a.isConnected)) != null ? t : null;
  };
}
function Kf({ ownerDocument: e }, n) {
  let t = qf(n);
  He(() => {
    Zt(() => {
      var a, r;
      n.value || ((a = e.value) == null ? void 0 : a.activeElement) === ((r = e.value) == null ? void 0 : r.body) && ca(t());
    }, { flush: "post" });
  }), wt(() => {
    n.value && ca(t());
  });
}
function Xf({ ownerDocument: e, container: n, initialFocus: t }, a) {
  let r = ee(null), l = ee(!1);
  return He(() => l.value = !0), wt(() => l.value = !1), He(() => {
    Be([n, t, a], (o, i) => {
      if (o.every((u, c) => (i == null ? void 0 : i[c]) === u) || !a.value) return;
      let s = ze(n);
      s && To(() => {
        var u, c;
        if (!l.value) return;
        let f = ze(t), d = (u = e.value) == null ? void 0 : u.activeElement;
        if (f) {
          if (f === d) {
            r.value = d;
            return;
          }
        } else if (s.contains(d)) {
          r.value = d;
          return;
        }
        f ? ca(f) : Br(s, Un.First | Un.NoScroll) === pu.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), r.value = (c = e.value) == null ? void 0 : c.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), r;
}
function Qf({ ownerDocument: e, container: n, containers: t, previousActiveElement: a }, r) {
  var l;
  Eu((l = e.value) == null ? void 0 : l.defaultView, "focus", (o) => {
    if (!r.value) return;
    let i = Pu(t);
    ze(n) instanceof HTMLElement && i.add(ze(n));
    let s = a.value;
    if (!s) return;
    let u = o.target;
    u && u instanceof HTMLElement ? Au(i, u) ? (a.value = u, ca(u)) : (o.preventDefault(), o.stopPropagation(), ca(s)) : ca(a.value);
  }, !0);
}
function Au(e, n) {
  for (let t of e) if (t.contains(n)) return !0;
  return !1;
}
function Jf(e) {
  let n = mr(e.getSnapshot());
  return wt(e.subscribe(() => {
    n.value = e.getSnapshot();
  })), n;
}
function em(e, n) {
  let t = e(), a = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return t;
  }, subscribe(r) {
    return a.add(r), () => a.delete(r);
  }, dispatch(r, ...l) {
    let o = n[r].call(t, ...l);
    o && (t = o, a.forEach((i) => i()));
  } };
}
function tm() {
  let e;
  return { before({ doc: n }) {
    var t;
    let a = n.documentElement;
    e = ((t = n.defaultView) != null ? t : window).innerWidth - a.clientWidth;
  }, after({ doc: n, d: t }) {
    let a = n.documentElement, r = a.clientWidth - a.offsetWidth, l = e - r;
    t.style(a, "paddingRight", `${l}px`);
  } };
}
function nm() {
  return hu() ? { before({ doc: e, d: n, meta: t }) {
    function a(r) {
      return t.containers.flatMap((l) => l()).some((l) => l.contains(r));
    }
    n.microTask(() => {
      var r;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let i = pr();
        i.style(e.documentElement, "scrollBehavior", "auto"), n.add(() => n.microTask(() => i.dispose()));
      }
      let l = (r = window.scrollY) != null ? r : window.pageYOffset, o = null;
      n.addEventListener(e, "click", (i) => {
        if (i.target instanceof HTMLElement) try {
          let s = i.target.closest("a");
          if (!s) return;
          let { hash: u } = new URL(s.href), c = e.querySelector(u);
          c && !a(c) && (o = c);
        } catch {
        }
      }, !0), n.addEventListener(e, "touchstart", (i) => {
        if (i.target instanceof HTMLElement) if (a(i.target)) {
          let s = i.target;
          for (; s.parentElement && a(s.parentElement); ) s = s.parentElement;
          n.style(s, "overscrollBehavior", "contain");
        } else n.style(i.target, "touchAction", "none");
      }), n.addEventListener(e, "touchmove", (i) => {
        if (i.target instanceof HTMLElement) {
          if (i.target.tagName === "INPUT") return;
          if (a(i.target)) {
            let s = i.target;
            for (; s.parentElement && s.dataset.headlessuiPortal !== "" && !(s.scrollHeight > s.clientHeight || s.scrollWidth > s.clientWidth); ) s = s.parentElement;
            s.dataset.headlessuiPortal === "" && i.preventDefault();
          } else i.preventDefault();
        }
      }, { passive: !1 }), n.add(() => {
        var i;
        let s = (i = window.scrollY) != null ? i : window.pageYOffset;
        l !== s && window.scrollTo(0, l), o && o.isConnected && (o.scrollIntoView({ block: "nearest" }), o = null);
      });
    });
  } } : {};
}
function am() {
  return { before({ doc: e, d: n }) {
    n.style(e.documentElement, "overflow", "hidden");
  } };
}
function rm(e) {
  let n = {};
  for (let t of e) Object.assign(n, t(n));
  return n;
}
let ia = em(() => /* @__PURE__ */ new Map(), { PUSH(e, n) {
  var t;
  let a = (t = this.get(e)) != null ? t : { doc: e, count: 0, d: pr(), meta: /* @__PURE__ */ new Set() };
  return a.count++, a.meta.add(n), this.set(e, a), this;
}, POP(e, n) {
  let t = this.get(e);
  return t && (t.count--, t.meta.delete(n)), this;
}, SCROLL_PREVENT({ doc: e, d: n, meta: t }) {
  let a = { doc: e, d: n, meta: rm(t) }, r = [nm(), tm(), am()];
  r.forEach(({ before: l }) => l == null ? void 0 : l(a)), r.forEach(({ after: l }) => l == null ? void 0 : l(a));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
ia.subscribe(() => {
  let e = ia.getSnapshot(), n = /* @__PURE__ */ new Map();
  for (let [t] of e) n.set(t, t.documentElement.style.overflow);
  for (let t of e.values()) {
    let a = n.get(t.doc) === "hidden", r = t.count !== 0;
    (r && !a || !r && a) && ia.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && ia.dispatch("TEARDOWN", t);
  }
});
function lm(e, n, t) {
  let a = Jf(ia), r = k(() => {
    let l = e.value ? a.value.get(e.value) : void 0;
    return l ? l.count > 0 : !1;
  });
  return Be([e, n], ([l, o], [i], s) => {
    if (!l || !o) return;
    ia.dispatch("PUSH", l, t);
    let u = !1;
    s(() => {
      u || (ia.dispatch("POP", i ?? l, t), u = !0);
    });
  }, { immediate: !0 }), r;
}
let Sl = /* @__PURE__ */ new Map(), za = /* @__PURE__ */ new Map();
function ti(e, n = ee(!0)) {
  Zt((t) => {
    var a;
    if (!n.value) return;
    let r = ze(e);
    if (!r) return;
    t(function() {
      var o;
      if (!r) return;
      let i = (o = za.get(r)) != null ? o : 1;
      if (i === 1 ? za.delete(r) : za.set(r, i - 1), i !== 1) return;
      let s = Sl.get(r);
      s && (s["aria-hidden"] === null ? r.removeAttribute("aria-hidden") : r.setAttribute("aria-hidden", s["aria-hidden"]), r.inert = s.inert, Sl.delete(r));
    });
    let l = (a = za.get(r)) != null ? a : 0;
    za.set(r, l + 1), l === 0 && (Sl.set(r, { "aria-hidden": r.getAttribute("aria-hidden"), inert: r.inert }), r.setAttribute("aria-hidden", "true"), r.inert = !0);
  });
}
function om({ defaultContainers: e = [], portals: n, mainTreeNodeRef: t } = {}) {
  let a = ee(null), r = Fa(a);
  function l() {
    var o, i, s;
    let u = [];
    for (let c of e) c !== null && (c instanceof HTMLElement ? u.push(c) : "value" in c && c.value instanceof HTMLElement && u.push(c.value));
    if (n != null && n.value) for (let c of n.value) u.push(c);
    for (let c of (o = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? o : []) c !== document.body && c !== document.head && c instanceof HTMLElement && c.id !== "headlessui-portal-root" && (c.contains(ze(a)) || c.contains((s = (i = ze(a)) == null ? void 0 : i.getRootNode()) == null ? void 0 : s.host) || u.some((f) => c.contains(f)) || u.push(c));
    return u;
  }
  return { resolveContainers: l, contains(o) {
    return l().some((i) => i.contains(o));
  }, mainTreeNodeRef: a, MainTreeNode() {
    return t != null ? null : je(Ur, { features: rr.Hidden, ref: a });
  } };
}
let Tu = Symbol("ForcePortalRootContext");
function sm() {
  return Ft(Tu, !1);
}
let Jl = Ce({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(e, { slots: n, attrs: t }) {
  return pn(Tu, e.force), () => {
    let { force: a, ...r } = e;
    return Mt({ theirProps: r, ourProps: {}, slot: {}, slots: n, attrs: t, name: "ForcePortalRoot" });
  };
} }), Du = Symbol("StackContext");
var eo = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(eo || {});
function im() {
  return Ft(Du, () => {
  });
}
function um({ type: e, enabled: n, element: t, onUpdate: a }) {
  let r = im();
  function l(...o) {
    a == null || a(...o), r(...o);
  }
  He(() => {
    Be(n, (o, i) => {
      o ? l(0, e, t) : i === !0 && l(1, e, t);
    }, { immediate: !0, flush: "sync" });
  }), wt(() => {
    n.value && l(1, e, t);
  }), pn(Du, l);
}
let Ru = Symbol("DescriptionContext");
function dm() {
  let e = Ft(Ru, null);
  if (e === null) throw new Error("Missing parent");
  return e;
}
function cm({ slot: e = ee({}), name: n = "Description", props: t = {} } = {}) {
  let a = ee([]);
  function r(l) {
    return a.value.push(l), () => {
      let o = a.value.indexOf(l);
      o !== -1 && a.value.splice(o, 1);
    };
  }
  return pn(Ru, { register: r, slot: e, name: n, props: t }), k(() => a.value.length > 0 ? a.value.join(" ") : void 0);
}
Ce({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t }) {
  var a;
  let r = (a = e.id) != null ? a : `headlessui-description-${hn()}`, l = dm();
  return He(() => wt(l.register(r))), () => {
    let { name: o = "Description", slot: i = ee({}), props: s = {} } = l, { ...u } = e, c = { ...Object.entries(s).reduce((f, [d, m]) => Object.assign(f, { [d]: D(m) }), {}), id: r };
    return Mt({ ourProps: c, theirProps: u, slot: i.value, attrs: n, slots: t, name: o });
  };
} });
function fm(e) {
  let n = Fa(e);
  if (!n) {
    if (e === null) return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let t = n.getElementById("headlessui-portal-root");
  if (t) return t;
  let a = n.createElement("div");
  return a.setAttribute("id", "headlessui-portal-root"), n.body.appendChild(a);
}
const to = /* @__PURE__ */ new WeakMap();
function mm(e) {
  var n;
  return (n = to.get(e)) != null ? n : 0;
}
function ni(e, n) {
  let t = n(mm(e));
  return t <= 0 ? to.delete(e) : to.set(e, t), t;
}
let Ou = Ce({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: n, attrs: t }) {
  let a = ee(null), r = k(() => Fa(a)), l = sm(), o = Ft(Iu, null), i = ee(l === !0 || o == null ? fm(a.value) : o.resolveTarget());
  i.value && ni(i.value, (d) => d + 1);
  let s = ee(!1);
  He(() => {
    s.value = !0;
  }), Zt(() => {
    l || o != null && (i.value = o.resolveTarget());
  });
  let u = Ft(no, null), c = !1, f = su();
  return Be(a, () => {
    if (c || !u) return;
    let d = ze(a);
    d && (wt(u.register(d), f), c = !0);
  }), wt(() => {
    var d, m;
    let y = (d = r.value) == null ? void 0 : d.getElementById("headlessui-portal-root");
    !y || i.value !== y || ni(i.value, (v) => v - 1) || i.value.children.length > 0 || (m = i.value.parentElement) == null || m.removeChild(i.value);
  }), () => {
    if (!s.value || i.value === null) return null;
    let d = { ref: a, "data-headlessui-portal": "" };
    return je(Jr, { to: i.value }, Mt({ ourProps: d, theirProps: e, slot: {}, attrs: t, slots: n, name: "Portal" }));
  };
} }), no = Symbol("PortalParentContext");
function pm() {
  let e = Ft(no, null), n = ee([]);
  function t(l) {
    return n.value.push(l), e && e.register(l), () => a(l);
  }
  function a(l) {
    let o = n.value.indexOf(l);
    o !== -1 && n.value.splice(o, 1), e && e.unregister(l);
  }
  let r = { register: t, unregister: a, portals: n };
  return [n, Ce({ name: "PortalWrapper", setup(l, { slots: o }) {
    return pn(no, r), () => {
      var i;
      return (i = o.default) == null ? void 0 : i.call(o);
    };
  } })];
}
let Iu = Symbol("PortalGroupContext"), vm = Ce({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: n, slots: t }) {
  let a = qn({ resolveTarget() {
    return e.target;
  } });
  return pn(Iu, a), () => {
    let { target: r, ...l } = e;
    return Mt({ theirProps: l, ourProps: {}, slot: {}, attrs: n, slots: t, name: "PortalGroup" });
  };
} });
var gm = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(gm || {});
let ao = Symbol("DialogContext");
function gr(e) {
  let n = Ft(ao, null);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, gr), t;
  }
  return n;
}
let Sr = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", hm = Ce({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: Sr }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (e) => !0 }, setup(e, { emit: n, attrs: t, slots: a, expose: r }) {
  var l, o;
  let i = (l = e.id) != null ? l : `headlessui-dialog-${hn()}`, s = ee(!1);
  He(() => {
    s.value = !0;
  });
  let u = !1, c = k(() => e.role === "dialog" || e.role === "alertdialog" ? e.role : (u || (u = !0, console.warn(`Invalid role [${c}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), f = ee(0), d = tl(), m = k(() => e.open === Sr && d !== null ? (d.value & $t.Open) === $t.Open : e.open), y = ee(null), v = k(() => Fa(y));
  if (r({ el: y, $el: y }), !(e.open !== Sr || d !== null)) throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof m.value != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${m.value === Sr ? void 0 : e.open}`);
  let S = k(() => s.value && m.value ? 0 : 1), g = k(() => S.value === 0), b = k(() => f.value > 1), h = Ft(ao, null) !== null, [x, F] = pm(), { resolveContainers: C, mainTreeNodeRef: A, MainTreeNode: O } = om({ portals: x, defaultContainers: [k(() => {
    var le;
    return (le = M.panelRef.value) != null ? le : y.value;
  })] }), $ = k(() => b.value ? "parent" : "leaf"), L = k(() => d !== null ? (d.value & $t.Closing) === $t.Closing : !1), N = k(() => h || L.value ? !1 : g.value), K = k(() => {
    var le, j, q;
    return (q = Array.from((j = (le = v.value) == null ? void 0 : le.querySelectorAll("body > *")) != null ? j : []).find((P) => P.id === "headlessui-portal-root" ? !1 : P.contains(ze(A)) && P instanceof HTMLElement)) != null ? q : null;
  });
  ti(K, N);
  let ue = k(() => b.value ? !0 : g.value), B = k(() => {
    var le, j, q;
    return (q = Array.from((j = (le = v.value) == null ? void 0 : le.querySelectorAll("[data-headlessui-portal]")) != null ? j : []).find((P) => P.contains(ze(A)) && P instanceof HTMLElement)) != null ? q : null;
  });
  ti(B, ue), um({ type: "Dialog", enabled: k(() => S.value === 0), element: y, onUpdate: (le, j) => {
    if (j === "Dialog") return Ct(le, { [eo.Add]: () => f.value += 1, [eo.Remove]: () => f.value -= 1 });
  } });
  let Z = cm({ name: "DialogDescription", slot: k(() => ({ open: m.value })) }), R = ee(null), M = { titleId: R, panelRef: ee(null), dialogState: S, setTitleId(le) {
    R.value !== le && (R.value = le);
  }, close() {
    n("close", !1);
  } };
  pn(ao, M);
  let z = k(() => !(!g.value || b.value));
  wu(C, (le, j) => {
    le.preventDefault(), M.close(), it(() => j == null ? void 0 : j.focus());
  }, z);
  let J = k(() => !(b.value || S.value !== 0));
  Eu((o = v.value) == null ? void 0 : o.defaultView, "keydown", (le) => {
    J.value && (le.defaultPrevented || le.key === ht.Escape && (le.preventDefault(), le.stopPropagation(), M.close()));
  });
  let H = k(() => !(L.value || S.value !== 0 || h));
  return lm(v, H, (le) => {
    var j;
    return { containers: [...(j = le.containers) != null ? j : [], C] };
  }), Zt((le) => {
    if (S.value !== 0) return;
    let j = ze(y);
    if (!j) return;
    let q = new ResizeObserver((P) => {
      for (let Q of P) {
        let ce = Q.target.getBoundingClientRect();
        ce.x === 0 && ce.y === 0 && ce.width === 0 && ce.height === 0 && M.close();
      }
    });
    q.observe(j), le(() => q.disconnect());
  }), () => {
    let { open: le, initialFocus: j, ...q } = e, P = { ...t, ref: y, id: i, role: c.value, "aria-modal": S.value === 0 ? !0 : void 0, "aria-labelledby": R.value, "aria-describedby": Z.value }, Q = { open: S.value === 0 };
    return je(Jl, { force: !0 }, () => [je(Ou, () => je(vm, { target: y.value }, () => je(Jl, { force: !1 }, () => je(Ha, { initialFocus: j, containers: C, features: g.value ? Ct($.value, { parent: Ha.features.RestoreFocus, leaf: Ha.features.All & ~Ha.features.FocusLock }) : Ha.features.None }, () => je(F, {}, () => Mt({ ourProps: P, theirProps: { ...q, ...t }, slot: Q, attrs: t, slots: a, visible: S.value === 0, features: Pa.RenderStrategy | Pa.Static, name: "Dialog" })))))), je(O)]);
  };
} });
Ce({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t }) {
  var a;
  let r = (a = e.id) != null ? a : `headlessui-dialog-overlay-${hn()}`, l = gr("DialogOverlay");
  function o(i) {
    i.target === i.currentTarget && (i.preventDefault(), i.stopPropagation(), l.close());
  }
  return () => {
    let { ...i } = e;
    return Mt({ ourProps: { id: r, "aria-hidden": !0, onClick: o }, theirProps: i, slot: { open: l.dialogState.value === 0 }, attrs: n, slots: t, name: "DialogOverlay" });
  };
} });
Ce({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: n, slots: t, expose: a }) {
  var r;
  let l = (r = e.id) != null ? r : `headlessui-dialog-backdrop-${hn()}`, o = gr("DialogBackdrop"), i = ee(null);
  return a({ el: i, $el: i }), He(() => {
    if (o.panelRef.value === null) throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...s } = e, u = { id: l, ref: i, "aria-hidden": !0 };
    return je(Jl, { force: !0 }, () => je(Ou, () => Mt({ ourProps: u, theirProps: { ...n, ...s }, slot: { open: o.dialogState.value === 0 }, attrs: n, slots: t, name: "DialogBackdrop" })));
  };
} });
let ym = Ce({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t, expose: a }) {
  var r;
  let l = (r = e.id) != null ? r : `headlessui-dialog-panel-${hn()}`, o = gr("DialogPanel");
  a({ el: o.panelRef, $el: o.panelRef });
  function i(s) {
    s.stopPropagation();
  }
  return () => {
    let { ...s } = e, u = { id: l, ref: o.panelRef, onClick: i };
    return Mt({ ourProps: u, theirProps: s, slot: { open: o.dialogState.value === 0 }, attrs: n, slots: t, name: "DialogPanel" });
  };
} }), wm = Ce({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t }) {
  var a;
  let r = (a = e.id) != null ? a : `headlessui-dialog-title-${hn()}`, l = gr("DialogTitle");
  return He(() => {
    l.setTitleId(r), wt(() => l.setTitleId(null));
  }), () => {
    let { ...o } = e;
    return Mt({ ourProps: { id: r }, theirProps: o, slot: { open: l.dialogState.value === 0 }, attrs: n, slots: t, name: "DialogTitle" });
  };
} }), ai = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function ri(e) {
  var n, t;
  let a = (n = e.innerText) != null ? n : "", r = e.cloneNode(!0);
  if (!(r instanceof HTMLElement)) return a;
  let l = !1;
  for (let i of r.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) i.remove(), l = !0;
  let o = l ? (t = r.innerText) != null ? t : "" : a;
  return ai.test(o) && (o = o.replace(ai, "")), o;
}
function bm(e) {
  let n = e.getAttribute("aria-label");
  if (typeof n == "string") return n.trim();
  let t = e.getAttribute("aria-labelledby");
  if (t) {
    let a = t.split(" ").map((r) => {
      let l = document.getElementById(r);
      if (l) {
        let o = l.getAttribute("aria-label");
        return typeof o == "string" ? o.trim() : ri(l).trim();
      }
      return null;
    }).filter(Boolean);
    if (a.length > 0) return a.join(", ");
  }
  return ri(e).trim();
}
function _m(e) {
  let n = ee(""), t = ee("");
  return () => {
    let a = ze(e);
    if (!a) return "";
    let r = a.innerText;
    if (n.value === r) return t.value;
    let l = bm(a).trim().toLowerCase();
    return n.value = r, t.value = l, l;
  };
}
function xm(e, n) {
  return e === n;
}
var km = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(km || {}), Cm = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Cm || {}), Sm = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Sm || {});
function Mm(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let Fu = Symbol("ListboxContext");
function hr(e) {
  let n = Ft(Fu, null);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, hr), t;
  }
  return n;
}
let Lu = Ce({ name: "Listbox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => xm }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: n, attrs: t, emit: a }) {
  let r = ee(1), l = ee(null), o = ee(null), i = ee(null), s = ee([]), u = ee(""), c = ee(null), f = ee(1);
  function d(h = (x) => x) {
    let x = c.value !== null ? s.value[c.value] : null, F = gu(h(s.value.slice()), (A) => ze(A.dataRef.domRef)), C = x ? F.indexOf(x) : null;
    return C === -1 && (C = null), { options: F, activeOptionIndex: C };
  }
  let m = k(() => e.multiple ? 1 : 0), [y, v] = Ef(k(() => e.modelValue), (h) => a("update:modelValue", h), k(() => e.defaultValue)), S = k(() => y.value === void 0 ? Ct(m.value, { 1: [], 0: void 0 }) : y.value), g = { listboxState: r, value: S, mode: m, compare(h, x) {
    if (typeof e.by == "string") {
      let F = e.by;
      return (h == null ? void 0 : h[F]) === (x == null ? void 0 : x[F]);
    }
    return e.by(h, x);
  }, orientation: k(() => e.horizontal ? "horizontal" : "vertical"), labelRef: l, buttonRef: o, optionsRef: i, disabled: k(() => e.disabled), options: s, searchQuery: u, activeOptionIndex: c, activationTrigger: f, closeListbox() {
    e.disabled || r.value !== 1 && (r.value = 1, c.value = null);
  }, openListbox() {
    e.disabled || r.value !== 0 && (r.value = 0);
  }, goToOption(h, x, F) {
    if (e.disabled || r.value === 1) return;
    let C = d(), A = Gf(h === Nt.Specific ? { focus: Nt.Specific, id: x } : { focus: h }, { resolveItems: () => C.options, resolveActiveIndex: () => C.activeOptionIndex, resolveId: (O) => O.id, resolveDisabled: (O) => O.dataRef.disabled });
    u.value = "", c.value = A, f.value = F ?? 1, s.value = C.options;
  }, search(h) {
    if (e.disabled || r.value === 1) return;
    let x = u.value !== "" ? 0 : 1;
    u.value += h.toLowerCase();
    let F = (c.value !== null ? s.value.slice(c.value + x).concat(s.value.slice(0, c.value + x)) : s.value).find((A) => A.dataRef.textValue.startsWith(u.value) && !A.dataRef.disabled), C = F ? s.value.indexOf(F) : -1;
    C === -1 || C === c.value || (c.value = C, f.value = 1);
  }, clearSearch() {
    e.disabled || r.value !== 1 && u.value !== "" && (u.value = "");
  }, registerOption(h, x) {
    let F = d((C) => [...C, { id: h, dataRef: x }]);
    s.value = F.options, c.value = F.activeOptionIndex;
  }, unregisterOption(h) {
    let x = d((F) => {
      let C = F.findIndex((A) => A.id === h);
      return C !== -1 && F.splice(C, 1), F;
    });
    s.value = x.options, c.value = x.activeOptionIndex, f.value = 1;
  }, theirOnChange(h) {
    e.disabled || v(h);
  }, select(h) {
    e.disabled || v(Ct(m.value, { 0: () => h, 1: () => {
      let x = ln(g.value.value).slice(), F = ln(h), C = x.findIndex((A) => g.compare(F, ln(A)));
      return C === -1 ? x.push(F) : x.splice(C, 1), x;
    } }));
  } };
  wu([o, i], (h, x) => {
    var F;
    g.closeListbox(), vu(x, Do.Loose) || (h.preventDefault(), (F = ze(o)) == null || F.focus());
  }, k(() => r.value === 0)), pn(Fu, g), ku(k(() => Ct(r.value, { 0: $t.Open, 1: $t.Closed })));
  let b = k(() => {
    var h;
    return (h = ze(o)) == null ? void 0 : h.closest("form");
  });
  return He(() => {
    Be([b], () => {
      if (!b.value || e.defaultValue === void 0) return;
      function h() {
        g.theirOnChange(e.defaultValue);
      }
      return b.value.addEventListener("reset", h), () => {
        var x;
        (x = b.value) == null || x.removeEventListener("reset", h);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: h, modelValue: x, disabled: F, form: C, ...A } = e, O = { open: r.value === 0, disabled: F, value: S.value };
    return je(_e, [...h != null && S.value != null ? Cu({ [h]: S.value }).map(([$, L]) => je(Ur, zf({ features: rr.Hidden, key: $, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: C, disabled: F, name: $, value: L }))) : [], Mt({ ourProps: {}, theirProps: { ...t, ...Ro(A, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: O, slots: n, attrs: t, name: "Listbox" })]);
  };
} });
Ce({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t }) {
  var a;
  let r = (a = e.id) != null ? a : `headlessui-listbox-label-${hn()}`, l = hr("ListboxLabel");
  function o() {
    var i;
    (i = ze(l.buttonRef)) == null || i.focus({ preventScroll: !0 });
  }
  return () => {
    let i = { open: l.listboxState.value === 0, disabled: l.disabled.value }, { ...s } = e, u = { id: r, ref: l.labelRef, onClick: o };
    return Mt({ ourProps: u, theirProps: s, slot: i, attrs: n, slots: t, name: "ListboxLabel" });
  };
} });
let Nu = Ce({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t, expose: a }) {
  var r;
  let l = (r = e.id) != null ? r : `headlessui-listbox-button-${hn()}`, o = hr("ListboxButton");
  a({ el: o.buttonRef, $el: o.buttonRef });
  function i(f) {
    switch (f.key) {
      case ht.Space:
      case ht.Enter:
      case ht.ArrowDown:
        f.preventDefault(), o.openListbox(), it(() => {
          var d;
          (d = ze(o.optionsRef)) == null || d.focus({ preventScroll: !0 }), o.value.value || o.goToOption(Nt.First);
        });
        break;
      case ht.ArrowUp:
        f.preventDefault(), o.openListbox(), it(() => {
          var d;
          (d = ze(o.optionsRef)) == null || d.focus({ preventScroll: !0 }), o.value.value || o.goToOption(Nt.Last);
        });
        break;
    }
  }
  function s(f) {
    switch (f.key) {
      case ht.Space:
        f.preventDefault();
        break;
    }
  }
  function u(f) {
    o.disabled.value || (o.listboxState.value === 0 ? (o.closeListbox(), it(() => {
      var d;
      return (d = ze(o.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    })) : (f.preventDefault(), o.openListbox(), Mm(() => {
      var d;
      return (d = ze(o.optionsRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    })));
  }
  let c = Bf(k(() => ({ as: e.as, type: n.type })), o.buttonRef);
  return () => {
    var f, d;
    let m = { open: o.listboxState.value === 0, disabled: o.disabled.value, value: o.value.value }, { ...y } = e, v = { ref: o.buttonRef, id: l, type: c.value, "aria-haspopup": "listbox", "aria-controls": (f = ze(o.optionsRef)) == null ? void 0 : f.id, "aria-expanded": o.listboxState.value === 0, "aria-labelledby": o.labelRef.value ? [(d = ze(o.labelRef)) == null ? void 0 : d.id, l].join(" ") : void 0, disabled: o.disabled.value === !0 ? !0 : void 0, onKeydown: i, onKeyup: s, onClick: u };
    return Mt({ ourProps: v, theirProps: y, slot: m, attrs: n, slots: t, name: "ListboxButton" });
  };
} }), Vu = Ce({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: n, slots: t, expose: a }) {
  var r;
  let l = (r = e.id) != null ? r : `headlessui-listbox-options-${hn()}`, o = hr("ListboxOptions"), i = ee(null);
  a({ el: o.optionsRef, $el: o.optionsRef });
  function s(f) {
    switch (i.value && clearTimeout(i.value), f.key) {
      case ht.Space:
        if (o.searchQuery.value !== "") return f.preventDefault(), f.stopPropagation(), o.search(f.key);
      case ht.Enter:
        if (f.preventDefault(), f.stopPropagation(), o.activeOptionIndex.value !== null) {
          let d = o.options.value[o.activeOptionIndex.value];
          o.select(d.dataRef.value);
        }
        o.mode.value === 0 && (o.closeListbox(), it(() => {
          var d;
          return (d = ze(o.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
        }));
        break;
      case Ct(o.orientation.value, { vertical: ht.ArrowDown, horizontal: ht.ArrowRight }):
        return f.preventDefault(), f.stopPropagation(), o.goToOption(Nt.Next);
      case Ct(o.orientation.value, { vertical: ht.ArrowUp, horizontal: ht.ArrowLeft }):
        return f.preventDefault(), f.stopPropagation(), o.goToOption(Nt.Previous);
      case ht.Home:
      case ht.PageUp:
        return f.preventDefault(), f.stopPropagation(), o.goToOption(Nt.First);
      case ht.End:
      case ht.PageDown:
        return f.preventDefault(), f.stopPropagation(), o.goToOption(Nt.Last);
      case ht.Escape:
        f.preventDefault(), f.stopPropagation(), o.closeListbox(), it(() => {
          var d;
          return (d = ze(o.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        break;
      case ht.Tab:
        f.preventDefault(), f.stopPropagation();
        break;
      default:
        f.key.length === 1 && (o.search(f.key), i.value = setTimeout(() => o.clearSearch(), 350));
        break;
    }
  }
  let u = tl(), c = k(() => u !== null ? (u.value & $t.Open) === $t.Open : o.listboxState.value === 0);
  return () => {
    var f, d;
    let m = { open: o.listboxState.value === 0 }, { ...y } = e, v = { "aria-activedescendant": o.activeOptionIndex.value === null || (f = o.options.value[o.activeOptionIndex.value]) == null ? void 0 : f.id, "aria-multiselectable": o.mode.value === 1 ? !0 : void 0, "aria-labelledby": (d = ze(o.buttonRef)) == null ? void 0 : d.id, "aria-orientation": o.orientation.value, id: l, onKeydown: s, role: "listbox", tabIndex: 0, ref: o.optionsRef };
    return Mt({ ourProps: v, theirProps: y, slot: m, attrs: n, slots: t, features: Pa.RenderStrategy | Pa.Static, visible: c.value, name: "ListboxOptions" });
  };
} }), Yr = Ce({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { slots: n, attrs: t, expose: a }) {
  var r;
  let l = (r = e.id) != null ? r : `headlessui-listbox-option-${hn()}`, o = hr("ListboxOption"), i = ee(null);
  a({ el: i, $el: i });
  let s = k(() => o.activeOptionIndex.value !== null ? o.options.value[o.activeOptionIndex.value].id === l : !1), u = k(() => Ct(o.mode.value, { 0: () => o.compare(ln(o.value.value), ln(e.value)), 1: () => ln(o.value.value).some((h) => o.compare(ln(h), ln(e.value))) })), c = k(() => Ct(o.mode.value, { 1: () => {
    var h;
    let x = ln(o.value.value);
    return ((h = o.options.value.find((F) => x.some((C) => o.compare(ln(C), ln(F.dataRef.value))))) == null ? void 0 : h.id) === l;
  }, 0: () => u.value })), f = _m(i), d = k(() => ({ disabled: e.disabled, value: e.value, get textValue() {
    return f();
  }, domRef: i }));
  He(() => o.registerOption(l, d)), wt(() => o.unregisterOption(l)), He(() => {
    Be([o.listboxState, u], () => {
      o.listboxState.value === 0 && u.value && Ct(o.mode.value, { 1: () => {
        c.value && o.goToOption(Nt.Specific, l);
      }, 0: () => {
        o.goToOption(Nt.Specific, l);
      } });
    }, { immediate: !0 });
  }), Zt(() => {
    o.listboxState.value === 0 && s.value && o.activationTrigger.value !== 0 && it(() => {
      var h, x;
      return (x = (h = ze(i)) == null ? void 0 : h.scrollIntoView) == null ? void 0 : x.call(h, { block: "nearest" });
    });
  });
  function m(h) {
    if (e.disabled) return h.preventDefault();
    o.select(e.value), o.mode.value === 0 && (o.closeListbox(), it(() => {
      var x;
      return (x = ze(o.buttonRef)) == null ? void 0 : x.focus({ preventScroll: !0 });
    }));
  }
  function y() {
    if (e.disabled) return o.goToOption(Nt.Nothing);
    o.goToOption(Nt.Specific, l);
  }
  let v = Hf();
  function S(h) {
    v.update(h);
  }
  function g(h) {
    v.wasMoved(h) && (e.disabled || s.value || o.goToOption(Nt.Specific, l, 0));
  }
  function b(h) {
    v.wasMoved(h) && (e.disabled || s.value && o.goToOption(Nt.Nothing));
  }
  return () => {
    let { disabled: h } = e, x = { active: s.value, selected: u.value, disabled: h }, { value: F, disabled: C, ...A } = e, O = { id: l, ref: i, role: "option", tabIndex: h === !0 ? void 0 : -1, "aria-disabled": h === !0 ? !0 : void 0, "aria-selected": u.value, disabled: void 0, onClick: m, onFocus: y, onPointerenter: S, onMouseenter: S, onPointermove: g, onMousemove: g, onPointerleave: b, onMouseleave: b };
    return Mt({ ourProps: O, theirProps: A, slot: x, attrs: t, slots: n, name: "ListboxOption" });
  };
} });
function Em(e) {
  let n = { called: !1 };
  return (...t) => {
    if (!n.called) return n.called = !0, e(...t);
  };
}
function Ml(e, ...n) {
  e && n.length > 0 && e.classList.add(...n);
}
function Mr(e, ...n) {
  e && n.length > 0 && e.classList.remove(...n);
}
var ro = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(ro || {});
function Pm(e, n) {
  let t = pr();
  if (!e) return t.dispose;
  let { transitionDuration: a, transitionDelay: r } = getComputedStyle(e), [l, o] = [a, r].map((i) => {
    let [s = 0] = i.split(",").filter(Boolean).map((u) => u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3).sort((u, c) => c - u);
    return s;
  });
  return l !== 0 ? t.setTimeout(() => n("finished"), l + o) : n("finished"), t.add(() => n("cancelled")), t.dispose;
}
function li(e, n, t, a, r, l) {
  let o = pr(), i = l !== void 0 ? Em(l) : () => {
  };
  return Mr(e, ...r), Ml(e, ...n, ...t), o.nextFrame(() => {
    Mr(e, ...t), Ml(e, ...a), o.add(Pm(e, (s) => (Mr(e, ...a, ...n), Ml(e, ...r), i(s))));
  }), o.add(() => Mr(e, ...n, ...t, ...a, ...r)), o.add(() => i("cancelled")), o.dispose;
}
function aa(e = "") {
  return e.split(/\s+/).filter((n) => n.length > 1);
}
let Oo = Symbol("TransitionContext");
var $m = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))($m || {});
function Am() {
  return Ft(Oo, null) !== null;
}
function Tm() {
  let e = Ft(Oo, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function Dm() {
  let e = Ft(Io, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let Io = Symbol("NestingContext");
function nl(e) {
  return "children" in e ? nl(e.children) : e.value.filter(({ state: n }) => n === "visible").length > 0;
}
function Bu(e) {
  let n = ee([]), t = ee(!1);
  He(() => t.value = !0), wt(() => t.value = !1);
  function a(l, o = Yn.Hidden) {
    let i = n.value.findIndex(({ id: s }) => s === l);
    i !== -1 && (Ct(o, { [Yn.Unmount]() {
      n.value.splice(i, 1);
    }, [Yn.Hidden]() {
      n.value[i].state = "hidden";
    } }), !nl(n) && t.value && (e == null || e()));
  }
  function r(l) {
    let o = n.value.find(({ id: i }) => i === l);
    return o ? o.state !== "visible" && (o.state = "visible") : n.value.push({ id: l, state: "visible" }), () => a(l, Yn.Unmount);
  }
  return { children: n, register: r, unregister: a };
}
let Hu = Pa.RenderStrategy, lo = Ce({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: n, attrs: t, slots: a, expose: r }) {
  let l = ee(0);
  function o() {
    l.value |= $t.Opening, n("beforeEnter");
  }
  function i() {
    l.value &= ~$t.Opening, n("afterEnter");
  }
  function s() {
    l.value |= $t.Closing, n("beforeLeave");
  }
  function u() {
    l.value &= ~$t.Closing, n("afterLeave");
  }
  if (!Am() && Yf()) return () => je(zu, { ...e, onBeforeEnter: o, onAfterEnter: i, onBeforeLeave: s, onAfterLeave: u }, a);
  let c = ee(null), f = k(() => e.unmount ? Yn.Unmount : Yn.Hidden);
  r({ el: c, $el: c });
  let { show: d, appear: m } = Tm(), { register: y, unregister: v } = Dm(), S = ee(d.value ? "visible" : "hidden"), g = { value: !0 }, b = hn(), h = { value: !1 }, x = Bu(() => {
    !h.value && S.value !== "hidden" && (S.value = "hidden", v(b), u());
  });
  He(() => {
    let ue = y(b);
    wt(ue);
  }), Zt(() => {
    if (f.value === Yn.Hidden && b) {
      if (d.value && S.value !== "visible") {
        S.value = "visible";
        return;
      }
      Ct(S.value, { hidden: () => v(b), visible: () => y(b) });
    }
  });
  let F = aa(e.enter), C = aa(e.enterFrom), A = aa(e.enterTo), O = aa(e.entered), $ = aa(e.leave), L = aa(e.leaveFrom), N = aa(e.leaveTo);
  He(() => {
    Zt(() => {
      if (S.value === "visible") {
        let ue = ze(c);
        if (ue instanceof Comment && ue.data === "") throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function K(ue) {
    let B = g.value && !m.value, Z = ze(c);
    !Z || !(Z instanceof HTMLElement) || B || (h.value = !0, d.value && o(), d.value || s(), ue(d.value ? li(Z, F, C, A, O, (R) => {
      h.value = !1, R === ro.Finished && i();
    }) : li(Z, $, L, N, O, (R) => {
      h.value = !1, R === ro.Finished && (nl(x) || (S.value = "hidden", v(b), u()));
    })));
  }
  return He(() => {
    Be([d], (ue, B, Z) => {
      K(Z), g.value = !1;
    }, { immediate: !0 });
  }), pn(Io, x), ku(k(() => Ct(S.value, { visible: $t.Open, hidden: $t.Closed }) | l.value)), () => {
    let { appear: ue, show: B, enter: Z, enterFrom: R, enterTo: M, entered: z, leave: J, leaveFrom: H, leaveTo: le, ...j } = e, q = { ref: c }, P = { ...j, ...m.value && d.value && vr.isServer ? { class: me([t.class, j.class, ...F, ...C]) } : {} };
    return Mt({ theirProps: P, ourProps: q, slot: {}, slots: a, attrs: t, features: Hu, visible: S.value === "visible", name: "TransitionChild" });
  };
} }), Rm = lo, zu = Ce({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: n, attrs: t, slots: a }) {
  let r = tl(), l = k(() => e.show === null && r !== null ? (r.value & $t.Open) === $t.Open : e.show);
  Zt(() => {
    if (![!0, !1].includes(l.value)) throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let o = ee(l.value ? "visible" : "hidden"), i = Bu(() => {
    o.value = "hidden";
  }), s = ee(!0), u = { show: l, appear: k(() => e.appear || !s.value) };
  return He(() => {
    Zt(() => {
      s.value = !1, l.value ? o.value = "visible" : nl(i) || (o.value = "hidden");
    });
  }), pn(Io, i), pn(Oo, u), () => {
    let c = Ro(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), f = { unmount: e.unmount };
    return Mt({ ourProps: { ...f, as: "template" }, theirProps: {}, slot: {}, slots: { ...a, default: () => [je(Rm, { onBeforeEnter: () => n("beforeEnter"), onAfterEnter: () => n("afterEnter"), onBeforeLeave: () => n("beforeLeave"), onAfterLeave: () => n("afterLeave"), ...t, ...f, ...c }, a.default)] }, attrs: {}, features: Hu, visible: o.value === "visible", name: "Transition" });
  };
} });
const Om = { class: "fixed inset-0 overflow-y-auto" }, Im = { class: "flex min-h-full items-center justify-center p-4" }, Fm = {
  key: 0,
  class: "flex items-start justify-between mb-6 shrink-0"
}, Lm = { class: "flex-1 text-lg font-semibold" }, Nm = {
  key: 0,
  class: "mt-6 pt-6 border-t border-gray-200 text-center"
}, Lb = /* @__PURE__ */ Ce({
  __name: "FModal",
  props: {
    modelValue: { type: Boolean },
    size: { default: "md" },
    showClose: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    product: {},
    allowOverflow: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, { currentProductColor: r } = gn(), l = k(() => {
      if (t.product) {
        const f = Vt[t.product];
        return (f == null ? void 0 : f.primaryColor) || r.value;
      }
      return r.value;
    }), o = k(() => ({
      color: l.value
    })), i = k(() => t.modelValue), s = (f) => {
      (f || t.closeOnBackdrop) && a("update:modelValue", !1);
    }, u = k(() => ({
      "w-full rounded-2xl bg-bg-primary p-6 shadow-xl max-h-[90vh] flex flex-col": !0,
      "overflow-hidden": !t.allowOverflow,
      "overflow-visible": t.allowOverflow,
      "max-w-md": t.size === "sm",
      "max-w-lg": t.size === "md",
      "max-w-2xl": t.size === "lg",
      "max-w-4xl": t.size === "xl",
      "max-w-6xl": t.size === "2xl",
      "max-w-7xl": t.size === "3xl",
      "max-w-full": t.size === "full"
    })), c = k(
      () => t.allowOverflow ? "flex-1 overflow-visible" : "flex-1 overflow-auto"
    );
    return (f, d) => (p(), Pe(D(zu), {
      show: i.value,
      as: "template"
    }, {
      default: xe(() => [
        Ae(D(hm), {
          onClose: d[2] || (d[2] = (m) => s(!1)),
          class: "relative z-50"
        }, {
          default: xe(() => [
            Ae(D(lo), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: xe(() => [
                _("div", {
                  class: "fixed inset-0 bg-black/25 backdrop-blur-sm",
                  onClick: d[0] || (d[0] = ot((m) => s(!1), ["self"]))
                })
              ]),
              _: 1
            }),
            _("div", Om, [
              _("div", Im, [
                Ae(D(lo), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 scale-95",
                  "enter-to": "opacity-100 scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 scale-100",
                  "leave-to": "opacity-0 scale-95"
                }, {
                  default: xe(() => [
                    Ae(D(ym), {
                      class: me(u.value)
                    }, {
                      default: xe(() => [
                        f.$slots.title || f.$slots.header ? (p(), w("div", Fm, [
                          _("div", Lm, [
                            f.$slots.title ? (p(), Pe(D(wm), {
                              key: 0,
                              as: "div",
                              style: tt(o.value)
                            }, {
                              default: xe(() => [
                                ge(f.$slots, "title")
                              ]),
                              _: 3
                            }, 8, ["style"])) : X("", !0),
                            ge(f.$slots, "header")
                          ]),
                          e.showClose ? (p(), w("button", {
                            key: 0,
                            onClick: d[1] || (d[1] = (m) => s(!0)),
                            type: "button",
                            class: "ml-4 rounded-md text-text-secondary"
                          }, [...d[3] || (d[3] = [
                            _("span", { class: "sr-only" }, "Close", -1),
                            _("svg", {
                              class: "h-6 w-6",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              "stroke-width": "1.5",
                              stroke: "currentColor"
                            }, [
                              _("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M6 18L18 6M6 6l12 12"
                              })
                            ], -1)
                          ])])) : X("", !0)
                        ])) : X("", !0),
                        _("div", {
                          class: me(c.value)
                        }, [
                          ge(f.$slots, "default"),
                          f.$slots.footer ? (p(), w("div", Nm, [
                            ge(f.$slots, "footer")
                          ])) : X("", !0)
                        ], 2)
                      ]),
                      _: 3
                    }, 8, ["class"])
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]));
  }
}), Nb = /* @__PURE__ */ Ce({
  __name: "FBadge",
  props: {
    variant: { default: "default" },
    size: { default: "md" },
    rounded: { type: Boolean, default: !1 },
    dot: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = k(() => ({
      // Base styles
      "inline-flex items-center gap-1 font-semibold transition-colors": !0,
      // Variant colors
      "bg-gray-100 text-gray-800": n.variant === "default",
      "bg-brand-primary text-white": n.variant === "primary",
      "bg-green-100 text-green-800": n.variant === "success",
      "bg-yellow-100 text-yellow-800": n.variant === "warning",
      "bg-red-100 text-red-800": n.variant === "error",
      "bg-blue-100 text-blue-800": n.variant === "info",
      // Sizes
      "px-2 py-0.5 text-xs": n.size === "sm",
      "px-2.5 py-1 text-sm": n.size === "md",
      "px-3 py-1.5 text-base": n.size === "lg",
      // Rounded
      "rounded-full": n.rounded,
      rounded: !n.rounded
    }));
    return (a, r) => (p(), w("span", {
      class: me(t.value)
    }, [
      ge(a.$slots, "default")
    ], 2));
  }
}), ra = ee([]), oi = ee("top-right"), El = ee(5);
let Vm = 0;
function Bm() {
  const e = () => `toast-${Date.now()}-${++Vm}`, n = (f) => {
    const d = e(), m = {
      id: d,
      dismissible: !0,
      duration: 5e3,
      ...f
    };
    return ra.value.push(m), ra.value.length > El.value && ra.value.shift(), m.duration && m.duration > 0 && setTimeout(() => {
      t(d);
    }, m.duration), d;
  }, t = (f) => {
    const d = ra.value.findIndex((m) => m.id === f);
    d !== -1 && ra.value.splice(d, 1);
  }, a = () => {
    ra.value = [];
  }, r = (f, d) => n({
    type: "success",
    message: f,
    ...d
  }), l = (f, d) => n({
    type: "error",
    message: f,
    duration: (d == null ? void 0 : d.duration) ?? 7e3,
    // Errors stay longer by default
    ...d
  }), o = (f, d) => n({
    type: "info",
    message: f,
    ...d
  }), i = (f, d) => n({
    type: "warning",
    message: f,
    ...d
  }), s = (f) => {
    oi.value = f;
  }, u = (f) => {
    El.value = f;
  }, c = async (f, d) => {
    const m = d.loading ? o(d.loading, { duration: 0, dismissible: !1 }) : null;
    try {
      const y = await f;
      if (m && t(m), d.success) {
        const v = typeof d.success == "function" ? d.success(y) : d.success;
        r(v);
      }
      return y;
    } catch (y) {
      if (m && t(m), d.error) {
        const v = typeof d.error == "function" ? d.error(y) : d.error;
        l(v);
      }
      throw y;
    }
  };
  return {
    // State (readonly)
    toasts: yl(ra),
    position: yl(oi),
    maxToasts: yl(El),
    // Methods
    success: r,
    error: l,
    info: o,
    warning: i,
    removeToast: t,
    clearAll: a,
    setPosition: s,
    setMaxToasts: u,
    promise: c
  };
}
const Hm = ["aria-live"], zm = { class: "flex-shrink-0 pt-0.5" }, Um = { class: "flex-1 min-w-0" }, Ym = ["onClick"], jm = ["onClick", "aria-label"], Zm = /* @__PURE__ */ Ce({
  __name: "FToast",
  props: {
    position: { default: "top-right" }
  },
  setup(e) {
    const n = () => je(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor"
      },
      [
        je("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          d: "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        })
      ]
    ), t = () => je(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor"
      },
      [
        je("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          d: "M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        })
      ]
    ), a = () => je(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor"
      },
      [
        je("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          d: "M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
        })
      ]
    ), r = () => je(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor"
      },
      [
        je("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
        })
      ]
    ), l = () => je(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "stroke-width": "1.5",
        stroke: "currentColor"
      },
      [
        je("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          d: "M6 18L18 6M6 6l12 12"
        })
      ]
    ), { toasts: o, removeToast: i } = Bm(), s = {
      "top-right": "top-0 right-0",
      "top-left": "top-0 left-0",
      "bottom-right": "bottom-0 right-0",
      "bottom-left": "bottom-0 left-0",
      "top-center": "top-0 left-1/2 -translate-x-1/2",
      "bottom-center": "bottom-0 left-1/2 -translate-x-1/2"
    }, u = {
      success: "bg-green-50/90 border-green-200 dark:bg-green-900/20 dark:border-green-800",
      error: "bg-red-50/90 border-red-200 dark:bg-red-900/20 dark:border-red-800",
      info: "bg-blue-50/90 border-blue-200 dark:bg-blue-900/20 dark:border-blue-800",
      warning: "bg-yellow-50/90 border-yellow-200 dark:bg-yellow-900/20 dark:border-yellow-800"
    }, c = {
      success: "text-green-600 dark:text-green-400",
      error: "text-red-600 dark:text-red-400",
      info: "text-blue-600 dark:text-blue-400",
      warning: "text-yellow-600 dark:text-yellow-400"
    }, f = {
      success: "text-green-900 dark:text-green-100",
      error: "text-red-900 dark:text-red-100",
      info: "text-blue-900 dark:text-blue-100",
      warning: "text-yellow-900 dark:text-yellow-100"
    }, d = {
      success: "text-green-800 dark:text-green-200",
      error: "text-red-800 dark:text-red-200",
      info: "text-blue-800 dark:text-blue-200",
      warning: "text-yellow-800 dark:text-yellow-200"
    }, m = {
      success: "text-green-700 hover:text-green-900 dark:text-green-300 dark:hover:text-green-100",
      error: "text-red-700 hover:text-red-900 dark:text-red-300 dark:hover:text-red-100",
      info: "text-blue-700 hover:text-blue-900 dark:text-blue-300 dark:hover:text-blue-100",
      warning: "text-yellow-700 hover:text-yellow-900 dark:text-yellow-300 dark:hover:text-yellow-100"
    }, y = {
      success: "text-green-600 hover:bg-green-100 dark:text-green-400 dark:hover:bg-green-800/30",
      error: "text-red-600 hover:bg-red-100 dark:text-red-400 dark:hover:bg-red-800/30",
      info: "text-blue-600 hover:bg-blue-100 dark:text-blue-400 dark:hover:bg-blue-800/30",
      warning: "text-yellow-600 hover:bg-yellow-100 dark:text-yellow-400 dark:hover:bg-yellow-800/30"
    }, v = (g) => {
      switch (g) {
        case "success":
          return n;
        case "error":
          return t;
        case "info":
          return a;
        case "warning":
          return r;
        default:
          return a;
      }
    }, S = (g) => {
      var b;
      (b = g.action) != null && b.onClick && (g.action.onClick(), i(g.id));
    };
    return (g, b) => (p(), Pe(Jr, { to: "body" }, [
      _("div", {
        class: me([
          "fixed !z-[9999] flex flex-col gap-3 p-4",
          s[e.position]
        ])
      }, [
        Ae(Cc, {
          name: "toast",
          tag: "div",
          class: "flex flex-col gap-3"
        }, {
          default: xe(() => [
            (p(!0), w(_e, null, Ie(D(o), (h) => (p(), w("div", {
              key: h.id,
              class: me([
                "flex items-start gap-3 rounded-lg px-4 py-3 shadow-lg backdrop-blur-sm transition-all",
                "border",
                u[h.type],
                "max-w-sm"
              ]),
              role: "alert",
              "aria-live": h.type === "error" ? "assertive" : "polite"
            }, [
              _("div", zm, [
                (p(), Pe(Ln(v(h.type)), {
                  class: me(["h-5 w-5", c[h.type]])
                }, null, 8, ["class"]))
              ]),
              _("div", Um, [
                h.title ? (p(), w("p", {
                  key: 0,
                  class: me(["text-sm font-medium", f[h.type]])
                }, he(h.title), 3)) : X("", !0),
                _("p", {
                  class: me([
                    "text-sm",
                    h.title ? "mt-1" : "",
                    d[h.type]
                  ])
                }, he(h.message), 3),
                h.action ? (p(), w("button", {
                  key: 1,
                  type: "button",
                  class: me([
                    "mt-2 text-sm font-medium underline",
                    m[h.type]
                  ]),
                  onClick: (x) => S(h)
                }, he(h.action.label), 11, Ym)) : X("", !0)
              ]),
              h.dismissible ? (p(), w("button", {
                key: 0,
                type: "button",
                class: me([
                  "flex-shrink-0 rounded-md p-1 transition-colors",
                  y[h.type]
                ]),
                onClick: (x) => D(i)(h.id),
                "aria-label": `Dismiss ${h.type} notification`
              }, [
                Ae(l, { class: "h-4 w-4" })
              ], 10, jm)) : X("", !0)
            ], 10, Hm))), 128))
          ]),
          _: 1
        })
      ], 2)
    ]));
  }
}), Vb = /* @__PURE__ */ el(Zm, [["__scopeId", "data-v-4dbcbc95"]]), Gm = ["aria-describedby"], Wm = ["id"], Bb = /* @__PURE__ */ Ce({
  __name: "FTooltip",
  props: {
    text: { default: "" },
    placement: { default: "top" }
  },
  setup(e) {
    const n = e, t = ee(null), a = ee(!1), r = k(() => `f-tooltip-${Math.random().toString(36).slice(2, 11)}`), l = k(() => {
      switch (n.placement) {
        case "bottom":
          return "top-full left-1/2 mt-2 -translate-x-1/2";
        case "left":
          return "right-full top-1/2 mr-2 -translate-y-1/2";
        case "right":
          return "left-full top-1/2 ml-2 -translate-y-1/2";
        case "top":
        default:
          return "bottom-full left-1/2 mb-2 -translate-x-1/2";
      }
    }), o = () => {
      n.text && (a.value = !0);
    }, i = () => {
      a.value = !1;
    }, s = (u) => {
      const c = u.target;
      t.value && c && t.value.contains(c) || i();
    };
    return He(() => {
      document.addEventListener("click", s);
    }), Ao(() => {
      document.removeEventListener("click", s);
    }), (u, c) => (p(), w("div", {
      ref_key: "wrapperRef",
      ref: t,
      class: "relative inline-flex max-w-full",
      "aria-describedby": e.text ? r.value : void 0,
      onMouseenter: o,
      onMouseleave: i,
      onFocusin: o,
      onFocusout: i
    }, [
      ge(u.$slots, "default"),
      e.text ? (p(), w("span", {
        key: 0,
        id: r.value,
        role: "tooltip",
        class: me(["pointer-events-none absolute z-[12000] whitespace-nowrap rounded-lg bg-gray-900 px-2 py-1 text-xs text-white shadow-lg transition duration-150", [l.value, a.value ? "opacity-100" : "opacity-0"]])
      }, he(e.text), 11, Wm)) : X("", !0)
    ], 40, Gm));
  }
}), qm = { class: "f-select-wrapper" }, Km = {
  key: 0,
  class: "border-b border-[#E6E6E6] bg-bg-primary p-2 dark:border-[#404040]"
}, Xm = { class: "relative" }, Qm = ["placeholder"], Jm = { class: "px-3 py-1 text-xs font-normal uppercase text-text-secondary" }, ep = ["title"], tp = {
  key: 0,
  class: "absolute left-2 inline-flex items-center justify-center text-text-primary"
}, np = ["title"], ap = {
  key: 0,
  class: "absolute left-2 inline-flex items-center justify-center text-text-primary"
}, rp = {
  key: 3,
  class: "px-3 py-2 text-sm text-text-secondary"
}, lp = {
  key: 1,
  class: "mt-2 text-sm text-red-500"
}, op = {
  key: 2,
  class: "mt-2 text-sm text-text-secondary"
}, oo = /* @__PURE__ */ Ce({
  __name: "FSelect",
  props: {
    modelValue: { type: [String, Number, Boolean, null], default: "" },
    options: { default: () => [] },
    groups: {},
    label: {},
    placeholder: { default: "Seçiniz..." },
    searchPlaceholder: { default: "Ara..." },
    hint: {},
    error: { type: Boolean, default: !1 },
    errorMessage: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    size: { default: "md" },
    product: {},
    searchable: { type: Boolean, default: !1 },
    title: {},
    optionsPlacement: { default: "bottom" },
    optionsMaxHeight: { default: "300px" }
  },
  emits: ["update:modelValue", "change", "search"],
  setup(e, { emit: n }) {
    const t = e, a = n, { currentProductColor: r } = gn(), l = k(() => `f-select-${Math.random().toString(36).slice(2, 11)}`), o = ee("");
    Be(o, (M) => {
      a("search", M.trim());
    });
    const i = (M) => {
      M instanceof HTMLInputElement && it(() => {
        document.activeElement !== M && M.focus({ preventScroll: !0 });
      });
    }, s = /* @__PURE__ */ new Set(["ArrowDown", "ArrowUp", "Enter", "Escape", "Tab"]), u = (M) => {
      s.has(M.key) || M.stopPropagation();
    }, c = (M) => {
      t.searchable && M.preventDefault();
    }, f = k(() => t.product || r.value), d = k(() => [
      "absolute z-[12000] w-full overflow-y-auto overscroll-contain rounded-2xl border border-[#E6E6E6] bg-bg-primary py-1 shadow-lg focus:outline-none dark:border-[#404040]",
      t.optionsPlacement === "top" ? "bottom-full mb-2" : "top-full mt-2"
    ]), m = (M) => M == null ? "empty" : String(M), y = (M) => M.toLocaleLowerCase("tr").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ı/g, "i"), v = (M, z, J) => {
      const H = m(M.value), le = M.label || "";
      return {
        key: `${J}-${z}-${H || "empty"}`,
        label: le,
        value: M.value,
        disabled: !!M.disabled,
        searchable: y(`${le} ${H}`)
      };
    }, S = k(
      () => t.options.map((M, z) => v(M, z, "option"))
    ), g = k(
      () => (t.groups ?? []).map((M, z) => ({
        key: `group-${z}-${M.label}`,
        label: M.label,
        options: M.options.map(
          (J, H) => v(J, H, `group-${z}`)
        )
      }))
    ), b = k(() => g.value.length > 0), h = k(() => y(o.value.trim())), x = k(() => !t.searchable || !h.value ? S.value : S.value.filter((M) => M.searchable.includes(h.value))), F = k(() => !t.searchable || !h.value ? g.value : g.value.map((M) => ({
      ...M,
      options: M.options.filter((z) => z.searchable.includes(h.value))
    })).filter((M) => M.options.length > 0)), C = k(() => x.value), A = k(() => F.value), O = k(() => b.value ? A.value.some((M) => M.options.length > 0) : C.value.length > 0), $ = k(() => t.searchable && !O.value), L = k(() => b.value ? g.value.flatMap((M) => M.options) : S.value), N = k({
      get: () => {
        const M = t.modelValue, z = L.value.find((J) => J.value === M);
        return z || null;
      },
      set: (M) => {
        const z = (M == null ? void 0 : M.value) ?? null;
        a("update:modelValue", z), a("change", z), o.value && (o.value = "");
      }
    }), K = k(() => !N.value), ue = k(() => {
      var M;
      return ((M = N.value) == null ? void 0 : M.label) ?? t.placeholder;
    }), B = k(() => {
      const M = [
        "inline-flex w-full items-center justify-between rounded-2xl border transition-colors",
        "focus:outline-none focus:ring-0 focus:ring-offset-0",
        "bg-bg-primary text-text-primary",
        "disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400 disabled:opacity-60 dark:disabled:bg-gray-800"
      ];
      return t.error ? M.push("border-red-500 focus:border-red-500") : (M.push("border-[#E6E6E6] dark:border-[#404040]"), M.push(`focus:border-${f.value}`)), t.size === "sm" ? M.push("px-3 py-2 text-sm") : t.size === "lg" ? M.push("px-6 py-3 text-lg") : M.push("px-4 py-2.5 text-base"), M.join(" ");
    }), Z = k(() => {
      const M = [
        "relative flex w-full items-center select-none rounded-xl pl-9 pr-3 transition-colors",
        "text-text-primary"
      ];
      return t.size === "sm" ? M.push("py-2 text-sm") : t.size === "lg" ? M.push("py-3 text-lg") : M.push("py-2.5 text-base"), M;
    }), R = (M, z, J) => {
      const H = [...Z.value];
      return J ? H.push("cursor-not-allowed opacity-50") : H.push("cursor-pointer"), (M || z) && H.push("bg-gray-100 dark:bg-gray-900"), z && H.push("font-medium"), H.join(" ");
    };
    return (M, z) => (p(), w("div", qm, [
      e.label ? (p(), Pe(bf, {
        key: 0,
        "for-id": l.value,
        label: e.label,
        required: e.required,
        size: e.size,
        disabled: e.disabled,
        class: "text-text-primary"
      }, null, 8, ["for-id", "label", "required", "size", "disabled"])) : X("", !0),
      Ae(D(Lu), {
        modelValue: N.value,
        "onUpdate:modelValue": z[1] || (z[1] = (J) => N.value = J),
        as: "div",
        class: "relative",
        disabled: e.disabled
      }, {
        default: xe(({ open: J }) => [
          Ae(D(Nu), {
            id: l.value,
            class: me(B.value),
            "aria-invalid": e.error ? "true" : void 0,
            "aria-required": e.required ? "true" : void 0,
            title: t.title || void 0
          }, {
            default: xe(() => [
              _("span", {
                class: me(["flex-1 truncate text-left", {
                  "text-text-secondary": K.value,
                  "text-text-primary": !K.value
                }])
              }, he(ue.value), 3),
              _("span", {
                class: me(["ml-3 inline-flex h-5 w-5 items-center justify-center text-gray-500 transition-transform duration-150", { "rotate-180": J }])
              }, [...z[2] || (z[2] = [
                _("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  "stroke-width": "1.5",
                  stroke: "currentColor",
                  class: "h-4 w-4"
                }, [
                  _("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    d: "m19.5 8.25-7.5 7.5-7.5-7.5"
                  })
                ], -1)
              ])], 2)
            ]),
            _: 2
          }, 1032, ["id", "class", "aria-invalid", "aria-required", "title"]),
          Ae(Pn, {
            leave: "transition ease-in duration-100",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: xe(() => [
              J ? (p(), Pe(D(Vu), {
                key: 0,
                class: me(d.value),
                style: tt({ maxHeight: t.optionsMaxHeight })
              }, {
                default: xe(() => [
                  t.searchable ? (p(), w("div", Km, [
                    _("div", Xm, [
                      On(_("input", {
                        ref: i,
                        "onUpdate:modelValue": z[0] || (z[0] = (H) => o.value = H),
                        type: "text",
                        placeholder: t.searchPlaceholder,
                        class: "w-full rounded-xl border border-[#E6E6E6] bg-transparent px-3 py-2 text-sm outline-none focus:border-current dark:border-[#404040]",
                        onKeydown: u
                      }, null, 40, Qm), [
                        [iu, o.value]
                      ]),
                      z[3] || (z[3] = _("span", { class: "pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-500" }, [
                        _("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          class: "h-4 w-4",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor",
                          "stroke-width": "1.5"
                        }, [
                          _("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            d: "M21 21l-4.35-4.35m0 0A7.5 7.5 0 1 0 6.75 6.75a7.5 7.5 0 0 0 9.9 9.9z"
                          })
                        ])
                      ], -1))
                    ])
                  ])) : X("", !0),
                  b.value ? (p(!0), w(_e, { key: 1 }, Ie(A.value, (H) => (p(), w("div", {
                    key: H.key,
                    class: "py-1"
                  }, [
                    _("div", Jm, he(H.label), 1),
                    (p(!0), w(_e, null, Ie(H.options, (le) => (p(), Pe(D(Yr), {
                      key: le.key,
                      value: le,
                      disabled: le.disabled,
                      as: "template"
                    }, {
                      default: xe(({ active: j, selected: q, disabled: P }) => [
                        _("li", {
                          class: me(R(j, q, P)),
                          onMousedown: c
                        }, [
                          _("span", {
                            class: "truncate",
                            title: le.label
                          }, he(le.label), 9, ep),
                          q ? (p(), w("span", tp, [...z[4] || (z[4] = [
                            _("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              "stroke-width": "1.5",
                              stroke: "currentColor",
                              class: "h-4 w-4"
                            }, [
                              _("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "m4.5 12.75 6 6 9-13.5"
                              })
                            ], -1)
                          ])])) : X("", !0)
                        ], 34)
                      ]),
                      _: 2
                    }, 1032, ["value", "disabled"]))), 128))
                  ]))), 128)) : (p(!0), w(_e, { key: 2 }, Ie(C.value, (H) => (p(), Pe(D(Yr), {
                    key: H.key,
                    value: H,
                    disabled: H.disabled,
                    as: "template"
                  }, {
                    default: xe(({ active: le, selected: j, disabled: q }) => [
                      _("li", {
                        class: me(R(le, j, q)),
                        onMousedown: c
                      }, [
                        _("span", {
                          class: "truncate",
                          title: H.label
                        }, he(H.label), 9, np),
                        j ? (p(), w("span", ap, [...z[5] || (z[5] = [
                          _("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            "stroke-width": "1.5",
                            stroke: "currentColor",
                            class: "h-4 w-4"
                          }, [
                            _("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "m4.5 12.75 6 6 9-13.5"
                            })
                          ], -1)
                        ])])) : X("", !0)
                      ], 34)
                    ]),
                    _: 2
                  }, 1032, ["value", "disabled"]))), 128)),
                  $.value || !t.searchable && !O.value ? (p(), w("div", rp, " Sonuç Bulunamadı ")) : X("", !0)
                ]),
                _: 1
              }, 8, ["class", "style"])) : X("", !0)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      e.error && e.errorMessage ? (p(), w("p", lp, he(e.errorMessage), 1)) : e.hint ? (p(), w("p", op, he(e.hint), 1)) : X("", !0)
    ]));
  }
}), sp = { class: "f-select-wrapper" }, ip = { class: "flex min-w-0 flex-1 items-center gap-1" }, up = {
  key: 0,
  class: "hidden sm:flex flex-wrap gap-1"
}, dp = ["onClick"], cp = { class: "sm:hidden truncate text-left !text-text-primary" }, fp = {
  key: 1,
  class: "hidden sm:inline truncate text-left !text-text-primary"
}, mp = {
  key: 1,
  class: "truncate text-left text-text-secondary"
}, pp = { class: "p-2 border-b border-[#E6E6E6] dark:border-[#404040] !bg-bg-primary" }, vp = { class: "relative" }, gp = ["placeholder"], hp = { class: "max-h-[300px] w-full overflow-auto py-1" }, yp = { class: "px-3 py-1 text-xs font-medium uppercase !text-text-secondary" }, wp = { class: "truncate !text-text-primary" }, bp = {
  key: 0,
  class: "absolute left-2 inline-flex items-center justify-center text-text-primary"
}, _p = { class: "truncate" }, xp = {
  key: 0,
  class: "absolute left-2 inline-flex items-center justify-center text-text-primary"
}, kp = {
  key: 2,
  class: "px-3 py-2 text-sm text-text-secondary"
}, Cp = {
  key: 1,
  class: "mt-2 text-sm text-red-500"
}, Sp = {
  key: 2,
  class: "mt-2 text-sm text-text-secondary"
}, Hb = /* @__PURE__ */ Ce({
  __name: "FMultiSelect",
  props: {
    modelValue: { default: () => [] },
    options: { default: () => [] },
    groups: {},
    label: {},
    placeholder: { default: "Seçiniz..." },
    searchPlaceholder: { default: "Ara..." },
    hint: {},
    error: { type: Boolean, default: !1 },
    errorMessage: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    size: { default: "md" },
    product: {},
    valueKey: { default: "value" },
    labelKey: { default: "label" },
    returnObject: { type: Boolean, default: !1 },
    showSelectedLength: { type: Boolean, default: !1 },
    selectedSummaryFormatter: { type: Function, default: (e) => `${e} seçili` },
    preserveUnknownValues: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = n, { currentProductColor: r } = gn(), l = k(() => `f-multiselect-${Math.random().toString(36).slice(2, 11)}`), o = k(() => t.product || r.value), i = (M) => M == null ? "" : String(M), s = (M) => {
      const z = M.value ?? M[t.valueKey];
      return i(z);
    }, u = (M) => {
      const z = M.label ?? M[t.labelKey];
      return z == null || z === "" ? "--" : String(z);
    }, c = (M, z, J) => {
      const H = s(M), le = u(M);
      return {
        key: `${J}-${z}-${H || "empty"}`,
        label: le,
        value: H,
        disabled: !!M.disabled,
        searchable: `${le} ${H}`.toLowerCase(),
        raw: M
      };
    }, f = k(
      () => t.options.map((M, z) => c(M, z, "o"))
    ), d = k(
      () => (t.groups ?? []).map((M, z) => ({
        key: `g-${z}-${M.label}`,
        label: M.label,
        options: M.options.map((J, H) => c(J, H, `g-${z}`))
      }))
    ), m = k(() => d.value.length > 0), y = k(
      () => m.value ? d.value.flatMap((M) => M.options) : f.value
    ), v = ee([]), S = ee(""), g = k(() => t.selectedSummaryFormatter(v.value.length)), b = (M) => {
      if (M && typeof M == "object") {
        const z = t.valueKey;
        return i(M[z]);
      }
      return i(M);
    }, h = (M) => t.returnObject ? b(M) : i(M), x = () => {
      const M = new Set((t.modelValue ?? []).map(h));
      v.value = y.value.filter((z) => M.has(z.value));
    };
    Be([y], x, { immediate: !0 }), Be(() => t.modelValue, x);
    const F = k(() => {
      if (!t.preserveUnknownValues) return [];
      const M = new Set(y.value.map((z) => z.value));
      return (t.modelValue ?? []).filter((z) => !M.has(h(z)));
    }), C = () => {
      const M = t.returnObject ? v.value.map((J) => J.raw ?? J) : v.value.map((J) => J.value), z = F.value.length ? [...M, ...F.value] : M;
      a("update:modelValue", z), a("change", z);
    }, A = k(() => S.value.trim().toLowerCase()), O = k(
      () => f.value.filter((M) => M.searchable.includes(A.value))
    ), $ = k(
      () => d.value.map((M) => ({ ...M, options: M.options.filter((z) => z.searchable.includes(A.value)) })).filter((M) => M.options.length > 0)
    ), L = k(
      () => m.value && $.value.length === 0 || !m.value && O.value.length === 0
    ), N = (M) => v.value.some((z) => z.key === M.key), K = (M) => {
      v.value = M, C();
    }, ue = (M) => {
      v.value = v.value.filter((z) => z.key !== M.key), C();
    }, B = k(() => {
      const M = [
        "inline-flex w-full items-center justify-between rounded-2xl border transition-colors",
        "focus:outline-none focus:ring-0 focus:ring-offset-0",
        "!bg-bg-primary !text-text-primary",
        "disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400 disabled:opacity-60 dark:disabled:bg-gray-800",
        "px-4 py-2.5 text-base"
      ];
      return t.size === "sm" && M.splice(-1, 1, "px-3 py-2 text-sm"), t.size === "lg" && M.splice(-1, 1, "px-6 py-3 text-lg"), t.error ? M.push("border-red-500 focus:border-red-500") : (M.push("!border-[#E6E6E6] dark:!border-[#404040]"), M.push(`focus:border-${o.value}`)), M.join(" ");
    }), Z = k(() => {
      const M = [
        "relative flex w-full items-center select-none rounded-xl pl-9 pr-3 transition-colors",
        "!text-text-primary"
      ];
      return t.size === "sm" ? M.push("py-2 text-sm") : t.size === "lg" ? M.push("py-3 text-lg") : M.push("py-2.5 text-base"), M;
    }), R = (M, z, J) => {
      const H = [...Z.value];
      return H.push(J ? "cursor-not-allowed opacity-50" : "cursor-pointer"), (M || z) && H.push("bg-[#f3f4f6] dark:bg-[#111827]"), z && H.push("font-medium"), H.join(" ");
    };
    return (M, z) => {
      const J = fr("FLabel");
      return p(), w("div", sp, [
        e.label ? (p(), Pe(J, {
          key: 0,
          "for-id": l.value,
          label: e.label,
          required: e.required,
          size: e.size,
          disabled: e.disabled
        }, null, 8, ["for-id", "label", "required", "size", "disabled"])) : X("", !0),
        Ae(D(Lu), {
          "model-value": v.value,
          "onUpdate:modelValue": K,
          multiple: "",
          as: "div",
          class: "relative",
          disabled: e.disabled
        }, {
          default: xe(({ open: H }) => [
            Ae(D(Nu), {
              id: l.value,
              class: me(B.value),
              "aria-invalid": e.error ? "true" : void 0,
              "aria-required": e.required ? "true" : void 0
            }, {
              default: xe(() => [
                _("div", ip, [
                  v.value.length ? (p(), w(_e, { key: 0 }, [
                    e.showSelectedLength ? X("", !0) : (p(), w("div", up, [
                      (p(!0), w(_e, null, Ie(v.value, (le) => (p(), w("span", {
                        key: le.key,
                        class: "inline-flex items-center gap-1 rounded-xl !bg-bg-primary px-2 py-1 text-xs text-text-primary dark:!bg-gray-900"
                      }, [
                        Qe(he(le.label) + " ", 1),
                        _("button", {
                          type: "button",
                          class: "opacity-60 hover:opacity-100",
                          onClick: ot((j) => ue(le), ["stop"]),
                          "aria-label": "Seçimi kaldır"
                        }, [...z[1] || (z[1] = [
                          _("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-3.5 w-3.5",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [
                            _("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M6 18 18 6M6 6l12 12"
                            })
                          ], -1)
                        ])], 8, dp)
                      ]))), 128))
                    ])),
                    _("span", cp, he(g.value), 1),
                    e.showSelectedLength ? (p(), w("span", fp, he(g.value), 1)) : X("", !0)
                  ], 64)) : (p(), w("span", mp, he(e.placeholder), 1))
                ]),
                _("span", {
                  class: me(["ml-3 inline-flex h-5 w-5 items-center justify-center text-gray-500 transition-transform duration-150", { "rotate-180": H }])
                }, [...z[2] || (z[2] = [
                  _("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.5",
                    stroke: "currentColor",
                    class: "h-4 w-4"
                  }, [
                    _("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "m19.5 8.25-7.5 7.5-7.5-7.5"
                    })
                  ], -1)
                ])], 2)
              ]),
              _: 2
            }, 1032, ["id", "class", "aria-invalid", "aria-required"]),
            Ae(Pn, {
              leave: "transition ease-in duration-100",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: xe(() => [
                H ? (p(), Pe(D(Vu), {
                  key: 0,
                  class: "absolute z-[12000] mt-2 w-full overflow-hidden rounded-2xl border border-[#E6E6E6] !bg-bg-primary !text-text-primary shadow-lg focus:outline-none dark:border-[#404040]"
                }, {
                  default: xe(() => [
                    _("div", pp, [
                      _("div", vp, [
                        On(_("input", {
                          "onUpdate:modelValue": z[0] || (z[0] = (le) => S.value = le),
                          type: "text",
                          placeholder: e.searchPlaceholder,
                          class: "w-full rounded-xl border border-[#E6E6E6] bg-transparent px-3 py-2 text-sm outline-none focus:border-current dark:border-[#404040]"
                        }, null, 8, gp), [
                          [iu, S.value]
                        ]),
                        z[3] || (z[3] = _("span", { class: "pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-500" }, [
                          _("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-4 w-4",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "stroke-width": "1.5"
                          }, [
                            _("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              d: "M21 21l-4.35-4.35m0 0A7.5 7.5 0 1 0 6.75 6.75a7.5 7.5 0 0 0 9.9 9.9z"
                            })
                          ])
                        ], -1))
                      ])
                    ]),
                    _("div", hp, [
                      m.value ? (p(!0), w(_e, { key: 0 }, Ie($.value, (le) => (p(), w("div", {
                        key: le.key,
                        class: "py-1"
                      }, [
                        _("div", yp, he(le.label), 1),
                        (p(!0), w(_e, null, Ie(le.options, (j) => (p(), Pe(D(Yr), {
                          key: j.key,
                          value: j,
                          disabled: j.disabled,
                          as: "template"
                        }, {
                          default: xe(({ active: q, selected: P, disabled: Q }) => [
                            _("li", {
                              class: me(R(q, P, Q))
                            }, [
                              _("span", wp, he(j.label), 1),
                              N(j) ? (p(), w("span", bp, [...z[4] || (z[4] = [
                                _("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  class: "h-4 w-4",
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  stroke: "currentColor",
                                  "stroke-width": "1.5"
                                }, [
                                  _("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "m4.5 12.75 6 6 9-13.5"
                                  })
                                ], -1)
                              ])])) : X("", !0)
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["value", "disabled"]))), 128))
                      ]))), 128)) : (p(!0), w(_e, { key: 1 }, Ie(O.value, (le) => (p(), Pe(D(Yr), {
                        key: le.key,
                        value: le,
                        disabled: le.disabled,
                        as: "template"
                      }, {
                        default: xe(({ active: j, selected: q, disabled: P }) => [
                          _("li", {
                            class: me(R(j, q, P))
                          }, [
                            _("span", _p, he(le.label), 1),
                            N(le) ? (p(), w("span", xp, [...z[5] || (z[5] = [
                              _("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-4 w-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "1.5"
                              }, [
                                _("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  d: "m4.5 12.75 6 6 9-13.5"
                                })
                              ], -1)
                            ])])) : X("", !0)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["value", "disabled"]))), 128)),
                      L.value ? (p(), w("div", kp, " Sonuç bulunamadı ")) : X("", !0)
                    ])
                  ]),
                  _: 1
                })) : X("", !0)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["model-value", "disabled"]),
        e.error && e.errorMessage ? (p(), w("p", Cp, he(e.errorMessage), 1)) : e.hint ? (p(), w("p", Sp, he(e.hint), 1)) : X("", !0)
      ]);
    };
  }
}), Mp = { class: "f-textarea-wrapper" }, Ep = { class: "relative" }, Pp = ["id", "value", "placeholder", "disabled", "required", "rows", "maxlength"], $p = {
  key: 0,
  class: "absolute top-3 right-3 pointer-events-none"
}, Ap = {
  key: 1,
  class: "mt-2 flex items-center justify-between"
}, Tp = {
  key: 0,
  class: "text-sm text-red-500"
}, Dp = {
  key: 1,
  class: "text-sm text-text-secondary"
}, Rp = {
  key: 2,
  class: "flex-1"
}, Op = { class: "text-sm text-text-secondary" }, Ip = {
  key: 0,
  class: "mt-2 text-sm text-red-500"
}, Fp = {
  key: 1,
  class: "mt-2 text-sm text-text-secondary"
}, Lp = /* @__PURE__ */ Ce({
  __name: "FTextarea",
  props: {
    modelValue: { default: "" },
    label: {},
    placeholder: {},
    hint: {},
    error: { type: Boolean, default: !1 },
    errorMessage: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    rows: { default: 3 },
    maxLength: {},
    showCharacterCount: { type: Boolean, default: !1 },
    autoResize: { type: Boolean, default: !1 },
    size: { default: "md" },
    product: {}
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(e, { emit: n }) {
    const t = e, a = n, r = ee(null), l = k(() => `f-textarea-${Math.random().toString(36).substr(2, 9)}`), o = k(() => {
      var d;
      return ((d = t.modelValue) == null ? void 0 : d.length) || 0;
    }), { currentProductColor: i } = gn(), s = (d) => {
      const m = d.target;
      a("update:modelValue", m.value), t.autoResize && c();
    }, u = k(() => t.product || i.value), c = () => {
      r.value && (r.value.style.height = "auto", r.value.style.height = `${r.value.scrollHeight}px`);
    };
    Be(() => t.modelValue, async () => {
      t.autoResize && (await it(), c());
    });
    const f = k(() => ({
      // Base styles
      "block w-full rounded-2xl border transition-colors resize-none bg-bg-primary": !0,
      "focus:outline-none focus:ring-0 focus:ring-offset-0": !0,
      "disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:cursor-not-allowed disabled:opacity-60": !0,
      // Normal state - product renginde focus border
      "border-[#E6E6E6] dark:border-[#404040]": !t.error,
      [`focus:border-${u.value}`]: !t.error,
      // Error state
      "border-red-500 focus:border-red-500 pr-10": t.error,
      // Sizes
      "px-3 py-2 text-sm": t.size === "sm",
      "px-4 py-2.5 text-base": t.size === "md",
      "px-6 py-3 text-lg": t.size === "lg",
      // Auto-resize
      "resize-y": !t.autoResize,
      "overflow-hidden": t.autoResize
    }));
    return (d, m) => {
      const y = fr("FLabel");
      return p(), w("div", Mp, [
        e.label ? (p(), Pe(y, {
          key: 0,
          "for-id": l.value,
          label: e.label,
          required: e.required,
          size: e.size,
          disabled: e.disabled
        }, null, 8, ["for-id", "label", "required", "size", "disabled"])) : X("", !0),
        _("div", Ep, [
          _("textarea", {
            id: l.value,
            ref_key: "textareaRef",
            ref: r,
            value: e.modelValue,
            placeholder: e.placeholder,
            disabled: e.disabled,
            required: e.required,
            rows: e.rows,
            maxlength: e.maxLength,
            class: me(f.value),
            onInput: s,
            onBlur: m[0] || (m[0] = (v) => d.$emit("blur", v)),
            onFocus: m[1] || (m[1] = (v) => d.$emit("focus", v))
          }, null, 42, Pp),
          e.error ? (p(), w("div", $p, [...m[2] || (m[2] = [
            _("span", { class: "text-red-500" }, "⚠️", -1)
          ])])) : X("", !0)
        ]),
        e.showCharacterCount && e.maxLength ? (p(), w("div", Ap, [
          e.error && e.errorMessage ? (p(), w("p", Tp, he(e.errorMessage), 1)) : e.hint ? (p(), w("p", Dp, he(e.hint), 1)) : (p(), w("span", Rp)),
          _("span", Op, he(o.value) + " / " + he(e.maxLength), 1)
        ])) : (p(), w(_e, { key: 2 }, [
          e.error && e.errorMessage ? (p(), w("p", Ip, he(e.errorMessage), 1)) : e.hint ? (p(), w("p", Fp, he(e.hint), 1)) : X("", !0)
        ], 64))
      ]);
    };
  }
}), Np = { class: "f-checkbox-wrapper" }, Vp = ["for"], Bp = { class: "relative flex items-center mr-4" }, Hp = ["id", "checked", "indeterminate", "disabled"], zp = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "3",
  stroke: "currentColor",
  class: "w-3 h-3 text-white"
}, Up = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "3",
  stroke: "currentColor",
  class: "w-3 h-3 text-white"
}, Yp = {
  key: 0,
  class: "ml-3 flex-1"
}, jp = {
  key: 0,
  class: "text-sm text-text-secondary mt-1"
}, Zp = {
  key: 0,
  class: "mt-2 text-sm text-red-500 ml-7"
}, zb = /* @__PURE__ */ Ce({
  __name: "FCheckbox",
  props: {
    modelValue: { type: [Boolean, Array], default: !1 },
    value: {},
    label: {},
    description: {},
    error: { type: Boolean, default: !1 },
    errorMessage: {},
    disabled: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    color: { default: "primary" },
    size: { default: "md" },
    product: {}
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = n, r = k(() => `f-checkbox-${Math.random().toString(36).substr(2, 9)}`), l = k(() => Array.isArray(t.modelValue) ? t.value !== void 0 && t.modelValue.includes(t.value) : t.modelValue === !0), o = (v) => {
      const S = v.target;
      if (Array.isArray(t.modelValue)) {
        const g = [...t.modelValue];
        if (S.checked && t.value !== void 0)
          g.push(t.value);
        else if (!S.checked && t.value !== void 0) {
          const b = g.indexOf(t.value);
          b > -1 && g.splice(b, 1);
        }
        a("update:modelValue", g), a("change", g);
      } else
        a("update:modelValue", S.checked), a("change", S.checked);
    }, i = k(() => {
      switch (t.size) {
        case "sm":
          return "w-4 h-4";
        case "lg":
          return "w-6 h-6";
        default:
          return "w-5 h-5";
      }
    }), { currentProductColor: s } = gn(), u = k(() => {
      if (t.product) {
        const v = Vt[t.product];
        return (v == null ? void 0 : v.primaryColor) || s.value;
      }
      return s.value;
    }), c = k(() => {
      if (t.disabled) return "bg-gray-300 border-gray-300";
      if (t.error) return "bg-red-500 border-red-500";
      switch (t.color) {
        case "success":
          return "bg-green-500 border-green-500";
        case "warning":
          return "bg-yellow-500 border-yellow-500";
        case "error":
          return "bg-red-500 border-red-500";
        default:
          return "";
      }
    }), f = k(() => ({
      "peer sr-only": !0
      // Hide native checkbox, show custom indicator
    })), d = k(() => {
      const v = {
        "absolute inset-0 flex items-center justify-center rounded transition-all": !0,
        "border pointer-events-none": !0,
        [i.value]: !0,
        "bg-bg-primary border-border-default": !0,
        "opacity-60 cursor-not-allowed": t.disabled
      };
      return t.error && (v["border-red-500"] = !0), c.value && (l.value || t.indeterminate) && (v[c.value] = !0), v;
    }), m = k(() => {
      if (t.disabled) return {};
      const v = {}, S = u.value;
      return !t.error && t.color === "primary" && typeof S == "string" ? (v.borderColor = S, (l.value || t.indeterminate) && (v.backgroundColor = S, v.color = "#FFFFFF")) : t.error && (l.value || t.indeterminate) && (v.backgroundColor = "#EF4444", v.color = "#FFFFFF"), v;
    }), y = k(() => ({
      "text-sm font-medium": !0,
      "text-text-primary": !t.disabled,
      "text-text-secondary opacity-60": t.disabled
    }));
    return (v, S) => (p(), w("div", Np, [
      _("label", {
        for: r.value,
        class: "inline-flex items-start cursor-pointer"
      }, [
        _("div", Bp, [
          _("input", {
            id: r.value,
            type: "checkbox",
            checked: l.value,
            indeterminate: e.indeterminate,
            disabled: e.disabled,
            class: me(f.value),
            onChange: o
          }, null, 42, Hp),
          _("div", {
            class: me(d.value),
            style: tt(m.value)
          }, [
            l.value && !e.indeterminate ? (p(), w("svg", zp, [...S[0] || (S[0] = [
              _("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "m4.5 12.75 6 6 9-13.5"
              }, null, -1)
            ])])) : e.indeterminate ? (p(), w("svg", Up, [...S[1] || (S[1] = [
              _("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M5 12h14"
              }, null, -1)
            ])])) : X("", !0)
          ], 6)
        ]),
        e.label || v.$slots.default ? (p(), w("div", Yp, [
          _("span", {
            class: me(y.value)
          }, [
            ge(v.$slots, "default", {}, () => [
              Qe(he(e.label), 1)
            ])
          ], 2),
          e.description ? (p(), w("p", jp, he(e.description), 1)) : X("", !0)
        ])) : X("", !0)
      ], 8, Vp),
      e.error && e.errorMessage ? (p(), w("p", Zp, he(e.errorMessage), 1)) : X("", !0)
    ]));
  }
}), Gp = { class: "f-radio-wrapper" }, Wp = {
  key: 0,
  class: "block text-sm font-medium text-text-primary mb-3"
}, qp = {
  key: 0,
  class: "text-red-500 ml-1"
}, Kp = ["for"], Xp = { class: "relative flex items-center" }, Qp = ["id", "name", "value", "checked", "disabled", "onChange"], Jp = { class: "ml-6 flex-1" }, ev = {
  key: 0,
  class: "text-sm text-text-secondary mt-1"
}, tv = {
  key: 1,
  class: "mt-2 text-sm text-red-500"
}, nv = {
  key: 2,
  class: "mt-2 text-sm text-text-secondary"
}, Ub = /* @__PURE__ */ Ce({
  __name: "FRadio",
  props: {
    modelValue: {},
    options: {},
    groupLabel: {},
    name: {},
    hint: {},
    error: { type: Boolean, default: !1 },
    errorMessage: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    layout: { default: "vertical" },
    color: { default: "primary" },
    size: { default: "md" }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = n, r = k(() => `f-radio-group-${Math.random().toString(36).substr(2, 9)}`), l = (v) => {
      a("update:modelValue", v), a("change", v);
    }, o = k(() => {
      switch (t.size) {
        case "sm":
          return "w-4 h-4";
        case "lg":
          return "w-6 h-6";
        default:
          return "w-5 h-5";
      }
    }), i = k(() => {
      switch (t.size) {
        case "sm":
          return "w-2 h-2";
        case "lg":
          return "w-3 h-3";
        default:
          return "w-2.5 h-2.5";
      }
    }), s = k(() => {
      if (t.disabled) return "border-gray-300";
      if (t.error) return "border-red-500";
      switch (t.color) {
        case "success":
          return "border-green-500";
        case "warning":
          return "border-yellow-500";
        case "error":
          return "border-red-500";
        default:
          return "border-brand-primary";
      }
    }), u = k(() => {
      if (t.disabled) return "bg-gray-300";
      if (t.error) return "bg-red-500";
      switch (t.color) {
        case "success":
          return "bg-green-500";
        case "warning":
          return "bg-yellow-500";
        case "error":
          return "bg-red-500";
        default:
          return "bg-brand-primary";
      }
    }), c = k(() => ({
      "flex gap-6": !0,
      "flex-col": t.layout === "vertical",
      "flex-row flex-wrap": t.layout === "horizontal"
    })), f = k(() => ({
      "peer sr-only": !0
      // Hide native radio, show custom indicator
    })), d = (v) => ({
      "absolute inset-0 flex items-center justify-center rounded-full transition-all": !0,
      "border-2": !0,
      "pointer-events-none": !0,
      // Size
      [o.value]: !0,
      // Unchecked state
      "border-gray-300 bg-white": t.modelValue !== v.value && !t.error,
      // Checked state
      [s.value]: t.modelValue === v.value,
      // Hover state (via peer)
      "peer-hover:border-gray-400": t.modelValue !== v.value && !v.disabled && !t.disabled && !t.error,
      // Focus state (via peer)
      "peer-focus:ring-2 peer-focus:ring-offset-2": !v.disabled && !t.disabled,
      "peer-focus:ring-brand-primary": !t.error,
      "peer-focus:ring-red-500": t.error,
      // Disabled state
      "opacity-60 cursor-not-allowed": v.disabled || t.disabled
    }), m = k(() => ({
      "rounded-full transition-all": !0,
      [i.value]: !0,
      [u.value]: !0
    })), y = (v) => ({
      "text-sm font-medium": !0,
      [v.labelClass ?? ""]: !!v.labelClass,
      "text-text-primary": !v.disabled && !t.disabled,
      "text-text-secondary opacity-60": v.disabled || t.disabled
    });
    return (v, S) => (p(), w("div", Gp, [
      e.groupLabel ? (p(), w("label", Wp, [
        Qe(he(e.groupLabel) + " ", 1),
        e.required ? (p(), w("span", qp, "*")) : X("", !0)
      ])) : X("", !0),
      _("div", {
        class: me(c.value)
      }, [
        (p(!0), w(_e, null, Ie(e.options, (g) => (p(), w("label", {
          key: g.value,
          for: `${r.value}-${g.value}`,
          class: me(["inline-flex items-start cursor-pointer", { "opacity-60 cursor-not-allowed": g.disabled || e.disabled }])
        }, [
          _("div", Xp, [
            _("input", {
              id: `${r.value}-${g.value}`,
              type: "radio",
              name: e.name || r.value,
              value: g.value,
              checked: e.modelValue === g.value,
              disabled: g.disabled || e.disabled,
              class: me(f.value),
              onChange: (b) => l(g.value)
            }, null, 42, Qp),
            _("div", {
              class: me(d(g))
            }, [
              e.modelValue === g.value ? (p(), w("div", {
                key: 0,
                class: me(m.value)
              }, null, 2)) : X("", !0)
            ], 2)
          ]),
          _("div", Jp, [
            _("span", {
              class: me(y(g))
            }, he(g.label), 3),
            g.description ? (p(), w("p", ev, he(g.description), 1)) : X("", !0)
          ])
        ], 10, Kp))), 128))
      ], 2),
      e.error && e.errorMessage ? (p(), w("p", tv, he(e.errorMessage), 1)) : e.hint ? (p(), w("p", nv, he(e.hint), 1)) : X("", !0)
    ]));
  }
}), Uu = 6048e5, av = 864e5, rv = 6e4, Yu = 36e5, lv = 1e3, si = Symbol.for("constructDateFrom");
function Xe(e, n) {
  return typeof e == "function" ? e(n) : e && typeof e == "object" && si in e ? e[si](n) : e instanceof Date ? new e.constructor(n) : new Date(n);
}
function Oe(e, n) {
  return Xe(n || e, e);
}
function sn(e, n, t) {
  const a = Oe(e, t == null ? void 0 : t.in);
  return isNaN(n) ? Xe((t == null ? void 0 : t.in) || e, NaN) : (n && a.setDate(a.getDate() + n), a);
}
function cn(e, n, t) {
  const a = Oe(e, t == null ? void 0 : t.in);
  if (isNaN(n)) return Xe(e, NaN);
  if (!n)
    return a;
  const r = a.getDate(), l = Xe(e, a.getTime());
  l.setMonth(a.getMonth() + n + 1, 0);
  const o = l.getDate();
  return r >= o ? l : (a.setFullYear(
    l.getFullYear(),
    l.getMonth(),
    r
  ), a);
}
function ju(e, n, t) {
  const {
    years: a = 0,
    months: r = 0,
    weeks: l = 0,
    days: o = 0,
    hours: i = 0,
    minutes: s = 0,
    seconds: u = 0
  } = n, c = Oe(e, t == null ? void 0 : t.in), f = r || a ? cn(c, r + a * 12) : c, d = o || l ? sn(f, o + l * 7) : f, m = s + i * 60, v = (u + m * 60) * 1e3;
  return Xe(e, +d + v);
}
function ov(e, n, t) {
  return Xe(e, +Oe(e) + n);
}
function sv(e, n, t) {
  return ov(e, n * Yu);
}
let iv = {};
function ga() {
  return iv;
}
function vn(e, n) {
  var i, s, u, c;
  const t = ga(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((s = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : s.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, r = Oe(e, n == null ? void 0 : n.in), l = r.getDay(), o = (l < a ? 7 : 0) + l - a;
  return r.setDate(r.getDate() - o), r.setHours(0, 0, 0, 0), r;
}
function $a(e, n) {
  return vn(e, { ...n, weekStartsOn: 1 });
}
function Zu(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in), a = t.getFullYear(), r = Xe(t, 0);
  r.setFullYear(a + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const l = $a(r), o = Xe(t, 0);
  o.setFullYear(a, 0, 4), o.setHours(0, 0, 0, 0);
  const i = $a(o);
  return t.getTime() >= l.getTime() ? a + 1 : t.getTime() >= i.getTime() ? a : a - 1;
}
function jr(e) {
  const n = Oe(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function yr(e, ...n) {
  const t = Xe.bind(
    null,
    n.find((a) => typeof a == "object")
  );
  return n.map(t);
}
function ii(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in);
  return t.setHours(0, 0, 0, 0), t;
}
function Gu(e, n, t) {
  const [a, r] = yr(
    t == null ? void 0 : t.in,
    e,
    n
  ), l = ii(a), o = ii(r), i = +l - jr(l), s = +o - jr(o);
  return Math.round((i - s) / av);
}
function uv(e, n) {
  const t = Zu(e, n), a = Xe(e, 0);
  return a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0), $a(a);
}
function dv(e, n, t) {
  return cn(e, n * 3, t);
}
function Fo(e, n, t) {
  return cn(e, n * 12, t);
}
function ui(e, n) {
  const t = +Oe(e) - +Oe(n);
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function Wu(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function er(e) {
  return !(!Wu(e) && typeof e != "number" || isNaN(+Oe(e)));
}
function di(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in);
  return Math.trunc(t.getMonth() / 3) + 1;
}
function cv(e, n, t) {
  const [a, r] = yr(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return a.getFullYear() - r.getFullYear();
}
function fv(e, n, t) {
  const [a, r] = yr(
    t == null ? void 0 : t.in,
    e,
    n
  ), l = ui(a, r), o = Math.abs(cv(a, r));
  a.setFullYear(1584), r.setFullYear(1584);
  const i = ui(a, r) === -l, s = l * (o - +i);
  return s === 0 ? 0 : s;
}
function qu(e, n) {
  const [t, a] = yr(e, n.start, n.end);
  return { start: t, end: a };
}
function Ku(e, n) {
  const { start: t, end: a } = qu(n == null ? void 0 : n.in, e);
  let r = +t > +a;
  const l = r ? +t : +a, o = r ? a : t;
  o.setHours(0, 0, 0, 0);
  let i = 1;
  const s = [];
  for (; +o <= l; )
    s.push(Xe(t, o)), o.setDate(o.getDate() + i), o.setHours(0, 0, 0, 0);
  return r ? s.reverse() : s;
}
function ua(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in), a = t.getMonth(), r = a - a % 3;
  return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
}
function mv(e, n) {
  const { start: t, end: a } = qu(n == null ? void 0 : n.in, e);
  let r = +t > +a;
  const l = r ? +ua(t) : +ua(a);
  let o = ua(r ? a : t), i = 1;
  const s = [];
  for (; +o <= l; )
    s.push(Xe(t, o)), o = dv(o, i);
  return r ? s.reverse() : s;
}
function pv(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Xu(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in), a = t.getFullYear();
  return t.setFullYear(a + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function lr(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function Qu(e, n) {
  var i, s, u, c;
  const t = ga(), a = (n == null ? void 0 : n.weekStartsOn) ?? ((s = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : s.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, r = Oe(e, n == null ? void 0 : n.in), l = r.getDay(), o = (l < a ? -7 : 0) + 6 - (l - a);
  return r.setDate(r.getDate() + o), r.setHours(23, 59, 59, 999), r;
}
function ci(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in), a = t.getMonth(), r = a - a % 3 + 3;
  return t.setMonth(r, 0), t.setHours(23, 59, 59, 999), t;
}
const vv = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, gv = (e, n, t) => {
  let a;
  const r = vv[e];
  return typeof r == "string" ? a = r : n === 1 ? a = r.one : a = r.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + a : a + " ago" : a;
};
function Pl(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const hv = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, yv = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, wv = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, bv = {
  date: Pl({
    formats: hv,
    defaultWidth: "full"
  }),
  time: Pl({
    formats: yv,
    defaultWidth: "full"
  }),
  dateTime: Pl({
    formats: wv,
    defaultWidth: "full"
  })
}, _v = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, xv = (e, n, t, a) => _v[e];
function Ua(e) {
  return (n, t) => {
    const a = t != null && t.context ? String(t.context) : "standalone";
    let r;
    if (a === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : o;
      r = e.formattingValues[i] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, i = t != null && t.width ? String(t.width) : e.defaultWidth;
      r = e.values[i] || e.values[o];
    }
    const l = e.argumentCallback ? e.argumentCallback(n) : n;
    return r[l];
  };
}
const kv = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Cv = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Sv = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Mv = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Ev = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Pv = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, $v = (e, n) => {
  const t = Number(e), a = t % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Av = {
  ordinalNumber: $v,
  era: Ua({
    values: kv,
    defaultWidth: "wide"
  }),
  quarter: Ua({
    values: Cv,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Ua({
    values: Sv,
    defaultWidth: "wide"
  }),
  day: Ua({
    values: Mv,
    defaultWidth: "wide"
  }),
  dayPeriod: Ua({
    values: Ev,
    defaultWidth: "wide",
    formattingValues: Pv,
    defaultFormattingWidth: "wide"
  })
};
function Ya(e) {
  return (n, t = {}) => {
    const a = t.width, r = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], l = n.match(r);
    if (!l)
      return null;
    const o = l[0], i = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(i) ? Dv(i, (f) => f.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      Tv(i, (f) => f.test(o))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(s) : s, u = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = n.slice(o.length);
    return { value: u, rest: c };
  };
}
function Tv(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function Dv(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function Rv(e) {
  return (n, t = {}) => {
    const a = n.match(e.matchPattern);
    if (!a) return null;
    const r = a[0], l = n.match(e.parsePattern);
    if (!l) return null;
    let o = e.valueCallback ? e.valueCallback(l[0]) : l[0];
    o = t.valueCallback ? t.valueCallback(o) : o;
    const i = n.slice(r.length);
    return { value: o, rest: i };
  };
}
const Ov = /^(\d+)(th|st|nd|rd)?/i, Iv = /\d+/i, Fv = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Lv = {
  any: [/^b/i, /^(a|c)/i]
}, Nv = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Vv = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Bv = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Hv = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, zv = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Uv = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Yv = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, jv = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Zv = {
  ordinalNumber: Rv({
    matchPattern: Ov,
    parsePattern: Iv,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ya({
    matchPatterns: Fv,
    defaultMatchWidth: "wide",
    parsePatterns: Lv,
    defaultParseWidth: "any"
  }),
  quarter: Ya({
    matchPatterns: Nv,
    defaultMatchWidth: "wide",
    parsePatterns: Vv,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ya({
    matchPatterns: Bv,
    defaultMatchWidth: "wide",
    parsePatterns: Hv,
    defaultParseWidth: "any"
  }),
  day: Ya({
    matchPatterns: zv,
    defaultMatchWidth: "wide",
    parsePatterns: Uv,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ya({
    matchPatterns: Yv,
    defaultMatchWidth: "any",
    parsePatterns: jv,
    defaultParseWidth: "any"
  })
}, Ju = {
  code: "en-US",
  formatDistance: gv,
  formatLong: bv,
  formatRelative: xv,
  localize: Av,
  match: Zv,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Gv(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in);
  return Gu(t, lr(t)) + 1;
}
function Lo(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in), a = +$a(t) - +uv(t);
  return Math.round(a / Uu) + 1;
}
function No(e, n) {
  var c, f, d, m;
  const t = Oe(e, n == null ? void 0 : n.in), a = t.getFullYear(), r = ga(), l = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (d = r.locale) == null ? void 0 : d.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, o = Xe((n == null ? void 0 : n.in) || e, 0);
  o.setFullYear(a + 1, 0, l), o.setHours(0, 0, 0, 0);
  const i = vn(o, n), s = Xe((n == null ? void 0 : n.in) || e, 0);
  s.setFullYear(a, 0, l), s.setHours(0, 0, 0, 0);
  const u = vn(s, n);
  return +t >= +i ? a + 1 : +t >= +u ? a : a - 1;
}
function Wv(e, n) {
  var i, s, u, c;
  const t = ga(), a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((s = (i = n == null ? void 0 : n.locale) == null ? void 0 : i.options) == null ? void 0 : s.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, r = No(e, n), l = Xe((n == null ? void 0 : n.in) || e, 0);
  return l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0), vn(l, n);
}
function Vo(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in), a = +vn(t, n) - +Wv(t, n);
  return Math.round(a / Uu) + 1;
}
function Ke(e, n) {
  const t = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(n, "0");
  return t + a;
}
const Hn = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), a = t > 0 ? t : 1 - t;
    return Ke(n === "yy" ? a % 100 : a, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : Ke(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return Ke(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return Ke(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return Ke(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return Ke(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return Ke(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, a = e.getMilliseconds(), r = Math.trunc(
      a * Math.pow(10, t - 3)
    );
    return Ke(r, n.length);
  }
}, wa = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, fi = {
  // Era
  G: function(e, n, t) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(a, { width: "abbreviated" });
      case "GGGGG":
        return t.era(a, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const a = e.getFullYear(), r = a > 0 ? a : 1 - a;
      return t.ordinalNumber(r, { unit: "year" });
    }
    return Hn.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, a) {
    const r = No(e, a), l = r > 0 ? r : 1 - r;
    if (n === "YY") {
      const o = l % 100;
      return Ke(o, 2);
    }
    return n === "Yo" ? t.ordinalNumber(l, { unit: "year" }) : Ke(l, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = Zu(e);
    return Ke(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return Ke(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(a);
      case "QQ":
        return Ke(a, 2);
      case "Qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      case "QQQ":
        return t.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(a);
      case "qq":
        return Ke(a, 2);
      case "qo":
        return t.ordinalNumber(a, { unit: "quarter" });
      case "qqq":
        return t.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return Hn.M(e, n);
      case "Mo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      case "MMM":
        return t.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const a = e.getMonth();
    switch (n) {
      case "L":
        return String(a + 1);
      case "LL":
        return Ke(a + 1, 2);
      case "Lo":
        return t.ordinalNumber(a + 1, { unit: "month" });
      case "LLL":
        return t.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, a) {
    const r = Vo(e, a);
    return n === "wo" ? t.ordinalNumber(r, { unit: "week" }) : Ke(r, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const a = Lo(e);
    return n === "Io" ? t.ordinalNumber(a, { unit: "week" }) : Ke(a, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Hn.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const a = Gv(e);
    return n === "Do" ? t.ordinalNumber(a, { unit: "dayOfYear" }) : Ke(a, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const a = e.getDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, a) {
    const r = e.getDay(), l = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(l);
      case "ee":
        return Ke(l, 2);
      case "eo":
        return t.ordinalNumber(l, { unit: "day" });
      case "eee":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, a) {
    const r = e.getDay(), l = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(l);
      case "cc":
        return Ke(l, n.length);
      case "co":
        return t.ordinalNumber(l, { unit: "day" });
      case "ccc":
        return t.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const a = e.getDay(), r = a === 0 ? 7 : a;
    switch (n) {
      case "i":
        return String(r);
      case "ii":
        return Ke(r, n.length);
      case "io":
        return t.ordinalNumber(r, { unit: "day" });
      case "iii":
        return t.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const a = e.getHours();
    let r;
    switch (a === 12 ? r = wa.noon : a === 0 ? r = wa.midnight : r = a / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const a = e.getHours();
    let r;
    switch (a >= 17 ? r = wa.evening : a >= 12 ? r = wa.afternoon : a >= 4 ? r = wa.morning : r = wa.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), t.ordinalNumber(a, { unit: "hour" });
    }
    return Hn.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Hn.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const a = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(a, { unit: "hour" }) : Ke(a, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let a = e.getHours();
    return a === 0 && (a = 24), n === "ko" ? t.ordinalNumber(a, { unit: "hour" }) : Ke(a, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Hn.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Hn.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Hn.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      case "X":
        return pi(a);
      case "XXXX":
      case "XX":
        return oa(a);
      case "XXXXX":
      case "XXX":
      default:
        return oa(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      case "x":
        return pi(a);
      case "xxxx":
      case "xx":
        return oa(a);
      case "xxxxx":
      case "xxx":
      default:
        return oa(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + mi(a, ":");
      case "OOOO":
      default:
        return "GMT" + oa(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const a = e.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + mi(a, ":");
      case "zzzz":
      default:
        return "GMT" + oa(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const a = Math.trunc(+e / 1e3);
    return Ke(a, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    return Ke(+e, n.length);
  }
};
function mi(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), r = Math.trunc(a / 60), l = a % 60;
  return l === 0 ? t + String(r) : t + String(r) + n + Ke(l, 2);
}
function pi(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ke(Math.abs(e) / 60, 2) : oa(e, n);
}
function oa(e, n = "") {
  const t = e > 0 ? "-" : "+", a = Math.abs(e), r = Ke(Math.trunc(a / 60), 2), l = Ke(a % 60, 2);
  return t + r + n + l;
}
const vi = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, ed = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, qv = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], a = t[1], r = t[2];
  if (!r)
    return vi(e, n);
  let l;
  switch (a) {
    case "P":
      l = n.dateTime({ width: "short" });
      break;
    case "PP":
      l = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      l = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      l = n.dateTime({ width: "full" });
      break;
  }
  return l.replace("{{date}}", vi(a, n)).replace("{{time}}", ed(r, n));
}, so = {
  p: ed,
  P: qv
}, Kv = /^D+$/, Xv = /^Y+$/, Qv = ["D", "DD", "YY", "YYYY"];
function td(e) {
  return Kv.test(e);
}
function nd(e) {
  return Xv.test(e);
}
function io(e, n, t) {
  const a = Jv(e, n, t);
  if (console.warn(a), Qv.includes(e)) throw new RangeError(a);
}
function Jv(e, n, t) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${a} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const e1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, t1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, n1 = /^'([^]*?)'?$/, a1 = /''/g, r1 = /[a-zA-Z]/;
function Mn(e, n, t) {
  var c, f, d, m, y, v, S, g;
  const a = ga(), r = (t == null ? void 0 : t.locale) ?? a.locale ?? Ju, l = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((m = (d = a.locale) == null ? void 0 : d.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, o = (t == null ? void 0 : t.weekStartsOn) ?? ((v = (y = t == null ? void 0 : t.locale) == null ? void 0 : y.options) == null ? void 0 : v.weekStartsOn) ?? a.weekStartsOn ?? ((g = (S = a.locale) == null ? void 0 : S.options) == null ? void 0 : g.weekStartsOn) ?? 0, i = Oe(e, t == null ? void 0 : t.in);
  if (!er(i))
    throw new RangeError("Invalid time value");
  let s = n.match(t1).map((b) => {
    const h = b[0];
    if (h === "p" || h === "P") {
      const x = so[h];
      return x(b, r.formatLong);
    }
    return b;
  }).join("").match(e1).map((b) => {
    if (b === "''")
      return { isToken: !1, value: "'" };
    const h = b[0];
    if (h === "'")
      return { isToken: !1, value: l1(b) };
    if (fi[h])
      return { isToken: !0, value: b };
    if (h.match(r1))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + h + "`"
      );
    return { isToken: !1, value: b };
  });
  r.localize.preprocessor && (s = r.localize.preprocessor(i, s));
  const u = {
    firstWeekContainsDate: l,
    weekStartsOn: o,
    locale: r
  };
  return s.map((b) => {
    if (!b.isToken) return b.value;
    const h = b.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && nd(h) || !(t != null && t.useAdditionalDayOfYearTokens) && td(h)) && io(h, n, String(e));
    const x = fi[h[0]];
    return x(i, h, r.localize, u);
  }).join("");
}
function l1(e) {
  const n = e.match(n1);
  return n ? n[1].replace(a1, "'") : e;
}
function o1(e, n) {
  return Oe(e, n == null ? void 0 : n.in).getDay();
}
function s1(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in), a = t.getFullYear(), r = t.getMonth(), l = Xe(t, 0);
  return l.setFullYear(a, r + 1, 0), l.setHours(0, 0, 0, 0), l.getDate();
}
function i1() {
  return Object.assign({}, ga());
}
function In(e, n) {
  return Oe(e, n == null ? void 0 : n.in).getHours();
}
function u1(e, n) {
  const t = Oe(e, n == null ? void 0 : n.in).getDay();
  return t === 0 ? 7 : t;
}
function Kn(e, n) {
  return Oe(e, n == null ? void 0 : n.in).getMinutes();
}
function Ue(e, n) {
  return Oe(e, n == null ? void 0 : n.in).getMonth();
}
function Aa(e) {
  return Oe(e).getSeconds();
}
function Le(e, n) {
  return Oe(e, n == null ? void 0 : n.in).getFullYear();
}
function Ta(e, n) {
  return +Oe(e) > +Oe(n);
}
function or(e, n) {
  return +Oe(e) < +Oe(n);
}
function Sa(e, n) {
  return +Oe(e) == +Oe(n);
}
function d1(e, n) {
  const t = c1(n) ? new n(0) : Xe(n, 0);
  return t.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
function c1(e) {
  var n;
  return typeof e == "function" && ((n = e.prototype) == null ? void 0 : n.constructor) === e;
}
const f1 = 10;
class ad {
  constructor() {
    Se(this, "subPriority", 0);
  }
  validate(n, t) {
    return !0;
  }
}
class m1 extends ad {
  constructor(n, t, a, r, l) {
    super(), this.value = n, this.validateValue = t, this.setValue = a, this.priority = r, l && (this.subPriority = l);
  }
  validate(n, t) {
    return this.validateValue(n, this.value, t);
  }
  set(n, t, a) {
    return this.setValue(n, t, this.value, a);
  }
}
class p1 extends ad {
  constructor(t, a) {
    super();
    Se(this, "priority", f1);
    Se(this, "subPriority", -1);
    this.context = t || ((r) => Xe(a, r));
  }
  set(t, a) {
    return a.timestampIsSet ? t : Xe(t, d1(t, this.context));
  }
}
class We {
  run(n, t, a, r) {
    const l = this.parse(n, t, a, r);
    return l ? {
      setter: new m1(
        l.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: l.rest
    } : null;
  }
  validate(n, t, a) {
    return !0;
  }
}
class v1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 140);
    Se(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, a, r) {
    switch (a) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
      case "GGGGG":
        return r.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(t, { width: "wide" }) || r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
    }
  }
  set(t, a, r) {
    return a.era = r, t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const vt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, kn = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function gt(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function st(e, n) {
  const t = n.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: n.slice(t[0].length)
  } : null;
}
function Cn(e, n) {
  const t = n.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const a = t[1] === "+" ? 1 : -1, r = t[2] ? parseInt(t[2], 10) : 0, l = t[3] ? parseInt(t[3], 10) : 0, o = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: a * (r * Yu + l * rv + o * lv),
    rest: n.slice(t[0].length)
  };
}
function rd(e) {
  return st(vt.anyDigitsSigned, e);
}
function dt(e, n) {
  switch (e) {
    case 1:
      return st(vt.singleDigit, n);
    case 2:
      return st(vt.twoDigits, n);
    case 3:
      return st(vt.threeDigits, n);
    case 4:
      return st(vt.fourDigits, n);
    default:
      return st(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function Zr(e, n) {
  switch (e) {
    case 1:
      return st(vt.singleDigitSigned, n);
    case 2:
      return st(vt.twoDigitsSigned, n);
    case 3:
      return st(vt.threeDigitsSigned, n);
    case 4:
      return st(vt.fourDigitsSigned, n);
    default:
      return st(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function Bo(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function ld(e, n) {
  const t = n > 0, a = t ? n : 1 - n;
  let r;
  if (a <= 50)
    r = e || 100;
  else {
    const l = a + 50, o = Math.trunc(l / 100) * 100, i = e >= l % 100;
    r = e + o - (i ? 100 : 0);
  }
  return t ? r : 1 - r;
}
function od(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class g1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 130);
    Se(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, r) {
    const l = (o) => ({
      year: o,
      isTwoDigitYear: a === "yy"
    });
    switch (a) {
      case "y":
        return gt(dt(4, t), l);
      case "yo":
        return gt(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          l
        );
      default:
        return gt(dt(a.length, t), l);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, r) {
    const l = t.getFullYear();
    if (r.isTwoDigitYear) {
      const i = ld(
        r.year,
        l
      );
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const o = !("era" in a) || a.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class h1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 130);
    Se(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, r) {
    const l = (o) => ({
      year: o,
      isTwoDigitYear: a === "YY"
    });
    switch (a) {
      case "Y":
        return gt(dt(4, t), l);
      case "Yo":
        return gt(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          l
        );
      default:
        return gt(dt(a.length, t), l);
    }
  }
  validate(t, a) {
    return a.isTwoDigitYear || a.year > 0;
  }
  set(t, a, r, l) {
    const o = No(t, l);
    if (r.isTwoDigitYear) {
      const s = ld(
        r.year,
        o
      );
      return t.setFullYear(
        s,
        0,
        l.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), vn(t, l);
    }
    const i = !("era" in a) || a.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(i, 0, l.firstWeekContainsDate), t.setHours(0, 0, 0, 0), vn(t, l);
  }
}
class y1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 130);
    Se(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a) {
    return Zr(a === "R" ? 4 : a.length, t);
  }
  set(t, a, r) {
    const l = Xe(t, 0);
    return l.setFullYear(r, 0, 4), l.setHours(0, 0, 0, 0), $a(l);
  }
}
class w1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 130);
    Se(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, a) {
    return Zr(a === "u" ? 4 : a.length, t);
  }
  set(t, a, r) {
    return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class b1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 120);
    Se(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, r) {
    switch (a) {
      case "Q":
      case "QQ":
        return dt(a.length, t);
      case "Qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class _1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 120);
    Se(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, r) {
    switch (a) {
      case "q":
      case "qq":
        return dt(a.length, t);
      case "qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 4;
  }
  set(t, a, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class x1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    Se(this, "priority", 110);
  }
  parse(t, a, r) {
    const l = (o) => o - 1;
    switch (a) {
      case "M":
        return gt(
          st(vt.month, t),
          l
        );
      case "MM":
        return gt(dt(2, t), l);
      case "Mo":
        return gt(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          l
        );
      case "MMM":
        return r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(t, { width: "wide", context: "formatting" }) || r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class k1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 110);
    Se(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, r) {
    const l = (o) => o - 1;
    switch (a) {
      case "L":
        return gt(
          st(vt.month, t),
          l
        );
      case "LL":
        return gt(dt(2, t), l);
      case "Lo":
        return gt(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          l
        );
      case "LLL":
        return r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(t, { width: "wide", context: "standalone" }) || r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function C1(e, n, t) {
  const a = Oe(e, t == null ? void 0 : t.in), r = Vo(a, t) - n;
  return a.setDate(a.getDate() - r * 7), Oe(a, t == null ? void 0 : t.in);
}
class S1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 100);
    Se(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, a, r) {
    switch (a) {
      case "w":
        return st(vt.week, t);
      case "wo":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return dt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, r, l) {
    return vn(C1(t, r, l), l);
  }
}
function M1(e, n, t) {
  const a = Oe(e, t == null ? void 0 : t.in), r = Lo(a, t) - n;
  return a.setDate(a.getDate() - r * 7), a;
}
class E1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 100);
    Se(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, r) {
    switch (a) {
      case "I":
        return st(vt.week, t);
      case "Io":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return dt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 53;
  }
  set(t, a, r) {
    return $a(M1(t, r));
  }
}
const P1 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], $1 = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class A1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 90);
    Se(this, "subPriority", 1);
    Se(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, r) {
    switch (a) {
      case "d":
        return st(vt.date, t);
      case "do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return dt(a.length, t);
    }
  }
  validate(t, a) {
    const r = t.getFullYear(), l = od(r), o = t.getMonth();
    return l ? a >= 1 && a <= $1[o] : a >= 1 && a <= P1[o];
  }
  set(t, a, r) {
    return t.setDate(r), t.setHours(0, 0, 0, 0), t;
  }
}
class T1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 90);
    Se(this, "subpriority", 1);
    Se(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, r) {
    switch (a) {
      case "D":
      case "DD":
        return st(vt.dayOfYear, t);
      case "Do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return dt(a.length, t);
    }
  }
  validate(t, a) {
    const r = t.getFullYear();
    return od(r) ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
  }
  set(t, a, r) {
    return t.setMonth(0, r), t.setHours(0, 0, 0, 0), t;
  }
}
function Ho(e, n, t) {
  var f, d, m, y;
  const a = ga(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((d = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : d.weekStartsOn) ?? a.weekStartsOn ?? ((y = (m = a.locale) == null ? void 0 : m.options) == null ? void 0 : y.weekStartsOn) ?? 0, l = Oe(e, t == null ? void 0 : t.in), o = l.getDay(), s = (n % 7 + 7) % 7, u = 7 - r, c = n < 0 || n > 6 ? n - (o + u) % 7 : (s + u) % 7 - (o + u) % 7;
  return sn(l, c, t);
}
class D1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 90);
    Se(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, a, r) {
    switch (a) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, r, l) {
    return t = Ho(t, r, l), t.setHours(0, 0, 0, 0), t;
  }
}
class R1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 90);
    Se(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, r, l) {
    const o = (i) => {
      const s = Math.floor((i - 1) / 7) * 7;
      return (i + l.weekStartsOn + 6) % 7 + s;
    };
    switch (a) {
      case "e":
      case "ee":
        return gt(dt(a.length, t), o);
      case "eo":
        return gt(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          o
        );
      case "eee":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, r, l) {
    return t = Ho(t, r, l), t.setHours(0, 0, 0, 0), t;
  }
}
class O1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 90);
    Se(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, a, r, l) {
    const o = (i) => {
      const s = Math.floor((i - 1) / 7) * 7;
      return (i + l.weekStartsOn + 6) % 7 + s;
    };
    switch (a) {
      case "c":
      case "cc":
        return gt(dt(a.length, t), o);
      case "co":
        return gt(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          o
        );
      case "ccc":
        return r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(t, { width: "wide", context: "standalone" }) || r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 6;
  }
  set(t, a, r, l) {
    return t = Ho(t, r, l), t.setHours(0, 0, 0, 0), t;
  }
}
function I1(e, n, t) {
  const a = Oe(e, t == null ? void 0 : t.in), r = u1(a, t), l = n - r;
  return sn(a, l, t);
}
class F1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 90);
    Se(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, a, r) {
    const l = (o) => o === 0 ? 7 : o;
    switch (a) {
      case "i":
      case "ii":
        return dt(a.length, t);
      case "io":
        return r.ordinalNumber(t, { unit: "day" });
      case "iii":
        return gt(
          r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      case "iiiii":
        return gt(
          r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      case "iiiiii":
        return gt(
          r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      case "iiii":
      default:
        return gt(
          r.day(t, {
            width: "wide",
            context: "formatting"
          }) || r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 7;
  }
  set(t, a, r) {
    return t = I1(t, r), t.setHours(0, 0, 0, 0), t;
  }
}
class L1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 80);
    Se(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, r) {
    switch (a) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, r) {
    return t.setHours(Bo(r), 0, 0, 0), t;
  }
}
class N1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 80);
    Se(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, a, r) {
    switch (a) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, r) {
    return t.setHours(Bo(r), 0, 0, 0), t;
  }
}
class V1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 80);
    Se(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, a, r) {
    switch (a) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, a, r) {
    return t.setHours(Bo(r), 0, 0, 0), t;
  }
}
class B1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 70);
    Se(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, a, r) {
    switch (a) {
      case "h":
        return st(vt.hour12h, t);
      case "ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return dt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 12;
  }
  set(t, a, r) {
    const l = t.getHours() >= 12;
    return l && r < 12 ? t.setHours(r + 12, 0, 0, 0) : !l && r === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class H1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 70);
    Se(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, a, r) {
    switch (a) {
      case "H":
        return st(vt.hour23h, t);
      case "Ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return dt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 23;
  }
  set(t, a, r) {
    return t.setHours(r, 0, 0, 0), t;
  }
}
class z1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 70);
    Se(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, a, r) {
    switch (a) {
      case "K":
        return st(vt.hour11h, t);
      case "Ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return dt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 11;
  }
  set(t, a, r) {
    return t.getHours() >= 12 && r < 12 ? t.setHours(r + 12, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class U1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 70);
    Se(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, a, r) {
    switch (a) {
      case "k":
        return st(vt.hour24h, t);
      case "ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return dt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 1 && a <= 24;
  }
  set(t, a, r) {
    const l = r <= 24 ? r % 24 : r;
    return t.setHours(l, 0, 0, 0), t;
  }
}
class Y1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 60);
    Se(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, r) {
    switch (a) {
      case "m":
        return st(vt.minute, t);
      case "mo":
        return r.ordinalNumber(t, { unit: "minute" });
      default:
        return dt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, r) {
    return t.setMinutes(r, 0, 0), t;
  }
}
class j1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 50);
    Se(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a, r) {
    switch (a) {
      case "s":
        return st(vt.second, t);
      case "so":
        return r.ordinalNumber(t, { unit: "second" });
      default:
        return dt(a.length, t);
    }
  }
  validate(t, a) {
    return a >= 0 && a <= 59;
  }
  set(t, a, r) {
    return t.setSeconds(r, 0), t;
  }
}
class Z1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 30);
    Se(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, a) {
    const r = (l) => Math.trunc(l * Math.pow(10, -a.length + 3));
    return gt(dt(a.length, t), r);
  }
  set(t, a, r) {
    return t.setMilliseconds(r), t;
  }
}
class G1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 10);
    Se(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, a) {
    switch (a) {
      case "X":
        return Cn(
          kn.basicOptionalMinutes,
          t
        );
      case "XX":
        return Cn(kn.basic, t);
      case "XXXX":
        return Cn(
          kn.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Cn(
          kn.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Cn(kn.extended, t);
    }
  }
  set(t, a, r) {
    return a.timestampIsSet ? t : Xe(
      t,
      t.getTime() - jr(t) - r
    );
  }
}
class W1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 10);
    Se(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, a) {
    switch (a) {
      case "x":
        return Cn(
          kn.basicOptionalMinutes,
          t
        );
      case "xx":
        return Cn(kn.basic, t);
      case "xxxx":
        return Cn(
          kn.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Cn(
          kn.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Cn(kn.extended, t);
    }
  }
  set(t, a, r) {
    return a.timestampIsSet ? t : Xe(
      t,
      t.getTime() - jr(t) - r
    );
  }
}
class q1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 40);
    Se(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return rd(t);
  }
  set(t, a, r) {
    return [Xe(t, r * 1e3), { timestampIsSet: !0 }];
  }
}
class K1 extends We {
  constructor() {
    super(...arguments);
    Se(this, "priority", 20);
    Se(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return rd(t);
  }
  set(t, a, r) {
    return [Xe(t, r), { timestampIsSet: !0 }];
  }
}
const X1 = {
  G: new v1(),
  y: new g1(),
  Y: new h1(),
  R: new y1(),
  u: new w1(),
  Q: new b1(),
  q: new _1(),
  M: new x1(),
  L: new k1(),
  w: new S1(),
  I: new E1(),
  d: new A1(),
  D: new T1(),
  E: new D1(),
  e: new R1(),
  c: new O1(),
  i: new F1(),
  a: new L1(),
  b: new N1(),
  B: new V1(),
  h: new B1(),
  H: new H1(),
  K: new z1(),
  k: new U1(),
  m: new Y1(),
  s: new j1(),
  S: new Z1(),
  X: new G1(),
  x: new W1(),
  t: new q1(),
  T: new K1()
}, Q1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, J1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, eg = /^'([^]*?)'?$/, tg = /''/g, ng = /\S/, ag = /[a-zA-Z]/;
function uo(e, n, t, a) {
  var S, g, b, h, x, F, C, A;
  const r = () => Xe((a == null ? void 0 : a.in) || t, NaN), l = i1(), o = (a == null ? void 0 : a.locale) ?? l.locale ?? Ju, i = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((g = (S = a == null ? void 0 : a.locale) == null ? void 0 : S.options) == null ? void 0 : g.firstWeekContainsDate) ?? l.firstWeekContainsDate ?? ((h = (b = l.locale) == null ? void 0 : b.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, s = (a == null ? void 0 : a.weekStartsOn) ?? ((F = (x = a == null ? void 0 : a.locale) == null ? void 0 : x.options) == null ? void 0 : F.weekStartsOn) ?? l.weekStartsOn ?? ((A = (C = l.locale) == null ? void 0 : C.options) == null ? void 0 : A.weekStartsOn) ?? 0;
  if (!n)
    return e ? r() : Oe(t, a == null ? void 0 : a.in);
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: o
  }, c = [new p1(a == null ? void 0 : a.in, t)], f = n.match(J1).map((O) => {
    const $ = O[0];
    if ($ in so) {
      const L = so[$];
      return L(O, o.formatLong);
    }
    return O;
  }).join("").match(Q1), d = [];
  for (let O of f) {
    !(a != null && a.useAdditionalWeekYearTokens) && nd(O) && io(O, n, e), !(a != null && a.useAdditionalDayOfYearTokens) && td(O) && io(O, n, e);
    const $ = O[0], L = X1[$];
    if (L) {
      const { incompatibleTokens: N } = L;
      if (Array.isArray(N)) {
        const ue = d.find(
          (B) => N.includes(B.token) || B.token === $
        );
        if (ue)
          throw new RangeError(
            `The format string mustn't contain \`${ue.fullToken}\` and \`${O}\` at the same time`
          );
      } else if (L.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${O}\` and any other token at the same time`
        );
      d.push({ token: $, fullToken: O });
      const K = L.run(
        e,
        O,
        o.match,
        u
      );
      if (!K)
        return r();
      c.push(K.setter), e = K.rest;
    } else {
      if ($.match(ag))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + $ + "`"
        );
      if (O === "''" ? O = "'" : $ === "'" && (O = rg(O)), e.indexOf(O) === 0)
        e = e.slice(O.length);
      else
        return r();
    }
  }
  if (e.length > 0 && ng.test(e))
    return r();
  const m = c.map((O) => O.priority).sort((O, $) => $ - O).filter((O, $, L) => L.indexOf(O) === $).map(
    (O) => c.filter(($) => $.priority === O).sort(($, L) => L.subPriority - $.subPriority)
  ).map((O) => O[0]);
  let y = Oe(t, a == null ? void 0 : a.in);
  if (isNaN(+y)) return r();
  const v = {};
  for (const O of m) {
    if (!O.validate(y, u))
      return r();
    const $ = O.set(y, v, u);
    Array.isArray($) ? (y = $[0], Object.assign(v, $[1])) : y = $;
  }
  return y;
}
function rg(e) {
  return e.match(eg)[1].replace(tg, "'");
}
function gi(e, n, t) {
  const [a, r] = yr(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return +ua(a) == +ua(r);
}
function lg(e, n, t) {
  return sn(e, -n, t);
}
function sd(e, n, t) {
  const a = Oe(e, t == null ? void 0 : t.in), r = a.getFullYear(), l = a.getDate(), o = Xe(e, 0);
  o.setFullYear(r, n, 15), o.setHours(0, 0, 0, 0);
  const i = s1(o);
  return a.setMonth(n, Math.min(l, i)), a;
}
function et(e, n, t) {
  let a = Oe(e, t == null ? void 0 : t.in);
  return isNaN(+a) ? Xe(e, NaN) : (n.year != null && a.setFullYear(n.year), n.month != null && (a = sd(a, n.month)), n.date != null && a.setDate(n.date), n.hours != null && a.setHours(n.hours), n.minutes != null && a.setMinutes(n.minutes), n.seconds != null && a.setSeconds(n.seconds), n.milliseconds != null && a.setMilliseconds(n.milliseconds), a);
}
function og(e, n, t) {
  const a = Oe(e, t == null ? void 0 : t.in);
  return a.setHours(n), a;
}
function id(e, n, t) {
  const a = Oe(e, t == null ? void 0 : t.in);
  return a.setMilliseconds(n), a;
}
function sg(e, n, t) {
  const a = Oe(e, t == null ? void 0 : t.in);
  return a.setMinutes(n), a;
}
function ud(e, n, t) {
  const a = Oe(e, t == null ? void 0 : t.in);
  return a.setSeconds(n), a;
}
function Sn(e, n, t) {
  const a = Oe(e, t == null ? void 0 : t.in);
  return isNaN(+a) ? Xe(e, NaN) : (a.setFullYear(n), a);
}
function Da(e, n, t) {
  return cn(e, -n, t);
}
function ig(e, n, t) {
  const {
    years: a = 0,
    months: r = 0,
    weeks: l = 0,
    days: o = 0,
    hours: i = 0,
    minutes: s = 0,
    seconds: u = 0
  } = n, c = Da(e, r + a * 12, t), f = lg(c, o + l * 7, t), d = s + i * 60, y = (u + d * 60) * 1e3;
  return Xe(e, +f - y);
}
function dd(e, n, t) {
  return Fo(e, -n, t);
}
function La() {
  const e = Sc();
  return p(), w(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img",
      ...e
    },
    [
      _("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      _("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      _("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      _("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
La.compatConfig = {
  MODE: 3
};
function cd() {
  return p(), w(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      _("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      _("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
cd.compatConfig = {
  MODE: 3
};
function zo() {
  return p(), w(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      _("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
zo.compatConfig = {
  MODE: 3
};
function Uo() {
  return p(), w(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      _("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
Uo.compatConfig = {
  MODE: 3
};
function Yo() {
  return p(), w(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      _("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      _("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
Yo.compatConfig = {
  MODE: 3
};
function jo() {
  return p(), w(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      _("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
jo.compatConfig = {
  MODE: 3
};
function Zo() {
  return p(), w(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      _("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Zo.compatConfig = {
  MODE: 3
};
const jt = (e, n) => n ? new Date(e.toLocaleString("en-US", { timeZone: n })) : new Date(e), Go = (e, n, t) => co(e, n, t) || ve(), ug = (e, n, t) => {
  const a = n.dateInTz ? jt(new Date(e), n.dateInTz) : ve(e);
  return t ? Ht(a, !0) : a;
}, co = (e, n, t) => {
  if (!e) return null;
  const a = t ? Ht(ve(e), !0) : ve(e);
  return n ? n.exactMatch ? ug(e, n, t) : jt(a, n.timezone) : a;
}, dg = (e, n) => {
  if (!e) return 0;
  const t = /* @__PURE__ */ new Date(), a = new Date(t.toLocaleString("en-US", { timeZone: "UTC" })), r = new Date(t.toLocaleString("en-US", { timeZone: e })), l = (n ?? r).getTimezoneOffset() / 60;
  return (+a - +r) / (1e3 * 60 * 60) - l;
};
var an = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(an || {}), rn = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(rn || {}), fa = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(fa || {}), Rt = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(Rt || {});
const cg = ["timestamp", "date", "iso"];
var Lt = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(Lt || {}), at = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(at || {});
function hi(e) {
  return (n) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${n}T00:00:00+00:00`)).slice(0, 2);
}
function fg(e) {
  return (n) => Mn(jt(/* @__PURE__ */ new Date(`2017-01-0${n}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: e });
}
const mg = (e, n, t) => {
  const a = [1, 2, 3, 4, 5, 6, 7];
  let r;
  if (e !== null)
    try {
      r = a.map(fg(e));
    } catch {
      r = a.map(hi(n));
    }
  else
    r = a.map(hi(n));
  const l = r.slice(0, t), o = r.slice(t + 1, r.length);
  return [r[t]].concat(...o).concat(...l);
}, Wo = (e, n, t) => {
  const a = [];
  for (let r = +e[0]; r <= +e[1]; r++)
    a.push({ value: +r, text: vd(r, n) });
  return t ? a.reverse() : a;
}, fd = (e, n, t) => {
  const a = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((l) => {
    const o = l < 10 ? `0${l}` : l;
    return /* @__PURE__ */ new Date(`2017-${o}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const l = t === "long" ? "LLLL" : "LLL";
      return a.map((o, i) => {
        const s = Mn(jt(o, "UTC"), l, { locale: e });
        return {
          text: s.charAt(0).toUpperCase() + s.substring(1),
          value: i
        };
      });
    } catch {
    }
  const r = new Intl.DateTimeFormat(n, { month: t, timeZone: "UTC" });
  return a.map((l, o) => {
    const i = r.format(l);
    return {
      text: i.charAt(0).toUpperCase() + i.substring(1),
      value: o
    };
  });
}, pg = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], yt = (e) => {
  const n = D(e);
  return n != null && n.$el ? n == null ? void 0 : n.$el : n;
}, vg = (e) => ({ type: "dot", ...e ?? {} }), md = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, qo = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, bt = (e) => e, yi = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, wi = (e) => e === null, pd = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, gg = (e) => {
  const n = [], t = (a) => a.filter((r) => r);
  for (let a = 0; a < e.length; a += 3) {
    const r = [e[a], e[a + 1], e[a + 2]];
    n.push(t(r));
  }
  return n;
}, sr = (e, n, t) => {
  const a = t != null, r = n != null;
  if (!a && !r) return !1;
  const l = +t, o = +n;
  return a && r ? +e > l || +e < o : a ? +e > l : r ? +e < o : !1;
}, Ra = (e, n) => gg(e).map((t) => t.map((a) => {
  const { active: r, disabled: l, isBetween: o, highlighted: i } = n(a);
  return {
    ...a,
    active: r,
    disabled: l,
    className: {
      dp__overlay_cell_active: r,
      dp__overlay_cell: !r,
      dp__overlay_cell_disabled: l,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: l && r,
      dp__cell_in_between: o,
      "dp--highlighted": i
    }
  };
})), Gn = (e, n, t = !1) => {
  e && n.allowStopPropagation && (t && e.stopImmediatePropagation(), e.stopPropagation());
}, hg = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function yg(e, n) {
  let t = [...document.querySelectorAll(hg())];
  t = t.filter((r) => !e.contains(r) || r.hasAttribute("data-datepicker-instance"));
  const a = t.indexOf(e);
  if (a >= 0 && (n ? a - 1 >= 0 : a + 1 <= t.length))
    return t[a + (n ? -1 : 1)];
}
const fo = (e, n) => e == null ? void 0 : e.querySelector(`[data-dp-element="${n}"]`), vd = (e, n) => new Intl.NumberFormat(n, { useGrouping: !1, style: "decimal" }).format(e), Ko = (e) => Mn(e, "dd-MM-yyyy"), $l = (e) => Array.isArray(e), Gr = (e, n) => n.get(Ko(e)), wg = (e, n) => e ? n ? n instanceof Map ? !!Gr(e, n) : n(ve(e)) : !1 : !0, Bt = (e, n, t = !1, a) => {
  if (e.key === at.enter || e.key === at.space)
    return t && e.preventDefault(), n();
  if (a) return a(e);
}, bi = () => ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].some(
  (e) => navigator.userAgent.includes(e)
) || navigator.userAgent.includes("Mac") && "ontouchend" in document, _i = (e, n, t, a, r, l) => {
  const o = uo(e, n.slice(0, e.length), /* @__PURE__ */ new Date(), { locale: l });
  return er(o) && Wu(o) ? a || r ? o : et(o, {
    hours: +t.hours,
    minutes: +(t == null ? void 0 : t.minutes),
    seconds: +(t == null ? void 0 : t.seconds),
    milliseconds: 0
  }) : null;
}, bg = (e, n, t, a, r, l) => {
  const o = Array.isArray(t) ? t[0] : t;
  if (typeof n == "string")
    return _i(e, n, o, a, r, l);
  if (Array.isArray(n)) {
    let i = null;
    for (const s of n)
      if (i = _i(e, s, o, a, r, l), i)
        break;
    return i;
  }
  return typeof n == "function" ? n(e) : null;
}, ve = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), _g = (e, n, t) => {
  if (n) {
    const r = (e.getMonth() + 1).toString().padStart(2, "0"), l = e.getDate().toString().padStart(2, "0"), o = e.getHours().toString().padStart(2, "0"), i = e.getMinutes().toString().padStart(2, "0"), s = t ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${r}-${l}T${o}:${i}:${s}.000Z`;
  }
  const a = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(a).toISOString();
}, Ht = (e, n) => {
  const t = ve(JSON.parse(JSON.stringify(e))), a = et(t, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return n ? pv(a) : a;
}, Wn = (e, n, t, a) => {
  let r = e ? ve(e) : ve();
  return (n || n === 0) && (r = og(r, +n)), (t || t === 0) && (r = sg(r, +t)), (a || a === 0) && (r = ud(r, +a)), id(r, 0);
}, ut = (e, n) => !e || !n ? !1 : or(Ht(e), Ht(n)), Ye = (e, n) => !e || !n ? !1 : Sa(Ht(e), Ht(n)), ft = (e, n) => !e || !n ? !1 : Ta(Ht(e), Ht(n)), al = (e, n, t) => e != null && e[0] && e != null && e[1] ? ft(t, e[0]) && ut(t, e[1]) : e != null && e[0] && n ? ft(t, e[0]) && ut(t, n) || ut(t, e[0]) && ft(t, n) : !1, un = (e) => {
  const n = et(new Date(e), { date: 1 });
  return Ht(n);
}, Al = (e, n, t) => n && (t || t === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((a) => a === n ? [a, t] : [a, isNaN(+e[a]) ? void 0 : +e[a]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, ma = (e) => ({
  hours: In(e),
  minutes: Kn(e),
  seconds: Aa(e)
}), gd = (e, n) => {
  if (n) {
    const t = Le(ve(n));
    if (t > e) return 12;
    if (t === e) return Ue(ve(n));
  }
}, hd = (e, n) => {
  if (n) {
    const t = Le(ve(n));
    return t < e ? -1 : t === e ? Ue(ve(n)) : void 0;
  }
}, Oa = (e) => {
  if (e) return Le(ve(e));
}, yd = (e, n) => {
  const t = ft(e, n) ? n : e, a = ft(n, e) ? n : e;
  return Ku({ start: t, end: a });
}, xg = (e) => {
  const n = cn(e, 1);
  return { month: Ue(n), year: Le(n) };
}, Tn = (e, n) => {
  const t = vn(e, { weekStartsOn: +n }), a = Qu(e, { weekStartsOn: +n });
  return [t, a];
}, wd = (e, n) => {
  const t = {
    hours: In(ve()),
    minutes: Kn(ve()),
    seconds: n ? Aa(ve()) : 0
  };
  return Object.assign(t, e);
}, jn = (e, n, t) => [et(ve(e), { date: 1 }), et(ve(), { month: n, year: t, date: 1 })], Dn = (e, n, t) => {
  let a = e ? ve(e) : ve();
  return (n || n === 0) && (a = sd(a, n)), t && (a = Sn(a, t)), a;
}, bd = (e, n, t, a, r) => {
  if (!a || r && !n || !r && !t) return !1;
  const l = r ? cn(e, 1) : Da(e, 1), o = [Ue(l), Le(l)];
  return r ? !Cg(...o, n) : !kg(...o, t);
}, kg = (e, n, t) => ut(...jn(t, e, n)) || Ye(...jn(t, e, n)), Cg = (e, n, t) => ft(...jn(t, e, n)) || Ye(...jn(t, e, n)), _d = (e, n, t, a, r, l, o) => {
  if (typeof n == "function" && !o) return n(e);
  const i = t ? { locale: t } : void 0;
  return Array.isArray(e) ? `${Mn(e[0], l, i)}${r && !e[1] ? "" : a}${e[1] ? Mn(e[1], l, i) : ""}` : Mn(e, l, i);
}, ba = (e) => {
  if (e) return null;
  throw new Error(qo.prop("partial-range"));
}, Er = (e, n) => {
  if (n) return e();
  throw new Error(qo.prop("range"));
}, mo = (e) => Array.isArray(e) ? er(e[0]) && (e[1] ? er(e[1]) : !0) : e ? er(e) : !1, Sg = (e, n) => et(n ?? ve(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), Tl = (e, n, t, a) => {
  if (!e) return !0;
  if (a) {
    const r = t === "max" ? or(e, n) : Ta(e, n), l = { seconds: 0, milliseconds: 0 };
    return r || Sa(et(e, l), et(n, l));
  }
  return t === "max" ? e.getTime() <= n.getTime() : e.getTime() >= n.getTime();
}, Dl = (e, n, t) => e ? Sg(e, n) : ve(t ?? n), xi = (e, n, t, a, r) => {
  if (Array.isArray(a)) {
    const o = Dl(e, a[0], n), i = Dl(e, a[1], n);
    return Tl(a[0], o, t, !!n) && Tl(a[1], i, t, !!n) && r;
  }
  const l = Dl(e, a, n);
  return Tl(a, l, t, !!n) && r;
}, Rl = (e) => et(ve(), ma(e)), Mg = (e, n) => e instanceof Map ? Array.from(e.values()).filter((t) => Le(ve(t)) === n).map((t) => Ue(t)) : [], Eg = (e, n, t) => {
  if (e instanceof Map) {
    const a = Array.from(e.values()).filter((r) => Le(ve(r)) === n).map((r) => Ue(r));
    return a.length ? a.includes(t) : !0;
  }
  return !0;
}, xd = (e, n, t) => typeof e == "function" ? e({ month: n, year: t }) : !!e.months.find((a) => a.month === n && a.year === t), Xo = (e, n) => typeof e == "function" ? e(n) : e.years.includes(n), kd = (e) => Mn(e, "yyyy-MM-dd"), ja = qn({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), Cd = () => {
  const e = (t) => {
    ja.menuFocused = t;
  }, n = (t) => {
    ja.shiftKeyInMenu !== t && (ja.shiftKeyInMenu = t);
  };
  return {
    control: k(() => ({ shiftKeyInMenu: ja.shiftKeyInMenu, menuFocused: ja.menuFocused })),
    setMenuFocused: e,
    setShiftKey: n
  };
}, nt = qn({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), Ol = ee(null), Pr = ee(!1), Il = ee(!1), Fl = ee(!1), Ll = ee(!1), At = ee(0), ct = ee(0), Jn = () => {
  const e = k(() => Pr.value ? [...nt.selectionGrid, nt.actionRow].filter((f) => f.length) : Il.value ? [
    ...nt.timePicker[0],
    ...nt.timePicker[1],
    Ll.value ? [] : [Ol.value],
    nt.actionRow
  ].filter((f) => f.length) : Fl.value ? [...nt.monthPicker, nt.actionRow] : [nt.monthYear, ...nt.calendar, nt.time, nt.actionRow].filter((f) => f.length)), n = (f) => {
    At.value = f ? At.value + 1 : At.value - 1;
    let d = null;
    e.value[ct.value] && (d = e.value[ct.value][At.value]), !d && e.value[ct.value + (f ? 1 : -1)] ? (ct.value = ct.value + (f ? 1 : -1), At.value = f ? 0 : e.value[ct.value].length - 1) : d || (At.value = f ? At.value - 1 : At.value + 1);
  }, t = (f) => {
    ct.value === 0 && !f || ct.value === e.value.length && f || (ct.value = f ? ct.value + 1 : ct.value - 1, e.value[ct.value] ? e.value[ct.value] && !e.value[ct.value][At.value] && At.value !== 0 && (At.value = e.value[ct.value].length - 1) : ct.value = f ? ct.value - 1 : ct.value + 1);
  }, a = (f) => {
    let d = null;
    e.value[ct.value] && (d = e.value[ct.value][At.value]), d ? d.focus({ preventScroll: !Pr.value }) : At.value = f ? At.value - 1 : At.value + 1;
  }, r = () => {
    n(!0), a(!0);
  }, l = () => {
    n(!1), a(!1);
  }, o = () => {
    t(!1), a(!0);
  }, i = () => {
    t(!0), a(!0);
  }, s = (f, d) => {
    nt[d] = f;
  }, u = (f, d) => {
    nt[d] = f;
  }, c = () => {
    At.value = 0, ct.value = 0;
  };
  return {
    buildMatrix: s,
    buildMultiLevelMatrix: u,
    setTimePickerBackRef: (f) => {
      Ol.value = f;
    },
    setSelectionGrid: (f) => {
      Pr.value = f, c(), f || (nt.selectionGrid = []);
    },
    setTimePicker: (f, d = !1) => {
      Il.value = f, Ll.value = d, c(), f || (nt.timePicker[0] = [], nt.timePicker[1] = []);
    },
    setTimePickerElements: (f, d = 0) => {
      nt.timePicker[d] = f;
    },
    arrowRight: r,
    arrowLeft: l,
    arrowUp: o,
    arrowDown: i,
    clearArrowNav: () => {
      nt.monthYear = [], nt.calendar = [], nt.time = [], nt.actionRow = [], nt.selectionGrid = [], nt.timePicker[0] = [], nt.timePicker[1] = [], Pr.value = !1, Il.value = !1, Ll.value = !1, Fl.value = !1, c(), Ol.value = null;
    },
    setMonthPicker: (f) => {
      Fl.value = f, c();
    },
    refSets: nt
    // exposed for testing
  };
}, ki = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e ?? {}
}), Pg = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (n) => `Increment ${n}`,
  decrementValue: (n) => `Decrement ${n}`,
  openTpOverlay: (n) => `Open ${n} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (n) => `Month picker${n ? " overlay" : ""}`,
  yearPicker: (n) => `Year picker${n ? " overlay" : ""}`,
  timeOverlay: (n) => `${n} overlay`,
  ...e ?? {}
}), Ci = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, $g = (e) => {
  const n = typeof e == "object" && e, t = {
    static: !0,
    solo: !1
  };
  if (!e) return { ...t, count: Ci(!1) };
  const a = n ? e : {}, r = n ? a.count ?? !0 : e, l = Ci(r);
  return Object.assign(t, a, { count: l });
}, Ag = (e, n, t) => e || (typeof t == "string" ? t : n), Tg = (e) => typeof e == "boolean" ? e ? ki({}) : !1 : ki(e), Dg = (e) => {
  const n = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: "open",
    selectOnFocus: !1,
    rangeSeparator: " - "
  };
  return typeof e == "object" ? { ...n, ...e ?? {}, enabled: !0 } : { ...n, enabled: e };
}, Rg = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e ?? {}
}), Og = (e) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...e ?? {}
}), Ig = (e) => {
  const n = { input: !1 };
  return typeof e == "object" ? { ...n, ...e ?? {}, enabled: !0 } : {
    enabled: e,
    ...n
  };
}, Fg = (e) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, shadowDom: !1, mobileBreakpoint: 600, setDateOnMenuClose: !1, ...e ?? {} }), Lg = (e) => {
  const n = {
    dates: Array.isArray(e) ? e.map((t) => ve(t)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof e == "function" ? e : { ...n, ...e ?? {} };
}, Ng = (e) => typeof e == "object" ? {
  type: (e == null ? void 0 : e.type) ?? "local",
  hideOnOffsetDates: (e == null ? void 0 : e.hideOnOffsetDates) ?? !1
} : {
  type: e,
  hideOnOffsetDates: !1
}, Vg = (e) => {
  const n = {
    noDisabledRange: !1,
    showLastInRange: !0,
    minMaxRawRange: !1,
    partialRange: !0,
    disableTimeRangeValidation: !1,
    maxRange: void 0,
    minRange: void 0,
    autoRange: void 0,
    fixedStart: !1,
    fixedEnd: !1
  };
  return typeof e == "object" ? { enabled: !0, ...n, ...e } : {
    enabled: e,
    ...n
  };
}, Bg = (e) => e ? typeof e == "string" ? {
  timezone: e,
  exactMatch: !1,
  dateInTz: void 0,
  emitTimezone: void 0,
  convertModel: !0
} : {
  timezone: e.timezone,
  exactMatch: e.exactMatch ?? !1,
  dateInTz: e.dateInTz ?? void 0,
  emitTimezone: e.emitTimezone ?? void 0,
  convertModel: e.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: void 0 }, Nl = (e, n, t) => new Map(
  e.map((a) => {
    const r = Go(a, n, t);
    return [Ko(r), r];
  })
), Hg = (e, n) => e.length ? new Map(
  e.map((t) => {
    const a = Go(t.date, n);
    return [Ko(a), t];
  })
) : null, zg = (e) => {
  var n;
  return {
    minDate: co(e.minDate, e.timezone, e.isSpecific),
    maxDate: co(e.maxDate, e.timezone, e.isSpecific),
    disabledDates: $l(e.disabledDates) ? Nl(e.disabledDates, e.timezone, e.isSpecific) : e.disabledDates,
    allowedDates: $l(e.allowedDates) ? Nl(e.allowedDates, e.timezone, e.isSpecific) : null,
    highlight: typeof e.highlight == "object" && $l((n = e.highlight) == null ? void 0 : n.dates) ? Nl(e.highlight.dates, e.timezone) : e.highlight,
    markers: Hg(e.markers, e.timezone)
  };
}, Ug = (e) => typeof e == "boolean" ? { enabled: e, dragSelect: !0, limit: null } : {
  enabled: !!e,
  limit: e.limit ? +e.limit : null,
  dragSelect: e.dragSelect ?? !0
}, Yg = (e) => ({
  ...Object.fromEntries(
    Object.keys(e).map((n) => {
      const t = n, a = e[t], r = typeof e[t] == "string" ? { [a]: !0 } : Object.fromEntries(a.map((l) => [l, !0]));
      return [n, r];
    })
  )
}), lt = (e) => {
  const n = () => {
    const C = e.enableSeconds ? ":ss" : "", A = e.enableMinutes ? ":mm" : "";
    return e.is24 ? `HH${A}${C}` : `hh${A}${C} aa`;
  }, t = () => {
    var C;
    return e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? n() : e.weekPicker ? `${((C = S.value) == null ? void 0 : C.type) === "iso" ? "RR" : "ww"}-yyyy` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${n()}` : "MM/dd/yyyy";
  }, a = (C) => wd(C, e.enableSeconds), r = () => x.value.enabled ? e.startTime && Array.isArray(e.startTime) ? [a(e.startTime[0]), a(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? a(e.startTime) : null, l = k(() => $g(e.multiCalendars)), o = k(() => r()), i = k(() => Pg(e.ariaLabels)), s = k(() => Rg(e.filters)), u = k(() => Tg(e.transitions)), c = k(() => Og(e.actionRow)), f = k(
    () => Ag(e.previewFormat, e.format, t())
  ), d = k(() => Dg(e.textInput)), m = k(() => Ig(e.inline)), y = k(() => Fg(e.config)), v = k(() => Lg(e.highlight)), S = k(() => Ng(e.weekNumbers)), g = k(() => Bg(e.timezone)), b = k(() => Ug(e.multiDates)), h = k(
    () => zg({
      minDate: e.minDate,
      maxDate: e.maxDate,
      disabledDates: e.disabledDates,
      allowedDates: e.allowedDates,
      highlight: v.value,
      markers: e.markers,
      timezone: g.value,
      isSpecific: e.monthPicker || e.yearPicker || e.quarterPicker
    })
  ), x = k(() => Vg(e.range)), F = k(() => Yg(e.ui));
  return {
    defaultedTransitions: u,
    defaultedMultiCalendars: l,
    defaultedStartTime: o,
    defaultedAriaLabels: i,
    defaultedFilters: s,
    defaultedActionRow: c,
    defaultedPreviewFormat: f,
    defaultedTextInput: d,
    defaultedInline: m,
    defaultedConfig: y,
    defaultedHighlight: v,
    defaultedWeekNumbers: S,
    defaultedRange: x,
    propDates: h,
    defaultedTz: g,
    defaultedMultiDates: b,
    defaultedUI: F,
    getDefaultPattern: t,
    getDefaultStartTime: r
  };
}, jg = (e, n, t) => {
  const a = ee(), { defaultedTextInput: r, defaultedRange: l, defaultedTz: o, defaultedMultiDates: i, getDefaultPattern: s } = lt(n), u = ee(""), c = Ea(n, "format"), f = Ea(n, "formatLocale");
  Be(
    a,
    () => {
      typeof n.onInternalModelChange == "function" && e("internal-model-change", a.value, ce(!0));
    },
    { deep: !0 }
  ), Be(l, (U, ye) => {
    U.enabled !== ye.enabled && (a.value = null);
  }), Be(c, () => {
    z();
  });
  const d = (U) => o.value.timezone && o.value.convertModel ? jt(U, o.value.timezone) : U, m = (U) => {
    if (o.value.timezone && o.value.convertModel) {
      const ye = dg(o.value.timezone, U);
      return sv(U, ye);
    }
    return U;
  }, y = (U, ye, Ee = !1) => _d(
    U,
    n.format,
    n.formatLocale,
    r.value.rangeSeparator,
    n.modelAuto,
    ye ?? s(),
    Ee
  ), v = (U) => U ? n.modelType ? H(U) : {
    hours: In(U),
    minutes: Kn(U),
    seconds: n.enableSeconds ? Aa(U) : 0
  } : null, S = (U) => n.modelType ? H(U) : { month: Ue(U), year: Le(U) }, g = (U) => Array.isArray(U) ? i.value.enabled ? U.map((ye) => b(ye, Sn(ve(), ye))) : Er(
    () => [
      Sn(ve(), U[0]),
      U[1] ? Sn(ve(), U[1]) : ba(l.value.partialRange)
    ],
    l.value.enabled
  ) : Sn(ve(), +U), b = (U, ye) => (typeof U == "string" || typeof U == "number") && n.modelType ? J(U) : ye, h = (U) => Array.isArray(U) ? [
    b(
      U[0],
      Wn(null, +U[0].hours, +U[0].minutes, U[0].seconds)
    ),
    b(
      U[1],
      Wn(null, +U[1].hours, +U[1].minutes, U[1].seconds)
    )
  ] : b(U, Wn(null, U.hours, U.minutes, U.seconds)), x = (U) => {
    const ye = et(ve(), { date: 1 });
    return Array.isArray(U) ? i.value.enabled ? U.map((Ee) => b(Ee, Dn(ye, +Ee.month, +Ee.year))) : Er(
      () => [
        b(U[0], Dn(ye, +U[0].month, +U[0].year)),
        b(
          U[1],
          U[1] ? Dn(ye, +U[1].month, +U[1].year) : ba(l.value.partialRange)
        )
      ],
      l.value.enabled
    ) : b(U, Dn(ye, +U.month, +U.year));
  }, F = (U) => {
    if (Array.isArray(U))
      return U.map((ye) => J(ye));
    throw new Error(qo.dateArr("multi-dates"));
  }, C = (U) => {
    if (Array.isArray(U) && l.value.enabled) {
      const ye = U[0], Ee = U[1];
      return [
        ve(Array.isArray(ye) ? ye[0] : null),
        Array.isArray(Ee) && Ee.length ? ve(Ee[0]) : null
      ];
    }
    return ve(U[0]);
  }, A = (U) => n.modelAuto ? Array.isArray(U) ? [J(U[0]), J(U[1])] : n.autoApply ? [J(U)] : [J(U), null] : Array.isArray(U) ? Er(
    () => U[1] ? [
      J(U[0]),
      U[1] ? J(U[1]) : ba(l.value.partialRange)
    ] : [J(U[0])],
    l.value.enabled
  ) : J(U), O = () => {
    Array.isArray(a.value) && l.value.enabled && a.value.length === 1 && a.value.push(ba(l.value.partialRange));
  }, $ = () => {
    const U = a.value;
    return [
      H(U[0]),
      U[1] ? H(U[1]) : ba(l.value.partialRange)
    ];
  }, L = () => a.value[1] ? $() : H(bt(a.value[0])), N = () => (a.value || []).map((U) => H(U)), K = (U = !1) => (U || O(), n.modelAuto ? L() : i.value.enabled ? N() : Array.isArray(a.value) ? Er(() => $(), l.value.enabled) : H(bt(a.value))), ue = (U) => !U || Array.isArray(U) && !U.length ? null : n.timePicker ? h(bt(U)) : n.monthPicker ? x(bt(U)) : n.yearPicker ? g(bt(U)) : i.value.enabled ? F(bt(U)) : n.weekPicker ? C(bt(U)) : A(bt(U)), B = (U) => {
    const ye = ue(U);
    mo(bt(ye)) ? (a.value = bt(ye), z()) : (a.value = null, u.value = "");
  }, Z = () => {
    const U = (ye) => Mn(ye, r.value.format);
    return `${U(a.value[0])} ${r.value.rangeSeparator} ${a.value[1] ? U(a.value[1]) : ""}`;
  }, R = () => t.value && a.value ? Array.isArray(a.value) ? Z() : Mn(a.value, r.value.format) : y(a.value), M = () => a.value ? i.value.enabled ? a.value.map((U) => y(U)).join("; ") : r.value.enabled && typeof r.value.format == "string" ? R() : y(a.value) : "", z = () => {
    !n.format || typeof n.format == "string" || r.value.enabled && typeof r.value.format == "string" ? u.value = M() : u.value = n.format(a.value);
  }, J = (U) => {
    if (n.utc) {
      const ye = new Date(U);
      return n.utc === "preserve" ? new Date(ye.getTime() + ye.getTimezoneOffset() * 6e4) : ye;
    }
    return n.modelType ? cg.includes(n.modelType) ? d(new Date(U)) : n.modelType === "format" && (typeof n.format == "string" || !n.format) ? d(
      uo(U, s(), /* @__PURE__ */ new Date(), { locale: f.value })
    ) : d(
      uo(U, n.modelType, /* @__PURE__ */ new Date(), { locale: f.value })
    ) : d(new Date(U));
  }, H = (U) => U ? n.utc ? _g(U, n.utc === "preserve", n.enableSeconds) : n.modelType ? n.modelType === "timestamp" ? +m(U) : n.modelType === "iso" ? m(U).toISOString() : n.modelType === "format" && (typeof n.format == "string" || !n.format) ? y(m(U)) : y(m(U), n.modelType, !0) : m(U) : "", le = (U, ye = !1, Ee = !1) => {
    if (Ee) return U;
    if (e("update:model-value", U), o.value.emitTimezone && ye) {
      const qe = Array.isArray(U) ? U.map((ie) => jt(bt(ie), o.value.emitTimezone)) : jt(bt(U), o.value.emitTimezone);
      e("update:model-timezone-value", qe);
    }
  }, j = (U) => Array.isArray(a.value) ? i.value.enabled ? a.value.map((ye) => U(ye)) : [
    U(a.value[0]),
    a.value[1] ? U(a.value[1]) : ba(l.value.partialRange)
  ] : U(bt(a.value)), q = () => {
    if (Array.isArray(a.value)) {
      const U = Tn(a.value[0], n.weekStart), ye = a.value[1] ? Tn(a.value[1], n.weekStart) : [];
      return [U.map((Ee) => ve(Ee)), ye.map((Ee) => ve(Ee))];
    }
    return Tn(a.value, n.weekStart).map((U) => ve(U));
  }, P = (U, ye) => le(bt(j(U)), !1, ye), Q = (U) => {
    const ye = q();
    return U ? ye : e("update:model-value", q());
  }, ce = (U = !1) => (U || z(), n.monthPicker ? P(S, U) : n.timePicker ? P(v, U) : n.yearPicker ? P(Le, U) : n.weekPicker ? Q(U) : le(K(U), !0, U));
  return {
    inputValue: u,
    internalModelValue: a,
    checkBeforeEmit: () => a.value ? l.value.enabled ? l.value.partialRange ? a.value.length >= 1 : a.value.length === 2 : !!a.value : !1,
    parseExternalModelValue: B,
    formatInputValue: z,
    emitModelValue: ce
  };
}, Zg = (e, n) => {
  const { defaultedFilters: t, propDates: a } = lt(e), { validateMonthYearInRange: r } = ea(e), l = (c, f) => {
    let d = c;
    return t.value.months.includes(Ue(d)) ? (d = f ? cn(c, 1) : Da(c, 1), l(d, f)) : d;
  }, o = (c, f) => {
    let d = c;
    return t.value.years.includes(Le(d)) ? (d = f ? Fo(c, 1) : dd(c, 1), o(d, f)) : d;
  }, i = (c, f = !1) => {
    const d = et(ve(), { month: e.month, year: e.year });
    let m = c ? cn(d, 1) : Da(d, 1);
    e.disableYearSelect && (m = Sn(m, e.year));
    let y = Ue(m), v = Le(m);
    t.value.months.includes(y) && (m = l(m, c), y = Ue(m), v = Le(m)), t.value.years.includes(v) && (m = o(m, c), v = Le(m)), r(y, v, c, e.preventMinMaxNavigation) && s(y, v, f);
  }, s = (c, f, d) => {
    n("update-month-year", { month: c, year: f, fromNav: d });
  }, u = k(() => (c) => bd(
    et(ve(), { month: e.month, year: e.year }),
    a.value.maxDate,
    a.value.minDate,
    e.preventMinMaxNavigation,
    c
  ));
  return { handleMonthYearChange: i, isDisabled: u, updateMonthYear: s };
}, rl = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: [Boolean, String], default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, yn = {
  ...rl,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 },
  isMobile: { type: Boolean, default: void 0 }
}, Gg = ["title"], Wg = ["disabled"], qg = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...yn
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: n }) {
    const t = n, a = e, {
      defaultedActionRow: r,
      defaultedPreviewFormat: l,
      defaultedMultiCalendars: o,
      defaultedTextInput: i,
      defaultedInline: s,
      defaultedRange: u,
      defaultedMultiDates: c
    } = lt(a), { isTimeValid: f, isMonthValid: d } = ea(a), { buildMatrix: m } = Jn(), y = ee(null), v = ee(null), S = ee(!1), g = ee({}), b = ee(null), h = ee(null);
    He(() => {
      a.arrowNavigation && m([yt(y), yt(v)], "actionRow"), x(), window.addEventListener("resize", x);
    }), wt(() => {
      window.removeEventListener("resize", x);
    });
    const x = () => {
      S.value = !1, setTimeout(() => {
        var B, Z;
        const R = (B = b.value) == null ? void 0 : B.getBoundingClientRect(), M = (Z = h.value) == null ? void 0 : Z.getBoundingClientRect();
        R && M && (g.value.maxWidth = `${M.width - R.width - 20}px`), S.value = !0;
      }, 0);
    }, F = k(() => u.value.enabled && !u.value.partialRange && a.internalModelValue ? a.internalModelValue.length === 2 : !0), C = k(
      () => !f.value(a.internalModelValue) || !d.value(a.internalModelValue) || !F.value
    ), A = () => {
      const B = l.value;
      return a.timePicker || a.monthPicker, B(bt(a.internalModelValue));
    }, O = () => {
      const B = a.internalModelValue;
      return o.value.count > 0 ? `${$(B[0])} - ${$(B[1])}` : [$(B[0]), $(B[1])];
    }, $ = (B) => _d(
      B,
      l.value,
      a.formatLocale,
      i.value.rangeSeparator,
      a.modelAuto,
      l.value
    ), L = k(() => !a.internalModelValue || !a.menuMount ? "" : typeof l.value == "string" ? Array.isArray(a.internalModelValue) ? a.internalModelValue.length === 2 && a.internalModelValue[1] ? O() : c.value.enabled ? a.internalModelValue.map((B) => `${$(B)}`) : a.modelAuto ? `${$(a.internalModelValue[0])}` : `${$(a.internalModelValue[0])} -` : $(a.internalModelValue) : A()), N = () => c.value.enabled ? "; " : " - ", K = k(
      () => Array.isArray(L.value) ? L.value.join(N()) : L.value
    ), ue = () => {
      f.value(a.internalModelValue) && d.value(a.internalModelValue) && F.value ? t("select-date") : t("invalid-select");
    };
    return (B, Z) => (p(), w("div", {
      ref_key: "actionRowRef",
      ref: h,
      class: "dp__action_row"
    }, [
      B.$slots["action-row"] ? ge(B.$slots, "action-row", kt(xt({ key: 0 }, {
        internalModelValue: B.internalModelValue,
        disabled: C.value,
        selectDate: () => B.$emit("select-date"),
        closePicker: () => B.$emit("close-picker")
      }))) : (p(), w(_e, { key: 1 }, [
        D(r).showPreview ? (p(), w("div", {
          key: 0,
          class: "dp__selection_preview",
          title: K.value,
          style: tt(g.value)
        }, [
          B.$slots["action-preview"] && S.value ? ge(B.$slots, "action-preview", {
            key: 0,
            value: B.internalModelValue
          }) : X("", !0),
          !B.$slots["action-preview"] && S.value ? (p(), w(_e, { key: 1 }, [
            Qe(he(K.value), 1)
          ], 64)) : X("", !0)
        ], 12, Gg)) : X("", !0),
        _("div", {
          ref_key: "actionBtnContainer",
          ref: b,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          B.$slots["action-buttons"] ? ge(B.$slots, "action-buttons", {
            key: 0,
            value: B.internalModelValue
          }) : X("", !0),
          B.$slots["action-buttons"] ? X("", !0) : (p(), w(_e, { key: 1 }, [
            !D(s).enabled && D(r).showCancel ? (p(), w("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: y,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: Z[0] || (Z[0] = (R) => B.$emit("close-picker")),
              onKeydown: Z[1] || (Z[1] = (R) => D(Bt)(R, () => B.$emit("close-picker")))
            }, he(B.cancelText), 545)) : X("", !0),
            D(r).showNow ? (p(), w("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: Z[2] || (Z[2] = (R) => B.$emit("select-now")),
              onKeydown: Z[3] || (Z[3] = (R) => D(Bt)(R, () => B.$emit("select-now")))
            }, he(B.nowButtonLabel), 33)) : X("", !0),
            D(r).showSelect ? (p(), w("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: v,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: C.value,
              "data-test-id": "select-button",
              onKeydown: Z[4] || (Z[4] = (R) => D(Bt)(R, () => ue())),
              onClick: ue
            }, he(B.selectText), 41, Wg)) : X("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), Kg = ["role", "aria-label", "tabindex"], Xg = { class: "dp__selection_grid_header" }, Qg = ["aria-selected", "aria-disabled", "data-test-id", "onClick", "onKeydown", "onMouseover"], Jg = ["aria-label"], wr = /* @__PURE__ */ Ce({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {},
    overlayLabel: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: n, emit: t }) {
    const { setSelectionGrid: a, buildMultiLevelMatrix: r, setMonthPicker: l } = Jn(), o = t, i = e, { defaultedAriaLabels: s, defaultedTextInput: u, defaultedConfig: c } = lt(
      i
    ), { hideNavigationButtons: f } = sl(), d = ee(!1), m = ee(null), y = ee(null), v = ee([]), S = ee(), g = ee(null), b = ee(0), h = ee(null);
    Mc(() => {
      m.value = null;
    }), He(() => {
      it().then(() => N()), i.noOverlayFocus || F(), x(!0);
    }), wt(() => x(!1));
    const x = (j) => {
      var q;
      i.arrowNavigation && ((q = i.headerRefs) != null && q.length ? l(j) : a(j));
    }, F = () => {
      var j;
      const q = yt(y);
      q && (u.value.enabled || (m.value ? (j = m.value) == null || j.focus({ preventScroll: !0 }) : q.focus({ preventScroll: !0 })), d.value = q.clientHeight < q.scrollHeight);
    }, C = k(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !i.useRelative,
        "dp--overlay-relative": i.useRelative
      })
    ), A = k(
      () => i.useRelative ? { height: `${i.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), O = k(() => ({
      dp__overlay_col: !0
    })), $ = k(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: d.value,
        dp__button_bottom: i.isLast
      })
    ), L = k(() => {
      var j, q;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((j = i.items) == null ? void 0 : j.length) <= 6,
        dp__container_block: ((q = i.items) == null ? void 0 : q.length) > 6
      };
    });
    Be(
      () => i.items,
      () => N(!1),
      { deep: !0 }
    );
    const N = (j = !0) => {
      it().then(() => {
        const q = yt(m), P = yt(y), Q = yt(g), ce = yt(h), U = Q ? Q.getBoundingClientRect().height : 0;
        P && (P.getBoundingClientRect().height ? b.value = P.getBoundingClientRect().height - U : b.value = c.value.modeHeight - U), q && ce && j && (ce.scrollTop = q.offsetTop - ce.offsetTop - (b.value / 2 - q.getBoundingClientRect().height) - U);
      });
    }, K = (j) => {
      j.disabled || o("selected", j.value);
    }, ue = () => {
      o("toggle"), o("reset-flow");
    }, B = () => {
      i.escClose && ue();
    }, Z = (j, q, P, Q) => {
      j && ((q.active || q.value === i.focusValue) && (m.value = j), i.arrowNavigation && (Array.isArray(v.value[P]) ? v.value[P][Q] = j : v.value[P] = [j], R()));
    }, R = () => {
      var j, q;
      const P = (j = i.headerRefs) != null && j.length ? [i.headerRefs].concat(v.value) : v.value.concat([i.skipButtonRef ? [] : [g.value]]);
      r(bt(P), (q = i.headerRefs) != null && q.length ? "monthPicker" : "selectionGrid");
    }, M = (j) => {
      i.arrowNavigation || Gn(j, c.value, !0);
    }, z = (j) => {
      S.value = j, o("hover-value", j);
    }, J = () => {
      if (ue(), !i.isLast) {
        const j = fo(i.menuWrapRef ?? null, "action-row");
        if (j) {
          const q = pd(j);
          q == null || q.focus();
        }
      }
    }, H = (j) => {
      switch (j.key) {
        case at.esc:
          return B();
        case at.arrowLeft:
          return M(j);
        case at.arrowRight:
          return M(j);
        case at.arrowUp:
          return M(j);
        case at.arrowDown:
          return M(j);
        default:
          return;
      }
    }, le = (j) => {
      if (j.key === at.enter) return ue();
      if (j.key === at.tab) return J();
    };
    return n({ focusGrid: F }), (j, q) => {
      var P;
      return p(), w("div", {
        ref_key: "gridWrapRef",
        ref: y,
        class: me(C.value),
        style: tt(A.value),
        role: j.useRelative ? void 0 : "dialog",
        "aria-label": j.overlayLabel,
        tabindex: j.useRelative ? void 0 : "0",
        onKeydown: H,
        onClick: q[0] || (q[0] = ot(() => {
        }, ["prevent"]))
      }, [
        _("div", {
          ref_key: "containerRef",
          ref: h,
          class: me(L.value),
          style: tt({ "--dp-overlay-height": `${b.value}px` }),
          role: "grid"
        }, [
          _("div", Xg, [
            ge(j.$slots, "header")
          ]),
          j.$slots.overlay ? ge(j.$slots, "overlay", { key: 0 }) : (p(!0), w(_e, { key: 1 }, Ie(j.items, (Q, ce) => (p(), w("div", {
            key: ce,
            class: me(["dp__overlay_row", { dp__flex_row: j.items.length >= 3 }]),
            role: "row"
          }, [
            (p(!0), w(_e, null, Ie(Q, (U, ye) => (p(), w("div", {
              key: U.value,
              ref_for: !0,
              ref: (Ee) => Z(Ee, U, ce, ye),
              role: "gridcell",
              class: me(O.value),
              "aria-selected": U.active || void 0,
              "aria-disabled": U.disabled || void 0,
              tabindex: "0",
              "data-test-id": U.text,
              onClick: ot((Ee) => K(U), ["prevent"]),
              onKeydown: (Ee) => D(Bt)(Ee, () => K(U), !0),
              onMouseover: (Ee) => z(U.value)
            }, [
              _("div", {
                class: me(U.className)
              }, [
                j.$slots.item ? ge(j.$slots, "item", {
                  key: 0,
                  item: U
                }) : X("", !0),
                j.$slots.item ? X("", !0) : (p(), w(_e, { key: 1 }, [
                  Qe(he(U.text), 1)
                ], 64))
              ], 2)
            ], 42, Qg))), 128))
          ], 2))), 128))
        ], 6),
        j.$slots["button-icon"] ? On((p(), w("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: g,
          type: "button",
          "aria-label": (P = D(s)) == null ? void 0 : P.toggleOverlay,
          class: me($.value),
          tabindex: "0",
          onClick: ue,
          onKeydown: le
        }, [
          ge(j.$slots, "button-icon")
        ], 42, Jg)), [
          [Qa, !D(f)(j.hideNavigation, j.type)]
        ]) : X("", !0)
      ], 46, Kg);
    };
  }
}), e5 = ["data-dp-mobile"], ll = /* @__PURE__ */ Ce({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean },
    isMobile: { type: Boolean }
  },
  setup(e) {
    const n = e, t = k(
      () => n.multiCalendars > 0 ? [...Array(n.multiCalendars).keys()] : [0]
    ), a = k(() => ({
      dp__instance_calendar: n.multiCalendars > 0
    }));
    return (r, l) => (p(), w("div", {
      class: me({
        dp__menu_inner: !r.stretch,
        "dp--menu--inner-stretched": r.stretch,
        dp__flex_display: r.multiCalendars > 0,
        "dp--flex-display-collapsed": r.collapse
      }),
      "data-dp-mobile": r.isMobile
    }, [
      (p(!0), w(_e, null, Ie(t.value, (o, i) => (p(), w("div", {
        key: o,
        class: me(a.value)
      }, [
        ge(r.$slots, "default", {
          instance: o,
          index: i
        })
      ], 2))), 128))
    ], 10, e5));
  }
}), t5 = ["data-dp-element", "aria-label", "aria-disabled"], tr = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: n }) {
    const t = n, a = ee(null);
    return He(() => t("set-ref", a)), (r, l) => (p(), w("button", {
      ref_key: "elRef",
      ref: a,
      type: "button",
      "data-dp-element": r.elName,
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": r.ariaLabel,
      "aria-disabled": r.disabled || void 0,
      onClick: l[0] || (l[0] = (o) => r.$emit("activate")),
      onKeydown: l[1] || (l[1] = (o) => D(Bt)(o, () => r.$emit("activate"), !0))
    }, [
      _("span", {
        class: me(["dp__inner_nav", { dp__inner_nav_disabled: r.disabled }])
      }, [
        ge(r.$slots, "default")
      ], 2)
    ], 40, t5));
  }
}), n5 = ["aria-label", "data-test-id"], Sd = /* @__PURE__ */ Ce({
  __name: "YearModePicker",
  props: {
    ...yn,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: n }) {
    const t = n, a = e, { showRightIcon: r, showLeftIcon: l } = sl(), { defaultedConfig: o, defaultedMultiCalendars: i, defaultedAriaLabels: s, defaultedTransitions: u, defaultedUI: c } = lt(a), { showTransition: f, transitionName: d } = br(u), m = ee(!1), y = (g = !1, b) => {
      m.value = !m.value, t("toggle-year-picker", { flow: g, show: b });
    }, v = (g) => {
      m.value = !1, t("year-select", g);
    }, S = (g = !1) => {
      t("handle-year", g);
    };
    return (g, b) => {
      var h, x, F, C, A;
      return p(), w(_e, null, [
        _("div", {
          class: me(["dp--year-mode-picker", { "dp--hidden-el": m.value }])
        }, [
          D(l)(D(i), e.instance) ? (p(), Pe(tr, {
            key: 0,
            ref: "mpPrevIconRef",
            "aria-label": (h = D(s)) == null ? void 0 : h.prevYear,
            disabled: e.isDisabled(!1),
            class: me((x = D(c)) == null ? void 0 : x.navBtnPrev),
            onActivate: b[0] || (b[0] = (O) => S(!1))
          }, {
            default: xe(() => [
              g.$slots["arrow-left"] ? ge(g.$slots, "arrow-left", { key: 0 }) : X("", !0),
              g.$slots["arrow-left"] ? X("", !0) : (p(), Pe(D(zo), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : X("", !0),
          _("button", {
            ref: "mpYearButtonRef",
            class: "dp__btn dp--year-select",
            type: "button",
            "aria-label": `${e.year}-${(F = D(s)) == null ? void 0 : F.openYearsOverlay}`,
            "data-test-id": `year-mode-btn-${e.instance}`,
            onClick: b[1] || (b[1] = () => y(!1)),
            onKeydown: b[2] || (b[2] = Ec(() => y(!1), ["enter"]))
          }, [
            g.$slots.year ? ge(g.$slots, "year", {
              key: 0,
              year: e.year
            }) : X("", !0),
            g.$slots.year ? X("", !0) : (p(), w(_e, { key: 1 }, [
              Qe(he(e.year), 1)
            ], 64))
          ], 40, n5),
          D(r)(D(i), e.instance) ? (p(), Pe(tr, {
            key: 1,
            ref: "mpNextIconRef",
            "aria-label": (C = D(s)) == null ? void 0 : C.nextYear,
            disabled: e.isDisabled(!0),
            class: me((A = D(c)) == null ? void 0 : A.navBtnNext),
            onActivate: b[3] || (b[3] = (O) => S(!0))
          }, {
            default: xe(() => [
              g.$slots["arrow-right"] ? ge(g.$slots, "arrow-right", { key: 0 }) : X("", !0),
              g.$slots["arrow-right"] ? X("", !0) : (p(), Pe(D(Uo), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : X("", !0)
        ], 2),
        Ae(Pn, {
          name: D(d)(e.showYearPicker),
          css: D(f)
        }, {
          default: xe(() => {
            var O, $;
            return [
              e.showYearPicker ? (p(), Pe(wr, {
                key: 0,
                items: e.items,
                "text-input": g.textInput,
                "esc-close": g.escClose,
                config: g.config,
                "is-last": g.autoApply && !D(o).keepActionRow,
                "hide-navigation": g.hideNavigation,
                "aria-labels": g.ariaLabels,
                "overlay-label": ($ = (O = D(s)) == null ? void 0 : O.yearPicker) == null ? void 0 : $.call(O, !0),
                type: "year",
                onToggle: y,
                onSelected: b[4] || (b[4] = (L) => v(L))
              }, It({
                "button-icon": xe(() => [
                  g.$slots["calendar-icon"] ? ge(g.$slots, "calendar-icon", { key: 0 }) : X("", !0),
                  g.$slots["calendar-icon"] ? X("", !0) : (p(), Pe(D(La), { key: 1 }))
                ]),
                _: 2
              }, [
                g.$slots["year-overlay-value"] ? {
                  name: "item",
                  fn: xe(({ item: L }) => [
                    ge(g.$slots, "year-overlay-value", {
                      text: L.text,
                      value: L.value
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels", "overlay-label"])) : X("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 64);
    };
  }
}), Qo = (e, n, t) => {
  if (n.value && Array.isArray(n.value))
    if (n.value.some((a) => Ye(e, a))) {
      const a = n.value.filter((r) => !Ye(r, e));
      n.value = a.length ? a : null;
    } else (t && +t > n.value.length || !t) && n.value.push(e);
  else
    n.value = [e];
}, Jo = (e, n, t) => {
  let a = e.value ? e.value.slice() : [];
  return a.length === 2 && a[1] !== null && (a = []), a.length ? (ut(n, a[0]) ? a.unshift(n) : a[1] = n, t("range-end", n)) : (a = [n], t("range-start", n)), a;
}, ol = (e, n, t, a) => {
  e && (e[0] && e[1] && t && n("auto-apply"), e[0] && !e[1] && a && t && n("auto-apply"));
}, Md = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((n) => jt(ve(n), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = jt(ve(e.value), e.timezone));
}, Ed = (e, n, t, a) => Array.isArray(n.value) && (n.value.length === 2 || n.value.length === 1 && a.value.partialRange) ? a.value.fixedStart && (ft(e, n.value[0]) || Ye(e, n.value[0])) ? [n.value[0], e] : a.value.fixedEnd && (ut(e, n.value[1]) || Ye(e, n.value[1])) ? [e, n.value[1]] : (t("invalid-fixed-range", e), n.value) : [], Pd = ({
  multiCalendars: e,
  range: n,
  highlight: t,
  propDates: a,
  calendars: r,
  modelValue: l,
  props: o,
  filters: i,
  year: s,
  month: u,
  emit: c
}) => {
  const f = k(() => Wo(o.yearRange, o.locale, o.reverseYears)), d = ee([!1]), m = k(() => (L, N) => {
    const K = et(un(/* @__PURE__ */ new Date()), {
      month: u.value(L),
      year: s.value(L)
    }), ue = N ? Xu(K) : lr(K);
    return bd(
      ue,
      a.value.maxDate,
      a.value.minDate,
      o.preventMinMaxNavigation,
      N
    );
  }), y = () => Array.isArray(l.value) && e.value.solo && l.value[1], v = () => {
    for (let L = 0; L < e.value.count; L++)
      if (L === 0)
        r.value[L] = r.value[0];
      else if (L === e.value.count - 1 && y())
        r.value[L] = {
          month: Ue(l.value[1]),
          year: Le(l.value[1])
        };
      else {
        const N = et(ve(), r.value[L - 1]);
        r.value[L] = { month: Ue(N), year: Le(Fo(N, 1)) };
      }
  }, S = (L) => {
    if (!L) return v();
    const N = et(ve(), r.value[L]);
    return r.value[0].year = Le(dd(N, e.value.count - 1)), v();
  }, g = (L, N) => {
    const K = fv(N, L);
    return n.value.showLastInRange && K > 1 ? N : L;
  }, b = (L) => o.focusStartDate || e.value.solo ? L[0] : L[1] ? g(L[0], L[1]) : L[0], h = () => {
    if (l.value) {
      const L = Array.isArray(l.value) ? b(l.value) : l.value;
      r.value[0] = { month: Ue(L), year: Le(L) };
    }
  }, x = () => {
    h(), e.value.count && v();
  };
  Be(l, (L, N) => {
    o.isTextInputDate && JSON.stringify(L ?? {}) !== JSON.stringify(N ?? {}) && x();
  }), He(() => {
    x();
  });
  const F = (L, N) => {
    r.value[N].year = L, c("update-month-year", { instance: N, year: L, month: r.value[N].month }), e.value.count && !e.value.solo && S(N);
  }, C = k(() => (L) => Ra(f.value, (N) => {
    var K;
    const ue = s.value(L) === N.value, B = sr(
      N.value,
      Oa(a.value.minDate),
      Oa(a.value.maxDate)
    ) || ((K = i.value.years) == null ? void 0 : K.includes(s.value(L))), Z = Xo(t.value, N.value);
    return { active: ue, disabled: B, highlighted: Z };
  })), A = (L, N) => {
    F(L, N), $(N);
  }, O = (L, N = !1) => {
    if (!m.value(L, N)) {
      const K = N ? s.value(L) + 1 : s.value(L) - 1;
      F(K, L);
    }
  }, $ = (L, N = !1, K) => {
    N || c("reset-flow"), K !== void 0 ? d.value[L] = K : d.value[L] = !d.value[L], d.value[L] ? c("overlay-toggle", { open: !0, overlay: Rt.year }) : (c("overlay-closed"), c("overlay-toggle", { open: !1, overlay: Rt.year }));
  };
  return {
    isDisabled: m,
    groupedYears: C,
    showYearPicker: d,
    selectYear: F,
    toggleYearPicker: $,
    handleYearSelect: A,
    handleYear: O
  };
}, a5 = (e, n) => {
  const {
    defaultedMultiCalendars: t,
    defaultedAriaLabels: a,
    defaultedTransitions: r,
    defaultedConfig: l,
    defaultedRange: o,
    defaultedHighlight: i,
    propDates: s,
    defaultedTz: u,
    defaultedFilters: c,
    defaultedMultiDates: f
  } = lt(e), d = () => {
    e.isTextInputDate && x(Le(ve(e.startDate)), 0);
  }, { modelValue: m, year: y, month: v, calendars: S } = _r(e, n, d), g = k(() => fd(e.formatLocale, e.locale, e.monthNameFormat)), b = ee(null), { checkMinMaxRange: h } = ea(e), {
    selectYear: x,
    groupedYears: F,
    showYearPicker: C,
    toggleYearPicker: A,
    handleYearSelect: O,
    handleYear: $,
    isDisabled: L
  } = Pd({
    modelValue: m,
    multiCalendars: t,
    range: o,
    highlight: i,
    calendars: S,
    year: y,
    propDates: s,
    month: v,
    filters: c,
    props: e,
    emit: n
  });
  He(() => {
    e.startDate && (m.value && e.focusStartDate || !m.value) && x(Le(ve(e.startDate)), 0);
  });
  const N = (P) => P ? { month: Ue(P), year: Le(P) } : { month: null, year: null }, K = () => m.value ? Array.isArray(m.value) ? m.value.map((P) => N(P)) : N(m.value) : N(), ue = (P, Q) => {
    const ce = S.value[P], U = K();
    return Array.isArray(U) ? U.some((ye) => ye.year === (ce == null ? void 0 : ce.year) && ye.month === Q) : (ce == null ? void 0 : ce.year) === U.year && Q === U.month;
  }, B = (P, Q, ce) => {
    var U, ye;
    const Ee = K();
    return Array.isArray(Ee) ? y.value(Q) === ((U = Ee[ce]) == null ? void 0 : U.year) && P === ((ye = Ee[ce]) == null ? void 0 : ye.month) : !1;
  }, Z = (P, Q) => {
    if (o.value.enabled) {
      const ce = K();
      if (Array.isArray(m.value) && Array.isArray(ce)) {
        const U = B(P, Q, 0) || B(P, Q, 1), ye = Dn(un(ve()), P, y.value(Q));
        return al(m.value, b.value, ye) && !U;
      }
      return !1;
    }
    return !1;
  }, R = k(() => (P) => Ra(g.value, (Q) => {
    var ce;
    const U = ue(P, Q.value), ye = sr(
      Q.value,
      gd(y.value(P), s.value.minDate),
      hd(y.value(P), s.value.maxDate)
    ) || Mg(s.value.disabledDates, y.value(P)).includes(Q.value) || ((ce = c.value.months) == null ? void 0 : ce.includes(Q.value)) || !Eg(s.value.allowedDates, y.value(P), Q.value), Ee = Z(Q.value, P), qe = xd(i.value, Q.value, y.value(P));
    return { active: U, disabled: ye, isBetween: Ee, highlighted: qe };
  })), M = (P, Q) => Dn(un(ve()), P, y.value(Q)), z = (P, Q) => {
    const ce = m.value ? m.value : un(/* @__PURE__ */ new Date());
    m.value = Dn(ce, P, y.value(Q)), n("auto-apply"), n("update-flow-step");
  }, J = (P, Q) => {
    const ce = M(P, Q);
    o.value.fixedEnd || o.value.fixedStart ? m.value = Ed(ce, m, n, o) : m.value ? h(ce, m.value) && (m.value = Jo(m, M(P, Q), n)) : m.value = [M(P, Q)], it().then(() => {
      ol(m.value, n, e.autoApply, e.modelAuto);
    });
  }, H = (P, Q) => {
    Qo(M(P, Q), m, f.value.limit), n("auto-apply", !0);
  }, le = (P, Q) => (S.value[Q].month = P, q(Q, S.value[Q].year, P), f.value.enabled ? H(P, Q) : o.value.enabled ? J(P, Q) : z(P, Q)), j = (P, Q) => {
    x(P, Q), q(Q, P, null);
  }, q = (P, Q, ce) => {
    let U = ce;
    if (!U && U !== 0) {
      const ye = K();
      U = Array.isArray(ye) ? ye[P].month : ye.month;
    }
    n("update-month-year", { instance: P, year: Q, month: U });
  };
  return {
    groupedMonths: R,
    groupedYears: F,
    year: y,
    isDisabled: L,
    defaultedMultiCalendars: t,
    defaultedAriaLabels: a,
    defaultedTransitions: r,
    defaultedConfig: l,
    showYearPicker: C,
    modelValue: m,
    presetDate: (P, Q) => {
      Md({
        value: P,
        modelValue: m,
        range: o.value.enabled,
        timezone: Q ? void 0 : u.value.timezone
      }), n("auto-apply");
    },
    setHoverDate: (P, Q) => {
      b.value = M(P, Q);
    },
    selectMonth: le,
    selectYear: j,
    toggleYearPicker: A,
    handleYearSelect: O,
    handleYear: $,
    getModelMonthYear: K
  };
}, r5 = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...yn
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(e, { expose: n, emit: t }) {
    const a = t, r = Qn(), l = Wt(r, "yearMode"), o = e;
    He(() => {
      o.shadow || a("mount", null);
    });
    const {
      groupedMonths: i,
      groupedYears: s,
      year: u,
      isDisabled: c,
      defaultedMultiCalendars: f,
      defaultedConfig: d,
      showYearPicker: m,
      modelValue: y,
      presetDate: v,
      setHoverDate: S,
      selectMonth: g,
      selectYear: b,
      toggleYearPicker: h,
      handleYearSelect: x,
      handleYear: F,
      getModelMonthYear: C
    } = a5(o, a);
    return n({ getSidebarProps: () => ({
      modelValue: y,
      year: u,
      getModelMonthYear: C,
      selectMonth: g,
      selectYear: b,
      handleYear: F
    }), presetDate: v, toggleYearPicker: (A) => h(0, A) }), (A, O) => (p(), Pe(ll, {
      "multi-calendars": D(f).count,
      collapse: A.collapse,
      stretch: "",
      "is-mobile": A.isMobile
    }, {
      default: xe(({ instance: $ }) => [
        A.$slots["top-extra"] ? ge(A.$slots, "top-extra", {
          key: 0,
          value: A.internalModelValue
        }) : X("", !0),
        A.$slots["month-year"] ? ge(A.$slots, "month-year", kt(xt({ key: 1 }, {
          year: D(u),
          months: D(i)($),
          years: D(s)($),
          selectMonth: D(g),
          selectYear: D(b),
          instance: $
        }))) : (p(), Pe(wr, {
          key: 2,
          items: D(i)($),
          "arrow-navigation": A.arrowNavigation,
          "is-last": A.autoApply && !D(d).keepActionRow,
          "esc-close": A.escClose,
          height: D(d).modeHeight,
          config: A.config,
          "no-overlay-focus": !!(A.noOverlayFocus || A.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (L) => D(g)(L, $),
          onHoverValue: (L) => D(S)(L, $)
        }, It({
          header: xe(() => [
            Ae(Sd, xt(A.$props, {
              items: D(s)($),
              instance: $,
              "show-year-picker": D(m)[$],
              year: D(u)($),
              "is-disabled": (L) => D(c)($, L),
              onHandleYear: (L) => D(F)($, L),
              onYearSelect: (L) => D(x)(L, $),
              onToggleYearPicker: (L) => D(h)($, L == null ? void 0 : L.flow, L == null ? void 0 : L.show)
            }), It({ _: 2 }, [
              Ie(D(l), (L, N) => ({
                name: L,
                fn: xe((K) => [
                  ge(A.$slots, L, kt(Yt(K)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          A.$slots["month-overlay-value"] ? {
            name: "item",
            fn: xe(({ item: L }) => [
              ge(A.$slots, "month-overlay-value", {
                text: L.text,
                value: L.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), l5 = (e, n) => {
  const t = () => {
    e.isTextInputDate && (c.value = Le(ve(e.startDate)));
  }, { modelValue: a } = _r(e, n, t), r = ee(null), { defaultedHighlight: l, defaultedMultiDates: o, defaultedFilters: i, defaultedRange: s, propDates: u } = lt(e), c = ee();
  He(() => {
    e.startDate && (a.value && e.focusStartDate || !a.value) && (c.value = Le(ve(e.startDate)));
  });
  const f = (v) => Array.isArray(a.value) ? a.value.some((S) => Le(S) === v) : a.value ? Le(a.value) === v : !1, d = (v) => s.value.enabled && Array.isArray(a.value) ? al(a.value, r.value, y(v)) : !1, m = k(() => Ra(Wo(e.yearRange, e.locale, e.reverseYears), (v) => {
    const S = f(v.value), g = sr(
      v.value,
      Oa(u.value.minDate),
      Oa(u.value.maxDate)
    ) || i.value.years.includes(v.value), b = d(v.value) && !S, h = Xo(l.value, v.value);
    return { active: S, disabled: g, isBetween: b, highlighted: h };
  })), y = (v) => Sn(un(lr(/* @__PURE__ */ new Date())), v);
  return {
    groupedYears: m,
    modelValue: a,
    focusYear: c,
    setHoverValue: (v) => {
      r.value = Sn(un(/* @__PURE__ */ new Date()), v);
    },
    selectYear: (v) => {
      var S;
      if (n("update-month-year", { instance: 0, year: v }), o.value.enabled)
        return a.value ? Array.isArray(a.value) && (((S = a.value) == null ? void 0 : S.map((g) => Le(g))).includes(v) ? a.value = a.value.filter((g) => Le(g) !== v) : a.value.push(Sn(Ht(ve()), v))) : a.value = [Sn(Ht(lr(ve())), v)], n("auto-apply", !0);
      s.value.enabled ? (a.value = Jo(a, y(v), n), it().then(() => {
        ol(a.value, n, e.autoApply, e.modelAuto);
      })) : (a.value = y(v), n("auto-apply"));
    }
  };
}, o5 = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...yn
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(e, { expose: n, emit: t }) {
    const a = t, r = e, { groupedYears: l, modelValue: o, focusYear: i, selectYear: s, setHoverValue: u } = l5(r, a), { defaultedConfig: c } = lt(r);
    return n({ getSidebarProps: () => ({
      modelValue: o,
      selectYear: s
    }) }), (f, d) => (p(), w("div", null, [
      f.$slots["top-extra"] ? ge(f.$slots, "top-extra", {
        key: 0,
        value: f.internalModelValue
      }) : X("", !0),
      f.$slots["month-year"] ? ge(f.$slots, "month-year", kt(xt({ key: 1 }, {
        years: D(l),
        selectYear: D(s)
      }))) : (p(), Pe(wr, {
        key: 2,
        items: D(l),
        "is-last": f.autoApply && !D(c).keepActionRow,
        height: D(c).modeHeight,
        config: f.config,
        "no-overlay-focus": !!(f.noOverlayFocus || f.textInput),
        "focus-value": D(i),
        type: "year",
        "use-relative": "",
        onSelected: D(s),
        onHoverValue: D(u)
      }, It({ _: 2 }, [
        f.$slots["year-overlay-value"] ? {
          name: "item",
          fn: xe(({ item: m }) => [
            ge(f.$slots, "year-overlay-value", {
              text: m.text,
              value: m.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), s5 = {
  key: 0,
  class: "dp__time_input"
}, i5 = ["data-compact", "data-collapsed"], u5 = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], d5 = ["aria-label", "disabled", "data-test-id", "onKeydown", "onClick"], c5 = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], f5 = { key: 0 }, m5 = ["aria-label", "data-compact"], p5 = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...yn
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(e, { expose: n, emit: t }) {
    const a = t, r = e, { setTimePickerElements: l, setTimePickerBackRef: o } = Jn(), {
      defaultedAriaLabels: i,
      defaultedTransitions: s,
      defaultedFilters: u,
      defaultedConfig: c,
      defaultedRange: f,
      defaultedMultiCalendars: d
    } = lt(r), { transitionName: m, showTransition: y } = br(s), v = qn({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), S = ee("AM"), g = ee(null), b = ee([]), h = ee(), x = ee(!1);
    He(() => {
      a("mounted");
    });
    const F = (T) => et(/* @__PURE__ */ new Date(), {
      hours: T.hours,
      minutes: T.minutes,
      seconds: r.enableSeconds ? T.seconds : 0,
      milliseconds: 0
    }), C = k(
      () => (T) => J(T, r[T]) || O(T, r[T])
    ), A = k(() => ({ hours: r.hours, minutes: r.minutes, seconds: r.seconds })), O = (T, te) => f.value.enabled && !f.value.disableTimeRangeValidation ? !r.validateTime(T, te) : !1, $ = (T, te) => {
      if (f.value.enabled && !f.value.disableTimeRangeValidation) {
        const ke = te ? +r[`${T}Increment`] : -+r[`${T}Increment`], E = r[T] + ke;
        return !r.validateTime(T, E);
      }
      return !1;
    }, L = k(() => (T) => !P(+r[T] + +r[`${T}Increment`], T) || $(T, !0)), N = k(() => (T) => !P(+r[T] - +r[`${T}Increment`], T) || $(T, !1)), K = (T, te) => ju(et(ve(), T), te), ue = (T, te) => ig(et(ve(), T), te), B = k(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !r.timePickerInline,
        dp__time_col_reg_block: !r.enableSeconds && r.is24 && !r.timePickerInline,
        dp__time_col_reg_inline: !r.enableSeconds && r.is24 && r.timePickerInline,
        dp__time_col_reg_with_button: !r.enableSeconds && !r.is24,
        dp__time_col_sec: r.enableSeconds && r.is24,
        dp__time_col_sec_with_button: r.enableSeconds && !r.is24
      })
    ), Z = k(
      () => r.timePickerInline && f.value.enabled && !d.value.count
    ), R = k(() => {
      const T = [{ type: "hours" }];
      return r.enableMinutes && T.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), r.enableSeconds && T.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), T;
    }), M = k(() => R.value.filter((T) => !T.separator)), z = k(() => (T) => {
      if (T === "hours") {
        const te = qe(+r.hours);
        return { text: te < 10 ? `0${te}` : `${te}`, value: te };
      }
      return { text: r[T] < 10 ? `0${r[T]}` : `${r[T]}`, value: r[T] };
    }), J = (T, te) => {
      var ke;
      if (!r.disabledTimesConfig) return !1;
      const E = r.disabledTimesConfig(r.order, T === "hours" ? te : void 0);
      return E[T] ? !!((ke = E[T]) != null && ke.includes(te)) : !0;
    }, H = (T, te) => te !== "hours" || S.value === "AM" ? T : T + 12, le = (T) => {
      const te = r.is24 ? 24 : 12, ke = T === "hours" ? te : 60, E = +r[`${T}GridIncrement`], V = T === "hours" && !r.is24 ? E : 0, oe = [];
      for (let Y = V; Y < ke; Y += E)
        oe.push({ value: r.is24 ? Y : H(Y, T), text: Y < 10 ? `0${Y}` : `${Y}` });
      return T === "hours" && !r.is24 && oe.unshift({ value: S.value === "PM" ? 12 : 0, text: "12" }), Ra(oe, (Y) => ({ active: !1, disabled: u.value.times[T].includes(Y.value) || !P(Y.value, T) || J(T, Y.value) || O(T, Y.value) }));
    }, j = (T) => T >= 0 ? T : 59, q = (T) => T >= 0 ? T : 23, P = (T, te) => {
      const ke = r.minTime ? F(Al(r.minTime)) : null, E = r.maxTime ? F(Al(r.maxTime)) : null, V = F(
        Al(
          A.value,
          te,
          te === "minutes" || te === "seconds" ? j(T) : q(T)
        )
      );
      return ke && E ? (or(V, E) || Sa(V, E)) && (Ta(V, ke) || Sa(V, ke)) : ke ? Ta(V, ke) || Sa(V, ke) : E ? or(V, E) || Sa(V, E) : !0;
    }, Q = (T) => r[`no${T[0].toUpperCase() + T.slice(1)}Overlay`], ce = (T) => {
      Q(T) || (v[T] = !v[T], v[T] ? (x.value = !0, a("overlay-opened", T)) : (x.value = !1, a("overlay-closed", T)));
    }, U = (T) => T === "hours" ? In : T === "minutes" ? Kn : Aa, ye = () => {
      h.value && clearTimeout(h.value);
    }, Ee = (T, te = !0, ke) => {
      const E = te ? K : ue, V = te ? +r[`${T}Increment`] : -+r[`${T}Increment`];
      P(+r[T] + V, T) && a(
        `update:${T}`,
        U(T)(E({ [T]: +r[T] }, { [T]: +r[`${T}Increment`] }))
      ), !(ke != null && ke.keyboard) && c.value.timeArrowHoldThreshold && (h.value = setTimeout(() => {
        Ee(T, te);
      }, c.value.timeArrowHoldThreshold));
    }, qe = (T) => r.is24 ? T : (T >= 12 ? S.value = "PM" : S.value = "AM", pg(T)), ie = () => {
      S.value === "PM" ? (S.value = "AM", a("update:hours", r.hours - 12)) : (S.value = "PM", a("update:hours", r.hours + 12)), a("am-pm-change", S.value);
    }, pe = (T) => {
      v[T] = !0;
    }, fe = (T, te, ke) => {
      if (T && r.arrowNavigation) {
        Array.isArray(b.value[te]) ? b.value[te][ke] = T : b.value[te] = [T];
        const E = b.value.reduce(
          (V, oe) => oe.map((Y, I) => [...V[I] || [], oe[I]]),
          []
        );
        o(r.closeTimePickerBtn), g.value && (E[1] = E[1].concat(g.value)), l(E, r.order);
      }
    }, ae = (T, te) => (ce(T), a(`update:${T}`, te));
    return n({ openChildCmp: pe }), (T, te) => {
      var ke;
      return T.disabled ? X("", !0) : (p(), w("div", s5, [
        (p(!0), w(_e, null, Ie(R.value, (E, V) => {
          var oe, Y, I;
          return p(), w("div", {
            key: V,
            class: me(B.value),
            "data-compact": Z.value && !T.enableSeconds,
            "data-collapsed": Z.value && T.enableSeconds
          }, [
            E.separator ? (p(), w(_e, { key: 0 }, [
              x.value ? X("", !0) : (p(), w(_e, { key: 0 }, [
                Qe(":")
              ], 64))
            ], 64)) : (p(), w(_e, { key: 1 }, [
              _("button", {
                ref_for: !0,
                ref: (G) => fe(G, V, 0),
                type: "button",
                class: me({
                  dp__btn: !0,
                  dp__inc_dec_button: !T.timePickerInline,
                  dp__inc_dec_button_inline: T.timePickerInline,
                  dp__tp_inline_btn_top: T.timePickerInline,
                  dp__inc_dec_button_disabled: L.value(E.type),
                  "dp--hidden-el": x.value
                }),
                "data-test-id": `${E.type}-time-inc-btn-${r.order}`,
                "aria-label": (oe = D(i)) == null ? void 0 : oe.incrementValue(E.type),
                tabindex: "0",
                onKeydown: (G) => D(Bt)(G, () => Ee(E.type, !0, { keyboard: !0 }), !0),
                onClick: (G) => D(c).timeArrowHoldThreshold ? void 0 : Ee(E.type, !0),
                onMousedown: (G) => D(c).timeArrowHoldThreshold ? Ee(E.type, !0) : void 0,
                onMouseup: ye
              }, [
                r.timePickerInline ? (p(), w(_e, { key: 1 }, [
                  T.$slots["tp-inline-arrow-up"] ? ge(T.$slots, "tp-inline-arrow-up", { key: 0 }) : (p(), w(_e, { key: 1 }, [
                    te[2] || (te[2] = _("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    te[3] || (te[3] = _("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (p(), w(_e, { key: 0 }, [
                  T.$slots["arrow-up"] ? ge(T.$slots, "arrow-up", { key: 0 }) : X("", !0),
                  T.$slots["arrow-up"] ? X("", !0) : (p(), Pe(D(jo), { key: 1 }))
                ], 64))
              ], 42, u5),
              _("button", {
                ref_for: !0,
                ref: (G) => fe(G, V, 1),
                type: "button",
                "aria-label": `${z.value(E.type).text}-${(Y = D(i)) == null ? void 0 : Y.openTpOverlay(E.type)}`,
                class: me({
                  dp__time_display: !0,
                  dp__time_display_block: !T.timePickerInline,
                  dp__time_display_inline: T.timePickerInline,
                  "dp--time-invalid": C.value(E.type),
                  "dp--time-overlay-btn": !C.value(E.type),
                  "dp--hidden-el": x.value
                }),
                disabled: Q(E.type),
                tabindex: "0",
                "data-test-id": `${E.type}-toggle-overlay-btn-${r.order}`,
                onKeydown: (G) => D(Bt)(G, () => ce(E.type), !0),
                onClick: (G) => ce(E.type)
              }, [
                T.$slots[E.type] ? ge(T.$slots, E.type, {
                  key: 0,
                  text: z.value(E.type).text,
                  value: z.value(E.type).value
                }) : X("", !0),
                T.$slots[E.type] ? X("", !0) : (p(), w(_e, { key: 1 }, [
                  Qe(he(z.value(E.type).text), 1)
                ], 64))
              ], 42, d5),
              _("button", {
                ref_for: !0,
                ref: (G) => fe(G, V, 2),
                type: "button",
                class: me({
                  dp__btn: !0,
                  dp__inc_dec_button: !T.timePickerInline,
                  dp__inc_dec_button_inline: T.timePickerInline,
                  dp__tp_inline_btn_bottom: T.timePickerInline,
                  dp__inc_dec_button_disabled: N.value(E.type),
                  "dp--hidden-el": x.value
                }),
                "data-test-id": `${E.type}-time-dec-btn-${r.order}`,
                "aria-label": (I = D(i)) == null ? void 0 : I.decrementValue(E.type),
                tabindex: "0",
                onKeydown: (G) => D(Bt)(G, () => Ee(E.type, !1, { keyboard: !0 }), !0),
                onClick: (G) => D(c).timeArrowHoldThreshold ? void 0 : Ee(E.type, !1),
                onMousedown: (G) => D(c).timeArrowHoldThreshold ? Ee(E.type, !1) : void 0,
                onMouseup: ye
              }, [
                r.timePickerInline ? (p(), w(_e, { key: 1 }, [
                  T.$slots["tp-inline-arrow-down"] ? ge(T.$slots, "tp-inline-arrow-down", { key: 0 }) : (p(), w(_e, { key: 1 }, [
                    te[4] || (te[4] = _("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                    te[5] || (te[5] = _("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
                  ], 64))
                ], 64)) : (p(), w(_e, { key: 0 }, [
                  T.$slots["arrow-down"] ? ge(T.$slots, "arrow-down", { key: 0 }) : X("", !0),
                  T.$slots["arrow-down"] ? X("", !0) : (p(), Pe(D(Zo), { key: 1 }))
                ], 64))
              ], 42, c5)
            ], 64))
          ], 10, i5);
        }), 128)),
        T.is24 ? X("", !0) : (p(), w("div", f5, [
          T.$slots["am-pm-button"] ? ge(T.$slots, "am-pm-button", {
            key: 0,
            toggle: ie,
            value: S.value
          }) : X("", !0),
          T.$slots["am-pm-button"] ? X("", !0) : (p(), w("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: g,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (ke = D(i)) == null ? void 0 : ke.amPmButton,
            tabindex: "0",
            "data-compact": Z.value,
            onClick: ie,
            onKeydown: te[0] || (te[0] = (E) => D(Bt)(E, () => ie(), !0))
          }, he(S.value), 41, m5))
        ])),
        (p(!0), w(_e, null, Ie(M.value, (E, V) => (p(), Pe(Pn, {
          key: V,
          name: D(m)(v[E.type]),
          css: D(y)
        }, {
          default: xe(() => {
            var oe, Y;
            return [
              v[E.type] ? (p(), Pe(wr, {
                key: 0,
                items: le(E.type),
                "is-last": T.autoApply && !D(c).keepActionRow,
                "esc-close": T.escClose,
                type: E.type,
                "text-input": T.textInput,
                config: T.config,
                "arrow-navigation": T.arrowNavigation,
                "aria-labels": T.ariaLabels,
                "overlay-label": (Y = (oe = D(i)).timeOverlay) == null ? void 0 : Y.call(oe, E.type),
                onSelected: (I) => ae(E.type, I),
                onToggle: (I) => ce(E.type),
                onResetFlow: te[1] || (te[1] = (I) => T.$emit("reset-flow"))
              }, It({
                "button-icon": xe(() => [
                  T.$slots["clock-icon"] ? ge(T.$slots, "clock-icon", { key: 0 }) : X("", !0),
                  T.$slots["clock-icon"] ? X("", !0) : (p(), Pe(Ln(T.timePickerInline ? D(La) : D(Yo)), { key: 1 }))
                ]),
                _: 2
              }, [
                T.$slots[`${E.type}-overlay-value`] ? {
                  name: "item",
                  fn: xe(({ item: I }) => [
                    ge(T.$slots, `${E.type}-overlay-value`, {
                      text: I.text,
                      value: I.value
                    })
                  ]),
                  key: "0"
                } : void 0,
                T.$slots[`${E.type}-overlay-header`] ? {
                  name: "header",
                  fn: xe(() => [
                    ge(T.$slots, `${E.type}-overlay-header`, {
                      toggle: () => ce(E.type)
                    })
                  ]),
                  key: "1"
                } : void 0
              ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : X("", !0)
            ];
          }),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), v5 = ["data-dp-mobile"], g5 = ["aria-label", "tabindex"], h5 = ["role", "aria-label", "tabindex"], y5 = ["aria-label"], $d = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...yn
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: n, emit: t }) {
    const a = t, r = e, { buildMatrix: l, setTimePicker: o } = Jn(), i = Qn(), { defaultedTransitions: s, defaultedAriaLabels: u, defaultedTextInput: c, defaultedConfig: f, defaultedRange: d } = lt(r), { transitionName: m, showTransition: y } = br(s), { hideNavigationButtons: v } = sl(), S = ee(null), g = ee(null), b = ee([]), h = ee(null), x = ee(!1);
    He(() => {
      a("mount"), !r.timePicker && r.arrowNavigation ? l([yt(S.value)], "time") : o(!0, r.timePicker);
    });
    const F = k(() => d.value.enabled && r.modelAuto ? md(r.internalModelValue) : !0), C = ee(!1), A = (J) => ({
      hours: Array.isArray(r.hours) ? r.hours[J] : r.hours,
      minutes: Array.isArray(r.minutes) ? r.minutes[J] : r.minutes,
      seconds: Array.isArray(r.seconds) ? r.seconds[J] : r.seconds
    }), O = k(() => {
      const J = [];
      if (d.value.enabled)
        for (let H = 0; H < 2; H++)
          J.push(A(H));
      else
        J.push(A(0));
      return J;
    }), $ = (J, H = !1, le = "") => {
      H || a("reset-flow"), C.value = J, a(J ? "overlay-opened" : "overlay-closed", Rt.time), r.arrowNavigation && o(J), it(() => {
        le !== "" && b.value[0] && b.value[0].openChildCmp(le);
      });
    }, L = k(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: r.autoApply && !f.value.keepActionRow
    })), N = Wt(i, "timePicker"), K = (J, H, le) => d.value.enabled ? H === 0 ? [J, O.value[1][le]] : [O.value[0][le], J] : J, ue = (J) => {
      a("update:hours", J);
    }, B = (J) => {
      a("update:minutes", J);
    }, Z = (J) => {
      a("update:seconds", J);
    }, R = () => {
      if (h.value && !c.value.enabled && !r.noOverlayFocus) {
        const J = pd(h.value);
        J && J.focus({ preventScroll: !0 });
      }
    }, M = (J) => {
      x.value = !1, a("overlay-closed", J);
    }, z = (J) => {
      x.value = !0, a("overlay-opened", J);
    };
    return n({ toggleTimePicker: $ }), (J, H) => {
      var le;
      return p(), w("div", {
        class: "dp--tp-wrap",
        "data-dp-mobile": J.isMobile
      }, [
        !J.timePicker && !J.timePickerInline ? On((p(), w("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: S,
          type: "button",
          class: me({ ...L.value, "dp--hidden-el": C.value }),
          "aria-label": (le = D(u)) == null ? void 0 : le.openTimePicker,
          tabindex: J.noOverlayFocus ? void 0 : 0,
          "data-test-id": "open-time-picker-btn",
          onKeydown: H[0] || (H[0] = (j) => D(Bt)(j, () => $(!0))),
          onClick: H[1] || (H[1] = (j) => $(!0))
        }, [
          J.$slots["clock-icon"] ? ge(J.$slots, "clock-icon", { key: 0 }) : X("", !0),
          J.$slots["clock-icon"] ? X("", !0) : (p(), Pe(D(Yo), { key: 1 }))
        ], 42, g5)), [
          [Qa, !D(v)(J.hideNavigation, "time")]
        ]) : X("", !0),
        Ae(Pn, {
          name: D(m)(C.value),
          css: D(y) && !J.timePickerInline
        }, {
          default: xe(() => {
            var j, q;
            return [
              C.value || J.timePicker || J.timePickerInline ? (p(), w("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: h,
                role: J.timePickerInline ? void 0 : "dialog",
                class: me({
                  dp__overlay: !J.timePickerInline,
                  "dp--overlay-absolute": !r.timePicker && !J.timePickerInline,
                  "dp--overlay-relative": r.timePicker
                }),
                style: tt(J.timePicker ? { height: `${D(f).modeHeight}px` } : void 0),
                "aria-label": (j = D(u)) == null ? void 0 : j.timePicker,
                tabindex: J.timePickerInline ? void 0 : 0
              }, [
                _("div", {
                  class: me(
                    J.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  J.$slots["time-picker-overlay"] ? ge(J.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: ue,
                    setMinutes: B,
                    setSeconds: Z
                  }) : X("", !0),
                  J.$slots["time-picker-overlay"] ? X("", !0) : (p(), w("div", {
                    key: 1,
                    class: me(J.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (p(!0), w(_e, null, Ie(O.value, (P, Q) => On((p(), Pe(p5, xt({
                      key: Q,
                      ref_for: !0
                    }, {
                      ...J.$props,
                      order: Q,
                      hours: P.hours,
                      minutes: P.minutes,
                      seconds: P.seconds,
                      closeTimePickerBtn: g.value,
                      disabledTimesConfig: e.disabledTimesConfig,
                      disabled: Q === 0 ? D(d).fixedStart : D(d).fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: b,
                      "validate-time": (ce, U) => e.validateTime(ce, K(U, Q, ce)),
                      "onUpdate:hours": (ce) => ue(K(ce, Q, "hours")),
                      "onUpdate:minutes": (ce) => B(K(ce, Q, "minutes")),
                      "onUpdate:seconds": (ce) => Z(K(ce, Q, "seconds")),
                      onMounted: R,
                      onOverlayClosed: M,
                      onOverlayOpened: z,
                      onAmPmChange: H[2] || (H[2] = (ce) => J.$emit("am-pm-change", ce))
                    }), It({ _: 2 }, [
                      Ie(D(N), (ce, U) => ({
                        name: ce,
                        fn: xe((ye) => [
                          ge(J.$slots, ce, xt({ ref_for: !0 }, ye))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Qa, Q === 0 ? !0 : F.value]
                    ])), 128))
                  ], 2)),
                  !J.timePicker && !J.timePickerInline ? On((p(), w("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: g,
                    type: "button",
                    class: me({ ...L.value, "dp--hidden-el": x.value }),
                    "aria-label": (q = D(u)) == null ? void 0 : q.closeTimePicker,
                    tabindex: "0",
                    onKeydown: H[3] || (H[3] = (P) => D(Bt)(P, () => $(!1))),
                    onClick: H[4] || (H[4] = (P) => $(!1))
                  }, [
                    J.$slots["calendar-icon"] ? ge(J.$slots, "calendar-icon", { key: 0 }) : X("", !0),
                    J.$slots["calendar-icon"] ? X("", !0) : (p(), Pe(D(La), { key: 1 }))
                  ], 42, y5)), [
                    [Qa, !D(v)(J.hideNavigation, "time")]
                  ]) : X("", !0)
                ], 2)
              ], 14, h5)) : X("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ], 8, v5);
    };
  }
}), Ad = (e, n, t, a) => {
  const { defaultedRange: r } = lt(e), l = (h, x) => Array.isArray(n[h]) ? n[h][x] : n[h], o = (h) => e.enableSeconds ? Array.isArray(n.seconds) ? n.seconds[h] : n.seconds : 0, i = (h, x) => h ? x !== void 0 ? Wn(h, l("hours", x), l("minutes", x), o(x)) : Wn(h, n.hours, n.minutes, o()) : ud(ve(), o(x)), s = (h, x) => {
    n[h] = x;
  }, u = k(() => e.modelAuto && r.value.enabled ? Array.isArray(t.value) ? t.value.length > 1 : !1 : r.value.enabled), c = (h, x) => {
    const F = Object.fromEntries(
      Object.keys(n).map((C) => C === h ? [C, x] : [C, n[C]].slice())
    );
    if (u.value && !r.value.disableTimeRangeValidation) {
      const C = (O) => t.value ? Wn(
        t.value[O],
        F.hours[O],
        F.minutes[O],
        F.seconds[O]
      ) : null, A = (O) => id(t.value[O], 0);
      return !(Ye(C(0), C(1)) && (Ta(C(0), A(1)) || or(C(1), A(0))));
    }
    return !0;
  }, f = (h, x) => {
    c(h, x) && (s(h, x), a && a());
  }, d = (h) => {
    f("hours", h);
  }, m = (h) => {
    f("minutes", h);
  }, y = (h) => {
    f("seconds", h);
  }, v = (h, x, F, C) => {
    x && d(h), !x && !F && m(h), F && y(h), t.value && C(t.value);
  }, S = (h) => {
    if (h) {
      const x = Array.isArray(h), F = x ? [+h[0].hours, +h[1].hours] : +h.hours, C = x ? [+h[0].minutes, +h[1].minutes] : +h.minutes, A = x ? [+h[0].seconds, +h[1].seconds] : +h.seconds;
      s("hours", F), s("minutes", C), e.enableSeconds && s("seconds", A);
    }
  }, g = (h, x) => {
    const F = {
      hours: Array.isArray(n.hours) ? n.hours[h] : n.hours,
      disabledArr: []
    };
    return (x || x === 0) && (F.hours = x), Array.isArray(e.disabledTimes) && (F.disabledArr = r.value.enabled && Array.isArray(e.disabledTimes[h]) ? e.disabledTimes[h] : e.disabledTimes), F;
  }, b = k(() => (h, x) => {
    var F;
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: C, hours: A } = g(h, x), O = C.filter(($) => +$.hours === A);
      return ((F = O[0]) == null ? void 0 : F.minutes) === "*" ? { hours: [A], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (O == null ? void 0 : O.map(($) => +$.minutes)) ?? [],
        seconds: (O == null ? void 0 : O.map(($) => $.seconds ? +$.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: s,
    updateHours: d,
    updateMinutes: m,
    updateSeconds: y,
    getSetDateTime: i,
    updateTimeValues: v,
    getSecondsValue: o,
    assignStartTime: S,
    validateTime: c,
    disabledTimesConfig: b
  };
}, w5 = (e, n) => {
  const t = () => {
    e.isTextInputDate && x();
  }, { modelValue: a, time: r } = _r(e, n, t), { defaultedStartTime: l, defaultedRange: o, defaultedTz: i } = lt(e), { updateTimeValues: s, getSetDateTime: u, setTime: c, assignStartTime: f, disabledTimesConfig: d, validateTime: m } = Ad(e, r, a, y);
  function y() {
    n("update-flow-step");
  }
  const v = (C) => {
    const { hours: A, minutes: O, seconds: $ } = C;
    return { hours: +A, minutes: +O, seconds: $ ? +$ : 0 };
  }, S = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const A = v(e.startTime[0]), O = v(e.startTime[1]);
        return [et(ve(), A), et(ve(), O)];
      }
      const C = v(e.startTime);
      return et(ve(), C);
    }
    return o.value.enabled ? [null, null] : null;
  }, g = () => {
    if (o.value.enabled) {
      const [C, A] = S();
      a.value = [
        jt(u(C, 0), i.value.timezone),
        jt(u(A, 1), i.value.timezone)
      ];
    } else
      a.value = jt(u(S()), i.value.timezone);
  }, b = (C) => Array.isArray(C) ? [ma(ve(C[0])), ma(ve(C[1]))] : [ma(C ?? ve())], h = (C, A, O) => {
    c("hours", C), c("minutes", A), c("seconds", e.enableSeconds ? O : 0);
  }, x = () => {
    const [C, A] = b(a.value);
    return o.value.enabled ? h(
      [C.hours, A.hours],
      [C.minutes, A.minutes],
      [C.seconds, A.seconds]
    ) : h(C.hours, C.minutes, C.seconds);
  };
  He(() => {
    if (!e.shadow)
      return f(l.value), a.value ? x() : g();
  });
  const F = () => {
    Array.isArray(a.value) ? a.value = a.value.map((C, A) => C && u(C, A)) : a.value = u(a.value), n("time-update");
  };
  return {
    modelValue: a,
    time: r,
    disabledTimesConfig: d,
    updateTime: (C, A = !0, O = !1) => {
      s(C, A, O, F);
    },
    validateTime: m
  };
}, b5 = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...yn
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(e, { expose: n, emit: t }) {
    const a = t, r = e, l = Qn(), o = Wt(l, "timePicker"), i = ee(null), { time: s, modelValue: u, disabledTimesConfig: c, updateTime: f, validateTime: d } = w5(r, a);
    return He(() => {
      r.shadow || a("mount", null);
    }), n({ getSidebarProps: () => ({
      modelValue: u,
      time: s,
      updateTime: f
    }), toggleTimePicker: (m, y = !1, v = "") => {
      var S;
      (S = i.value) == null || S.toggleTimePicker(m, y, v);
    } }), (m, y) => (p(), Pe(ll, {
      "multi-calendars": 0,
      stretch: "",
      "is-mobile": m.isMobile
    }, {
      default: xe(() => [
        Ae($d, xt({
          ref_key: "tpRef",
          ref: i
        }, m.$props, {
          hours: D(s).hours,
          minutes: D(s).minutes,
          seconds: D(s).seconds,
          "internal-model-value": m.internalModelValue,
          "disabled-times-config": D(c),
          "validate-time": D(d),
          "onUpdate:hours": y[0] || (y[0] = (v) => D(f)(v)),
          "onUpdate:minutes": y[1] || (y[1] = (v) => D(f)(v, !1)),
          "onUpdate:seconds": y[2] || (y[2] = (v) => D(f)(v, !1, !0)),
          onAmPmChange: y[3] || (y[3] = (v) => m.$emit("am-pm-change", v)),
          onResetFlow: y[4] || (y[4] = (v) => m.$emit("reset-flow")),
          onOverlayClosed: y[5] || (y[5] = (v) => m.$emit("overlay-toggle", { open: !1, overlay: v })),
          onOverlayOpened: y[6] || (y[6] = (v) => m.$emit("overlay-toggle", { open: !0, overlay: v }))
        }), It({ _: 2 }, [
          Ie(D(o), (v, S) => ({
            name: v,
            fn: xe((g) => [
              ge(m.$slots, v, kt(Yt(g)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }, 8, ["is-mobile"]));
  }
}), _5 = { class: "dp--header-wrap" }, x5 = {
  key: 0,
  class: "dp__month_year_wrap"
}, k5 = { key: 0 }, C5 = { class: "dp__month_year_wrap" }, S5 = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], M5 = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...yn
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(e, { expose: n, emit: t }) {
    const a = t, r = e, {
      defaultedTransitions: l,
      defaultedAriaLabels: o,
      defaultedMultiCalendars: i,
      defaultedFilters: s,
      defaultedConfig: u,
      defaultedHighlight: c,
      propDates: f,
      defaultedUI: d
    } = lt(r), { transitionName: m, showTransition: y } = br(l), { buildMatrix: v } = Jn(), { handleMonthYearChange: S, isDisabled: g, updateMonthYear: b } = Zg(r, a), { showLeftIcon: h, showRightIcon: x } = sl(), F = ee(!1), C = ee(!1), A = ee(!1), O = ee([null, null, null, null]);
    He(() => {
      a("mount");
    });
    const $ = (q) => ({
      get: () => r[q],
      set: (P) => {
        const Q = q === an.month ? an.year : an.month;
        a("update-month-year", { [q]: P, [Q]: r[Q] }), q === an.month ? M(!0) : z(!0);
      }
    }), L = k($(an.month)), N = k($(an.year)), K = k(() => (q) => ({
      month: r.month,
      year: r.year,
      items: q === an.month ? r.months : r.years,
      instance: r.instance,
      updateMonthYear: b,
      toggle: q === an.month ? M : z
    })), ue = k(() => r.months.find((P) => P.value === r.month) || { text: "", value: 0 }), B = k(() => Ra(r.months, (q) => {
      const P = r.month === q.value, Q = sr(
        q.value,
        gd(r.year, f.value.minDate),
        hd(r.year, f.value.maxDate)
      ) || s.value.months.includes(q.value), ce = xd(c.value, q.value, r.year);
      return { active: P, disabled: Q, highlighted: ce };
    })), Z = k(() => Ra(r.years, (q) => {
      const P = r.year === q.value, Q = sr(
        q.value,
        Oa(f.value.minDate),
        Oa(f.value.maxDate)
      ) || s.value.years.includes(q.value), ce = Xo(c.value, q.value);
      return { active: P, disabled: Q, highlighted: ce };
    })), R = (q, P, Q) => {
      Q !== void 0 ? q.value = Q : q.value = !q.value, q.value ? (A.value = !0, a("overlay-opened", P)) : (A.value = !1, a("overlay-closed", P));
    }, M = (q = !1, P) => {
      J(q), R(F, Rt.month, P);
    }, z = (q = !1, P) => {
      J(q), R(C, Rt.year, P);
    }, J = (q) => {
      q || a("reset-flow");
    }, H = (q, P) => {
      r.arrowNavigation && (O.value[P] = yt(q), v(O.value, "monthYear"));
    }, le = k(() => {
      var q, P, Q, ce, U, ye;
      return [
        {
          type: an.month,
          index: 1,
          toggle: M,
          modelValue: L.value,
          updateModelValue: (Ee) => L.value = Ee,
          text: ue.value.text,
          showSelectionGrid: F.value,
          items: B.value,
          ariaLabel: (q = o.value) == null ? void 0 : q.openMonthsOverlay,
          overlayLabel: ((Q = (P = o.value).monthPicker) == null ? void 0 : Q.call(P, !0)) ?? void 0
        },
        {
          type: an.year,
          index: 2,
          toggle: z,
          modelValue: N.value,
          updateModelValue: (Ee) => N.value = Ee,
          text: vd(r.year, r.locale),
          showSelectionGrid: C.value,
          items: Z.value,
          ariaLabel: (ce = o.value) == null ? void 0 : ce.openYearsOverlay,
          overlayLabel: ((ye = (U = o.value).yearPicker) == null ? void 0 : ye.call(U, !0)) ?? void 0
        }
      ];
    }), j = k(() => r.disableYearSelect ? [le.value[0]] : r.yearFirst ? [...le.value].reverse() : le.value);
    return n({
      toggleMonthPicker: M,
      toggleYearPicker: z,
      handleMonthYearChange: S
    }), (q, P) => {
      var Q, ce, U, ye, Ee, qe;
      return p(), w("div", _5, [
        q.$slots["month-year"] ? (p(), w("div", x5, [
          ge(q.$slots, "month-year", kt(Yt({ month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: D(b), handleMonthYearChange: D(S), instance: e.instance })))
        ])) : (p(), w(_e, { key: 1 }, [
          q.$slots["top-extra"] ? (p(), w("div", k5, [
            ge(q.$slots, "top-extra", { value: q.internalModelValue })
          ])) : X("", !0),
          _("div", C5, [
            D(h)(D(i), e.instance) && !q.vertical ? (p(), Pe(tr, {
              key: 0,
              "aria-label": (Q = D(o)) == null ? void 0 : Q.prevMonth,
              disabled: D(g)(!1),
              class: me((ce = D(d)) == null ? void 0 : ce.navBtnPrev),
              "el-name": "action-prev",
              onActivate: P[0] || (P[0] = (ie) => D(S)(!1, !0)),
              onSetRef: P[1] || (P[1] = (ie) => H(ie, 0))
            }, {
              default: xe(() => [
                q.$slots["arrow-left"] ? ge(q.$slots, "arrow-left", { key: 0 }) : X("", !0),
                q.$slots["arrow-left"] ? X("", !0) : (p(), Pe(D(zo), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : X("", !0),
            _("div", {
              class: me(["dp__month_year_wrap", {
                dp__year_disable_select: q.disableYearSelect
              }])
            }, [
              (p(!0), w(_e, null, Ie(j.value, (ie, pe) => (p(), w(_e, {
                key: ie.type
              }, [
                _("button", {
                  ref_for: !0,
                  ref: (fe) => H(fe, pe + 1),
                  type: "button",
                  "data-dp-element": `overlay-${ie.type}`,
                  class: me(["dp__btn dp__month_year_select", { "dp--hidden-el": A.value }]),
                  "aria-label": `${ie.text}-${ie.ariaLabel}`,
                  "data-test-id": `${ie.type}-toggle-overlay-${e.instance}`,
                  onClick: ie.toggle,
                  onKeydown: (fe) => D(Bt)(fe, () => ie.toggle(), !0)
                }, [
                  q.$slots[ie.type] ? ge(q.$slots, ie.type, {
                    key: 0,
                    text: ie.text,
                    value: r[ie.type]
                  }) : X("", !0),
                  q.$slots[ie.type] ? X("", !0) : (p(), w(_e, { key: 1 }, [
                    Qe(he(ie.text), 1)
                  ], 64))
                ], 42, S5),
                Ae(Pn, {
                  name: D(m)(ie.showSelectionGrid),
                  css: D(y)
                }, {
                  default: xe(() => [
                    ie.showSelectionGrid ? (p(), Pe(wr, {
                      key: 0,
                      items: ie.items,
                      "arrow-navigation": q.arrowNavigation,
                      "hide-navigation": q.hideNavigation,
                      "is-last": q.autoApply && !D(u).keepActionRow,
                      "skip-button-ref": !1,
                      config: q.config,
                      type: ie.type,
                      "header-refs": [],
                      "esc-close": q.escClose,
                      "menu-wrap-ref": q.menuWrapRef,
                      "text-input": q.textInput,
                      "aria-labels": q.ariaLabels,
                      "overlay-label": ie.overlayLabel,
                      onSelected: ie.updateModelValue,
                      onToggle: ie.toggle
                    }, It({
                      "button-icon": xe(() => [
                        q.$slots["calendar-icon"] ? ge(q.$slots, "calendar-icon", { key: 0 }) : X("", !0),
                        q.$slots["calendar-icon"] ? X("", !0) : (p(), Pe(D(La), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      q.$slots[`${ie.type}-overlay-value`] ? {
                        name: "item",
                        fn: xe(({ item: fe }) => [
                          ge(q.$slots, `${ie.type}-overlay-value`, {
                            text: fe.text,
                            value: fe.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      q.$slots[`${ie.type}-overlay`] ? {
                        name: "overlay",
                        fn: xe(() => [
                          ge(q.$slots, `${ie.type}-overlay`, xt({ ref_for: !0 }, K.value(ie.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      q.$slots[`${ie.type}-overlay-header`] ? {
                        name: "header",
                        fn: xe(() => [
                          ge(q.$slots, `${ie.type}-overlay-header`, {
                            toggle: ie.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : X("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            D(h)(D(i), e.instance) && q.vertical ? (p(), Pe(tr, {
              key: 1,
              "aria-label": (U = D(o)) == null ? void 0 : U.prevMonth,
              "el-name": "action-prev",
              disabled: D(g)(!1),
              class: me((ye = D(d)) == null ? void 0 : ye.navBtnPrev),
              onActivate: P[2] || (P[2] = (ie) => D(S)(!1, !0))
            }, {
              default: xe(() => [
                q.$slots["arrow-up"] ? ge(q.$slots, "arrow-up", { key: 0 }) : X("", !0),
                q.$slots["arrow-up"] ? X("", !0) : (p(), Pe(D(jo), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : X("", !0),
            D(x)(D(i), e.instance) ? (p(), Pe(tr, {
              key: 2,
              ref: "rightIcon",
              "el-name": "action-next",
              disabled: D(g)(!0),
              "aria-label": (Ee = D(o)) == null ? void 0 : Ee.nextMonth,
              class: me((qe = D(d)) == null ? void 0 : qe.navBtnNext),
              onActivate: P[3] || (P[3] = (ie) => D(S)(!0, !0)),
              onSetRef: P[4] || (P[4] = (ie) => H(ie, q.disableYearSelect ? 2 : 3))
            }, {
              default: xe(() => [
                q.$slots[q.vertical ? "arrow-down" : "arrow-right"] ? ge(q.$slots, q.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : X("", !0),
                q.$slots[q.vertical ? "arrow-down" : "arrow-right"] ? X("", !0) : (p(), Pe(Ln(q.vertical ? D(Zo) : D(Uo)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : X("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), E5 = {
  class: "dp__calendar_header",
  role: "row"
}, P5 = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, $5 = ["aria-label"], A5 = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, T5 = { class: "dp__cell_inner" }, D5 = ["id", "aria-pressed", "aria-disabled", "aria-label", "tabindex", "data-test-id", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], R5 = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...yn
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: n, emit: t }) {
    const a = t, r = e, { buildMultiLevelMatrix: l } = Jn(), {
      defaultedTransitions: o,
      defaultedConfig: i,
      defaultedAriaLabels: s,
      defaultedMultiCalendars: u,
      defaultedWeekNumbers: c,
      defaultedMultiDates: f,
      defaultedUI: d
    } = lt(r), m = ee(null), y = ee({
      bottom: "",
      left: "",
      transform: ""
    }), v = ee([]), S = ee(null), g = ee(!0), b = ee(""), h = ee({ startX: 0, endX: 0, startY: 0, endY: 0 }), x = ee([]), F = ee({ left: "50%" }), C = ee(!1), A = k(() => r.calendar ? r.calendar(r.mappedDates) : r.mappedDates), O = k(() => r.dayNames ? Array.isArray(r.dayNames) ? r.dayNames : r.dayNames(r.locale, +r.weekStart) : mg(r.formatLocale, r.locale, +r.weekStart));
    He(() => {
      a("mount", { cmp: "calendar", refs: v }), i.value.noSwipe || S.value && (S.value.addEventListener("touchstart", H, { passive: !1 }), S.value.addEventListener("touchend", le, { passive: !1 }), S.value.addEventListener("touchmove", j, { passive: !1 })), r.monthChangeOnScroll && S.value && S.value.addEventListener("wheel", Q, { passive: !1 });
    });
    const $ = (ie) => ie ? r.vertical ? "vNext" : "next" : r.vertical ? "vPrevious" : "previous", L = (ie, pe) => {
      if (r.transitions) {
        const fe = Ht(Dn(ve(), r.month, r.year));
        b.value = ft(Ht(Dn(ve(), ie, pe)), fe) ? o.value[$(!0)] : o.value[$(!1)], g.value = !1, it(() => {
          g.value = !0;
        });
      }
    }, N = k(
      () => ({
        ...d.value.calendar ?? {}
      })
    ), K = k(() => (ie) => {
      const pe = vg(ie);
      return {
        dp__marker_dot: pe.type === "dot",
        dp__marker_line: pe.type === "line"
      };
    }), ue = k(() => (ie) => Ye(ie, m.value)), B = k(() => ({
      dp__calendar: !0,
      dp__calendar_next: u.value.count > 0 && r.instance !== 0
    })), Z = k(() => (ie) => r.hideOffsetDates ? ie.current : !0), R = async (ie, pe) => {
      const { width: fe, height: ae } = ie.getBoundingClientRect();
      m.value = pe.value;
      let T = { left: `${fe / 2}px` }, te = -50;
      if (await it(), x.value[0]) {
        const { left: ke, width: E } = x.value[0].getBoundingClientRect();
        ke < 0 && (T = { left: "0" }, te = 0, F.value.left = `${fe / 2}px`), window.innerWidth < ke + E && (T = { right: "0" }, te = 0, F.value.left = `${E - fe / 2}px`);
      }
      y.value = {
        bottom: `${ae}px`,
        ...T,
        transform: `translateX(${te}%)`
      };
    }, M = async (ie, pe, fe) => {
      var ae, T, te;
      const ke = yt(v.value[pe][fe]);
      ke && ((ae = ie.marker) != null && ae.customPosition && (te = (T = ie.marker) == null ? void 0 : T.tooltip) != null && te.length ? y.value = ie.marker.customPosition(ke) : await R(ke, ie), a("tooltip-open", ie.marker));
    }, z = async (ie, pe, fe) => {
      var ae, T;
      if (C.value && f.value.enabled && f.value.dragSelect)
        return a("select-date", ie);
      if (a("set-hover-date", ie), (T = (ae = ie.marker) == null ? void 0 : ae.tooltip) != null && T.length) {
        if (r.hideOffsetDates && !ie.current) return;
        await M(ie, pe, fe);
      }
    }, J = (ie) => {
      m.value && (m.value = null, y.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), a("tooltip-close", ie.marker));
    }, H = (ie) => {
      h.value.startX = ie.changedTouches[0].screenX, h.value.startY = ie.changedTouches[0].screenY;
    }, le = (ie) => {
      h.value.endX = ie.changedTouches[0].screenX, h.value.endY = ie.changedTouches[0].screenY, q();
    }, j = (ie) => {
      r.vertical && !r.inline && ie.preventDefault();
    }, q = () => {
      const ie = r.vertical ? "Y" : "X";
      Math.abs(h.value[`start${ie}`] - h.value[`end${ie}`]) > 10 && a("handle-swipe", h.value[`start${ie}`] > h.value[`end${ie}`] ? "right" : "left");
    }, P = (ie, pe, fe) => {
      ie && (Array.isArray(v.value[pe]) ? v.value[pe][fe] = ie : v.value[pe] = [ie]), r.arrowNavigation && l(v.value, "calendar");
    }, Q = (ie) => {
      r.monthChangeOnScroll && (ie.preventDefault(), a("handle-scroll", ie));
    }, ce = (ie) => c.value.type === "local" ? Vo(ie.value, { weekStartsOn: +r.weekStart }) : c.value.type === "iso" ? Lo(ie.value) : typeof c.value.type == "function" ? c.value.type(ie.value) : "", U = (ie) => {
      const pe = ie[0];
      return c.value.hideOnOffsetDates ? ie.some((fe) => fe.current) ? ce(pe) : "" : ce(pe);
    }, ye = (ie, pe, fe = !0) => {
      fe && bi() || !fe && !bi() || (!f.value.enabled || i.value.allowPreventDefault) && (Gn(ie, i.value), a("select-date", pe));
    }, Ee = (ie) => {
      Gn(ie, i.value);
    }, qe = (ie) => {
      f.value.enabled && f.value.dragSelect ? (C.value = !0, a("select-date", ie)) : f.value.enabled && a("select-date", ie);
    };
    return n({ triggerTransition: L }), (ie, pe) => (p(), w("div", {
      class: me(B.value)
    }, [
      _("div", {
        ref_key: "calendarWrapRef",
        ref: S,
        class: me(N.value),
        role: "grid"
      }, [
        _("div", E5, [
          ie.weekNumbers ? (p(), w("div", P5, he(ie.weekNumName), 1)) : X("", !0),
          (p(!0), w(_e, null, Ie(O.value, (fe, ae) => {
            var T, te;
            return p(), w("div", {
              key: ae,
              class: "dp__calendar_header_item",
              role: "gridcell",
              "data-test-id": "calendar-header",
              "aria-label": (te = (T = D(s)) == null ? void 0 : T.weekDay) == null ? void 0 : te.call(T, ae)
            }, [
              ie.$slots["calendar-header"] ? ge(ie.$slots, "calendar-header", {
                key: 0,
                day: fe,
                index: ae
              }) : X("", !0),
              ie.$slots["calendar-header"] ? X("", !0) : (p(), w(_e, { key: 1 }, [
                Qe(he(fe), 1)
              ], 64))
            ], 8, $5);
          }), 128))
        ]),
        pe[2] || (pe[2] = _("div", { class: "dp__calendar_header_separator" }, null, -1)),
        Ae(Pn, {
          name: b.value,
          css: !!ie.transitions
        }, {
          default: xe(() => [
            g.value ? (p(), w("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: pe[1] || (pe[1] = (fe) => C.value = !1)
            }, [
              (p(!0), w(_e, null, Ie(A.value, (fe, ae) => (p(), w("div", {
                key: ae,
                class: "dp__calendar_row",
                role: "row"
              }, [
                ie.weekNumbers ? (p(), w("div", A5, [
                  _("div", T5, he(U(fe.days)), 1)
                ])) : X("", !0),
                (p(!0), w(_e, null, Ie(fe.days, (T, te) => {
                  var ke, E, V;
                  return p(), w("div", {
                    id: D(kd)(T.value),
                    ref_for: !0,
                    ref: (oe) => P(oe, ae, te),
                    key: te + ae,
                    role: "gridcell",
                    class: "dp__calendar_item",
                    "aria-pressed": (T.classData.dp__active_date || T.classData.dp__range_start || T.classData.dp__range_start) ?? void 0,
                    "aria-disabled": T.classData.dp__cell_disabled || void 0,
                    "aria-label": (E = (ke = D(s)) == null ? void 0 : ke.day) == null ? void 0 : E.call(ke, T),
                    tabindex: !T.current && ie.hideOffsetDates ? void 0 : 0,
                    "data-test-id": T.value,
                    onClick: ot((oe) => ye(oe, T), ["prevent"]),
                    onTouchend: (oe) => ye(oe, T, !1),
                    onKeydown: (oe) => D(Bt)(oe, () => ie.$emit("select-date", T)),
                    onMouseenter: (oe) => z(T, ae, te),
                    onMouseleave: (oe) => J(T),
                    onMousedown: (oe) => qe(T),
                    onMouseup: pe[0] || (pe[0] = (oe) => C.value = !1)
                  }, [
                    _("div", {
                      class: me(["dp__cell_inner", T.classData])
                    }, [
                      ie.$slots.day && Z.value(T) ? ge(ie.$slots, "day", {
                        key: 0,
                        day: +T.text,
                        date: T.value
                      }) : X("", !0),
                      ie.$slots.day ? X("", !0) : (p(), w(_e, { key: 1 }, [
                        Qe(he(T.text), 1)
                      ], 64)),
                      T.marker && Z.value(T) ? (p(), w(_e, { key: 2 }, [
                        ie.$slots.marker ? ge(ie.$slots, "marker", {
                          key: 0,
                          marker: T.marker,
                          day: +T.text,
                          date: T.value
                        }) : (p(), w("div", {
                          key: 1,
                          class: me(K.value(T.marker)),
                          style: tt(T.marker.color ? { backgroundColor: T.marker.color } : {})
                        }, null, 6))
                      ], 64)) : X("", !0),
                      ue.value(T.value) ? (p(), w("div", {
                        key: 3,
                        ref_for: !0,
                        ref_key: "activeTooltip",
                        ref: x,
                        class: "dp__marker_tooltip",
                        style: tt(y.value)
                      }, [
                        (V = T.marker) != null && V.tooltip ? (p(), w("div", {
                          key: 0,
                          class: "dp__tooltip_content",
                          onClick: Ee
                        }, [
                          (p(!0), w(_e, null, Ie(T.marker.tooltip, (oe, Y) => (p(), w("div", {
                            key: Y,
                            class: "dp__tooltip_text"
                          }, [
                            ie.$slots["marker-tooltip"] ? ge(ie.$slots, "marker-tooltip", {
                              key: 0,
                              tooltip: oe,
                              day: T.value
                            }) : X("", !0),
                            ie.$slots["marker-tooltip"] ? X("", !0) : (p(), w(_e, { key: 1 }, [
                              _("div", {
                                class: "dp__tooltip_mark",
                                style: tt(oe.color ? { backgroundColor: oe.color } : {})
                              }, null, 4),
                              _("div", null, he(oe.text), 1)
                            ], 64))
                          ]))), 128)),
                          _("div", {
                            class: "dp__arrow_bottom_tp",
                            style: tt(F.value)
                          }, null, 4)
                        ])) : X("", !0)
                      ], 4)) : X("", !0)
                    ], 2)
                  ], 40, D5);
                }), 128))
              ]))), 128))
            ], 32)) : X("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), Si = (e) => Array.isArray(e), O5 = (e, n, t, a) => {
  const r = ee([]), l = ee(/* @__PURE__ */ new Date()), o = ee(), i = () => H(e.isTextInputDate), { modelValue: s, calendars: u, time: c, today: f } = _r(e, n, i), {
    defaultedMultiCalendars: d,
    defaultedStartTime: m,
    defaultedRange: y,
    defaultedConfig: v,
    defaultedTz: S,
    propDates: g,
    defaultedMultiDates: b
  } = lt(e), { validateMonthYearInRange: h, isDisabled: x, isDateRangeAllowed: F, checkMinMaxRange: C } = ea(e), { updateTimeValues: A, getSetDateTime: O, setTime: $, assignStartTime: L, validateTime: N, disabledTimesConfig: K } = Ad(e, c, s, a), ue = k(
    () => (re) => u.value[re] ? u.value[re].month : 0
  ), B = k(
    () => (re) => u.value[re] ? u.value[re].year : 0
  ), Z = (re) => !v.value.keepViewOnOffsetClick || re ? !0 : !o.value, R = (re, we, Te, de = !1) => {
    var be, $e;
    Z(de) && (u.value[re] || (u.value[re] = { month: 0, year: 0 }), u.value[re].month = wi(we) ? (be = u.value[re]) == null ? void 0 : be.month : we, u.value[re].year = wi(Te) ? ($e = u.value[re]) == null ? void 0 : $e.year : Te);
  }, M = () => {
    e.autoApply && n("select-date");
  };
  He(() => {
    e.shadow || (s.value || (ie(), m.value && L(m.value)), H(!0), e.focusStartDate && e.startDate && ie());
  });
  const z = k(() => {
    var re;
    return (re = e.flow) != null && re.length && !e.partialFlow ? e.flowStep === e.flow.length : !0;
  }), J = () => {
    e.autoApply && z.value && n("auto-apply", e.partialFlow ? e.flowStep !== e.flow.length : !1);
  }, H = (re = !1) => {
    if (s.value)
      return Array.isArray(s.value) ? (r.value = s.value, U(re)) : q(s.value, re);
    if (d.value.count && re && !e.startDate)
      return j(ve(), re);
  }, le = () => Array.isArray(s.value) && y.value.enabled ? Ue(s.value[0]) === Ue(s.value[1] ?? s.value[0]) : !1, j = (re = /* @__PURE__ */ new Date(), we = !1) => {
    if ((!d.value.count || !d.value.static || we) && R(0, Ue(re), Le(re)), d.value.count && (!s.value || le() || !d.value.solo) && (!d.value.solo || we))
      for (let Te = 1; Te < d.value.count; Te++) {
        const de = et(ve(), { month: ue.value(Te - 1), year: B.value(Te - 1) }), be = ju(de, { months: 1 });
        u.value[Te] = { month: Ue(be), year: Le(be) };
      }
  }, q = (re, we) => {
    j(re), $("hours", In(re)), $("minutes", Kn(re)), $("seconds", Aa(re)), d.value.count && we && qe();
  }, P = (re) => {
    if (d.value.count) {
      if (d.value.solo) return 0;
      const we = Ue(re[0]), Te = Ue(re[1]);
      return Math.abs(Te - we) < d.value.count ? 0 : 1;
    }
    return 1;
  }, Q = (re, we) => {
    re[1] && y.value.showLastInRange ? j(re[P(re)], we) : j(re[0], we);
    const Te = (de, be) => [
      de(re[0]),
      re[1] ? de(re[1]) : c[be][1]
    ];
    $("hours", Te(In, "hours")), $("minutes", Te(Kn, "minutes")), $("seconds", Te(Aa, "seconds"));
  }, ce = (re, we) => {
    if ((y.value.enabled || e.weekPicker) && !b.value.enabled)
      return Q(re, we);
    if (b.value.enabled && we) {
      const Te = re[re.length - 1];
      return q(Te, we);
    }
  }, U = (re) => {
    const we = s.value;
    ce(we, re), d.value.count && d.value.solo && qe();
  }, ye = (re, we) => {
    const Te = et(ve(), { month: ue.value(we), year: B.value(we) }), de = re < 0 ? cn(Te, 1) : Da(Te, 1);
    h(Ue(de), Le(de), re < 0, e.preventMinMaxNavigation) && (R(we, Ue(de), Le(de)), n("update-month-year", { instance: we, month: Ue(de), year: Le(de) }), d.value.count && !d.value.solo && Ee(we), t());
  }, Ee = (re) => {
    for (let we = re - 1; we >= 0; we--) {
      const Te = Da(et(ve(), { month: ue.value(we + 1), year: B.value(we + 1) }), 1);
      R(we, Ue(Te), Le(Te));
    }
    for (let we = re + 1; we <= d.value.count - 1; we++) {
      const Te = cn(et(ve(), { month: ue.value(we - 1), year: B.value(we - 1) }), 1);
      R(we, Ue(Te), Le(Te));
    }
  }, qe = () => {
    if (Array.isArray(s.value) && s.value.length === 2) {
      const re = ve(
        ve(s.value[1] ? s.value[1] : cn(s.value[0], 1))
      ), [we, Te] = [Ue(s.value[0]), Le(s.value[0])], [de, be] = [Ue(s.value[1]), Le(s.value[1])];
      (we !== de || we === de && Te !== be) && d.value.solo && R(1, Ue(re), Le(re));
    } else s.value && !Array.isArray(s.value) && (R(0, Ue(s.value), Le(s.value)), j(ve()));
  }, ie = () => {
    e.startDate && (R(0, Ue(ve(e.startDate)), Le(ve(e.startDate))), d.value.count && Ee(0));
  }, pe = (re, we) => {
    if (e.monthChangeOnScroll) {
      const Te = (/* @__PURE__ */ new Date()).getTime() - l.value.getTime(), de = Math.abs(re.deltaY);
      let be = 500;
      de > 1 && (be = 100), de > 100 && (be = 0), Te > be && (l.value = /* @__PURE__ */ new Date(), ye(e.monthChangeOnScroll !== "inverse" ? -re.deltaY : re.deltaY, we));
    }
  }, fe = (re, we, Te = !1) => {
    e.monthChangeOnArrows && e.vertical === Te && ae(re, we);
  }, ae = (re, we) => {
    ye(re === "right" ? -1 : 1, we);
  }, T = (re) => {
    if (g.value.markers)
      return Gr(re.value, g.value.markers);
  }, te = (re, we) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [re == 0, !0];
      case "fair":
        return [re == 0 || we > re, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, ke = (re, we, Te, de) => {
    if (e.sixWeeks && re.length < 6) {
      const be = 6 - re.length, $e = (we.getDay() + 7 - de) % 7, wn = 6 - (Te.getDay() + 7 - de) % 7, [nn, ya] = te($e, wn);
      for (let Ba = 1; Ba <= be; Ba++)
        if (ya ? !!(Ba % 2) == nn : nn) {
          const Bn = re[0].days[0], hl = E(sn(Bn.value, -7), Ue(we));
          re.unshift({ days: hl });
        } else {
          const Bn = re[re.length - 1], hl = Bn.days[Bn.days.length - 1], wc = E(sn(hl.value, 1), Ue(we));
          re.push({ days: wc });
        }
    }
    return re;
  }, E = (re, we) => {
    const Te = ve(re), de = [];
    for (let be = 0; be < 7; be++) {
      const $e = sn(Te, be), wn = Ue($e) !== we;
      de.push({
        text: e.hideOffsetDates && wn ? "" : $e.getDate(),
        value: $e,
        current: !wn,
        classData: {}
      });
    }
    return de;
  }, V = (re, we) => {
    const Te = [], de = new Date(we, re), be = new Date(we, re + 1, 0), $e = e.weekStart, wn = vn(de, { weekStartsOn: $e }), nn = (ya) => {
      const Ba = E(ya, re);
      if (Te.push({ days: Ba }), !Te[Te.length - 1].days.some(
        (Bn) => Ye(Ht(Bn.value), Ht(be))
      )) {
        const Bn = sn(ya, 7);
        nn(Bn);
      }
    };
    return nn(wn), ke(Te, de, be, $e);
  }, oe = (re) => {
    const we = Wn(ve(re.value), c.hours, c.minutes, Ne());
    n("date-update", we), b.value.enabled ? Qo(we, s, b.value.limit) : s.value = we, a(), it().then(() => {
      J();
    });
  }, Y = (re) => y.value.noDisabledRange ? yd(r.value[0], re).some((we) => x(we)) : !1, I = () => {
    r.value = s.value ? s.value.slice() : [], r.value.length === 2 && !(y.value.fixedStart || y.value.fixedEnd) && (r.value = []);
  }, G = (re, we) => {
    const Te = [
      ve(re.value),
      sn(ve(re.value), +y.value.autoRange)
    ];
    F(Te) ? (we && se(re.value), r.value = Te) : n("invalid-date", re.value);
  }, se = (re) => {
    const we = Ue(ve(re)), Te = Le(ve(re));
    if (R(0, we, Te), d.value.count > 0)
      for (let de = 1; de < d.value.count; de++) {
        const be = xg(
          et(ve(re), { year: B.value(de - 1), month: ue.value(de - 1) })
        );
        R(de, be.month, be.year);
      }
  }, W = (re) => {
    if (Y(re.value) || !C(re.value, s.value, y.value.fixedStart ? 0 : 1))
      return n("invalid-date", re.value);
    r.value = Ed(ve(re.value), s, n, y);
  }, ne = (re, we) => {
    if (I(), y.value.autoRange) return G(re, we);
    if (y.value.fixedStart || y.value.fixedEnd) return W(re);
    r.value[0] ? C(ve(re.value), s.value) && !Y(re.value) ? ut(ve(re.value), ve(r.value[0])) ? (r.value.unshift(ve(re.value)), n("range-end", r.value[0])) : (r.value[1] = ve(re.value), n("range-end", r.value[1])) : (e.autoApply && n("auto-apply-invalid", re.value), n("invalid-date", re.value)) : (r.value[0] = ve(re.value), n("range-start", r.value[0]));
  }, Ne = (re = !0) => e.enableSeconds ? Array.isArray(c.seconds) ? re ? c.seconds[0] : c.seconds[1] : c.seconds : 0, Ve = (re) => {
    r.value[re] = Wn(
      r.value[re],
      c.hours[re],
      c.minutes[re],
      Ne(re !== 1)
    );
  }, Jt = () => {
    var re, we;
    r.value[0] && r.value[1] && +((re = r.value) == null ? void 0 : re[0]) > +((we = r.value) == null ? void 0 : we[1]) && (r.value.reverse(), n("range-start", r.value[0]), n("range-end", r.value[1]));
  }, Vn = () => {
    r.value.length && (r.value[0] && !r.value[1] ? Ve(0) : (Ve(0), Ve(1), a()), Jt(), s.value = r.value.slice(), ol(r.value, n, e.autoApply, e.modelAuto));
  }, en = (re, we = !1) => {
    if (x(re.value) || !re.current && e.hideOffsetDates) return n("invalid-date", re.value);
    if (o.value = JSON.parse(JSON.stringify(re)), !y.value.enabled) return oe(re);
    Si(c.hours) && Si(c.minutes) && !b.value.enabled && (ne(re, we), Vn());
  }, tn = (re, we) => {
    var Te;
    R(re, we.month, we.year, !0), d.value.count && !d.value.solo && Ee(re), n("update-month-year", { instance: re, month: we.month, year: we.year }), t(d.value.solo ? re : void 0);
    const de = (Te = e.flow) != null && Te.length ? e.flow[e.flowStep] : void 0;
    !we.fromNav && (de === Rt.month || de === Rt.year) && a();
  }, Va = (re, we) => {
    Md({
      value: re,
      modelValue: s,
      range: y.value.enabled,
      timezone: we ? void 0 : S.value.timezone
    }), M(), e.multiCalendars && it().then(() => H(!0));
  }, ha = () => {
    const re = Go(ve(), S.value);
    !y.value.enabled && !b.value.enabled ? s.value = re : s.value && Array.isArray(s.value) && s.value[0] ? b.value.enabled ? s.value = [...s.value, re] : s.value = ut(re, s.value[0]) ? [re, s.value[0]] : [s.value[0], re] : s.value = [re], M();
  }, vl = () => {
    if (Array.isArray(s.value))
      if (b.value.enabled) {
        const re = gl();
        s.value[s.value.length - 1] = O(re);
      } else
        s.value = s.value.map((re, we) => re && O(re, we));
    else
      s.value = O(s.value);
    n("time-update");
  }, gl = () => Array.isArray(s.value) && s.value.length ? s.value[s.value.length - 1] : null;
  return {
    calendars: u,
    modelValue: s,
    month: ue,
    year: B,
    time: c,
    disabledTimesConfig: K,
    today: f,
    validateTime: N,
    getCalendarDays: V,
    getMarker: T,
    handleScroll: pe,
    handleSwipe: ae,
    handleArrow: fe,
    selectDate: en,
    updateMonthYear: tn,
    presetDate: Va,
    selectCurrentDate: ha,
    updateTime: (re, we = !0, Te = !1) => {
      A(re, we, Te, vl);
    },
    assignMonthAndYear: j
  };
}, I5 = { key: 0 }, F5 = /* @__PURE__ */ Ce({
  __name: "DatePicker",
  props: {
    ...yn
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: n, emit: t }) {
    const a = t, r = e, {
      calendars: l,
      month: o,
      year: i,
      modelValue: s,
      time: u,
      disabledTimesConfig: c,
      today: f,
      validateTime: d,
      getCalendarDays: m,
      getMarker: y,
      handleArrow: v,
      handleScroll: S,
      handleSwipe: g,
      selectDate: b,
      updateMonthYear: h,
      presetDate: x,
      selectCurrentDate: F,
      updateTime: C,
      assignMonthAndYear: A
    } = O5(r, a, le, j), O = Qn(), { setHoverDate: $, getDayClassData: L, clearHoverDate: N } = J5(s, r), { defaultedMultiCalendars: K } = lt(r), ue = ee([]), B = ee([]), Z = ee(null), R = Wt(O, "calendar"), M = Wt(O, "monthYear"), z = Wt(O, "timePicker"), J = (pe) => {
      r.shadow || a("mount", pe);
    };
    Be(
      l,
      () => {
        r.shadow || setTimeout(() => {
          a("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), Be(
      K,
      (pe, fe) => {
        pe.count - fe.count > 0 && A();
      },
      { deep: !0 }
    );
    const H = k(() => (pe) => m(o.value(pe), i.value(pe)).map((fe) => ({
      ...fe,
      days: fe.days.map((ae) => (ae.marker = y(ae), ae.classData = L(ae), ae))
    })));
    function le(pe) {
      var fe;
      pe || pe === 0 ? (fe = B.value[pe]) == null || fe.triggerTransition(o.value(pe), i.value(pe)) : B.value.forEach((ae, T) => ae.triggerTransition(o.value(T), i.value(T)));
    }
    function j() {
      a("update-flow-step");
    }
    const q = (pe, fe = !1) => {
      b(pe, fe), r.spaceConfirm && a("select-date");
    }, P = (pe, fe, ae = 0) => {
      var T;
      (T = ue.value[ae]) == null || T.toggleMonthPicker(pe, fe);
    }, Q = (pe, fe, ae = 0) => {
      var T;
      (T = ue.value[ae]) == null || T.toggleYearPicker(pe, fe);
    }, ce = (pe, fe, ae) => {
      var T;
      (T = Z.value) == null || T.toggleTimePicker(pe, fe, ae);
    }, U = (pe, fe) => {
      var ae;
      if (!r.range) {
        const T = s.value ? s.value : f, te = fe ? new Date(fe) : T, ke = pe ? vn(te, { weekStartsOn: 1 }) : Qu(te, { weekStartsOn: 1 });
        b({
          value: ke,
          current: Ue(te) === o.value(0),
          text: "",
          classData: {}
        }), (ae = document.getElementById(kd(ke))) == null || ae.focus();
      }
    }, ye = (pe) => {
      var fe;
      (fe = ue.value[0]) == null || fe.handleMonthYearChange(pe, !0);
    }, Ee = (pe) => {
      h(0, { month: o.value(0), year: i.value(0) + (pe ? 1 : -1), fromNav: !0 });
    }, qe = (pe, fe) => {
      pe === Rt.time && a(`time-picker-${fe ? "open" : "close"}`), a("overlay-toggle", { open: fe, overlay: pe });
    }, ie = (pe) => {
      a("overlay-toggle", { open: !1, overlay: pe }), a("focus-menu");
    };
    return n({
      clearHoverDate: N,
      presetDate: x,
      selectCurrentDate: F,
      toggleMonthPicker: P,
      toggleYearPicker: Q,
      toggleTimePicker: ce,
      handleArrow: v,
      updateMonthYear: h,
      getSidebarProps: () => ({
        modelValue: s,
        month: o,
        year: i,
        time: u,
        updateTime: C,
        updateMonthYear: h,
        selectDate: b,
        presetDate: x
      }),
      changeMonth: ye,
      changeYear: Ee,
      selectWeekDate: U
    }), (pe, fe) => (p(), w(_e, null, [
      Ae(ll, {
        "multi-calendars": D(K).count,
        collapse: pe.collapse,
        "is-mobile": pe.isMobile
      }, {
        default: xe(({ instance: ae, index: T }) => [
          pe.disableMonthYearSelect ? X("", !0) : (p(), Pe(M5, xt({
            key: 0,
            ref: (te) => {
              te && (ue.value[T] = te);
            },
            months: D(fd)(pe.formatLocale, pe.locale, pe.monthNameFormat),
            years: D(Wo)(pe.yearRange, pe.locale, pe.reverseYears),
            month: D(o)(ae),
            year: D(i)(ae),
            instance: ae
          }, pe.$props, {
            onMount: fe[0] || (fe[0] = (te) => J(D(fa).header)),
            onResetFlow: fe[1] || (fe[1] = (te) => pe.$emit("reset-flow")),
            onUpdateMonthYear: (te) => D(h)(ae, te),
            onOverlayClosed: ie,
            onOverlayOpened: fe[2] || (fe[2] = (te) => pe.$emit("overlay-toggle", { open: !0, overlay: te }))
          }), It({ _: 2 }, [
            Ie(D(M), (te, ke) => ({
              name: te,
              fn: xe((E) => [
                ge(pe.$slots, te, kt(Yt(E)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          Ae(R5, xt({
            ref: (te) => {
              te && (B.value[T] = te);
            },
            "mapped-dates": H.value(ae),
            month: D(o)(ae),
            year: D(i)(ae),
            instance: ae
          }, pe.$props, {
            onSelectDate: (te) => D(b)(te, ae !== 1),
            onHandleSpace: (te) => q(te, ae !== 1),
            onSetHoverDate: fe[3] || (fe[3] = (te) => D($)(te)),
            onHandleScroll: (te) => D(S)(te, ae),
            onHandleSwipe: (te) => D(g)(te, ae),
            onMount: fe[4] || (fe[4] = (te) => J(D(fa).calendar)),
            onResetFlow: fe[5] || (fe[5] = (te) => pe.$emit("reset-flow")),
            onTooltipOpen: fe[6] || (fe[6] = (te) => pe.$emit("tooltip-open", te)),
            onTooltipClose: fe[7] || (fe[7] = (te) => pe.$emit("tooltip-close", te))
          }), It({ _: 2 }, [
            Ie(D(R), (te, ke) => ({
              name: te,
              fn: xe((E) => [
                ge(pe.$slots, te, kt(Yt({ ...E })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse", "is-mobile"]),
      pe.enableTimePicker ? (p(), w("div", I5, [
        pe.$slots["time-picker"] ? ge(pe.$slots, "time-picker", kt(xt({ key: 0 }, { time: D(u), updateTime: D(C) }))) : (p(), Pe($d, xt({
          key: 1,
          ref_key: "timePickerRef",
          ref: Z
        }, pe.$props, {
          hours: D(u).hours,
          minutes: D(u).minutes,
          seconds: D(u).seconds,
          "internal-model-value": pe.internalModelValue,
          "disabled-times-config": D(c),
          "validate-time": D(d),
          onMount: fe[8] || (fe[8] = (ae) => J(D(fa).timePicker)),
          "onUpdate:hours": fe[9] || (fe[9] = (ae) => D(C)(ae)),
          "onUpdate:minutes": fe[10] || (fe[10] = (ae) => D(C)(ae, !1)),
          "onUpdate:seconds": fe[11] || (fe[11] = (ae) => D(C)(ae, !1, !0)),
          onResetFlow: fe[12] || (fe[12] = (ae) => pe.$emit("reset-flow")),
          onOverlayClosed: fe[13] || (fe[13] = (ae) => qe(ae, !1)),
          onOverlayOpened: fe[14] || (fe[14] = (ae) => qe(ae, !0)),
          onAmPmChange: fe[15] || (fe[15] = (ae) => pe.$emit("am-pm-change", ae))
        }), It({ _: 2 }, [
          Ie(D(z), (ae, T) => ({
            name: ae,
            fn: xe((te) => [
              ge(pe.$slots, ae, kt(Yt(te)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : X("", !0)
    ], 64));
  }
}), L5 = (e, n) => {
  const t = ee(), {
    defaultedMultiCalendars: a,
    defaultedConfig: r,
    defaultedHighlight: l,
    defaultedRange: o,
    propDates: i,
    defaultedFilters: s,
    defaultedMultiDates: u
  } = lt(e), { modelValue: c, year: f, month: d, calendars: m } = _r(e, n), { isDisabled: y } = ea(e), { selectYear: v, groupedYears: S, showYearPicker: g, isDisabled: b, toggleYearPicker: h, handleYearSelect: x, handleYear: F } = Pd({
    modelValue: c,
    multiCalendars: a,
    range: o,
    highlight: l,
    calendars: m,
    propDates: i,
    month: d,
    year: f,
    filters: s,
    props: e,
    emit: n
  }), C = (Z, R) => [Z, R].map((M) => Mn(M, "MMMM", { locale: e.formatLocale })).join("-"), A = k(() => (Z) => c.value ? Array.isArray(c.value) ? c.value.some((R) => gi(Z, R)) : gi(c.value, Z) : !1), O = (Z) => {
    if (o.value.enabled) {
      if (Array.isArray(c.value)) {
        const R = Ye(Z, c.value[0]) || Ye(Z, c.value[1]);
        return al(c.value, t.value, Z) && !R;
      }
      return !1;
    }
    return !1;
  }, $ = (Z, R) => Z.quarter === di(R) && Z.year === Le(R), L = (Z) => typeof l.value == "function" ? l.value({ quarter: di(Z), year: Le(Z) }) : !!l.value.quarters.find((R) => $(R, Z)), N = k(() => (Z) => {
    const R = et(/* @__PURE__ */ new Date(), { year: f.value(Z) });
    return mv({
      start: lr(R),
      end: Xu(R)
    }).map((M) => {
      const z = ua(M), J = ci(M), H = y(M), le = O(z), j = L(z);
      return {
        text: C(z, J),
        value: z,
        active: A.value(z),
        highlighted: j,
        disabled: H,
        isBetween: le
      };
    });
  }), K = (Z) => {
    Qo(Z, c, u.value.limit), n("auto-apply", !0);
  }, ue = (Z) => {
    c.value = Jo(c, Z, n), ol(c.value, n, e.autoApply, e.modelAuto);
  }, B = (Z) => {
    c.value = Z, n("auto-apply");
  };
  return {
    defaultedConfig: r,
    defaultedMultiCalendars: a,
    groupedYears: S,
    year: f,
    isDisabled: b,
    quarters: N,
    showYearPicker: g,
    modelValue: c,
    setHoverDate: (Z) => {
      t.value = Z;
    },
    selectYear: v,
    selectQuarter: (Z, R, M) => {
      if (!M)
        return m.value[R].month = Ue(ci(Z)), u.value.enabled ? K(Z) : o.value.enabled ? ue(Z) : B(Z);
    },
    toggleYearPicker: h,
    handleYearSelect: x,
    handleYear: F
  };
}, N5 = { class: "dp--quarter-items" }, V5 = ["data-test-id", "disabled", "onClick", "onMouseover"], B5 = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...yn
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(e, { expose: n, emit: t }) {
    const a = t, r = e, l = Qn(), o = Wt(l, "yearMode"), {
      defaultedMultiCalendars: i,
      defaultedConfig: s,
      groupedYears: u,
      year: c,
      isDisabled: f,
      quarters: d,
      modelValue: m,
      showYearPicker: y,
      setHoverDate: v,
      selectQuarter: S,
      toggleYearPicker: g,
      handleYearSelect: b,
      handleYear: h
    } = L5(r, a);
    return n({ getSidebarProps: () => ({
      modelValue: m,
      year: c,
      selectQuarter: S,
      handleYearSelect: b,
      handleYear: h
    }) }), (x, F) => (p(), Pe(ll, {
      "multi-calendars": D(i).count,
      collapse: x.collapse,
      stretch: "",
      "is-mobile": x.isMobile
    }, {
      default: xe(({ instance: C }) => [
        _("div", {
          class: "dp-quarter-picker-wrap",
          style: tt({ minHeight: `${D(s).modeHeight}px` })
        }, [
          x.$slots["top-extra"] ? ge(x.$slots, "top-extra", {
            key: 0,
            value: x.internalModelValue
          }) : X("", !0),
          _("div", null, [
            Ae(Sd, xt(x.$props, {
              items: D(u)(C),
              instance: C,
              "show-year-picker": D(y)[C],
              year: D(c)(C),
              "is-disabled": (A) => D(f)(C, A),
              onHandleYear: (A) => D(h)(C, A),
              onYearSelect: (A) => D(b)(A, C),
              onToggleYearPicker: (A) => D(g)(C, A == null ? void 0 : A.flow, A == null ? void 0 : A.show)
            }), It({ _: 2 }, [
              Ie(D(o), (A, O) => ({
                name: A,
                fn: xe(($) => [
                  ge(x.$slots, A, kt(Yt($)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _("div", N5, [
            (p(!0), w(_e, null, Ie(D(d)(C), (A, O) => (p(), w("div", { key: O }, [
              _("button", {
                type: "button",
                class: me(["dp--qr-btn", {
                  "dp--qr-btn-active": A.active,
                  "dp--qr-btn-between": A.isBetween,
                  "dp--qr-btn-disabled": A.disabled,
                  "dp--highlighted": A.highlighted
                }]),
                "data-test-id": A.value,
                disabled: A.disabled,
                onClick: ($) => D(S)(A.value, C, A.disabled),
                onMouseover: ($) => D(v)(A.value)
              }, [
                x.$slots.quarter ? ge(x.$slots, "quarter", {
                  key: 0,
                  value: A.value,
                  text: A.text
                }) : (p(), w(_e, { key: 1 }, [
                  Qe(he(A.text), 1)
                ], 64))
              ], 42, V5)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), Td = (e, n) => {
  const t = ee(0);
  He(() => {
    a(), window.addEventListener("resize", a, { passive: !0 });
  }), wt(() => {
    window.removeEventListener("resize", a);
  });
  const a = () => {
    t.value = window.document.documentElement.clientWidth;
  };
  return {
    isMobile: k(
      () => t.value <= e.value.mobileBreakpoint && !n ? !0 : void 0
    )
  };
}, H5 = ["id", "tabindex", "role", "aria-label"], z5 = {
  key: 0,
  class: "dp--menu-load-container"
}, U5 = {
  key: 1,
  class: "dp--menu-header"
}, Y5 = ["data-dp-mobile"], j5 = {
  key: 0,
  class: "dp__sidebar_left"
}, Z5 = ["data-dp-mobile"], G5 = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], W5 = {
  key: 2,
  class: "dp__sidebar_right"
}, q5 = {
  key: 3,
  class: "dp__action_extra"
}, Mi = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...rl,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "menu-blur"
  ],
  setup(e, { expose: n, emit: t }) {
    const a = t, r = e, l = ee(null), o = k(() => {
      const { openOnTop: Y, ...I } = r;
      return {
        ...I,
        isMobile: v.value,
        flowStep: N.value,
        menuWrapRef: l.value
      };
    }), { setMenuFocused: i, setShiftKey: s, control: u } = Cd(), c = Qn(), { defaultedTextInput: f, defaultedInline: d, defaultedConfig: m, defaultedUI: y } = lt(r), { isMobile: v } = Td(m, r.shadow), S = ee(null), g = ee(0), b = ee(null), h = ee(!1), x = ee(null), F = ee(!1);
    He(() => {
      if (!r.shadow) {
        h.value = !0, C(), window.addEventListener("resize", C);
        const Y = yt(l);
        if (Y && !f.value.enabled && !d.value.enabled && (i(!0), z()), Y) {
          const I = (G) => {
            F.value = !0, m.value.allowPreventDefault && G.preventDefault(), Gn(G, m.value, !0);
          };
          Y.addEventListener("pointerdown", I), Y.addEventListener("mousedown", I);
        }
      }
      document.addEventListener("mousedown", oe);
    }), wt(() => {
      window.removeEventListener("resize", C), document.addEventListener("mousedown", oe);
    });
    const C = () => {
      const Y = yt(b);
      Y && (g.value = Y.getBoundingClientRect().width);
    }, { arrowRight: A, arrowLeft: O, arrowDown: $, arrowUp: L } = Jn(), { flowStep: N, updateFlowStep: K, childMount: ue, resetFlow: B, handleFlow: Z } = eh(r, a, x), R = k(() => r.monthPicker ? r5 : r.yearPicker ? o5 : r.timePicker ? b5 : r.quarterPicker ? B5 : F5), M = k(() => {
      var Y;
      if (m.value.arrowLeft) return m.value.arrowLeft;
      const I = (Y = l.value) == null ? void 0 : Y.getBoundingClientRect(), G = r.getInputRect();
      return (G == null ? void 0 : G.width) < (g == null ? void 0 : g.value) && (G == null ? void 0 : G.left) <= ((I == null ? void 0 : I.left) ?? 0) ? `${(G == null ? void 0 : G.width) / 2}px` : (G == null ? void 0 : G.right) >= ((I == null ? void 0 : I.right) ?? 0) && (G == null ? void 0 : G.width) < (g == null ? void 0 : g.value) ? `${(g == null ? void 0 : g.value) - (G == null ? void 0 : G.width) / 2}px` : "50%";
    }), z = () => {
      const Y = yt(l);
      Y && Y.focus({ preventScroll: !0 });
    }, J = k(() => {
      var Y;
      return ((Y = x.value) == null ? void 0 : Y.getSidebarProps()) || {};
    }), H = () => {
      r.openOnTop && a("recalculate-position");
    }, le = Wt(c, "action"), j = k(() => r.monthPicker || r.yearPicker ? Wt(c, "monthYear") : r.timePicker ? Wt(c, "timePicker") : Wt(c, "shared")), q = k(() => r.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), P = k(() => ({
      dp__menu_disabled: r.disabled,
      dp__menu_readonly: r.readonly,
      "dp-menu-loading": r.loading
    })), Q = k(
      () => ({
        dp__menu: !0,
        dp__menu_index: !d.value.enabled,
        dp__relative: d.value.enabled,
        ...y.value.menu ?? {}
      })
    ), ce = (Y) => {
      Gn(Y, m.value, !0);
    }, U = () => {
      r.escClose && a("close-picker");
    }, ye = (Y) => {
      if (r.arrowNavigation) {
        if (Y === Lt.up) return L();
        if (Y === Lt.down) return $();
        if (Y === Lt.left) return O();
        if (Y === Lt.right) return A();
      } else Y === Lt.left || Y === Lt.up ? fe("handleArrow", Lt.left, 0, Y === Lt.up) : fe("handleArrow", Lt.right, 0, Y === Lt.down);
    }, Ee = (Y) => {
      s(Y.shiftKey), !r.disableMonthYearSelect && Y.code === at.tab && Y.target.classList.contains("dp__menu") && u.value.shiftKeyInMenu && (Y.preventDefault(), Gn(Y, m.value, !0), a("close-picker"));
    }, qe = () => {
      z(), a("time-picker-close");
    }, ie = (Y) => {
      var I, G, se;
      (I = x.value) == null || I.toggleTimePicker(!1, !1), (G = x.value) == null || G.toggleMonthPicker(!1, !1, Y), (se = x.value) == null || se.toggleYearPicker(!1, !1, Y);
    }, pe = (Y, I = 0) => {
      var G, se, W;
      return Y === "month" ? (G = x.value) == null ? void 0 : G.toggleMonthPicker(!1, !0, I) : Y === "year" ? (se = x.value) == null ? void 0 : se.toggleYearPicker(!1, !0, I) : Y === "time" ? (W = x.value) == null ? void 0 : W.toggleTimePicker(!0, !1) : ie(I);
    }, fe = (Y, ...I) => {
      var G, se;
      (G = x.value) != null && G[Y] && ((se = x.value) == null || se[Y](...I));
    }, ae = () => {
      fe("selectCurrentDate");
    }, T = (Y, I) => {
      fe("presetDate", Y, I);
    }, te = () => {
      fe("clearHoverDate");
    }, ke = (Y, I) => {
      fe("updateMonthYear", Y, I);
    }, E = (Y, I) => {
      Y.preventDefault(), ye(I);
    }, V = (Y) => {
      var I, G, se;
      if (Ee(Y), Y.key === at.home || Y.key === at.end)
        return fe(
          "selectWeekDate",
          Y.key === at.home,
          Y.target.getAttribute("id")
        );
      switch ((Y.key === at.pageUp || Y.key === at.pageDown) && (Y.shiftKey ? (fe("changeYear", Y.key === at.pageUp), (I = fo(l.value, "overlay-year")) == null || I.focus()) : (fe("changeMonth", Y.key === at.pageUp), (G = fo(l.value, Y.key === at.pageUp ? "action-prev" : "action-next")) == null || G.focus()), Y.target.getAttribute("id") && ((se = l.value) == null || se.focus({ preventScroll: !0 }))), Y.key) {
        case at.esc:
          return U();
        case at.arrowLeft:
          return E(Y, Lt.left);
        case at.arrowRight:
          return E(Y, Lt.right);
        case at.arrowUp:
          return E(Y, Lt.up);
        case at.arrowDown:
          return E(Y, Lt.down);
        default:
          return;
      }
    }, oe = (Y) => {
      var I;
      d.value.enabled && !d.value.input && !((I = l.value) != null && I.contains(Y.target)) && F.value && (F.value = !1, a("menu-blur"));
    };
    return n({
      updateMonthYear: ke,
      switchView: pe,
      handleFlow: Z
    }), (Y, I) => {
      var G, se, W;
      return p(), w("div", {
        id: Y.uid ? `dp-menu-${Y.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: l,
        tabindex: D(d).enabled ? void 0 : "0",
        role: D(d).enabled ? void 0 : "dialog",
        "aria-label": (G = Y.ariaLabels) == null ? void 0 : G.menu,
        class: me(Q.value),
        style: tt({ "--dp-arrow-left": M.value }),
        onMouseleave: te,
        onClick: ce,
        onKeydown: V
      }, [
        (Y.disabled || Y.readonly) && D(d).enabled || Y.loading ? (p(), w("div", {
          key: 0,
          class: me(P.value)
        }, [
          Y.loading ? (p(), w("div", z5, I[19] || (I[19] = [
            _("span", { class: "dp--menu-loader" }, null, -1)
          ]))) : X("", !0)
        ], 2)) : X("", !0),
        Y.$slots["menu-header"] ? (p(), w("div", U5, [
          ge(Y.$slots, "menu-header")
        ])) : X("", !0),
        !D(d).enabled && !Y.teleportCenter ? (p(), w("div", {
          key: 2,
          class: me(q.value)
        }, null, 2)) : X("", !0),
        _("div", {
          ref_key: "innerMenuRef",
          ref: b,
          class: me({
            dp__menu_content_wrapper: ((se = Y.presetDates) == null ? void 0 : se.length) || !!Y.$slots["left-sidebar"] || !!Y.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": e.collapse && (((W = Y.presetDates) == null ? void 0 : W.length) || !!Y.$slots["left-sidebar"] || !!Y.$slots["right-sidebar"])
          }),
          "data-dp-mobile": D(v),
          style: tt({ "--dp-menu-width": `${g.value}px` })
        }, [
          Y.$slots["left-sidebar"] ? (p(), w("div", j5, [
            ge(Y.$slots, "left-sidebar", kt(Yt(J.value)))
          ])) : X("", !0),
          Y.presetDates.length ? (p(), w("div", {
            key: 1,
            class: me({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 }),
            "data-dp-mobile": D(v)
          }, [
            (p(!0), w(_e, null, Ie(Y.presetDates, (ne, Ne) => (p(), w(_e, { key: Ne }, [
              ne.slot ? ge(Y.$slots, ne.slot, {
                key: 0,
                presetDate: T,
                label: ne.label,
                value: ne.value
              }) : (p(), w("button", {
                key: 1,
                type: "button",
                style: tt(ne.style || {}),
                class: me(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
                "data-test-id": ne.testId ?? void 0,
                "data-dp-mobile": D(v),
                onClick: ot((Ve) => T(ne.value, ne.noTz), ["prevent"]),
                onKeydown: (Ve) => D(Bt)(Ve, () => T(ne.value, ne.noTz), !0)
              }, he(ne.label), 47, G5))
            ], 64))), 128))
          ], 10, Z5)) : X("", !0),
          _("div", {
            ref_key: "calendarWrapperRef",
            ref: S,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (p(), Pe(Ln(R.value), xt({
              ref_key: "dynCmpRef",
              ref: x
            }, o.value, {
              "flow-step": D(N),
              onMount: D(ue),
              onUpdateFlowStep: D(K),
              onResetFlow: D(B),
              onFocusMenu: z,
              onSelectDate: I[0] || (I[0] = (ne) => Y.$emit("select-date")),
              onDateUpdate: I[1] || (I[1] = (ne) => Y.$emit("date-update", ne)),
              onTooltipOpen: I[2] || (I[2] = (ne) => Y.$emit("tooltip-open", ne)),
              onTooltipClose: I[3] || (I[3] = (ne) => Y.$emit("tooltip-close", ne)),
              onAutoApply: I[4] || (I[4] = (ne) => Y.$emit("auto-apply", ne)),
              onRangeStart: I[5] || (I[5] = (ne) => Y.$emit("range-start", ne)),
              onRangeEnd: I[6] || (I[6] = (ne) => Y.$emit("range-end", ne)),
              onInvalidFixedRange: I[7] || (I[7] = (ne) => Y.$emit("invalid-fixed-range", ne)),
              onTimeUpdate: I[8] || (I[8] = (ne) => Y.$emit("time-update")),
              onAmPmChange: I[9] || (I[9] = (ne) => Y.$emit("am-pm-change", ne)),
              onTimePickerOpen: I[10] || (I[10] = (ne) => Y.$emit("time-picker-open", ne)),
              onTimePickerClose: qe,
              onRecalculatePosition: H,
              onUpdateMonthYear: I[11] || (I[11] = (ne) => Y.$emit("update-month-year", ne)),
              onAutoApplyInvalid: I[12] || (I[12] = (ne) => Y.$emit("auto-apply-invalid", ne)),
              onInvalidDate: I[13] || (I[13] = (ne) => Y.$emit("invalid-date", ne)),
              onOverlayToggle: I[14] || (I[14] = (ne) => Y.$emit("overlay-toggle", ne)),
              "onUpdate:internalModelValue": I[15] || (I[15] = (ne) => Y.$emit("update:internal-model-value", ne))
            }), It({ _: 2 }, [
              Ie(j.value, (ne, Ne) => ({
                name: ne,
                fn: xe((Ve) => [
                  ge(Y.$slots, ne, kt(Yt({ ...Ve })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          Y.$slots["right-sidebar"] ? (p(), w("div", W5, [
            ge(Y.$slots, "right-sidebar", kt(Yt(J.value)))
          ])) : X("", !0),
          Y.$slots["action-extra"] ? (p(), w("div", q5, [
            Y.$slots["action-extra"] ? ge(Y.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: ae
            }) : X("", !0)
          ])) : X("", !0)
        ], 14, Y5),
        !Y.autoApply || D(m).keepActionRow ? (p(), Pe(qg, xt({
          key: 3,
          "menu-mount": h.value
        }, o.value, {
          "calendar-width": g.value,
          onClosePicker: I[16] || (I[16] = (ne) => Y.$emit("close-picker")),
          onSelectDate: I[17] || (I[17] = (ne) => Y.$emit("select-date")),
          onInvalidSelect: I[18] || (I[18] = (ne) => Y.$emit("invalid-select")),
          onSelectNow: ae
        }), It({ _: 2 }, [
          Ie(D(le), (ne, Ne) => ({
            name: ne,
            fn: xe((Ve) => [
              ge(Y.$slots, ne, kt(Yt({ ...Ve })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : X("", !0)
      ], 46, H5);
    };
  }
});
var ka = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(ka || {});
const K5 = ({
  menuRef: e,
  menuRefInner: n,
  inputRef: t,
  pickerWrapperRef: a,
  inline: r,
  emit: l,
  props: o,
  slots: i
}) => {
  const { defaultedConfig: s } = lt(o), u = ee({}), c = ee(!1), f = ee({
    top: "0",
    left: "0"
  }), d = ee(!1), m = Ea(o, "teleportCenter");
  Be(m, () => {
    f.value = JSON.parse(JSON.stringify({})), F();
  });
  const y = (R) => {
    if (o.teleport) {
      const M = R.getBoundingClientRect();
      return {
        left: M.left + window.scrollX,
        top: M.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, v = (R, M) => {
    f.value.left = `${R + M - u.value.width}px`;
  }, S = (R) => {
    f.value.left = `${R}px`;
  }, g = (R, M) => {
    o.position === ka.left && S(R), o.position === ka.right && v(R, M), o.position === ka.center && (f.value.left = `${R + M / 2 - u.value.width / 2}px`);
  }, b = (R) => {
    const { width: M, height: z } = R.getBoundingClientRect(), { top: J, left: H } = y(R);
    return { top: +J, left: +H, width: M, height: z };
  }, h = () => {
    f.value.left = "50%", f.value.top = "50%", f.value.transform = "translate(-50%, -50%)", f.value.position = "fixed", delete f.value.opacity;
  }, x = () => {
    const R = yt(t);
    f.value = o.altPosition(R);
  }, F = (R = !0) => {
    var M;
    if (!r.value.enabled) {
      if (m.value) return h();
      if (o.altPosition !== null) return x();
      if (R) {
        const z = o.teleport ? (M = n.value) == null ? void 0 : M.$el : e.value;
        z && (u.value = z.getBoundingClientRect()), l("recalculate-position");
      }
      return K();
    }
  }, C = ({ inputEl: R, left: M, width: z }) => {
    window.screen.width > 768 && !c.value && g(M, z), $(R);
  }, A = (R) => {
    const { top: M, left: z, height: J, width: H } = b(R);
    f.value.top = `${J + M + +o.offset}px`, d.value = !1, c.value || (f.value.left = `${z + H / 2 - u.value.width / 2}px`), C({ inputEl: R, left: z, width: H });
  }, O = (R) => {
    const { top: M, left: z, width: J } = b(R);
    f.value.top = `${M - +o.offset - u.value.height}px`, d.value = !0, C({ inputEl: R, left: z, width: J });
  }, $ = (R) => {
    if (o.autoPosition) {
      const { left: M, width: z } = b(R), { left: J, right: H } = u.value;
      if (!c.value) {
        if (Math.abs(J) !== Math.abs(H)) {
          if (J <= 0)
            return c.value = !0, S(M);
          if (H >= document.documentElement.clientWidth)
            return c.value = !0, v(M, z);
        }
        return g(M, z);
      }
    }
  }, L = () => {
    const R = yt(t);
    if (R) {
      if (o.autoPosition === rn.top) return rn.top;
      if (o.autoPosition === rn.bottom) return rn.bottom;
      const { height: M } = u.value, { top: z, height: J } = R.getBoundingClientRect(), H = window.innerHeight - z - J, le = z;
      return M <= H ? rn.bottom : M > H && M <= le ? rn.top : H >= le ? rn.bottom : rn.top;
    }
    return rn.bottom;
  }, N = (R) => L() === rn.bottom ? A(R) : O(R), K = () => {
    const R = yt(t);
    if (R)
      return o.autoPosition ? N(R) : A(R);
  }, ue = function(R) {
    if (R) {
      const M = R.scrollHeight > R.clientHeight, z = window.getComputedStyle(R).overflowY.indexOf("hidden") !== -1;
      return M && !z;
    }
    return !0;
  }, B = function(R) {
    return !R || R === document.body || R.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : ue(R) ? R : B(
      R.assignedSlot && s.value.shadowDom ? R.assignedSlot.parentNode : R.parentNode
    );
  }, Z = (R) => {
    if (R)
      switch (o.position) {
        case ka.left:
          return { left: 0, transform: "translateX(0)" };
        case ka.right:
          return { left: `${R.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${R.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: d,
    menuStyle: f,
    xCorrect: c,
    setMenuPosition: F,
    getScrollableParent: B,
    shadowRender: (R, M) => {
      var z, J, H;
      const le = document.createElement("div"), j = (z = yt(t)) == null ? void 0 : z.getBoundingClientRect();
      le.setAttribute("id", "dp--temp-container");
      const q = (J = a.value) != null && J.clientWidth ? a.value : document.body;
      q.append(le);
      const P = Z(j), Q = s.value.shadowDom ? Object.keys(i).filter(
        (U) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(U)
      ) : Object.keys(i), ce = je(
        R,
        {
          ...M,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...P }
        },
        Object.fromEntries(Q.map((U) => [U, i[U]]))
      );
      fs(ce, le), u.value = (H = ce.el) == null ? void 0 : H.getBoundingClientRect(), fs(null, le), q.removeChild(le);
    }
  };
}, zn = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] },
  { name: "menu-header", use: ["menu"] }
], X5 = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], Q5 = {
  all: () => zn,
  monthYear: () => zn.filter((e) => e.use.includes("month-year")),
  input: () => X5,
  timePicker: () => zn.filter((e) => e.use.includes("time")),
  action: () => zn.filter((e) => e.use.includes("action")),
  calendar: () => zn.filter((e) => e.use.includes("calendar")),
  menu: () => zn.filter((e) => e.use.includes("menu")),
  shared: () => zn.filter((e) => e.use.includes("shared")),
  yearMode: () => zn.filter((e) => e.use.includes("year-mode"))
}, Wt = (e, n, t) => {
  const a = [];
  return Q5[n]().forEach((r) => {
    e[r.name] && a.push(r.name);
  }), t != null && t.length && t.forEach((r) => {
    r.slot && a.push(r.slot);
  }), a;
}, br = (e) => {
  const n = k(() => (a) => e.value ? a ? e.value.open : e.value.close : ""), t = k(() => (a) => e.value ? a ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: n, showTransition: !!e.value, menuTransition: t };
}, _r = (e, n, t) => {
  const { defaultedRange: a, defaultedTz: r } = lt(e), l = ve(jt(ve(), r.value.timezone)), o = ee([{ month: Ue(l), year: Le(l) }]), i = (d) => {
    const m = {
      hours: In(l),
      minutes: Kn(l),
      seconds: 0
    };
    return a.value.enabled ? [m[d], m[d]] : m[d];
  }, s = qn({
    hours: i("hours"),
    minutes: i("minutes"),
    seconds: i("seconds")
  });
  Be(
    a,
    (d, m) => {
      d.enabled !== m.enabled && (s.hours = i("hours"), s.minutes = i("minutes"), s.seconds = i("seconds"));
    },
    { deep: !0 }
  );
  const u = k({
    get: () => e.internalModelValue,
    set: (d) => {
      !e.readonly && !e.disabled && n("update:internal-model-value", d);
    }
  }), c = k(
    () => (d) => o.value[d] ? o.value[d].month : 0
  ), f = k(
    () => (d) => o.value[d] ? o.value[d].year : 0
  );
  return Be(
    u,
    (d, m) => {
      t && JSON.stringify(d ?? {}) !== JSON.stringify(m ?? {}) && t();
    },
    { deep: !0 }
  ), {
    calendars: o,
    time: s,
    modelValue: u,
    month: c,
    year: f,
    today: l
  };
}, J5 = (e, n) => {
  const {
    defaultedMultiCalendars: t,
    defaultedMultiDates: a,
    defaultedUI: r,
    defaultedHighlight: l,
    defaultedTz: o,
    propDates: i,
    defaultedRange: s
  } = lt(n), { isDisabled: u } = ea(n), c = ee(null), f = ee(jt(/* @__PURE__ */ new Date(), o.value.timezone)), d = (P) => {
    !P.current && n.hideOffsetDates || (c.value = P.value);
  }, m = () => {
    c.value = null;
  }, y = (P) => Array.isArray(e.value) && s.value.enabled && e.value[0] && c.value ? P ? ft(c.value, e.value[0]) : ut(c.value, e.value[0]) : !0, v = (P, Q) => {
    const ce = () => e.value ? Q ? e.value[0] || null : e.value[1] : null, U = e.value && Array.isArray(e.value) ? ce() : null;
    return Ye(ve(P.value), U);
  }, S = (P) => {
    const Q = Array.isArray(e.value) ? e.value[0] : null;
    return P ? !ut(c.value ?? null, Q) : !0;
  }, g = (P, Q = !0) => (s.value.enabled || n.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? n.hideOffsetDates && !P.current ? !1 : Ye(ve(P.value), e.value[Q ? 0 : 1]) : s.value.enabled ? v(P, Q) && S(Q) || Ye(P.value, Array.isArray(e.value) ? e.value[0] : null) && y(Q) : !1, b = (P, Q) => {
    if (Array.isArray(e.value) && e.value[0] && e.value.length === 1) {
      const ce = Ye(P.value, c.value);
      return Q ? ft(e.value[0], P.value) && ce : ut(e.value[0], P.value) && ce;
    }
    return !1;
  }, h = (P) => !e.value || n.hideOffsetDates && !P.current ? !1 : s.value.enabled ? n.modelAuto && Array.isArray(e.value) ? Ye(P.value, e.value[0] ? e.value[0] : f.value) : !1 : a.value.enabled && Array.isArray(e.value) ? e.value.some((Q) => Ye(Q, P.value)) : Ye(P.value, e.value ? e.value : f.value), x = (P) => {
    if (s.value.autoRange || n.weekPicker) {
      if (c.value) {
        if (n.hideOffsetDates && !P.current) return !1;
        const Q = sn(c.value, +s.value.autoRange), ce = Tn(ve(c.value), n.weekStart);
        return n.weekPicker ? Ye(ce[1], ve(P.value)) : Ye(Q, ve(P.value));
      }
      return !1;
    }
    return !1;
  }, F = (P) => {
    if (s.value.autoRange || n.weekPicker) {
      if (c.value) {
        const Q = sn(c.value, +s.value.autoRange);
        if (n.hideOffsetDates && !P.current) return !1;
        const ce = Tn(ve(c.value), n.weekStart);
        return n.weekPicker ? ft(P.value, ce[0]) && ut(P.value, ce[1]) : ft(P.value, c.value) && ut(P.value, Q);
      }
      return !1;
    }
    return !1;
  }, C = (P) => {
    if (s.value.autoRange || n.weekPicker) {
      if (c.value) {
        if (n.hideOffsetDates && !P.current) return !1;
        const Q = Tn(ve(c.value), n.weekStart);
        return n.weekPicker ? Ye(Q[0], P.value) : Ye(c.value, P.value);
      }
      return !1;
    }
    return !1;
  }, A = (P) => al(e.value, c.value, P.value), O = () => n.modelAuto && Array.isArray(n.internalModelValue) ? !!n.internalModelValue[0] : !1, $ = () => n.modelAuto ? md(n.internalModelValue) : !0, L = (P) => {
    if (n.weekPicker) return !1;
    const Q = s.value.enabled ? !g(P) && !g(P, !1) : !0;
    return !u(P.value) && !h(P) && !(!P.current && n.hideOffsetDates) && Q;
  }, N = (P) => s.value.enabled ? n.modelAuto ? O() && h(P) : !1 : h(P), K = (P) => l.value ? wg(P.value, i.value.highlight) : !1, ue = (P) => {
    const Q = u(P.value);
    return Q && (typeof l.value == "function" ? !l.value(P.value, Q) : !l.value.options.highlightDisabled);
  }, B = (P) => {
    var Q;
    return typeof l.value == "function" ? l.value(P.value) : (Q = l.value.weekdays) == null ? void 0 : Q.includes(P.value.getDay());
  }, Z = (P) => (s.value.enabled || n.weekPicker) && (!(t.value.count > 0) || P.current) && $() && !(!P.current && n.hideOffsetDates) && !h(P) ? A(P) : !1, R = (P) => {
    const { isRangeStart: Q, isRangeEnd: ce } = H(P), U = s.value.enabled ? Q || ce : !1;
    return {
      dp__cell_offset: !P.current,
      dp__pointer: !n.disabled && !(!P.current && n.hideOffsetDates) && !u(P.value),
      dp__cell_disabled: u(P.value),
      dp__cell_highlight: !ue(P) && (K(P) || B(P)) && !N(P) && !U && !C(P) && !(Z(P) && n.weekPicker) && !ce,
      dp__cell_highlight_active: !ue(P) && (K(P) || B(P)) && N(P),
      dp__today: !n.noToday && Ye(P.value, f.value) && P.current,
      "dp--past": ut(P.value, f.value),
      "dp--future": ft(P.value, f.value)
    };
  }, M = (P) => ({
    dp__active_date: N(P),
    dp__date_hover: L(P)
  }), z = (P) => {
    if (e.value && !Array.isArray(e.value)) {
      const Q = Tn(e.value, n.weekStart);
      return {
        ...j(P),
        dp__range_start: Ye(Q[0], P.value),
        dp__range_end: Ye(Q[1], P.value),
        dp__range_between_week: ft(P.value, Q[0]) && ut(P.value, Q[1])
      };
    }
    return {
      ...j(P)
    };
  }, J = (P) => {
    if (e.value && Array.isArray(e.value)) {
      const Q = Tn(e.value[0], n.weekStart), ce = e.value[1] ? Tn(e.value[1], n.weekStart) : [];
      return {
        ...j(P),
        dp__range_start: Ye(Q[0], P.value) || Ye(ce[0], P.value),
        dp__range_end: Ye(Q[1], P.value) || Ye(ce[1], P.value),
        dp__range_between_week: ft(P.value, Q[0]) && ut(P.value, Q[1]) || ft(P.value, ce[0]) && ut(P.value, ce[1]),
        dp__range_between: ft(P.value, Q[1]) && ut(P.value, ce[0])
      };
    }
    return {
      ...j(P)
    };
  }, H = (P) => {
    const Q = t.value.count > 0 ? P.current && g(P) && $() : g(P) && $(), ce = t.value.count > 0 ? P.current && g(P, !1) && $() : g(P, !1) && $();
    return { isRangeStart: Q, isRangeEnd: ce };
  }, le = (P) => {
    const { isRangeStart: Q, isRangeEnd: ce } = H(P);
    return {
      dp__range_start: Q,
      dp__range_end: ce,
      dp__range_between: Z(P),
      dp__date_hover: Ye(P.value, c.value) && !Q && !ce && !n.weekPicker,
      dp__date_hover_start: b(P, !0),
      dp__date_hover_end: b(P, !1)
    };
  }, j = (P) => ({
    ...le(P),
    dp__cell_auto_range: F(P),
    dp__cell_auto_range_start: C(P),
    dp__cell_auto_range_end: x(P)
  }), q = (P) => s.value.enabled ? s.value.autoRange ? j(P) : n.modelAuto ? { ...M(P), ...le(P) } : n.weekPicker ? J(P) : le(P) : n.weekPicker ? z(P) : M(P);
  return {
    setHoverDate: d,
    clearHoverDate: m,
    getDayClassData: (P) => n.hideOffsetDates && !P.current ? {} : {
      ...R(P),
      ...q(P),
      [n.dayClass ? n.dayClass(P.value, n.internalModelValue) : ""]: !0,
      ...r.value.calendarCell ?? {}
    }
  };
}, ea = (e) => {
  const { defaultedFilters: n, defaultedRange: t, propDates: a, defaultedMultiDates: r } = lt(e), l = (B) => a.value.disabledDates ? typeof a.value.disabledDates == "function" ? a.value.disabledDates(ve(B)) : !!Gr(B, a.value.disabledDates) : !1, o = (B) => a.value.maxDate ? e.yearPicker ? Le(B) > Le(a.value.maxDate) : ft(B, a.value.maxDate) : !1, i = (B) => a.value.minDate ? e.yearPicker ? Le(B) < Le(a.value.minDate) : ut(B, a.value.minDate) : !1, s = (B) => {
    const Z = o(B), R = i(B), M = l(B), z = n.value.months.map((q) => +q).includes(Ue(B)), J = e.disabledWeekDays.length ? e.disabledWeekDays.some((q) => +q === o1(B)) : !1, H = m(B), le = Le(B), j = le < +e.yearRange[0] || le > +e.yearRange[1];
    return !(Z || R || M || z || j || J || H);
  }, u = (B, Z) => ut(...jn(a.value.minDate, B, Z)) || Ye(...jn(a.value.minDate, B, Z)), c = (B, Z) => ft(...jn(a.value.maxDate, B, Z)) || Ye(...jn(a.value.maxDate, B, Z)), f = (B, Z, R) => {
    let M = !1;
    return a.value.maxDate && R && c(B, Z) && (M = !0), a.value.minDate && !R && u(B, Z) && (M = !0), M;
  }, d = (B, Z, R, M) => {
    let z = !1;
    return M && (a.value.minDate || a.value.maxDate) ? a.value.minDate && a.value.maxDate ? z = f(B, Z, R) : (a.value.minDate && u(B, Z) || a.value.maxDate && c(B, Z)) && (z = !0) : z = !0, z;
  }, m = (B) => Array.isArray(a.value.allowedDates) && !a.value.allowedDates.length ? !0 : a.value.allowedDates ? !Gr(B, a.value.allowedDates) : !1, y = (B) => !s(B), v = (B) => t.value.noDisabledRange ? !Ku({ start: B[0], end: B[1] }).some((Z) => y(Z)) : !0, S = (B) => {
    if (B) {
      const Z = Le(B);
      return Z >= +e.yearRange[0] && Z <= e.yearRange[1];
    }
    return !0;
  }, g = (B, Z) => !!(Array.isArray(B) && B[Z] && (t.value.maxRange || t.value.minRange) && S(B[Z])), b = (B, Z, R = 0) => {
    if (g(Z, R) && S(B)) {
      const M = Gu(B, Z[R]), z = yd(Z[R], B), J = z.length === 1 ? 0 : z.filter((le) => y(le)).length, H = Math.abs(M) - (t.value.minMaxRawRange ? 0 : J);
      if (t.value.minRange && t.value.maxRange)
        return H >= +t.value.minRange && H <= +t.value.maxRange;
      if (t.value.minRange) return H >= +t.value.minRange;
      if (t.value.maxRange) return H <= +t.value.maxRange;
    }
    return !0;
  }, h = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, x = (B) => Array.isArray(B) ? [B[0] ? Rl(B[0]) : null, B[1] ? Rl(B[1]) : null] : Rl(B), F = (B, Z, R) => B.find(
    (M) => +M.hours === In(Z) && M.minutes === "*" ? !0 : +M.minutes === Kn(Z) && +M.hours === In(Z)
  ) && R, C = (B, Z, R) => {
    const [M, z] = B, [J, H] = Z;
    return !F(M, J, R) && !F(z, H, R) && R;
  }, A = (B, Z) => {
    const R = Array.isArray(Z) ? Z : [Z];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? C(e.disabledTimes, R, B) : !R.some((M) => F(e.disabledTimes, M, B)) : B;
  }, O = (B, Z) => {
    const R = Array.isArray(Z) ? [ma(Z[0]), Z[1] ? ma(Z[1]) : void 0] : ma(Z), M = !e.disabledTimes(R);
    return B && M;
  }, $ = (B, Z) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? A(Z, B) : O(Z, B) : Z, L = (B) => {
    let Z = !0;
    if (!B || h()) return !0;
    const R = !a.value.minDate && !a.value.maxDate ? x(B) : B;
    return (e.maxTime || a.value.maxDate) && (Z = xi(
      e.maxTime,
      a.value.maxDate,
      "max",
      bt(R),
      Z
    )), (e.minTime || a.value.minDate) && (Z = xi(
      e.minTime,
      a.value.minDate,
      "min",
      bt(R),
      Z
    )), $(B, Z);
  }, N = (B) => {
    if (!e.monthPicker) return !0;
    let Z = !0;
    const R = ve(un(B));
    if (a.value.minDate && a.value.maxDate) {
      const M = ve(un(a.value.minDate)), z = ve(un(a.value.maxDate));
      return ft(R, M) && ut(R, z) || Ye(R, M) || Ye(R, z);
    }
    if (a.value.minDate) {
      const M = ve(un(a.value.minDate));
      Z = ft(R, M) || Ye(R, M);
    }
    if (a.value.maxDate) {
      const M = ve(un(a.value.maxDate));
      Z = ut(R, M) || Ye(R, M);
    }
    return Z;
  }, K = k(() => (B) => !e.enableTimePicker || e.ignoreTimeValidation ? !0 : L(B)), ue = k(() => (B) => e.monthPicker ? Array.isArray(B) && (t.value.enabled || r.value.enabled) ? !B.filter((Z) => !N(Z)).length : N(B) : !0);
  return {
    isDisabled: y,
    validateDate: s,
    validateMonthYearInRange: d,
    isDateRangeAllowed: v,
    checkMinMaxRange: b,
    isValidTime: L,
    isTimeValid: K,
    isMonthValid: ue
  };
}, sl = () => {
  const e = k(() => (a, r) => a == null ? void 0 : a.includes(r)), n = k(() => (a, r) => a.count ? a.solo ? !0 : r === 0 : !0), t = k(() => (a, r) => a.count ? a.solo ? !0 : r === a.count - 1 : !0);
  return { hideNavigationButtons: e, showLeftIcon: n, showRightIcon: t };
}, eh = (e, n, t) => {
  const a = ee(0), r = qn({
    [fa.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [fa.calendar]: !1,
    [fa.header]: !1
  }), l = k(() => e.monthPicker || e.timePicker), o = (f) => {
    var d;
    if ((d = e.flow) != null && d.length) {
      if (!f && l.value) return c();
      r[f] = !0, Object.keys(r).filter((m) => !r[m]).length || c();
    }
  }, i = () => {
    var f, d;
    (f = e.flow) != null && f.length && a.value !== -1 && (a.value += 1, n("flow-step", a.value), c()), ((d = e.flow) == null ? void 0 : d.length) === a.value && it().then(() => s());
  }, s = () => {
    a.value = -1;
  }, u = (f, d, ...m) => {
    var y, v;
    e.flow[a.value] === f && t.value && ((v = (y = t.value)[d]) == null || v.call(y, ...m));
  }, c = (f = 0) => {
    f && (a.value += f), u(Rt.month, "toggleMonthPicker", !0), u(Rt.year, "toggleYearPicker", !0), u(Rt.calendar, "toggleTimePicker", !1, !0), u(Rt.time, "toggleTimePicker", !0, !0);
    const d = e.flow[a.value];
    (d === Rt.hours || d === Rt.minutes || d === Rt.seconds) && u(d, "toggleTimePicker", !0, !0, d);
  };
  return { childMount: o, updateFlowStep: i, resetFlow: s, handleFlow: c, flowStep: a };
}, th = {
  key: 1,
  class: "dp__input_wrap"
}, nh = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], ah = {
  key: 2,
  class: "dp--clear-btn"
}, rh = ["aria-label"], lh = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...rl
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur",
    "text-input"
  ],
  setup(e, { expose: n, emit: t }) {
    const a = t, r = e, {
      defaultedTextInput: l,
      defaultedAriaLabels: o,
      defaultedInline: i,
      defaultedConfig: s,
      defaultedRange: u,
      defaultedMultiDates: c,
      defaultedUI: f,
      getDefaultPattern: d,
      getDefaultStartTime: m
    } = lt(r), { checkMinMaxRange: y } = ea(r), v = ee(), S = ee(null), g = ee(!1), b = ee(!1), h = k(
      () => ({
        dp__pointer: !r.disabled && !r.readonly && !l.value.enabled,
        dp__disabled: r.disabled,
        dp__input_readonly: !l.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !r.hideInputIcon,
        dp__input_valid: typeof r.state == "boolean" ? r.state : !1,
        dp__input_invalid: typeof r.state == "boolean" ? !r.state : !1,
        dp__input_focus: g.value || r.isMenuOpen,
        dp__input_reg: !l.value.enabled,
        ...f.value.input ?? {}
      })
    ), x = () => {
      a("set-input-date", null), r.clearable && r.autoApply && (a("set-empty-date"), v.value = null);
    }, F = (H) => {
      const le = m();
      return bg(
        H,
        l.value.format ?? d(),
        le ?? wd({}, r.enableSeconds),
        r.inputValue,
        b.value,
        r.formatLocale
      );
    }, C = (H) => {
      const { rangeSeparator: le } = l.value, [j, q] = H.split(`${le}`);
      if (j) {
        const P = F(j.trim()), Q = q ? F(q.trim()) : null;
        if (Ta(P, Q)) return;
        const ce = P && Q ? [P, Q] : [P];
        y(Q, ce, 0) && (v.value = P ? ce : null);
      }
    }, A = () => {
      b.value = !0;
    }, O = (H) => {
      if (u.value.enabled)
        C(H);
      else if (c.value.enabled) {
        const le = H.split(";");
        v.value = le.map((j) => F(j.trim())).filter((j) => j);
      } else
        v.value = F(H);
    }, $ = (H) => {
      var le;
      const j = typeof H == "string" ? H : (le = H.target) == null ? void 0 : le.value;
      j !== "" ? (l.value.openMenu && !r.isMenuOpen && a("open"), O(j), a("set-input-date", v.value)) : x(), b.value = !1, a("update:input-value", j), a("text-input", H, v.value);
    }, L = (H) => {
      l.value.enabled ? (O(H.target.value), l.value.enterSubmit && mo(v.value) && r.inputValue !== "" ? (a("set-input-date", v.value, !0), v.value = null) : l.value.enterSubmit && r.inputValue === "" && (v.value = null, a("clear"))) : ue(H);
    }, N = (H, le) => {
      l.value.enabled && l.value.tabSubmit && !le && O(H.target.value), l.value.tabSubmit && mo(v.value) && r.inputValue !== "" ? (a("set-input-date", v.value, !0, !0), v.value = null) : l.value.tabSubmit && r.inputValue === "" && (v.value = null, a("clear", !0));
    }, K = () => {
      g.value = !0, a("focus"), it().then(() => {
        var H;
        l.value.enabled && l.value.selectOnFocus && ((H = S.value) == null || H.select());
      });
    }, ue = (H) => {
      if (Gn(H, s.value, !0), l.value.enabled && l.value.openMenu && !i.value.input) {
        if (l.value.openMenu === "open" && !r.isMenuOpen) return a("open");
        if (l.value.openMenu === "toggle") return a("toggle");
      } else l.value.enabled || a("toggle");
    }, B = () => {
      a("real-blur"), g.value = !1, (!r.isMenuOpen || i.value.enabled && i.value.input) && a("blur"), r.autoApply && l.value.enabled && v.value && !r.isMenuOpen && (a("set-input-date", v.value), a("select-date"), v.value = null);
    }, Z = (H) => {
      Gn(H, s.value, !0), a("clear");
    }, R = (H) => {
      if (H.key === "Tab" && N(H), H.key === "Enter" && L(H), !l.value.enabled) {
        if (H.code === "Tab") return;
        H.preventDefault();
      }
    }, M = () => {
      var H;
      (H = S.value) == null || H.focus({ preventScroll: !0 });
    }, z = (H) => {
      v.value = H;
    }, J = (H) => {
      H.key === at.tab && N(H, !0);
    };
    return n({
      focusInput: M,
      setParsedDate: z
    }), (H, le) => {
      var j, q, P;
      return p(), w("div", { onClick: ue }, [
        H.$slots.trigger && !H.$slots["dp-input"] && !D(i).enabled ? ge(H.$slots, "trigger", { key: 0 }) : X("", !0),
        !H.$slots.trigger && (!D(i).enabled || D(i).input) ? (p(), w("div", th, [
          H.$slots["dp-input"] && !H.$slots.trigger && (!D(i).enabled || D(i).enabled && D(i).input) ? ge(H.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            isMenuOpen: e.isMenuOpen,
            onInput: $,
            onEnter: L,
            onTab: N,
            onClear: Z,
            onBlur: B,
            onKeypress: R,
            onPaste: A,
            onFocus: K,
            openMenu: () => H.$emit("open"),
            closeMenu: () => H.$emit("close"),
            toggleMenu: () => H.$emit("toggle")
          }) : X("", !0),
          H.$slots["dp-input"] ? X("", !0) : (p(), w("input", {
            key: 1,
            id: H.uid ? `dp-input-${H.uid}` : void 0,
            ref_key: "inputRef",
            ref: S,
            "data-test-id": "dp-input",
            name: H.name,
            class: me(h.value),
            inputmode: D(l).enabled ? "text" : "none",
            placeholder: H.placeholder,
            disabled: H.disabled,
            readonly: H.readonly,
            required: H.required,
            value: e.inputValue,
            autocomplete: H.autocomplete,
            "aria-label": (j = D(o)) == null ? void 0 : j.input,
            "aria-disabled": H.disabled || void 0,
            "aria-invalid": H.state === !1 ? !0 : void 0,
            onInput: $,
            onBlur: B,
            onFocus: K,
            onKeypress: R,
            onKeydown: le[0] || (le[0] = (Q) => R(Q)),
            onPaste: A
          }, null, 42, nh)),
          _("div", {
            onClick: le[3] || (le[3] = (Q) => a("toggle"))
          }, [
            H.$slots["input-icon"] && !H.hideInputIcon ? (p(), w("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: le[1] || (le[1] = (Q) => a("toggle"))
            }, [
              ge(H.$slots, "input-icon")
            ])) : X("", !0),
            !H.$slots["input-icon"] && !H.hideInputIcon && !H.$slots["dp-input"] ? (p(), Pe(D(La), {
              key: 1,
              "aria-label": (q = D(o)) == null ? void 0 : q.calendarIcon,
              class: "dp__input_icon dp__input_icons",
              onClick: le[2] || (le[2] = (Q) => a("toggle"))
            }, null, 8, ["aria-label"])) : X("", !0)
          ]),
          H.$slots["clear-icon"] && e.inputValue && H.clearable && !H.disabled && !H.readonly ? (p(), w("span", ah, [
            ge(H.$slots, "clear-icon", { clear: Z })
          ])) : X("", !0),
          H.clearable && !H.$slots["clear-icon"] && e.inputValue && !H.disabled && !H.readonly ? (p(), w("button", {
            key: 3,
            "aria-label": (P = D(o)) == null ? void 0 : P.clearInput,
            class: "dp--clear-btn",
            type: "button",
            onKeydown: le[4] || (le[4] = (Q) => D(Bt)(Q, () => Z(Q), !0, J)),
            onClick: le[5] || (le[5] = ot((Q) => Z(Q), ["prevent"]))
          }, [
            Ae(D(cd), {
              class: "dp__input_icons",
              "data-test-id": "clear-icon"
            })
          ], 40, rh)) : X("", !0)
        ])) : X("", !0)
      ]);
    };
  }
}), oh = typeof window < "u" ? window : void 0, Vl = () => {
}, sh = (e) => uu() ? (du(e), !0) : !1, ih = (e, n, t, a) => {
  if (!e) return Vl;
  let r = Vl;
  const l = Be(
    () => D(e),
    (i) => {
      r(), i && (i.addEventListener(n, t, a), r = () => {
        i.removeEventListener(n, t, a), r = Vl;
      });
    },
    { immediate: !0, flush: "post" }
  ), o = () => {
    l(), r();
  };
  return sh(o), o;
}, uh = (e, n, t, a = {}) => {
  const { window: r = oh, event: l = "pointerdown" } = a;
  return r ? ih(r, l, (o) => {
    const i = yt(e), s = yt(n);
    !i || !s || i === o.target || o.composedPath().includes(i) || o.composedPath().includes(s) || t(o);
  }, { passive: !0 }) : void 0;
}, dh = ["data-dp-mobile"], ch = /* @__PURE__ */ Ce({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...rl
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "text-input"
  ],
  setup(e, { expose: n, emit: t }) {
    const a = t, r = e, l = Qn(), o = ee(!1), i = Ea(r, "modelValue"), s = Ea(r, "timezone"), u = ee(null), c = ee(null), f = ee(null), d = ee(!1), m = ee(null), y = ee(!1), v = ee(!1), S = ee(!1), g = ee(!1), { setMenuFocused: b, setShiftKey: h } = Cd(), { clearArrowNav: x } = Jn(), { validateDate: F, isValidTime: C } = ea(r), {
      defaultedTransitions: A,
      defaultedTextInput: O,
      defaultedInline: $,
      defaultedConfig: L,
      defaultedRange: N,
      defaultedMultiDates: K
    } = lt(r), { menuTransition: ue, showTransition: B } = br(A), { isMobile: Z } = Td(L);
    He(() => {
      ce(r.modelValue), it().then(() => {
        if (!$.value.enabled) {
          const de = j(m.value);
          de == null || de.addEventListener("scroll", te), window == null || window.addEventListener("resize", ke);
        }
      }), $.value.enabled && (o.value = !0), window == null || window.addEventListener("keyup", E), window == null || window.addEventListener("keydown", V);
    }), wt(() => {
      if (!$.value.enabled) {
        const de = j(m.value);
        de == null || de.removeEventListener("scroll", te), window == null || window.removeEventListener("resize", ke);
      }
      window == null || window.removeEventListener("keyup", E), window == null || window.removeEventListener("keydown", V);
    });
    const R = Wt(l, "all", r.presetDates), M = Wt(l, "input");
    Be(
      [i, s],
      () => {
        ce(i.value);
      },
      { deep: !0 }
    );
    const { openOnTop: z, menuStyle: J, xCorrect: H, setMenuPosition: le, getScrollableParent: j, shadowRender: q } = K5({
      menuRef: u,
      menuRefInner: c,
      inputRef: f,
      pickerWrapperRef: m,
      inline: $,
      emit: a,
      props: r,
      slots: l
    }), {
      inputValue: P,
      internalModelValue: Q,
      parseExternalModelValue: ce,
      emitModelValue: U,
      formatInputValue: ye,
      checkBeforeEmit: Ee
    } = jg(a, r, d), qe = k(
      () => ({
        dp__main: !0,
        dp__theme_dark: r.dark,
        dp__theme_light: !r.dark,
        dp__flex_display: $.value.enabled,
        "dp--flex-display-collapsed": S.value,
        dp__flex_display_with_input: $.value.input
      })
    ), ie = k(() => r.dark ? "dp__theme_dark" : "dp__theme_light"), pe = k(() => r.teleport ? {
      to: typeof r.teleport == "boolean" ? "body" : r.teleport,
      disabled: !r.teleport || $.value.enabled
    } : {}), fe = k(() => ({ class: "dp__outer_menu_wrap" })), ae = k(() => $.value.enabled && (r.timePicker || r.monthPicker || r.yearPicker || r.quarterPicker)), T = () => {
      var de, be;
      return ((be = (de = f.value) == null ? void 0 : de.$el) == null ? void 0 : be.getBoundingClientRect()) ?? { width: 0, left: 0, right: 0 };
    }, te = () => {
      o.value && (L.value.closeOnScroll ? Ve() : le());
    }, ke = () => {
      var de;
      o.value && le();
      const be = ((de = c.value) == null ? void 0 : de.$el.getBoundingClientRect().width) ?? 0;
      S.value = document.body.offsetWidth <= be;
    }, E = (de) => {
      de.key === "Tab" && !$.value.enabled && !r.teleport && L.value.tabOutClosesMenu && (m.value.contains(document.activeElement) || Ve()), v.value = de.shiftKey;
    }, V = (de) => {
      v.value = de.shiftKey;
    }, oe = () => {
      !r.disabled && !r.readonly && (q(Mi, r), le(!1), o.value = !0, o.value && a("open"), o.value || Ne(), ce(r.modelValue));
    }, Y = () => {
      var de;
      P.value = "", Ne(), (de = f.value) == null || de.setParsedDate(null), a("update:model-value", null), a("update:model-timezone-value", null), a("cleared"), L.value.closeOnClearValue && Ve();
    }, I = () => {
      const de = Q.value;
      return !de || !Array.isArray(de) && F(de) ? !0 : Array.isArray(de) ? K.value.enabled || de.length === 2 && F(de[0]) && F(de[1]) ? !0 : N.value.partialRange && !r.timePicker ? F(de[0]) : !1 : !1;
    }, G = () => {
      Ee() && I() ? (U(), Ve()) : a("invalid-select", Q.value);
    }, se = (de) => {
      W(), U(), L.value.closeOnAutoApply && !de && Ve();
    }, W = () => {
      f.value && O.value.enabled && f.value.setParsedDate(Q.value);
    }, ne = (de = !1) => {
      r.autoApply && C(Q.value) && I() && (N.value.enabled && Array.isArray(Q.value) ? (N.value.partialRange || Q.value.length === 2) && se(de) : se(de));
    }, Ne = () => {
      O.value.enabled || (Q.value = null);
    }, Ve = (de = !1) => {
      de && Q.value && L.value.setDateOnMenuClose && G(), $.value.enabled || (o.value && (o.value = !1, H.value = !1, b(!1), h(!1), x(), a("closed"), P.value && ce(i.value)), Ne(), a("blur"));
    }, Jt = (de, be, $e = !1) => {
      if (!de) {
        Q.value = null;
        return;
      }
      const wn = Array.isArray(de) ? !de.some((ya) => !F(ya)) : F(de), nn = C(de);
      wn && nn ? (g.value = !0, Q.value = de, be && (y.value = $e, G(), a("text-submit")), it().then(() => {
        g.value = !1;
      })) : a("invalid-date", de);
    }, Vn = () => {
      r.autoApply && C(Q.value) && U(), W();
    }, en = () => o.value ? Ve() : oe(), tn = (de) => {
      Q.value = de;
    }, Va = () => {
      O.value.enabled && (d.value = !0, ye()), a("focus");
    }, ha = () => {
      if (O.value.enabled && (d.value = !1, ce(r.modelValue), y.value)) {
        const de = yg(m.value, v.value);
        de == null || de.focus();
      }
      a("blur");
    }, vl = (de) => {
      c.value && c.value.updateMonthYear(0, {
        month: yi(de.month),
        year: yi(de.year)
      });
    }, gl = (de) => {
      ce(de ?? r.modelValue);
    }, re = (de, be) => {
      var $e;
      ($e = c.value) == null || $e.switchView(de, be);
    }, we = (de) => L.value.onClickOutside ? L.value.onClickOutside(de) : Ve(!0), Te = (de = 0) => {
      var be;
      (be = c.value) == null || be.handleFlow(de);
    };
    return uh(u, f, () => we(I)), n({
      closeMenu: Ve,
      selectDate: G,
      clearValue: Y,
      openMenu: oe,
      onScroll: te,
      formatInputValue: ye,
      // exposed for testing purposes
      updateInternalModelValue: tn,
      // modify internal modelValue
      setMonthYear: vl,
      parseModel: gl,
      switchView: re,
      toggleMenu: en,
      handleFlow: Te,
      dpWrapMenuRef: u
    }), (de, be) => (p(), w("div", {
      ref_key: "pickerWrapperRef",
      ref: m,
      class: me(qe.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": D(Z)
    }, [
      Ae(lh, xt({
        ref_key: "inputRef",
        ref: f,
        "input-value": D(P),
        "onUpdate:inputValue": be[0] || (be[0] = ($e) => zr(P) ? P.value = $e : null),
        "is-menu-open": o.value
      }, de.$props, {
        onClear: Y,
        onOpen: oe,
        onSetInputDate: Jt,
        onSetEmptyDate: D(U),
        onSelectDate: G,
        onToggle: en,
        onClose: Ve,
        onFocus: Va,
        onBlur: ha,
        onRealBlur: be[1] || (be[1] = ($e) => d.value = !1),
        onTextInput: be[2] || (be[2] = ($e) => de.$emit("text-input", $e))
      }), It({ _: 2 }, [
        Ie(D(M), ($e, wn) => ({
          name: $e,
          fn: xe((nn) => [
            ge(de.$slots, $e, kt(Yt(nn)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (p(), Pe(Ln(de.teleport ? Jr : "div"), kt(Yt(pe.value)), {
        default: xe(() => [
          Ae(Pn, {
            name: D(ue)(D(z)),
            css: D(B) && !D($).enabled
          }, {
            default: xe(() => [
              o.value ? (p(), w("div", xt({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: u
              }, fe.value, {
                class: { "dp--menu-wrapper": !D($).enabled },
                style: D($).enabled ? void 0 : D(J)
              }), [
                Ae(Mi, xt({
                  ref_key: "dpMenuRef",
                  ref: c
                }, de.$props, {
                  "internal-model-value": D(Q),
                  "onUpdate:internalModelValue": be[3] || (be[3] = ($e) => zr(Q) ? Q.value = $e : null),
                  class: { [ie.value]: !0, "dp--menu-wrapper": de.teleport },
                  "open-on-top": D(z),
                  "no-overlay-focus": ae.value,
                  collapse: S.value,
                  "get-input-rect": T,
                  "is-text-input-date": g.value,
                  onClosePicker: Ve,
                  onSelectDate: G,
                  onAutoApply: ne,
                  onTimeUpdate: Vn,
                  onFlowStep: be[4] || (be[4] = ($e) => de.$emit("flow-step", $e)),
                  onUpdateMonthYear: be[5] || (be[5] = ($e) => de.$emit("update-month-year", $e)),
                  onInvalidSelect: be[6] || (be[6] = ($e) => de.$emit("invalid-select", D(Q))),
                  onAutoApplyInvalid: be[7] || (be[7] = ($e) => de.$emit("invalid-select", $e)),
                  onInvalidFixedRange: be[8] || (be[8] = ($e) => de.$emit("invalid-fixed-range", $e)),
                  onRecalculatePosition: D(le),
                  onTooltipOpen: be[9] || (be[9] = ($e) => de.$emit("tooltip-open", $e)),
                  onTooltipClose: be[10] || (be[10] = ($e) => de.$emit("tooltip-close", $e)),
                  onTimePickerOpen: be[11] || (be[11] = ($e) => de.$emit("time-picker-open", $e)),
                  onTimePickerClose: be[12] || (be[12] = ($e) => de.$emit("time-picker-close", $e)),
                  onAmPmChange: be[13] || (be[13] = ($e) => de.$emit("am-pm-change", $e)),
                  onRangeStart: be[14] || (be[14] = ($e) => de.$emit("range-start", $e)),
                  onRangeEnd: be[15] || (be[15] = ($e) => de.$emit("range-end", $e)),
                  onDateUpdate: be[16] || (be[16] = ($e) => de.$emit("date-update", $e)),
                  onInvalidDate: be[17] || (be[17] = ($e) => de.$emit("invalid-date", $e)),
                  onOverlayToggle: be[18] || (be[18] = ($e) => de.$emit("overlay-toggle", $e)),
                  onMenuBlur: be[19] || (be[19] = ($e) => de.$emit("blur"))
                }), It({ _: 2 }, [
                  Ie(D(R), ($e, wn) => ({
                    name: $e,
                    fn: xe((nn) => [
                      ge(de.$slots, $e, kt(Yt({ ...nn })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : X("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 10, dh));
  }
}), es = /* @__PURE__ */ (() => {
  const e = ch;
  return e.install = (n) => {
    n.component("Vue3DatePicker", e);
  }, e;
})(), fh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: es
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(fh).forEach(([e, n]) => {
  e !== "default" && (es[e] = n);
});
const mh = { class: "f-datepicker-wrapper" }, ph = ["for"], vh = {
  key: 0,
  class: "text-red-500 ml-1"
}, gh = {
  key: 0,
  class: "absolute inset-y-0 right-10 flex items-center pr-3 pointer-events-none"
}, hh = {
  key: 1,
  class: "mt-2 text-sm text-red-500"
}, yh = {
  key: 2,
  class: "mt-2 text-sm text-text-secondary"
}, wh = /* @__PURE__ */ Ce({
  __name: "FDatePicker",
  props: {
    modelValue: { default: null },
    label: {},
    placeholder: { default: "" },
    hint: {},
    error: { type: Boolean, default: !1 },
    errorMessage: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    range: { type: Boolean, default: !1 },
    enableTimePicker: { type: Boolean, default: !1 },
    timeOnly: { type: Boolean, default: !1 },
    format: {},
    size: { default: "md" },
    locale: { default: "" },
    returnType: { default: "auto" },
    placeholderFormat: { type: [String, Function], default: void 0 },
    product: {}
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: n }) {
    const t = e, a = n, { currentProductColor: r } = gn(), l = k(() => {
      if (t.product) {
        const R = Vt[t.product];
        return (R == null ? void 0 : R.primaryColor) || r.value;
      }
      return r.value;
    }), o = k(() => ({
      "--brand": l.value,
      "--brand-primary": l.value,
      "--f-datepicker-primary": l.value,
      "--dp-primary-color": l.value,
      "--dp-marker-color": l.value,
      "--dp-border-color-hover": l.value
    })), i = k(() => `f-datepicker-${Math.random().toString(36).substr(2, 9)}`), s = k(() => t.timeOnly), u = ee(!1);
    let c = null;
    if (typeof window < "u") {
      const R = () => {
        u.value = document.documentElement.classList.contains("dark");
      };
      R(), c = new MutationObserver(R), c.observe(document.documentElement, {
        attributes: !0,
        attributeFilter: ["class"]
      });
    }
    const f = k(() => {
      const R = [
        "block w-full rounded-2xl transition-colors !bg-bg-primary !border !border-[#E6E6E6] dark:!border-[#404040] shadow-none",
        "focus:outline-none focus:ring-0 focus:ring-offset-0"
      ];
      switch (t.error && R.push("border-red-500 focus:border-red-500"), t.disabled && R.push("disabled:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-60"), t.size) {
        case "sm":
          R.push("pl-10 pr-3 py-2 text-sm");
          break;
        case "lg":
          R.push("pl-12 pr-4 py-3 text-lg");
          break;
        default:
          R.push("pl-10 pr-4 py-2.5 text-base");
      }
      return R.join(" ");
    }), d = k(() => [
      "rounded-lg shadow-lg border",
      u.value ? "bg-gray-800 border-gray-700" : "bg-white border-gray-200"
    ].join(" ")), m = k(() => [
      "font-baloo",
      u.value ? "text-white" : "text-text-primary"
    ].join(" ")), y = k(() => t.locale && t.locale.trim().length > 0 ? t.locale : typeof navigator < "u" && navigator.language ? navigator.language : "tr-TR"), v = k(() => s.value || t.enableTimePicker), S = k(() => s.value ? !0 : void 0), g = (R) => {
      if (Array.isArray(R)) {
        const z = R.find(
          (J) => J != null
        );
        return z instanceof Date ? "date" : typeof z == "string" ? "string" : "date";
      }
      return R instanceof Date ? "date" : typeof R == "string" ? "string" : "date";
    }, b = ee("date");
    Be(
      () => t.modelValue,
      (R) => {
        t.returnType === "auto" && R !== null && R !== void 0 && (b.value = g(R));
      },
      { immediate: !0 }
    );
    const h = (R) => {
      if (!R) return null;
      if (R instanceof Date)
        return isNaN(R.getTime()) ? null : R;
      if (typeof R == "string" && R.trim().length > 0) {
        if (s.value) {
          const [z, J] = R.split(":").map((H) => Number(H));
          if (Number.isInteger(z) && Number.isInteger(J) && z >= 0 && z <= 23 && J >= 0 && J <= 59) {
            const H = /* @__PURE__ */ new Date();
            return H.setHours(z, J, 0, 0), H;
          }
        }
        const M = new Date(R);
        return isNaN(M.getTime()) ? null : M;
      }
      return null;
    }, x = (R) => {
      if (R == null || R === "")
        return t.range ? [null, null] : null;
      if (Array.isArray(R)) {
        const M = R.map((z) => h(z));
        if (t.range) {
          const [z, J] = M;
          return [z ?? null, J ?? null];
        }
        return M.filter((z) => !!z);
      }
      return h(R);
    }, F = k(() => t.returnType === "date" || t.returnType === "string" ? t.returnType : b.value), C = (R) => {
      const M = R.getFullYear(), z = `${R.getMonth() + 1}`.padStart(2, "0"), J = `${R.getDate()}`.padStart(2, "0");
      return `${M}-${z}-${J}`;
    }, A = (R) => {
      const M = R.getFullYear(), z = `${R.getMonth() + 1}`.padStart(2, "0"), J = `${R.getDate()}`.padStart(2, "0"), H = `${R.getHours()}`.padStart(2, "0"), le = `${R.getMinutes()}`.padStart(2, "0"), j = -R.getTimezoneOffset(), q = j >= 0 ? "+" : "-", P = `${Math.floor(Math.abs(j) / 60)}`.padStart(2, "0"), Q = `${Math.abs(j) % 60}`.padStart(2, "0");
      return `${M}-${z}-${J}T${H}:${le}${q}${P}:${Q}`;
    }, O = (R) => {
      const M = `${R.getHours()}`.padStart(2, "0"), z = `${R.getMinutes()}`.padStart(2, "0");
      return `${M}:${z}`;
    }, $ = (R) => {
      if (R == null)
        return null;
      if (F.value === "date")
        return Array.isArray(R), R;
      const z = (J) => J ? s.value ? O(J) : t.enableTimePicker ? A(J) : C(J) : "";
      return Array.isArray(R) ? R.map((J) => z(J)) : z(R);
    }, L = (R) => {
      const z = $(R === void 0 ? null : R);
      a("update:modelValue", z), a("change", z);
    }, N = k({
      get: () => x(t.modelValue),
      set: (R) => {
        L(R);
      }
    }), K = () => {
      const R = s.value ? { timeStyle: "short" } : t.enableTimePicker ? { dateStyle: "medium", timeStyle: "short" } : { dateStyle: "medium" }, M = new Intl.DateTimeFormat(y.value, R);
      return (z) => Array.isArray(z) ? z.filter((J) => J instanceof Date).map((J) => M.format(J)).join(" – ") : z instanceof Date ? M.format(z) : "";
    }, ue = k(() => typeof t.format == "function" || typeof t.format == "string" ? t.format : K()), B = k(() => {
      if (t.placeholderFormat) {
        if (typeof t.placeholderFormat == "function" || typeof t.placeholderFormat == "string")
          return t.placeholderFormat;
        if (t.placeholderFormat === "date") {
          const R = new Intl.DateTimeFormat(y.value, { dateStyle: "medium" });
          return (M) => Array.isArray(M) ? M.filter((z) => z instanceof Date).map((z) => R.format(z)).join(" – ") : M instanceof Date ? R.format(M) : "";
        }
        if (t.placeholderFormat === "datetime") {
          const R = new Intl.DateTimeFormat(y.value, {
            dateStyle: "medium",
            timeStyle: "short"
          });
          return (M) => Array.isArray(M) ? M.filter((z) => z instanceof Date).map((z) => R.format(z)).join(" – ") : M instanceof Date ? R.format(M) : "";
        }
        if (t.placeholderFormat === "time") {
          const R = new Intl.DateTimeFormat(y.value, { timeStyle: "short" });
          return (M) => Array.isArray(M) ? M.filter((z) => z instanceof Date).map((z) => R.format(z)).join(' ?" ') : M instanceof Date ? R.format(M) : "";
        }
      }
      return ue.value;
    }), Z = k(() => {
      if (t.placeholder && t.placeholder.trim().length > 0)
        return t.placeholder;
      const R = B.value;
      if (typeof R == "string")
        return R;
      if (typeof R == "function") {
        const M = new Date(Date.UTC(2024, 0, 1, 12, 30));
        if (t.range) {
          const z = new Date(M.getTime() + 12096e5);
          return R([M, z]);
        }
        return R(M);
      }
      return "";
    });
    return Ao(() => {
      c && (c.disconnect(), c = null);
    }), (R, M) => (p(), w("div", mh, [
      e.label ? (p(), w("label", {
        key: 0,
        for: i.value,
        class: "block text-sm font-medium text-text-primary mb-2"
      }, [
        Qe(he(e.label) + " ", 1),
        e.required ? (p(), w("span", vh, "*")) : X("", !0)
      ], 8, ph)) : X("", !0),
      _("div", {
        class: "relative f-datepicker__container",
        style: tt(o.value)
      }, [
        Ae(D(es), {
          id: i.value,
          modelValue: N.value,
          "onUpdate:modelValue": M[0] || (M[0] = (z) => N.value = z),
          locale: y.value,
          placeholder: Z.value,
          disabled: e.disabled,
          required: e.required,
          range: e.range,
          "enable-time-picker": v.value,
          "time-picker": S.value,
          "mode-height": 240,
          dark: u.value,
          format: ue.value,
          "preview-format": ue.value,
          "input-class-name": f.value,
          "menu-class-name": d.value,
          "calendar-class-name": m.value,
          teleport: !1,
          style: tt(o.value),
          "auto-apply": ""
        }, {
          "input-icon": xe(() => [...M[1] || (M[1] = [
            _("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              "stroke-width": "1.5",
              stroke: "currentColor",
              class: "w-5 h-5"
            }, [
              _("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
              })
            ], -1)
          ])]),
          _: 1
        }, 8, ["id", "modelValue", "locale", "placeholder", "disabled", "required", "range", "enable-time-picker", "time-picker", "dark", "format", "preview-format", "input-class-name", "menu-class-name", "calendar-class-name", "style"]),
        e.error ? (p(), w("div", gh, [...M[2] || (M[2] = [
          _("span", { class: "text-red-500" }, "⚠️", -1)
        ])])) : X("", !0)
      ], 4),
      e.error && e.errorMessage ? (p(), w("p", hh, he(e.errorMessage), 1)) : e.hint ? (p(), w("p", yh, he(e.hint), 1)) : X("", !0)
    ]));
  }
}), Yb = /* @__PURE__ */ el(wh, [["__scopeId", "data-v-7ceb5abc"]]), bh = { class: "flex w-full flex-col gap-1 text-sm text-slate-600 dark:text-slate-200" }, _h = {
  key: 0,
  class: "font-medium"
}, xh = ["value", "placeholder", "disabled"], kh = {
  key: 1,
  class: "text-xs text-rose-500"
}, Ch = {
  key: 2,
  class: "text-xs text-slate-500"
}, jb = /* @__PURE__ */ Ce({
  __name: "FFinanceInput",
  props: {
    modelValue: { default: null },
    currency: { default: "TRY" },
    locale: { default: "tr-TR" },
    precision: { default: 2 },
    allowNegative: { type: Boolean, default: !1 },
    min: {},
    max: {},
    placeholder: {},
    disabled: { type: Boolean },
    label: {},
    hint: {},
    error: {},
    clearZeroOnFocus: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "focus", "blur", "enter"],
  setup(e, { emit: n }) {
    const t = e, a = n, r = ee(!1), l = ee(""), o = k(() => {
      var h;
      return ((h = Intl.NumberFormat(t.locale).formatToParts(1.1).find((x) => x.type === "decimal")) == null ? void 0 : h.value) ?? ".";
    }), i = (g) => {
      if (!g) return "";
      const b = o.value || ".";
      let h = g.replace(/[^0-9.,-]/g, "");
      if (!t.allowNegative)
        h = h.replace(/-/g, "");
      else {
        const $ = h.startsWith("-") || g.trim().startsWith("-");
        h = h.replace(/-/g, ""), $ && (h = `-${h}`);
      }
      const x = h.lastIndexOf("."), F = h.lastIndexOf(","), C = Math.max(x, F);
      if (C === -1)
        return h = h.replace(/[.,]/g, ""), h;
      const A = h.slice(0, C).replace(/[.,]/g, ""), O = h.slice(C + 1).replace(/[.,]/g, "");
      return h = `${A}${b}${O}`, h;
    }, s = (g) => g === null || Number.isNaN(g) ? "" : Intl.NumberFormat(t.locale, {
      style: "currency",
      currency: t.currency,
      minimumFractionDigits: t.precision,
      maximumFractionDigits: t.precision
    }).format(g), u = (g) => g === null || Number.isNaN(g) ? "" : g.toFixed(t.precision), c = (g) => {
      if (g === null || Number.isNaN(g)) return null;
      let b = g;
      return typeof t.min == "number" && (b = Math.max(t.min, b)), typeof t.max == "number" && (b = Math.min(t.max, b)), Number(b.toFixed(t.precision));
    }, f = () => {
      const g = c(t.modelValue);
      if (g === null) {
        l.value = "";
        return;
      }
      l.value = r.value ? u(g) : s(g);
    };
    Be(
      () => [t.modelValue, t.locale, t.currency, t.precision],
      () => {
        r.value || f();
      },
      { immediate: !0 }
    );
    const d = (g) => {
      const b = o.value;
      if (!g || g === "-" || g === "." || b && g === b) {
        a("update:modelValue", null);
        return;
      }
      if (b && g.endsWith(b))
        return;
      let h = g;
      b && b !== "." && (h = h.replace(b, "."));
      const x = Number(h), F = c(x);
      a("update:modelValue", F);
    }, m = (g) => {
      const b = g.target, h = i(b.value);
      l.value = h, d(h);
    }, y = (g) => {
      if (g.ctrlKey || g.metaKey || [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Home",
        "End"
      ].includes(g.key)) return;
      if (g.key === "Enter") {
        a("enter", g);
        return;
      }
      const h = o.value, x = g.key;
      x >= "0" && x <= "9" || x === h || x === "." || x === "," || t.allowNegative && x === "-" || g.preventDefault();
    }, v = (g) => {
      if (r.value = !0, t.clearZeroOnFocus && (t.modelValue ?? 0) === 0) {
        l.value = "", a("focus", g);
        return;
      }
      const b = u(t.modelValue);
      l.value = o.value && o.value !== "." ? b.replace(".", o.value) : b, a("focus", g);
    }, S = (g) => {
      r.value = !1, f(), a("blur", g);
    };
    return (g, b) => (p(), w("label", bh, [
      e.label ? (p(), w("span", _h, he(e.label), 1)) : X("", !0),
      _("div", {
        class: me(["flex items-center rounded-2xl border border-slate-200 bg-white px-4 py-2 text-base text-slate-900 focus-within:border-primary-500 focus-within:ring-2 focus-within:ring-primary-100 dark:border-slate-700 dark:bg-slate-900 dark:text-white", {
          "border-rose-500 focus-within:ring-rose-100 dark:border-rose-400": e.error,
          "opacity-60": e.disabled
        }])
      }, [
        _("input", {
          value: l.value,
          type: "text",
          inputmode: "decimal",
          placeholder: e.placeholder,
          disabled: e.disabled,
          class: "w-full bg-transparent text-base outline-none",
          onInput: m,
          onKeydown: y,
          onFocus: v,
          onBlur: S
        }, null, 40, xh)
      ], 2),
      e.error ? (p(), w("p", kh, he(e.error), 1)) : e.hint ? (p(), w("p", Ch, he(e.hint), 1)) : X("", !0)
    ]));
  }
}), Zb = /* @__PURE__ */ Ce({
  __name: "FForm",
  props: {
    spacing: { default: "lg" },
    width: { default: "full" }
  },
  emits: ["submit", "reset"],
  setup(e) {
    const n = e, t = k(() => [
      "bg-bg-primary rounded-2xl p-6 flex flex-col",
      n.width === "full" ? {
        none: "",
        sm: "gap-y-2",
        md: "gap-y-4",
        lg: "gap-y-6"
      }[n.spacing] : {
        none: "",
        sm: "space-y-2",
        md: "space-y-4",
        lg: "space-y-6"
      }[n.spacing]
    ]);
    return (a, r) => (p(), w("form", {
      class: me(t.value),
      onSubmit: r[0] || (r[0] = ot((l) => a.$emit("submit", l), ["prevent"])),
      onReset: r[1] || (r[1] = (l) => a.$emit("reset", l))
    }, [
      ge(a.$slots, "default")
    ], 34));
  }
}), Gb = /* @__PURE__ */ Ce({
  __name: "FFormFooter",
  props: {
    padding: { default: "md" }
  },
  setup(e) {
    const n = e, t = k(() => ({
      "border-t border-gray-200 !mt-12 col-span-full": !0,
      "flex justify-center items-center gap-3": !0,
      "pt-2": n.padding === "sm",
      "pt-4": n.padding === "md",
      "pt-6": n.padding === "lg"
    }));
    return (a, r) => (p(), w("div", {
      class: me(t.value)
    }, [
      ge(a.$slots, "default")
    ], 2));
  }
}), Wb = /* @__PURE__ */ Ce({
  __name: "FFormHeader",
  props: {
    title: {},
    padding: { default: "md" }
  },
  setup(e) {
    const n = e, t = k(() => ({
      "col-span-full": !0,
      "pb-2": n.padding === "sm",
      "pb-4": n.padding === "md",
      "pb-6": n.padding === "lg"
    })), a = k(() => ({
      "text-text-primary": !0
    }));
    return (r, l) => {
      const o = fr("FTitle");
      return p(), w("div", {
        class: me(t.value)
      }, [
        ge(r.$slots, "default", {}, () => [
          e.title ? (p(), Pe(o, {
            key: 0,
            variant: "H8",
            class: me(a.value)
          }, {
            default: xe(() => [
              Qe(he(e.title), 1)
            ]),
            _: 1
          }, 8, ["class"])) : X("", !0)
        ])
      ], 2);
    };
  }
});
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Zn(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function Kt(e, n) {
  return (t) => {
    n.setState((a) => ({
      ...a,
      [e]: Zn(t, a[e])
    }));
  };
}
function il(e) {
  return e instanceof Function;
}
function Sh(e) {
  return Array.isArray(e) && e.every((n) => typeof n == "number");
}
function Dd(e, n) {
  const t = [], a = (r) => {
    r.forEach((l) => {
      t.push(l);
      const o = n(l);
      o != null && o.length && a(o);
    });
  };
  return a(e), t;
}
function De(e, n, t) {
  let a = [], r;
  return (l) => {
    let o;
    t.key && t.debug && (o = Date.now());
    const i = e(l);
    if (!(i.length !== a.length || i.some((c, f) => a[f] !== c)))
      return r;
    a = i;
    let u;
    if (t.key && t.debug && (u = Date.now()), r = n(...i), t == null || t.onChange == null || t.onChange(r), t.key && t.debug && t != null && t.debug()) {
      const c = Math.round((Date.now() - o) * 100) / 100, f = Math.round((Date.now() - u) * 100) / 100, d = f / 16, m = (y, v) => {
        for (y = String(y); y.length < v; )
          y = " " + y;
        return y;
      };
      console.info(`%c⏱ ${m(f, 5)} /${m(c, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * d, 120))}deg 100% 31%);`, t == null ? void 0 : t.key);
    }
    return r;
  };
}
function Re(e, n, t, a) {
  return {
    debug: () => {
      var r;
      return (r = e == null ? void 0 : e.debugAll) != null ? r : e[n];
    },
    key: process.env.NODE_ENV === "development" && t,
    onChange: a
  };
}
function Mh(e, n, t, a) {
  const r = () => {
    var o;
    return (o = l.getValue()) != null ? o : e.options.renderFallbackValue;
  }, l = {
    id: `${n.id}_${t.id}`,
    row: n,
    column: t,
    getValue: () => n.getValue(a),
    renderValue: r,
    getContext: De(() => [e, t, n, l], (o, i, s, u) => ({
      table: o,
      column: i,
      row: s,
      cell: u,
      getValue: u.getValue,
      renderValue: u.renderValue
    }), Re(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((o) => {
    o.createCell == null || o.createCell(l, t, n, e);
  }, {}), l;
}
function Eh(e, n, t, a) {
  var r, l;
  const i = {
    ...e._getDefaultColumnDef(),
    ...n
  }, s = i.accessorKey;
  let u = (r = (l = i.id) != null ? l : s ? typeof String.prototype.replaceAll == "function" ? s.replaceAll(".", "_") : s.replace(/\./g, "_") : void 0) != null ? r : typeof i.header == "string" ? i.header : void 0, c;
  if (i.accessorFn ? c = i.accessorFn : s && (s.includes(".") ? c = (d) => {
    let m = d;
    for (const v of s.split(".")) {
      var y;
      m = (y = m) == null ? void 0 : y[v], process.env.NODE_ENV !== "production" && m === void 0 && console.warn(`"${v}" in deeply nested key "${s}" returned undefined.`);
    }
    return m;
  } : c = (d) => d[i.accessorKey]), !u)
    throw process.env.NODE_ENV !== "production" ? new Error(i.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let f = {
    id: `${String(u)}`,
    accessorFn: c,
    parent: a,
    depth: t,
    columnDef: i,
    columns: [],
    getFlatColumns: De(() => [!0], () => {
      var d;
      return [f, ...(d = f.columns) == null ? void 0 : d.flatMap((m) => m.getFlatColumns())];
    }, Re(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: De(() => [e._getOrderColumnsFn()], (d) => {
      var m;
      if ((m = f.columns) != null && m.length) {
        let y = f.columns.flatMap((v) => v.getLeafColumns());
        return d(y);
      }
      return [f];
    }, Re(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const d of e._features)
    d.createColumn == null || d.createColumn(f, e);
  return f;
}
const Tt = "debugHeaders";
function Ei(e, n, t) {
  var a;
  let l = {
    id: (a = t.id) != null ? a : n.id,
    column: n,
    index: t.index,
    isPlaceholder: !!t.isPlaceholder,
    placeholderId: t.placeholderId,
    depth: t.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const o = [], i = (s) => {
        s.subHeaders && s.subHeaders.length && s.subHeaders.map(i), o.push(s);
      };
      return i(l), o;
    },
    getContext: () => ({
      table: e,
      header: l,
      column: n
    })
  };
  return e._features.forEach((o) => {
    o.createHeader == null || o.createHeader(l, e);
  }), l;
}
const Ph = {
  createTable: (e) => {
    e.getHeaderGroups = De(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, a, r) => {
      var l, o;
      const i = (l = a == null ? void 0 : a.map((f) => t.find((d) => d.id === f)).filter(Boolean)) != null ? l : [], s = (o = r == null ? void 0 : r.map((f) => t.find((d) => d.id === f)).filter(Boolean)) != null ? o : [], u = t.filter((f) => !(a != null && a.includes(f.id)) && !(r != null && r.includes(f.id)));
      return $r(n, [...i, ...u, ...s], e);
    }, Re(e.options, Tt, "getHeaderGroups")), e.getCenterHeaderGroups = De(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, a, r) => (t = t.filter((l) => !(a != null && a.includes(l.id)) && !(r != null && r.includes(l.id))), $r(n, t, e, "center")), Re(e.options, Tt, "getCenterHeaderGroups")), e.getLeftHeaderGroups = De(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (n, t, a) => {
      var r;
      const l = (r = a == null ? void 0 : a.map((o) => t.find((i) => i.id === o)).filter(Boolean)) != null ? r : [];
      return $r(n, l, e, "left");
    }, Re(e.options, Tt, "getLeftHeaderGroups")), e.getRightHeaderGroups = De(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (n, t, a) => {
      var r;
      const l = (r = a == null ? void 0 : a.map((o) => t.find((i) => i.id === o)).filter(Boolean)) != null ? r : [];
      return $r(n, l, e, "right");
    }, Re(e.options, Tt, "getRightHeaderGroups")), e.getFooterGroups = De(() => [e.getHeaderGroups()], (n) => [...n].reverse(), Re(e.options, Tt, "getFooterGroups")), e.getLeftFooterGroups = De(() => [e.getLeftHeaderGroups()], (n) => [...n].reverse(), Re(e.options, Tt, "getLeftFooterGroups")), e.getCenterFooterGroups = De(() => [e.getCenterHeaderGroups()], (n) => [...n].reverse(), Re(e.options, Tt, "getCenterFooterGroups")), e.getRightFooterGroups = De(() => [e.getRightHeaderGroups()], (n) => [...n].reverse(), Re(e.options, Tt, "getRightFooterGroups")), e.getFlatHeaders = De(() => [e.getHeaderGroups()], (n) => n.map((t) => t.headers).flat(), Re(e.options, Tt, "getFlatHeaders")), e.getLeftFlatHeaders = De(() => [e.getLeftHeaderGroups()], (n) => n.map((t) => t.headers).flat(), Re(e.options, Tt, "getLeftFlatHeaders")), e.getCenterFlatHeaders = De(() => [e.getCenterHeaderGroups()], (n) => n.map((t) => t.headers).flat(), Re(e.options, Tt, "getCenterFlatHeaders")), e.getRightFlatHeaders = De(() => [e.getRightHeaderGroups()], (n) => n.map((t) => t.headers).flat(), Re(e.options, Tt, "getRightFlatHeaders")), e.getCenterLeafHeaders = De(() => [e.getCenterFlatHeaders()], (n) => n.filter((t) => {
      var a;
      return !((a = t.subHeaders) != null && a.length);
    }), Re(e.options, Tt, "getCenterLeafHeaders")), e.getLeftLeafHeaders = De(() => [e.getLeftFlatHeaders()], (n) => n.filter((t) => {
      var a;
      return !((a = t.subHeaders) != null && a.length);
    }), Re(e.options, Tt, "getLeftLeafHeaders")), e.getRightLeafHeaders = De(() => [e.getRightFlatHeaders()], (n) => n.filter((t) => {
      var a;
      return !((a = t.subHeaders) != null && a.length);
    }), Re(e.options, Tt, "getRightLeafHeaders")), e.getLeafHeaders = De(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (n, t, a) => {
      var r, l, o, i, s, u;
      return [...(r = (l = n[0]) == null ? void 0 : l.headers) != null ? r : [], ...(o = (i = t[0]) == null ? void 0 : i.headers) != null ? o : [], ...(s = (u = a[0]) == null ? void 0 : u.headers) != null ? s : []].map((c) => c.getLeafHeaders()).flat();
    }, Re(e.options, Tt, "getLeafHeaders"));
  }
};
function $r(e, n, t, a) {
  var r, l;
  let o = 0;
  const i = function(d, m) {
    m === void 0 && (m = 1), o = Math.max(o, m), d.filter((y) => y.getIsVisible()).forEach((y) => {
      var v;
      (v = y.columns) != null && v.length && i(y.columns, m + 1);
    }, 0);
  };
  i(e);
  let s = [];
  const u = (d, m) => {
    const y = {
      depth: m,
      id: [a, `${m}`].filter(Boolean).join("_"),
      headers: []
    }, v = [];
    d.forEach((S) => {
      const g = [...v].reverse()[0], b = S.column.depth === y.depth;
      let h, x = !1;
      if (b && S.column.parent ? h = S.column.parent : (h = S.column, x = !0), g && (g == null ? void 0 : g.column) === h)
        g.subHeaders.push(S);
      else {
        const F = Ei(t, h, {
          id: [a, m, h.id, S == null ? void 0 : S.id].filter(Boolean).join("_"),
          isPlaceholder: x,
          placeholderId: x ? `${v.filter((C) => C.column === h).length}` : void 0,
          depth: m,
          index: v.length
        });
        F.subHeaders.push(S), v.push(F);
      }
      y.headers.push(S), S.headerGroup = y;
    }), s.push(y), m > 0 && u(v, m - 1);
  }, c = n.map((d, m) => Ei(t, d, {
    depth: o,
    index: m
  }));
  u(c, o - 1), s.reverse();
  const f = (d) => d.filter((y) => y.column.getIsVisible()).map((y) => {
    let v = 0, S = 0, g = [0];
    y.subHeaders && y.subHeaders.length ? (g = [], f(y.subHeaders).forEach((h) => {
      let {
        colSpan: x,
        rowSpan: F
      } = h;
      v += x, g.push(F);
    })) : v = 1;
    const b = Math.min(...g);
    return S = S + b, y.colSpan = v, y.rowSpan = S, {
      colSpan: v,
      rowSpan: S
    };
  });
  return f((r = (l = s[0]) == null ? void 0 : l.headers) != null ? r : []), s;
}
const ul = (e, n, t, a, r, l, o) => {
  let i = {
    id: n,
    index: a,
    original: t,
    depth: r,
    parentId: o,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (s) => {
      if (i._valuesCache.hasOwnProperty(s))
        return i._valuesCache[s];
      const u = e.getColumn(s);
      if (u != null && u.accessorFn)
        return i._valuesCache[s] = u.accessorFn(i.original, a), i._valuesCache[s];
    },
    getUniqueValues: (s) => {
      if (i._uniqueValuesCache.hasOwnProperty(s))
        return i._uniqueValuesCache[s];
      const u = e.getColumn(s);
      if (u != null && u.accessorFn)
        return u.columnDef.getUniqueValues ? (i._uniqueValuesCache[s] = u.columnDef.getUniqueValues(i.original, a), i._uniqueValuesCache[s]) : (i._uniqueValuesCache[s] = [i.getValue(s)], i._uniqueValuesCache[s]);
    },
    renderValue: (s) => {
      var u;
      return (u = i.getValue(s)) != null ? u : e.options.renderFallbackValue;
    },
    subRows: l ?? [],
    getLeafRows: () => Dd(i.subRows, (s) => s.subRows),
    getParentRow: () => i.parentId ? e.getRow(i.parentId, !0) : void 0,
    getParentRows: () => {
      let s = [], u = i;
      for (; ; ) {
        const c = u.getParentRow();
        if (!c) break;
        s.push(c), u = c;
      }
      return s.reverse();
    },
    getAllCells: De(() => [e.getAllLeafColumns()], (s) => s.map((u) => Mh(e, i, u, u.id)), Re(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: De(() => [i.getAllCells()], (s) => s.reduce((u, c) => (u[c.column.id] = c, u), {}), Re(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let s = 0; s < e._features.length; s++) {
    const u = e._features[s];
    u == null || u.createRow == null || u.createRow(i, e);
  }
  return i;
}, $h = {
  createColumn: (e, n) => {
    e._getFacetedRowModel = n.options.getFacetedRowModel && n.options.getFacetedRowModel(n, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : n.getPreFilteredRowModel(), e._getFacetedUniqueValues = n.options.getFacetedUniqueValues && n.options.getFacetedUniqueValues(n, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = n.options.getFacetedMinMaxValues && n.options.getFacetedMinMaxValues(n, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, Rd = (e, n, t) => {
  var a, r;
  const l = t == null || (a = t.toString()) == null ? void 0 : a.toLowerCase();
  return !!(!((r = e.getValue(n)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(l));
};
Rd.autoRemove = (e) => fn(e);
const Od = (e, n, t) => {
  var a;
  return !!(!((a = e.getValue(n)) == null || (a = a.toString()) == null) && a.includes(t));
};
Od.autoRemove = (e) => fn(e);
const Id = (e, n, t) => {
  var a;
  return ((a = e.getValue(n)) == null || (a = a.toString()) == null ? void 0 : a.toLowerCase()) === (t == null ? void 0 : t.toLowerCase());
};
Id.autoRemove = (e) => fn(e);
const Fd = (e, n, t) => {
  var a;
  return (a = e.getValue(n)) == null ? void 0 : a.includes(t);
};
Fd.autoRemove = (e) => fn(e);
const Ld = (e, n, t) => !t.some((a) => {
  var r;
  return !((r = e.getValue(n)) != null && r.includes(a));
});
Ld.autoRemove = (e) => fn(e) || !(e != null && e.length);
const Nd = (e, n, t) => t.some((a) => {
  var r;
  return (r = e.getValue(n)) == null ? void 0 : r.includes(a);
});
Nd.autoRemove = (e) => fn(e) || !(e != null && e.length);
const Vd = (e, n, t) => e.getValue(n) === t;
Vd.autoRemove = (e) => fn(e);
const Bd = (e, n, t) => e.getValue(n) == t;
Bd.autoRemove = (e) => fn(e);
const ts = (e, n, t) => {
  let [a, r] = t;
  const l = e.getValue(n);
  return l >= a && l <= r;
};
ts.resolveFilterValue = (e) => {
  let [n, t] = e, a = typeof n != "number" ? parseFloat(n) : n, r = typeof t != "number" ? parseFloat(t) : t, l = n === null || Number.isNaN(a) ? -1 / 0 : a, o = t === null || Number.isNaN(r) ? 1 / 0 : r;
  if (l > o) {
    const i = l;
    l = o, o = i;
  }
  return [l, o];
};
ts.autoRemove = (e) => fn(e) || fn(e[0]) && fn(e[1]);
const An = {
  includesString: Rd,
  includesStringSensitive: Od,
  equalsString: Id,
  arrIncludes: Fd,
  arrIncludesAll: Ld,
  arrIncludesSome: Nd,
  equals: Vd,
  weakEquals: Bd,
  inNumberRange: ts
};
function fn(e) {
  return e == null || e === "";
}
const Ah = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: Kt("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, n) => {
    e.getAutoFilterFn = () => {
      const t = n.getCoreRowModel().flatRows[0], a = t == null ? void 0 : t.getValue(e.id);
      return typeof a == "string" ? An.includesString : typeof a == "number" ? An.inNumberRange : typeof a == "boolean" || a !== null && typeof a == "object" ? An.equals : Array.isArray(a) ? An.arrIncludes : An.weakEquals;
    }, e.getFilterFn = () => {
      var t, a;
      return il(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (t = (a = n.options.filterFns) == null ? void 0 : a[e.columnDef.filterFn]) != null ? t : An[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var t, a, r;
      return ((t = e.columnDef.enableColumnFilter) != null ? t : !0) && ((a = n.options.enableColumnFilters) != null ? a : !0) && ((r = n.options.enableFilters) != null ? r : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var t;
      return (t = n.getState().columnFilters) == null || (t = t.find((a) => a.id === e.id)) == null ? void 0 : t.value;
    }, e.getFilterIndex = () => {
      var t, a;
      return (t = (a = n.getState().columnFilters) == null ? void 0 : a.findIndex((r) => r.id === e.id)) != null ? t : -1;
    }, e.setFilterValue = (t) => {
      n.setColumnFilters((a) => {
        const r = e.getFilterFn(), l = a == null ? void 0 : a.find((c) => c.id === e.id), o = Zn(t, l ? l.value : void 0);
        if (Pi(r, o, e)) {
          var i;
          return (i = a == null ? void 0 : a.filter((c) => c.id !== e.id)) != null ? i : [];
        }
        const s = {
          id: e.id,
          value: o
        };
        if (l) {
          var u;
          return (u = a == null ? void 0 : a.map((c) => c.id === e.id ? s : c)) != null ? u : [];
        }
        return a != null && a.length ? [...a, s] : [s];
      });
    };
  },
  createRow: (e, n) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (n) => {
      const t = e.getAllLeafColumns(), a = (r) => {
        var l;
        return (l = Zn(n, r)) == null ? void 0 : l.filter((o) => {
          const i = t.find((s) => s.id === o.id);
          if (i) {
            const s = i.getFilterFn();
            if (Pi(s, o.value, i))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(a);
    }, e.resetColumnFilters = (n) => {
      var t, a;
      e.setColumnFilters(n ? [] : (t = (a = e.initialState) == null ? void 0 : a.columnFilters) != null ? t : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function Pi(e, n, t) {
  return (e && e.autoRemove ? e.autoRemove(n, t) : !1) || typeof n > "u" || typeof n == "string" && !n;
}
const Th = (e, n, t) => t.reduce((a, r) => {
  const l = r.getValue(e);
  return a + (typeof l == "number" ? l : 0);
}, 0), Dh = (e, n, t) => {
  let a;
  return t.forEach((r) => {
    const l = r.getValue(e);
    l != null && (a > l || a === void 0 && l >= l) && (a = l);
  }), a;
}, Rh = (e, n, t) => {
  let a;
  return t.forEach((r) => {
    const l = r.getValue(e);
    l != null && (a < l || a === void 0 && l >= l) && (a = l);
  }), a;
}, Oh = (e, n, t) => {
  let a, r;
  return t.forEach((l) => {
    const o = l.getValue(e);
    o != null && (a === void 0 ? o >= o && (a = r = o) : (a > o && (a = o), r < o && (r = o)));
  }), [a, r];
}, Ih = (e, n) => {
  let t = 0, a = 0;
  if (n.forEach((r) => {
    let l = r.getValue(e);
    l != null && (l = +l) >= l && (++t, a += l);
  }), t) return a / t;
}, Fh = (e, n) => {
  if (!n.length)
    return;
  const t = n.map((l) => l.getValue(e));
  if (!Sh(t))
    return;
  if (t.length === 1)
    return t[0];
  const a = Math.floor(t.length / 2), r = t.sort((l, o) => l - o);
  return t.length % 2 !== 0 ? r[a] : (r[a - 1] + r[a]) / 2;
}, Lh = (e, n) => Array.from(new Set(n.map((t) => t.getValue(e))).values()), Nh = (e, n) => new Set(n.map((t) => t.getValue(e))).size, Vh = (e, n) => n.length, Bl = {
  sum: Th,
  min: Dh,
  max: Rh,
  extent: Oh,
  mean: Ih,
  median: Fh,
  unique: Lh,
  uniqueCount: Nh,
  count: Vh
}, Bh = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var n, t;
      return (n = (t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) != null ? n : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: Kt("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, n) => {
    e.toggleGrouping = () => {
      n.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((a) => a !== e.id) : [...t ?? [], e.id]);
    }, e.getCanGroup = () => {
      var t, a;
      return ((t = e.columnDef.enableGrouping) != null ? t : !0) && ((a = n.options.enableGrouping) != null ? a : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.includes(e.id);
    }, e.getGroupedIndex = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const t = e.getCanGroup();
      return () => {
        t && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const t = n.getCoreRowModel().flatRows[0], a = t == null ? void 0 : t.getValue(e.id);
      if (typeof a == "number")
        return Bl.sum;
      if (Object.prototype.toString.call(a) === "[object Date]")
        return Bl.extent;
    }, e.getAggregationFn = () => {
      var t, a;
      if (!e)
        throw new Error();
      return il(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (t = (a = n.options.aggregationFns) == null ? void 0 : a[e.columnDef.aggregationFn]) != null ? t : Bl[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (n) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(n), e.resetGrouping = (n) => {
      var t, a;
      e.setGrouping(n ? [] : (t = (a = e.initialState) == null ? void 0 : a.grouping) != null ? t : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, n) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (t) => {
      if (e._groupingValuesCache.hasOwnProperty(t))
        return e._groupingValuesCache[t];
      const a = n.getColumn(t);
      return a != null && a.columnDef.getGroupingValue ? (e._groupingValuesCache[t] = a.columnDef.getGroupingValue(e.original), e._groupingValuesCache[t]) : e.getValue(t);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, n, t, a) => {
    e.getIsGrouped = () => n.getIsGrouped() && n.id === t.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && n.getIsGrouped(), e.getIsAggregated = () => {
      var r;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((r = t.subRows) != null && r.length);
    };
  }
};
function Hh(e, n, t) {
  if (!(n != null && n.length) || !t)
    return e;
  const a = e.filter((l) => !n.includes(l.id));
  return t === "remove" ? a : [...n.map((l) => e.find((o) => o.id === l)).filter(Boolean), ...a];
}
const zh = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: Kt("columnOrder", e)
  }),
  createColumn: (e, n) => {
    e.getIndex = De((t) => [nr(n, t)], (t) => t.findIndex((a) => a.id === e.id), Re(n.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (t) => {
      var a;
      return ((a = nr(n, t)[0]) == null ? void 0 : a.id) === e.id;
    }, e.getIsLastColumn = (t) => {
      var a;
      const r = nr(n, t);
      return ((a = r[r.length - 1]) == null ? void 0 : a.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (n) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(n), e.resetColumnOrder = (n) => {
      var t;
      e.setColumnOrder(n ? [] : (t = e.initialState.columnOrder) != null ? t : []);
    }, e._getOrderColumnsFn = De(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (n, t, a) => (r) => {
      let l = [];
      if (!(n != null && n.length))
        l = r;
      else {
        const o = [...n], i = [...r];
        for (; i.length && o.length; ) {
          const s = o.shift(), u = i.findIndex((c) => c.id === s);
          u > -1 && l.push(i.splice(u, 1)[0]);
        }
        l = [...l, ...i];
      }
      return Hh(l, t, a);
    }, Re(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Hl = () => ({
  left: [],
  right: []
}), Uh = {
  getInitialState: (e) => ({
    columnPinning: Hl(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: Kt("columnPinning", e)
  }),
  createColumn: (e, n) => {
    e.pin = (t) => {
      const a = e.getLeafColumns().map((r) => r.id).filter(Boolean);
      n.setColumnPinning((r) => {
        var l, o;
        if (t === "right") {
          var i, s;
          return {
            left: ((i = r == null ? void 0 : r.left) != null ? i : []).filter((f) => !(a != null && a.includes(f))),
            right: [...((s = r == null ? void 0 : r.right) != null ? s : []).filter((f) => !(a != null && a.includes(f))), ...a]
          };
        }
        if (t === "left") {
          var u, c;
          return {
            left: [...((u = r == null ? void 0 : r.left) != null ? u : []).filter((f) => !(a != null && a.includes(f))), ...a],
            right: ((c = r == null ? void 0 : r.right) != null ? c : []).filter((f) => !(a != null && a.includes(f)))
          };
        }
        return {
          left: ((l = r == null ? void 0 : r.left) != null ? l : []).filter((f) => !(a != null && a.includes(f))),
          right: ((o = r == null ? void 0 : r.right) != null ? o : []).filter((f) => !(a != null && a.includes(f)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((a) => {
      var r, l, o;
      return ((r = a.columnDef.enablePinning) != null ? r : !0) && ((l = (o = n.options.enableColumnPinning) != null ? o : n.options.enablePinning) != null ? l : !0);
    }), e.getIsPinned = () => {
      const t = e.getLeafColumns().map((i) => i.id), {
        left: a,
        right: r
      } = n.getState().columnPinning, l = t.some((i) => a == null ? void 0 : a.includes(i)), o = t.some((i) => r == null ? void 0 : r.includes(i));
      return l ? "left" : o ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var t, a;
      const r = e.getIsPinned();
      return r ? (t = (a = n.getState().columnPinning) == null || (a = a[r]) == null ? void 0 : a.indexOf(e.id)) != null ? t : -1 : 0;
    };
  },
  createRow: (e, n) => {
    e.getCenterVisibleCells = De(() => [e._getAllVisibleCells(), n.getState().columnPinning.left, n.getState().columnPinning.right], (t, a, r) => {
      const l = [...a ?? [], ...r ?? []];
      return t.filter((o) => !l.includes(o.column.id));
    }, Re(n.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = De(() => [e._getAllVisibleCells(), n.getState().columnPinning.left], (t, a) => (a ?? []).map((l) => t.find((o) => o.column.id === l)).filter(Boolean).map((l) => ({
      ...l,
      position: "left"
    })), Re(n.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = De(() => [e._getAllVisibleCells(), n.getState().columnPinning.right], (t, a) => (a ?? []).map((l) => t.find((o) => o.column.id === l)).filter(Boolean).map((l) => ({
      ...l,
      position: "right"
    })), Re(n.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (n) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(n), e.resetColumnPinning = (n) => {
      var t, a;
      return e.setColumnPinning(n ? Hl() : (t = (a = e.initialState) == null ? void 0 : a.columnPinning) != null ? t : Hl());
    }, e.getIsSomeColumnsPinned = (n) => {
      var t;
      const a = e.getState().columnPinning;
      if (!n) {
        var r, l;
        return !!((r = a.left) != null && r.length || (l = a.right) != null && l.length);
      }
      return !!((t = a[n]) != null && t.length);
    }, e.getLeftLeafColumns = De(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (n, t) => (t ?? []).map((a) => n.find((r) => r.id === a)).filter(Boolean), Re(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = De(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (n, t) => (t ?? []).map((a) => n.find((r) => r.id === a)).filter(Boolean), Re(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = De(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, a) => {
      const r = [...t ?? [], ...a ?? []];
      return n.filter((l) => !r.includes(l.id));
    }, Re(e.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function Yh(e) {
  return e || (typeof document < "u" ? document : null);
}
const Ar = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, zl = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), jh = {
  getDefaultColumnDef: () => Ar,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: zl(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: Kt("columnSizing", e),
    onColumnSizingInfoChange: Kt("columnSizingInfo", e)
  }),
  createColumn: (e, n) => {
    e.getSize = () => {
      var t, a, r;
      const l = n.getState().columnSizing[e.id];
      return Math.min(Math.max((t = e.columnDef.minSize) != null ? t : Ar.minSize, (a = l ?? e.columnDef.size) != null ? a : Ar.size), (r = e.columnDef.maxSize) != null ? r : Ar.maxSize);
    }, e.getStart = De((t) => [t, nr(n, t), n.getState().columnSizing], (t, a) => a.slice(0, e.getIndex(t)).reduce((r, l) => r + l.getSize(), 0), Re(n.options, "debugColumns", "getStart")), e.getAfter = De((t) => [t, nr(n, t), n.getState().columnSizing], (t, a) => a.slice(e.getIndex(t) + 1).reduce((r, l) => r + l.getSize(), 0), Re(n.options, "debugColumns", "getAfter")), e.resetSize = () => {
      n.setColumnSizing((t) => {
        let {
          [e.id]: a,
          ...r
        } = t;
        return r;
      });
    }, e.getCanResize = () => {
      var t, a;
      return ((t = e.columnDef.enableResizing) != null ? t : !0) && ((a = n.options.enableColumnResizing) != null ? a : !0);
    }, e.getIsResizing = () => n.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, n) => {
    e.getSize = () => {
      let t = 0;
      const a = (r) => {
        if (r.subHeaders.length)
          r.subHeaders.forEach(a);
        else {
          var l;
          t += (l = r.column.getSize()) != null ? l : 0;
        }
      };
      return a(e), t;
    }, e.getStart = () => {
      if (e.index > 0) {
        const t = e.headerGroup.headers[e.index - 1];
        return t.getStart() + t.getSize();
      }
      return 0;
    }, e.getResizeHandler = (t) => {
      const a = n.getColumn(e.column.id), r = a == null ? void 0 : a.getCanResize();
      return (l) => {
        if (!a || !r || (l.persist == null || l.persist(), Ul(l) && l.touches && l.touches.length > 1))
          return;
        const o = e.getSize(), i = e ? e.getLeafHeaders().map((g) => [g.column.id, g.column.getSize()]) : [[a.id, a.getSize()]], s = Ul(l) ? Math.round(l.touches[0].clientX) : l.clientX, u = {}, c = (g, b) => {
          typeof b == "number" && (n.setColumnSizingInfo((h) => {
            var x, F;
            const C = n.options.columnResizeDirection === "rtl" ? -1 : 1, A = (b - ((x = h == null ? void 0 : h.startOffset) != null ? x : 0)) * C, O = Math.max(A / ((F = h == null ? void 0 : h.startSize) != null ? F : 0), -0.999999);
            return h.columnSizingStart.forEach(($) => {
              let [L, N] = $;
              u[L] = Math.round(Math.max(N + N * O, 0) * 100) / 100;
            }), {
              ...h,
              deltaOffset: A,
              deltaPercentage: O
            };
          }), (n.options.columnResizeMode === "onChange" || g === "end") && n.setColumnSizing((h) => ({
            ...h,
            ...u
          })));
        }, f = (g) => c("move", g), d = (g) => {
          c("end", g), n.setColumnSizingInfo((b) => ({
            ...b,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, m = Yh(t), y = {
          moveHandler: (g) => f(g.clientX),
          upHandler: (g) => {
            m == null || m.removeEventListener("mousemove", y.moveHandler), m == null || m.removeEventListener("mouseup", y.upHandler), d(g.clientX);
          }
        }, v = {
          moveHandler: (g) => (g.cancelable && (g.preventDefault(), g.stopPropagation()), f(g.touches[0].clientX), !1),
          upHandler: (g) => {
            var b;
            m == null || m.removeEventListener("touchmove", v.moveHandler), m == null || m.removeEventListener("touchend", v.upHandler), g.cancelable && (g.preventDefault(), g.stopPropagation()), d((b = g.touches[0]) == null ? void 0 : b.clientX);
          }
        }, S = Zh() ? {
          passive: !1
        } : !1;
        Ul(l) ? (m == null || m.addEventListener("touchmove", v.moveHandler, S), m == null || m.addEventListener("touchend", v.upHandler, S)) : (m == null || m.addEventListener("mousemove", y.moveHandler, S), m == null || m.addEventListener("mouseup", y.upHandler, S)), n.setColumnSizingInfo((g) => ({
          ...g,
          startOffset: s,
          startSize: o,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: i,
          isResizingColumn: a.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (n) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(n), e.setColumnSizingInfo = (n) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(n), e.resetColumnSizing = (n) => {
      var t;
      e.setColumnSizing(n ? {} : (t = e.initialState.columnSizing) != null ? t : {});
    }, e.resetHeaderSizeInfo = (n) => {
      var t;
      e.setColumnSizingInfo(n ? zl() : (t = e.initialState.columnSizingInfo) != null ? t : zl());
    }, e.getTotalSize = () => {
      var n, t;
      return (n = (t = e.getHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, r) => a + r.getSize(), 0)) != null ? n : 0;
    }, e.getLeftTotalSize = () => {
      var n, t;
      return (n = (t = e.getLeftHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, r) => a + r.getSize(), 0)) != null ? n : 0;
    }, e.getCenterTotalSize = () => {
      var n, t;
      return (n = (t = e.getCenterHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, r) => a + r.getSize(), 0)) != null ? n : 0;
    }, e.getRightTotalSize = () => {
      var n, t;
      return (n = (t = e.getRightHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((a, r) => a + r.getSize(), 0)) != null ? n : 0;
    };
  }
};
let Tr = null;
function Zh() {
  if (typeof Tr == "boolean") return Tr;
  let e = !1;
  try {
    const n = {
      get passive() {
        return e = !0, !1;
      }
    }, t = () => {
    };
    window.addEventListener("test", t, n), window.removeEventListener("test", t);
  } catch {
    e = !1;
  }
  return Tr = e, Tr;
}
function Ul(e) {
  return e.type === "touchstart";
}
const Gh = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: Kt("columnVisibility", e)
  }),
  createColumn: (e, n) => {
    e.toggleVisibility = (t) => {
      e.getCanHide() && n.setColumnVisibility((a) => ({
        ...a,
        [e.id]: t ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var t, a;
      const r = e.columns;
      return (t = r.length ? r.some((l) => l.getIsVisible()) : (a = n.getState().columnVisibility) == null ? void 0 : a[e.id]) != null ? t : !0;
    }, e.getCanHide = () => {
      var t, a;
      return ((t = e.columnDef.enableHiding) != null ? t : !0) && ((a = n.options.enableHiding) != null ? a : !0);
    }, e.getToggleVisibilityHandler = () => (t) => {
      e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
    };
  },
  createRow: (e, n) => {
    e._getAllVisibleCells = De(() => [e.getAllCells(), n.getState().columnVisibility], (t) => t.filter((a) => a.column.getIsVisible()), Re(n.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = De(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (t, a, r) => [...t, ...a, ...r], Re(n.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const n = (t, a) => De(() => [a(), a().filter((r) => r.getIsVisible()).map((r) => r.id).join("_")], (r) => r.filter((l) => l.getIsVisible == null ? void 0 : l.getIsVisible()), Re(e.options, "debugColumns", t));
    e.getVisibleFlatColumns = n("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = n("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = n("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = n("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = n("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
      var a;
      e.setColumnVisibility(t ? {} : (a = e.initialState.columnVisibility) != null ? a : {});
    }, e.toggleAllColumnsVisible = (t) => {
      var a;
      t = (a = t) != null ? a : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((r, l) => ({
        ...r,
        [l.id]: t || !(l.getCanHide != null && l.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((t) => !(t.getIsVisible != null && t.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
      var a;
      e.toggleAllColumnsVisible((a = t.target) == null ? void 0 : a.checked);
    };
  }
};
function nr(e, n) {
  return n ? n === "center" ? e.getCenterVisibleLeafColumns() : n === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const Wh = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, qh = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: Kt("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (n) => {
      var t;
      const a = (t = e.getCoreRowModel().flatRows[0]) == null || (t = t._getAllCellsByColumnId()[n.id]) == null ? void 0 : t.getValue();
      return typeof a == "string" || typeof a == "number";
    }
  }),
  createColumn: (e, n) => {
    e.getCanGlobalFilter = () => {
      var t, a, r, l;
      return ((t = e.columnDef.enableGlobalFilter) != null ? t : !0) && ((a = n.options.enableGlobalFilter) != null ? a : !0) && ((r = n.options.enableFilters) != null ? r : !0) && ((l = n.options.getColumnCanGlobalFilter == null ? void 0 : n.options.getColumnCanGlobalFilter(e)) != null ? l : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => An.includesString, e.getGlobalFilterFn = () => {
      var n, t;
      const {
        globalFilterFn: a
      } = e.options;
      return il(a) ? a : a === "auto" ? e.getGlobalAutoFilterFn() : (n = (t = e.options.filterFns) == null ? void 0 : t[a]) != null ? n : An[a];
    }, e.setGlobalFilter = (n) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(n);
    }, e.resetGlobalFilter = (n) => {
      e.setGlobalFilter(n ? void 0 : e.initialState.globalFilter);
    };
  }
}, Kh = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: Kt("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetExpanded = () => {
      var a, r;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((a = (r = e.options.autoResetAll) != null ? r : e.options.autoResetExpanded) != null ? a : !e.options.manualExpanding) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetExpanded(), t = !1;
        });
      }
    }, e.setExpanded = (a) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(a), e.toggleAllRowsExpanded = (a) => {
      a ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (a) => {
      var r, l;
      e.setExpanded(a ? {} : (r = (l = e.initialState) == null ? void 0 : l.expanded) != null ? r : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((a) => a.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (a) => {
      a.persist == null || a.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const a = e.getState().expanded;
      return a === !0 || Object.values(a).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const a = e.getState().expanded;
      return typeof a == "boolean" ? a === !0 : !(!Object.keys(a).length || e.getRowModel().flatRows.some((r) => !r.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let a = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((l) => {
        const o = l.split(".");
        a = Math.max(a, o.length);
      }), a;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, n) => {
    e.toggleExpanded = (t) => {
      n.setExpanded((a) => {
        var r;
        const l = a === !0 ? !0 : !!(a != null && a[e.id]);
        let o = {};
        if (a === !0 ? Object.keys(n.getRowModel().rowsById).forEach((i) => {
          o[i] = !0;
        }) : o = a, t = (r = t) != null ? r : !l, !l && t)
          return {
            ...o,
            [e.id]: !0
          };
        if (l && !t) {
          const {
            [e.id]: i,
            ...s
          } = o;
          return s;
        }
        return a;
      });
    }, e.getIsExpanded = () => {
      var t;
      const a = n.getState().expanded;
      return !!((t = n.options.getIsRowExpanded == null ? void 0 : n.options.getIsRowExpanded(e)) != null ? t : a === !0 || a != null && a[e.id]);
    }, e.getCanExpand = () => {
      var t, a, r;
      return (t = n.options.getRowCanExpand == null ? void 0 : n.options.getRowCanExpand(e)) != null ? t : ((a = n.options.enableExpanding) != null ? a : !0) && !!((r = e.subRows) != null && r.length);
    }, e.getIsAllParentsExpanded = () => {
      let t = !0, a = e;
      for (; t && a.parentId; )
        a = n.getRow(a.parentId, !0), t = a.getIsExpanded();
      return t;
    }, e.getToggleExpandedHandler = () => {
      const t = e.getCanExpand();
      return () => {
        t && e.toggleExpanded();
      };
    };
  }
}, po = 0, vo = 10, Yl = () => ({
  pageIndex: po,
  pageSize: vo
}), Xh = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...Yl(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: Kt("pagination", e)
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetPageIndex = () => {
      var a, r;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((a = (r = e.options.autoResetAll) != null ? r : e.options.autoResetPageIndex) != null ? a : !e.options.manualPagination) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetPageIndex(), t = !1;
        });
      }
    }, e.setPagination = (a) => {
      const r = (l) => Zn(a, l);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(r);
    }, e.resetPagination = (a) => {
      var r;
      e.setPagination(a ? Yl() : (r = e.initialState.pagination) != null ? r : Yl());
    }, e.setPageIndex = (a) => {
      e.setPagination((r) => {
        let l = Zn(a, r.pageIndex);
        const o = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return l = Math.max(0, Math.min(l, o)), {
          ...r,
          pageIndex: l
        };
      });
    }, e.resetPageIndex = (a) => {
      var r, l;
      e.setPageIndex(a ? po : (r = (l = e.initialState) == null || (l = l.pagination) == null ? void 0 : l.pageIndex) != null ? r : po);
    }, e.resetPageSize = (a) => {
      var r, l;
      e.setPageSize(a ? vo : (r = (l = e.initialState) == null || (l = l.pagination) == null ? void 0 : l.pageSize) != null ? r : vo);
    }, e.setPageSize = (a) => {
      e.setPagination((r) => {
        const l = Math.max(1, Zn(a, r.pageSize)), o = r.pageSize * r.pageIndex, i = Math.floor(o / l);
        return {
          ...r,
          pageIndex: i,
          pageSize: l
        };
      });
    }, e.setPageCount = (a) => e.setPagination((r) => {
      var l;
      let o = Zn(a, (l = e.options.pageCount) != null ? l : -1);
      return typeof o == "number" && (o = Math.max(-1, o)), {
        ...r,
        pageCount: o
      };
    }), e.getPageOptions = De(() => [e.getPageCount()], (a) => {
      let r = [];
      return a && a > 0 && (r = [...new Array(a)].fill(null).map((l, o) => o)), r;
    }, Re(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: a
      } = e.getState().pagination, r = e.getPageCount();
      return r === -1 ? !0 : r === 0 ? !1 : a < r - 1;
    }, e.previousPage = () => e.setPageIndex((a) => a - 1), e.nextPage = () => e.setPageIndex((a) => a + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var a;
      return (a = e.options.pageCount) != null ? a : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var a;
      return (a = e.options.rowCount) != null ? a : e.getPrePaginationRowModel().rows.length;
    };
  }
}, jl = () => ({
  top: [],
  bottom: []
}), Qh = {
  getInitialState: (e) => ({
    rowPinning: jl(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: Kt("rowPinning", e)
  }),
  createRow: (e, n) => {
    e.pin = (t, a, r) => {
      const l = a ? e.getLeafRows().map((s) => {
        let {
          id: u
        } = s;
        return u;
      }) : [], o = r ? e.getParentRows().map((s) => {
        let {
          id: u
        } = s;
        return u;
      }) : [], i = /* @__PURE__ */ new Set([...o, e.id, ...l]);
      n.setRowPinning((s) => {
        var u, c;
        if (t === "bottom") {
          var f, d;
          return {
            top: ((f = s == null ? void 0 : s.top) != null ? f : []).filter((v) => !(i != null && i.has(v))),
            bottom: [...((d = s == null ? void 0 : s.bottom) != null ? d : []).filter((v) => !(i != null && i.has(v))), ...Array.from(i)]
          };
        }
        if (t === "top") {
          var m, y;
          return {
            top: [...((m = s == null ? void 0 : s.top) != null ? m : []).filter((v) => !(i != null && i.has(v))), ...Array.from(i)],
            bottom: ((y = s == null ? void 0 : s.bottom) != null ? y : []).filter((v) => !(i != null && i.has(v)))
          };
        }
        return {
          top: ((u = s == null ? void 0 : s.top) != null ? u : []).filter((v) => !(i != null && i.has(v))),
          bottom: ((c = s == null ? void 0 : s.bottom) != null ? c : []).filter((v) => !(i != null && i.has(v)))
        };
      });
    }, e.getCanPin = () => {
      var t;
      const {
        enableRowPinning: a,
        enablePinning: r
      } = n.options;
      return typeof a == "function" ? a(e) : (t = a ?? r) != null ? t : !0;
    }, e.getIsPinned = () => {
      const t = [e.id], {
        top: a,
        bottom: r
      } = n.getState().rowPinning, l = t.some((i) => a == null ? void 0 : a.includes(i)), o = t.some((i) => r == null ? void 0 : r.includes(i));
      return l ? "top" : o ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var t, a;
      const r = e.getIsPinned();
      if (!r) return -1;
      const l = (t = r === "top" ? n.getTopRows() : n.getBottomRows()) == null ? void 0 : t.map((o) => {
        let {
          id: i
        } = o;
        return i;
      });
      return (a = l == null ? void 0 : l.indexOf(e.id)) != null ? a : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (n) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(n), e.resetRowPinning = (n) => {
      var t, a;
      return e.setRowPinning(n ? jl() : (t = (a = e.initialState) == null ? void 0 : a.rowPinning) != null ? t : jl());
    }, e.getIsSomeRowsPinned = (n) => {
      var t;
      const a = e.getState().rowPinning;
      if (!n) {
        var r, l;
        return !!((r = a.top) != null && r.length || (l = a.bottom) != null && l.length);
      }
      return !!((t = a[n]) != null && t.length);
    }, e._getPinnedRows = (n, t, a) => {
      var r;
      return ((r = e.options.keepPinnedRows) == null || r ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (t ?? []).map((o) => {
          const i = e.getRow(o, !0);
          return i.getIsAllParentsExpanded() ? i : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (t ?? []).map((o) => n.find((i) => i.id === o))
      )).filter(Boolean).map((o) => ({
        ...o,
        position: a
      }));
    }, e.getTopRows = De(() => [e.getRowModel().rows, e.getState().rowPinning.top], (n, t) => e._getPinnedRows(n, t, "top"), Re(e.options, "debugRows", "getTopRows")), e.getBottomRows = De(() => [e.getRowModel().rows, e.getState().rowPinning.bottom], (n, t) => e._getPinnedRows(n, t, "bottom"), Re(e.options, "debugRows", "getBottomRows")), e.getCenterRows = De(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (n, t, a) => {
      const r = /* @__PURE__ */ new Set([...t ?? [], ...a ?? []]);
      return n.filter((l) => !r.has(l.id));
    }, Re(e.options, "debugRows", "getCenterRows"));
  }
}, Jh = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: Kt("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (n) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(n), e.resetRowSelection = (n) => {
      var t;
      return e.setRowSelection(n ? {} : (t = e.initialState.rowSelection) != null ? t : {});
    }, e.toggleAllRowsSelected = (n) => {
      e.setRowSelection((t) => {
        n = typeof n < "u" ? n : !e.getIsAllRowsSelected();
        const a = {
          ...t
        }, r = e.getPreGroupedRowModel().flatRows;
        return n ? r.forEach((l) => {
          l.getCanSelect() && (a[l.id] = !0);
        }) : r.forEach((l) => {
          delete a[l.id];
        }), a;
      });
    }, e.toggleAllPageRowsSelected = (n) => e.setRowSelection((t) => {
      const a = typeof n < "u" ? n : !e.getIsAllPageRowsSelected(), r = {
        ...t
      };
      return e.getRowModel().rows.forEach((l) => {
        go(r, l.id, a, !0, e);
      }), r;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = De(() => [e.getState().rowSelection, e.getCoreRowModel()], (n, t) => Object.keys(n).length ? Zl(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Re(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = De(() => [e.getState().rowSelection, e.getFilteredRowModel()], (n, t) => Object.keys(n).length ? Zl(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Re(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = De(() => [e.getState().rowSelection, e.getSortedRowModel()], (n, t) => Object.keys(n).length ? Zl(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Re(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const n = e.getFilteredRowModel().flatRows, {
        rowSelection: t
      } = e.getState();
      let a = !!(n.length && Object.keys(t).length);
      return a && n.some((r) => r.getCanSelect() && !t[r.id]) && (a = !1), a;
    }, e.getIsAllPageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows.filter((r) => r.getCanSelect()), {
        rowSelection: t
      } = e.getState();
      let a = !!n.length;
      return a && n.some((r) => !t[r.id]) && (a = !1), a;
    }, e.getIsSomeRowsSelected = () => {
      var n;
      const t = Object.keys((n = e.getState().rowSelection) != null ? n : {}).length;
      return t > 0 && t < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : n.filter((t) => t.getCanSelect()).some((t) => t.getIsSelected() || t.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (n) => {
      e.toggleAllRowsSelected(n.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (n) => {
      e.toggleAllPageRowsSelected(n.target.checked);
    };
  },
  createRow: (e, n) => {
    e.toggleSelected = (t, a) => {
      const r = e.getIsSelected();
      n.setRowSelection((l) => {
        var o;
        if (t = typeof t < "u" ? t : !r, e.getCanSelect() && r === t)
          return l;
        const i = {
          ...l
        };
        return go(i, e.id, t, (o = a == null ? void 0 : a.selectChildren) != null ? o : !0, n), i;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return ns(e, t);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return ho(e, t) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return ho(e, t) === "all";
    }, e.getCanSelect = () => {
      var t;
      return typeof n.options.enableRowSelection == "function" ? n.options.enableRowSelection(e) : (t = n.options.enableRowSelection) != null ? t : !0;
    }, e.getCanSelectSubRows = () => {
      var t;
      return typeof n.options.enableSubRowSelection == "function" ? n.options.enableSubRowSelection(e) : (t = n.options.enableSubRowSelection) != null ? t : !0;
    }, e.getCanMultiSelect = () => {
      var t;
      return typeof n.options.enableMultiRowSelection == "function" ? n.options.enableMultiRowSelection(e) : (t = n.options.enableMultiRowSelection) != null ? t : !0;
    }, e.getToggleSelectedHandler = () => {
      const t = e.getCanSelect();
      return (a) => {
        var r;
        t && e.toggleSelected((r = a.target) == null ? void 0 : r.checked);
      };
    };
  }
}, go = (e, n, t, a, r) => {
  var l;
  const o = r.getRow(n, !0);
  t ? (o.getCanMultiSelect() || Object.keys(e).forEach((i) => delete e[i]), o.getCanSelect() && (e[n] = !0)) : delete e[n], a && (l = o.subRows) != null && l.length && o.getCanSelectSubRows() && o.subRows.forEach((i) => go(e, i.id, t, a, r));
};
function Zl(e, n) {
  const t = e.getState().rowSelection, a = [], r = {}, l = function(o, i) {
    return o.map((s) => {
      var u;
      const c = ns(s, t);
      if (c && (a.push(s), r[s.id] = s), (u = s.subRows) != null && u.length && (s = {
        ...s,
        subRows: l(s.subRows)
      }), c)
        return s;
    }).filter(Boolean);
  };
  return {
    rows: l(n.rows),
    flatRows: a,
    rowsById: r
  };
}
function ns(e, n) {
  var t;
  return (t = n[e.id]) != null ? t : !1;
}
function ho(e, n, t) {
  var a;
  if (!((a = e.subRows) != null && a.length)) return !1;
  let r = !0, l = !1;
  return e.subRows.forEach((o) => {
    if (!(l && !r) && (o.getCanSelect() && (ns(o, n) ? l = !0 : r = !1), o.subRows && o.subRows.length)) {
      const i = ho(o, n);
      i === "all" ? l = !0 : (i === "some" && (l = !0), r = !1);
    }
  }), r ? "all" : l ? "some" : !1;
}
const yo = /([0-9]+)/gm, e2 = (e, n, t) => Hd(Xn(e.getValue(t)).toLowerCase(), Xn(n.getValue(t)).toLowerCase()), t2 = (e, n, t) => Hd(Xn(e.getValue(t)), Xn(n.getValue(t))), n2 = (e, n, t) => as(Xn(e.getValue(t)).toLowerCase(), Xn(n.getValue(t)).toLowerCase()), a2 = (e, n, t) => as(Xn(e.getValue(t)), Xn(n.getValue(t))), r2 = (e, n, t) => {
  const a = e.getValue(t), r = n.getValue(t);
  return a > r ? 1 : a < r ? -1 : 0;
}, l2 = (e, n, t) => as(e.getValue(t), n.getValue(t));
function as(e, n) {
  return e === n ? 0 : e > n ? 1 : -1;
}
function Xn(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function Hd(e, n) {
  const t = e.split(yo).filter(Boolean), a = n.split(yo).filter(Boolean);
  for (; t.length && a.length; ) {
    const r = t.shift(), l = a.shift(), o = parseInt(r, 10), i = parseInt(l, 10), s = [o, i].sort();
    if (isNaN(s[0])) {
      if (r > l)
        return 1;
      if (l > r)
        return -1;
      continue;
    }
    if (isNaN(s[1]))
      return isNaN(o) ? -1 : 1;
    if (o > i)
      return 1;
    if (i > o)
      return -1;
  }
  return t.length - a.length;
}
const Za = {
  alphanumeric: e2,
  alphanumericCaseSensitive: t2,
  text: n2,
  textCaseSensitive: a2,
  datetime: r2,
  basic: l2
}, o2 = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: Kt("sorting", e),
    isMultiSortEvent: (n) => n.shiftKey
  }),
  createColumn: (e, n) => {
    e.getAutoSortingFn = () => {
      const t = n.getFilteredRowModel().flatRows.slice(10);
      let a = !1;
      for (const r of t) {
        const l = r == null ? void 0 : r.getValue(e.id);
        if (Object.prototype.toString.call(l) === "[object Date]")
          return Za.datetime;
        if (typeof l == "string" && (a = !0, l.split(yo).length > 1))
          return Za.alphanumeric;
      }
      return a ? Za.text : Za.basic;
    }, e.getAutoSortDir = () => {
      const t = n.getFilteredRowModel().flatRows[0];
      return typeof (t == null ? void 0 : t.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var t, a;
      if (!e)
        throw new Error();
      return il(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (t = (a = n.options.sortingFns) == null ? void 0 : a[e.columnDef.sortingFn]) != null ? t : Za[e.columnDef.sortingFn];
    }, e.toggleSorting = (t, a) => {
      const r = e.getNextSortingOrder(), l = typeof t < "u" && t !== null;
      n.setSorting((o) => {
        const i = o == null ? void 0 : o.find((m) => m.id === e.id), s = o == null ? void 0 : o.findIndex((m) => m.id === e.id);
        let u = [], c, f = l ? t : r === "desc";
        if (o != null && o.length && e.getCanMultiSort() && a ? i ? c = "toggle" : c = "add" : o != null && o.length && s !== o.length - 1 ? c = "replace" : i ? c = "toggle" : c = "replace", c === "toggle" && (l || r || (c = "remove")), c === "add") {
          var d;
          u = [...o, {
            id: e.id,
            desc: f
          }], u.splice(0, u.length - ((d = n.options.maxMultiSortColCount) != null ? d : Number.MAX_SAFE_INTEGER));
        } else c === "toggle" ? u = o.map((m) => m.id === e.id ? {
          ...m,
          desc: f
        } : m) : c === "remove" ? u = o.filter((m) => m.id !== e.id) : u = [{
          id: e.id,
          desc: f
        }];
        return u;
      });
    }, e.getFirstSortDir = () => {
      var t, a;
      return ((t = (a = e.columnDef.sortDescFirst) != null ? a : n.options.sortDescFirst) != null ? t : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (t) => {
      var a, r;
      const l = e.getFirstSortDir(), o = e.getIsSorted();
      return o ? o !== l && ((a = n.options.enableSortingRemoval) == null || a) && // If enableSortRemove, enable in general
      (!(t && (r = n.options.enableMultiRemove) != null) || r) ? !1 : o === "desc" ? "asc" : "desc" : l;
    }, e.getCanSort = () => {
      var t, a;
      return ((t = e.columnDef.enableSorting) != null ? t : !0) && ((a = n.options.enableSorting) != null ? a : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var t, a;
      return (t = (a = e.columnDef.enableMultiSort) != null ? a : n.options.enableMultiSort) != null ? t : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var t;
      const a = (t = n.getState().sorting) == null ? void 0 : t.find((r) => r.id === e.id);
      return a ? a.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var t, a;
      return (t = (a = n.getState().sorting) == null ? void 0 : a.findIndex((r) => r.id === e.id)) != null ? t : -1;
    }, e.clearSorting = () => {
      n.setSorting((t) => t != null && t.length ? t.filter((a) => a.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const t = e.getCanSort();
      return (a) => {
        t && (a.persist == null || a.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? n.options.isMultiSortEvent == null ? void 0 : n.options.isMultiSortEvent(a) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (n) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(n), e.resetSorting = (n) => {
      var t, a;
      e.setSorting(n ? [] : (t = (a = e.initialState) == null ? void 0 : a.sorting) != null ? t : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, s2 = [
  Ph,
  Gh,
  zh,
  Uh,
  $h,
  Ah,
  Wh,
  //depends on ColumnFaceting
  qh,
  //depends on ColumnFiltering
  o2,
  Bh,
  //depends on RowSorting
  Kh,
  Xh,
  Qh,
  Jh,
  jh
];
function i2(e) {
  var n, t;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const a = [...s2, ...(n = e._features) != null ? n : []];
  let r = {
    _features: a
  };
  const l = r._features.reduce((d, m) => Object.assign(d, m.getDefaultOptions == null ? void 0 : m.getDefaultOptions(r)), {}), o = (d) => r.options.mergeOptions ? r.options.mergeOptions(l, d) : {
    ...l,
    ...d
  };
  let s = {
    ...{},
    ...(t = e.initialState) != null ? t : {}
  };
  r._features.forEach((d) => {
    var m;
    s = (m = d.getInitialState == null ? void 0 : d.getInitialState(s)) != null ? m : s;
  });
  const u = [];
  let c = !1;
  const f = {
    _features: a,
    options: {
      ...l,
      ...e
    },
    initialState: s,
    _queue: (d) => {
      u.push(d), c || (c = !0, Promise.resolve().then(() => {
        for (; u.length; )
          u.shift()();
        c = !1;
      }).catch((m) => setTimeout(() => {
        throw m;
      })));
    },
    reset: () => {
      r.setState(r.initialState);
    },
    setOptions: (d) => {
      const m = Zn(d, r.options);
      r.options = o(m);
    },
    getState: () => r.options.state,
    setState: (d) => {
      r.options.onStateChange == null || r.options.onStateChange(d);
    },
    _getRowId: (d, m, y) => {
      var v;
      return (v = r.options.getRowId == null ? void 0 : r.options.getRowId(d, m, y)) != null ? v : `${y ? [y.id, m].join(".") : m}`;
    },
    getCoreRowModel: () => (r._getCoreRowModel || (r._getCoreRowModel = r.options.getCoreRowModel(r)), r._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => r.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (d, m) => {
      let y = (m ? r.getPrePaginationRowModel() : r.getRowModel()).rowsById[d];
      if (!y && (y = r.getCoreRowModel().rowsById[d], !y))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${d}`) : new Error();
      return y;
    },
    _getDefaultColumnDef: De(() => [r.options.defaultColumn], (d) => {
      var m;
      return d = (m = d) != null ? m : {}, {
        header: (y) => {
          const v = y.header.column.columnDef;
          return v.accessorKey ? v.accessorKey : v.accessorFn ? v.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (y) => {
          var v, S;
          return (v = (S = y.renderValue()) == null || S.toString == null ? void 0 : S.toString()) != null ? v : null;
        },
        ...r._features.reduce((y, v) => Object.assign(y, v.getDefaultColumnDef == null ? void 0 : v.getDefaultColumnDef()), {}),
        ...d
      };
    }, Re(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => r.options.columns,
    getAllColumns: De(() => [r._getColumnDefs()], (d) => {
      const m = function(y, v, S) {
        return S === void 0 && (S = 0), y.map((g) => {
          const b = Eh(r, g, S, v), h = g;
          return b.columns = h.columns ? m(h.columns, b, S + 1) : [], b;
        });
      };
      return m(d);
    }, Re(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: De(() => [r.getAllColumns()], (d) => d.flatMap((m) => m.getFlatColumns()), Re(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: De(() => [r.getAllFlatColumns()], (d) => d.reduce((m, y) => (m[y.id] = y, m), {}), Re(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: De(() => [r.getAllColumns(), r._getOrderColumnsFn()], (d, m) => {
      let y = d.flatMap((v) => v.getLeafColumns());
      return m(y);
    }, Re(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (d) => {
      const m = r._getAllFlatColumnsById()[d];
      return process.env.NODE_ENV !== "production" && !m && console.error(`[Table] Column with id '${d}' does not exist.`), m;
    }
  };
  Object.assign(r, f);
  for (let d = 0; d < r._features.length; d++) {
    const m = r._features[d];
    m == null || m.createTable == null || m.createTable(r);
  }
  return r;
}
function u2() {
  return (e) => De(() => [e.options.data], (n) => {
    const t = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, a = function(r, l, o) {
      l === void 0 && (l = 0);
      const i = [];
      for (let u = 0; u < r.length; u++) {
        const c = ul(e, e._getRowId(r[u], u, o), r[u], u, l, void 0, o == null ? void 0 : o.id);
        if (t.flatRows.push(c), t.rowsById[c.id] = c, i.push(c), e.options.getSubRows) {
          var s;
          c.originalSubRows = e.options.getSubRows(r[u], u), (s = c.originalSubRows) != null && s.length && (c.subRows = a(c.originalSubRows, l + 1, c));
        }
      }
      return i;
    };
    return t.rows = a(n), t;
  }, Re(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function d2() {
  return (e) => De(() => [e.getState().expanded, e.getPreExpandedRowModel(), e.options.paginateExpandedRows], (n, t, a) => !t.rows.length || n !== !0 && !Object.keys(n ?? {}).length || !a ? t : zd(t), Re(e.options, "debugTable", "getExpandedRowModel"));
}
function zd(e) {
  const n = [], t = (a) => {
    var r;
    n.push(a), (r = a.subRows) != null && r.length && a.getIsExpanded() && a.subRows.forEach(t);
  };
  return e.rows.forEach(t), {
    rows: n,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function c2(e, n, t) {
  return t.options.filterFromLeafRows ? f2(e, n, t) : m2(e, n, t);
}
function f2(e, n, t) {
  var a;
  const r = [], l = {}, o = (a = t.options.maxLeafRowFilterDepth) != null ? a : 100, i = function(s, u) {
    u === void 0 && (u = 0);
    const c = [];
    for (let d = 0; d < s.length; d++) {
      var f;
      let m = s[d];
      const y = ul(t, m.id, m.original, m.index, m.depth, void 0, m.parentId);
      if (y.columnFilters = m.columnFilters, (f = m.subRows) != null && f.length && u < o) {
        if (y.subRows = i(m.subRows, u + 1), m = y, n(m) && !y.subRows.length) {
          c.push(m), l[m.id] = m, r.push(m);
          continue;
        }
        if (n(m) || y.subRows.length) {
          c.push(m), l[m.id] = m, r.push(m);
          continue;
        }
      } else
        m = y, n(m) && (c.push(m), l[m.id] = m, r.push(m));
    }
    return c;
  };
  return {
    rows: i(e),
    flatRows: r,
    rowsById: l
  };
}
function m2(e, n, t) {
  var a;
  const r = [], l = {}, o = (a = t.options.maxLeafRowFilterDepth) != null ? a : 100, i = function(s, u) {
    u === void 0 && (u = 0);
    const c = [];
    for (let d = 0; d < s.length; d++) {
      let m = s[d];
      if (n(m)) {
        var f;
        if ((f = m.subRows) != null && f.length && u < o) {
          const v = ul(t, m.id, m.original, m.index, m.depth, void 0, m.parentId);
          v.subRows = i(m.subRows, u + 1), m = v;
        }
        c.push(m), r.push(m), l[m.id] = m;
      }
    }
    return c;
  };
  return {
    rows: i(e),
    flatRows: r,
    rowsById: l
  };
}
function p2() {
  return (e) => De(() => [e.getPreFilteredRowModel(), e.getState().columnFilters, e.getState().globalFilter], (n, t, a) => {
    if (!n.rows.length || !(t != null && t.length) && !a) {
      for (let d = 0; d < n.flatRows.length; d++)
        n.flatRows[d].columnFilters = {}, n.flatRows[d].columnFiltersMeta = {};
      return n;
    }
    const r = [], l = [];
    (t ?? []).forEach((d) => {
      var m;
      const y = e.getColumn(d.id);
      if (!y)
        return;
      const v = y.getFilterFn();
      if (!v) {
        process.env.NODE_ENV !== "production" && console.warn(`Could not find a valid 'column.filterFn' for column with the ID: ${y.id}.`);
        return;
      }
      r.push({
        id: d.id,
        filterFn: v,
        resolvedValue: (m = v.resolveFilterValue == null ? void 0 : v.resolveFilterValue(d.value)) != null ? m : d.value
      });
    });
    const o = (t ?? []).map((d) => d.id), i = e.getGlobalFilterFn(), s = e.getAllLeafColumns().filter((d) => d.getCanGlobalFilter());
    a && i && s.length && (o.push("__global__"), s.forEach((d) => {
      var m;
      l.push({
        id: d.id,
        filterFn: i,
        resolvedValue: (m = i.resolveFilterValue == null ? void 0 : i.resolveFilterValue(a)) != null ? m : a
      });
    }));
    let u, c;
    for (let d = 0; d < n.flatRows.length; d++) {
      const m = n.flatRows[d];
      if (m.columnFilters = {}, r.length)
        for (let y = 0; y < r.length; y++) {
          u = r[y];
          const v = u.id;
          m.columnFilters[v] = u.filterFn(m, v, u.resolvedValue, (S) => {
            m.columnFiltersMeta[v] = S;
          });
        }
      if (l.length) {
        for (let y = 0; y < l.length; y++) {
          c = l[y];
          const v = c.id;
          if (c.filterFn(m, v, c.resolvedValue, (S) => {
            m.columnFiltersMeta[v] = S;
          })) {
            m.columnFilters.__global__ = !0;
            break;
          }
        }
        m.columnFilters.__global__ !== !0 && (m.columnFilters.__global__ = !1);
      }
    }
    const f = (d) => {
      for (let m = 0; m < o.length; m++)
        if (d.columnFilters[o[m]] === !1)
          return !1;
      return !0;
    };
    return c2(n.rows, f, e);
  }, Re(e.options, "debugTable", "getFilteredRowModel", () => e._autoResetPageIndex()));
}
function v2() {
  return (e) => De(() => [e.getState().grouping, e.getPreGroupedRowModel()], (n, t) => {
    if (!t.rows.length || !n.length)
      return t.rows.forEach((s) => {
        s.depth = 0, s.parentId = void 0;
      }), t;
    const a = n.filter((s) => e.getColumn(s)), r = [], l = {}, o = function(s, u, c) {
      if (u === void 0 && (u = 0), u >= a.length)
        return s.map((y) => (y.depth = u, r.push(y), l[y.id] = y, y.subRows && (y.subRows = o(y.subRows, u + 1, y.id)), y));
      const f = a[u], d = g2(s, f);
      return Array.from(d.entries()).map((y, v) => {
        let [S, g] = y, b = `${f}:${S}`;
        b = c ? `${c}>${b}` : b;
        const h = o(g, u + 1, b);
        h.forEach((C) => {
          C.parentId = b;
        });
        const x = u ? Dd(g, (C) => C.subRows) : g, F = ul(e, b, x[0].original, v, u, void 0, c);
        return Object.assign(F, {
          groupingColumnId: f,
          groupingValue: S,
          subRows: h,
          leafRows: x,
          getValue: (C) => {
            if (a.includes(C)) {
              if (F._valuesCache.hasOwnProperty(C))
                return F._valuesCache[C];
              if (g[0]) {
                var A;
                F._valuesCache[C] = (A = g[0].getValue(C)) != null ? A : void 0;
              }
              return F._valuesCache[C];
            }
            if (F._groupingValuesCache.hasOwnProperty(C))
              return F._groupingValuesCache[C];
            const O = e.getColumn(C), $ = O == null ? void 0 : O.getAggregationFn();
            if ($)
              return F._groupingValuesCache[C] = $(C, x, g), F._groupingValuesCache[C];
          }
        }), h.forEach((C) => {
          r.push(C), l[C.id] = C;
        }), F;
      });
    }, i = o(t.rows, 0);
    return i.forEach((s) => {
      r.push(s), l[s.id] = s;
    }), {
      rows: i,
      flatRows: r,
      rowsById: l
    };
  }, Re(e.options, "debugTable", "getGroupedRowModel", () => {
    e._queue(() => {
      e._autoResetExpanded(), e._autoResetPageIndex();
    });
  }));
}
function g2(e, n) {
  const t = /* @__PURE__ */ new Map();
  return e.reduce((a, r) => {
    const l = `${r.getGroupingValue(n)}`, o = a.get(l);
    return o ? o.push(r) : a.set(l, [r]), a;
  }, t);
}
function h2(e) {
  return (n) => De(() => [n.getState().pagination, n.getPrePaginationRowModel(), n.options.paginateExpandedRows ? void 0 : n.getState().expanded], (t, a) => {
    if (!a.rows.length)
      return a;
    const {
      pageSize: r,
      pageIndex: l
    } = t;
    let {
      rows: o,
      flatRows: i,
      rowsById: s
    } = a;
    const u = r * l, c = u + r;
    o = o.slice(u, c);
    let f;
    n.options.paginateExpandedRows ? f = {
      rows: o,
      flatRows: i,
      rowsById: s
    } : f = zd({
      rows: o,
      flatRows: i,
      rowsById: s
    }), f.flatRows = [];
    const d = (m) => {
      f.flatRows.push(m), m.subRows.length && m.subRows.forEach(d);
    };
    return f.rows.forEach(d), f;
  }, Re(n.options, "debugTable", "getPaginationRowModel"));
}
function y2() {
  return (e) => De(() => [e.getState().sorting, e.getPreSortedRowModel()], (n, t) => {
    if (!t.rows.length || !(n != null && n.length))
      return t;
    const a = e.getState().sorting, r = [], l = a.filter((s) => {
      var u;
      return (u = e.getColumn(s.id)) == null ? void 0 : u.getCanSort();
    }), o = {};
    l.forEach((s) => {
      const u = e.getColumn(s.id);
      u && (o[s.id] = {
        sortUndefined: u.columnDef.sortUndefined,
        invertSorting: u.columnDef.invertSorting,
        sortingFn: u.getSortingFn()
      });
    });
    const i = (s) => {
      const u = s.map((c) => ({
        ...c
      }));
      return u.sort((c, f) => {
        for (let m = 0; m < l.length; m += 1) {
          var d;
          const y = l[m], v = o[y.id], S = v.sortUndefined, g = (d = y == null ? void 0 : y.desc) != null ? d : !1;
          let b = 0;
          if (S) {
            const h = c.getValue(y.id), x = f.getValue(y.id), F = h === void 0, C = x === void 0;
            if (F || C) {
              if (S === "first") return F ? -1 : 1;
              if (S === "last") return F ? 1 : -1;
              b = F && C ? 0 : F ? S : -S;
            }
          }
          if (b === 0 && (b = v.sortingFn(c, f, y.id)), b !== 0)
            return g && (b *= -1), v.invertSorting && (b *= -1), b;
        }
        return c.index - f.index;
      }), u.forEach((c) => {
        var f;
        r.push(c), (f = c.subRows) != null && f.length && (c.subRows = i(c.subRows));
      }), u;
    };
    return {
      rows: i(t.rows),
      flatRows: r,
      rowsById: t.rowsById
    };
  }, Re(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * vue-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Dr() {
  return !0;
}
const w2 = Symbol("merge-proxy"), b2 = {
  get(e, n, t) {
    return n === w2 ? t : e.get(n);
  },
  has(e, n) {
    return e.has(n);
  },
  set: Dr,
  deleteProperty: Dr,
  getOwnPropertyDescriptor(e, n) {
    return {
      configurable: !0,
      enumerable: !0,
      get() {
        return e.get(n);
      },
      set: Dr,
      deleteProperty: Dr
    };
  },
  ownKeys(e) {
    return e.keys();
  }
};
function Gl(e) {
  return "value" in e ? e.value : e;
}
function Ka() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return new Proxy({
    get(a) {
      for (let r = n.length - 1; r >= 0; r--) {
        const l = Gl(n[r])[a];
        if (l !== void 0) return l;
      }
    },
    has(a) {
      for (let r = n.length - 1; r >= 0; r--)
        if (a in Gl(n[r])) return !0;
      return !1;
    },
    keys() {
      const a = [];
      for (let r = 0; r < n.length; r++) a.push(...Object.keys(Gl(n[r])));
      return [...Array.from(new Set(a))];
    }
  }, b2);
}
const Ma = Ce({
  props: ["render", "props"],
  setup: (e) => () => typeof e.render == "function" || typeof e.render == "object" ? je(e.render, e.props) : e.render
});
function $i(e) {
  return Ka(e, {
    data: D(e.data)
  });
}
function _2(e) {
  const n = zr(e.data), t = Ka({
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    mergeOptions(l, o) {
      return n ? {
        ...l,
        ...o
      } : Ka(l, o);
    }
  }, n ? $i(e) : e), a = i2(t);
  if (n) {
    const l = mr(e.data);
    Be(l, () => {
      a.setState((o) => ({
        ...o,
        data: l.value
      }));
    }, {
      immediate: !0
    });
  }
  const r = ee(a.initialState);
  return Zt(() => {
    a.setOptions((l) => {
      var o;
      const i = new Proxy({}, {
        get: (s, u) => r.value[u]
      });
      return Ka(l, n ? $i(e) : e, {
        // merge the initialState and `options.state`
        // create a new proxy on each `setOptions` call
        // and get the value from state on each property access
        state: Ka(i, (o = e.state) != null ? o : {}),
        // Similarly, we'll maintain both our internal state and any user-provided
        // state.
        onStateChange: (s) => {
          s instanceof Function ? r.value = s(r.value) : r.value = s, e.onStateChange == null || e.onStateChange(s);
        }
      });
    });
  }), a;
}
function Ud(e) {
  var H, le;
  const {
    pageSize: n = 10,
    pageSizeOptions: t = [10, 20, 30, 50],
    enableSorting: a = !0,
    enableFiltering: r = !1,
    enablePagination: l = !0,
    enableRowSelection: o = !1,
    enableGrouping: i = !1,
    enableExpanding: s,
    manualPagination: u = !1,
    pageCount: c,
    pagination: f,
    onPaginationChange: d,
    grouping: m,
    expanded: y,
    onGroupingChange: v,
    onExpandedChange: S
  } = e, g = {
    pageIndex: f ? ((H = D(f)) == null ? void 0 : H.pageIndex) ?? 0 : 0,
    pageSize: f ? ((le = D(f)) == null ? void 0 : le.pageSize) ?? n : n
  }, b = (m ? D(m) : void 0) ?? [], h = i && y === void 0, x = ee([]), F = ee([]), C = ee({}), A = ee([]), O = ee({}), $ = ee({ ...g }), L = ee(b), N = ee(
    y ? D(y) ?? {} : h ? !0 : {}
  ), K = ee(t), ue = s ?? i;
  let B = !1, Z = !1, R = !1;
  const M = _2({
    get data() {
      return D(e.data);
    },
    get columns() {
      return D(e.columns);
    },
    enableSorting: a,
    enableFilters: r,
    enableRowSelection: o,
    enableGrouping: i,
    manualPagination: u,
    getRowCanExpand: ue ? () => !0 : void 0,
    state: {
      get sorting() {
        return x.value;
      },
      get columnFilters() {
        return F.value;
      },
      get columnVisibility() {
        return C.value;
      },
      get columnOrder() {
        return A.value;
      },
      get rowSelection() {
        return O.value;
      },
      get grouping() {
        return L.value;
      },
      get expanded() {
        return N.value;
      },
      get pagination() {
        return $.value;
      }
    },
    get pageCount() {
      var q;
      if (!l) return;
      if (u && c !== void 0) {
        const P = D(c);
        if (typeof P == "number")
          return P;
      }
      const j = ((q = D(e.data)) == null ? void 0 : q.length) ?? 0;
      return Math.max(Math.ceil(j / $.value.pageSize), 1);
    },
    getCoreRowModel: u2(),
    getSortedRowModel: a ? y2() : void 0,
    getFilteredRowModel: r ? p2() : void 0,
    getGroupedRowModel: i ? v2() : void 0,
    getExpandedRowModel: ue ? d2() : void 0,
    getPaginationRowModel: l && !u ? h2() : void 0,
    groupedColumnMode: i ? "reorder" : !1,
    // Manual pagination data is already a server-paged result set. TanStack must expand
    // grouped children before returning the row model because no client pagination stage runs.
    paginateExpandedRows: u,
    onSortingChange: (j) => {
      x.value = typeof j == "function" ? j(x.value) : j;
    },
    onColumnFiltersChange: (j) => {
      F.value = typeof j == "function" ? j(F.value) : j;
    },
    onColumnVisibilityChange: (j) => {
      C.value = typeof j == "function" ? j(C.value) : j;
    },
    onColumnOrderChange: (j) => {
      A.value = typeof j == "function" ? j(A.value) : j;
    },
    onRowSelectionChange: (j) => {
      O.value = typeof j == "function" ? j(O.value) : j;
    },
    onGroupingChange: (j) => {
      B = !0, L.value = typeof j == "function" ? j(L.value) : j, v == null || v(L.value);
    },
    onExpandedChange: (j) => {
      Z = !0, N.value = typeof j == "function" ? j(N.value) : j, S == null || S(N.value);
    },
    onPaginationChange: (j) => {
      R = !0, $.value = typeof j == "function" ? j($.value) : j, d == null || d($.value);
    }
  });
  return Be(
    () => m ? D(m) : void 0,
    (j) => {
      if (B) {
        B = !1;
        return;
      }
      if (j !== void 0) {
        const q = [...j];
        JSON.stringify(q) !== JSON.stringify(L.value) && (L.value = q, M.setGrouping(q));
      }
    },
    { deep: !0 }
  ), Be(
    () => y ? D(y) : void 0,
    (j) => {
      if (Z) {
        Z = !1;
        return;
      }
      j && (typeof j == "boolean" ? (N.value = j, M.setExpanded(j)) : (N.value = { ...j ?? {} }, M.setExpanded(N.value)));
    },
    { deep: !0 }
  ), Be(
    () => f ? D(f) : void 0,
    (j) => {
      if (R) {
        R = !1;
        return;
      }
      if (!j) return;
      const q = {
        pageIndex: j.pageIndex ?? 0,
        pageSize: j.pageSize ?? n
      };
      (q.pageIndex !== $.value.pageIndex || q.pageSize !== $.value.pageSize) && ($.value = q, M.setPagination(q));
    },
    { deep: !0 }
  ), Be(
    () => D(e.data),
    () => {
      u || ($.value = {
        ...$.value,
        pageIndex: 0
      });
    },
    { deep: !0 }
  ), {
    table: M,
    sorting: x,
    columnFilters: F,
    columnVisibility: C,
    columnOrder: A,
    rowSelection: O,
    pagination: $,
    pageSizeOptions: K,
    setPageSize: (j) => {
      $.value = {
        ...$.value,
        pageIndex: 0,
        pageSize: j
      }, d == null || d($.value);
    },
    grouping: L,
    expanded: N,
    reset: () => {
      x.value = [], F.value = [], C.value = {}, A.value = [], O.value = {}, $.value = {
        pageIndex: 0,
        pageSize: g.pageSize
      }, L.value = [], N.value = {}, d == null || d($.value);
    }
  };
}
const x2 = { class: "f-datagrid [contain:inline-size] rounded-3xl border border-slate-200 !bg-bg-primary p-6 shadow-sm dark:border-slate-800" }, k2 = {
  key: 0,
  class: "mb-4 space-y-1"
}, C2 = { class: "text-lg font-semibold text-slate-900 dark:text-white" }, S2 = {
  key: 0,
  class: "text-sm text-slate-500"
}, M2 = {
  key: 1,
  class: "mb-4 flex flex-wrap items-center gap-1"
}, E2 = {
  key: 0,
  class: "flex-shrink-0 min-w-[240px]"
}, P2 = {
  key: 1,
  class: "f-datagrid__dynamic-tools relative flex flex-wrap items-center gap-1"
}, $2 = {
  key: 0,
  class: "relative"
}, A2 = { class: "mb-2 flex items-center justify-between gap-2" }, T2 = { class: "max-h-80 space-y-1 overflow-auto pr-1" }, D2 = ["onDragstart", "onDrop"], R2 = ["checked", "onChange"], O2 = { class: "min-w-0 flex-1 whitespace-normal break-words leading-5 text-text-primary" }, I2 = {
  key: 1,
  class: "relative"
}, F2 = { class: "mb-3 flex items-center gap-2" }, L2 = {
  key: 0,
  class: "mb-3 flex items-center justify-between gap-2 rounded-md bg-slate-50 px-2 py-1.5 text-xs text-slate-600 dark:bg-slate-900 dark:text-slate-300"
}, N2 = { class: "min-w-0" }, V2 = { class: "block truncate" }, B2 = {
  key: 0,
  class: "mt-0.5 block text-[11px] font-medium text-green-600 dark:text-green-400"
}, H2 = {
  key: 1,
  class: "py-3 text-sm text-slate-500"
}, z2 = {
  key: 2,
  class: "max-h-72 space-y-1 overflow-auto pr-1"
}, U2 = ["onClick"], Y2 = ["onClick"], j2 = { class: "relative overflow-x-auto rounded-2xl border border-slate-200 dark:border-slate-800" }, Z2 = { class: "w-full border-collapse text-left" }, G2 = ["colspan", "onClick"], W2 = { class: "flex flex-col gap-2" }, q2 = { class: "flex items-center gap-2" }, K2 = { key: 0 }, X2 = {
  key: 1,
  class: "text-[10px] text-slate-400"
}, Q2 = ["onClick"], J2 = ["onClick", "onContextmenu"], ey = {
  key: 0,
  class: "flex items-center gap-2"
}, ty = ["onClick"], ny = { class: "font-medium text-slate-800 dark:text-slate-100" }, ay = { class: "text-[11px] text-slate-400" }, ry = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center rounded-2xl bg-white/80 backdrop-blur-sm dark:bg-slate-900/80"
}, ly = {
  key: 2,
  class: "py-8 text-center text-sm text-slate-500"
}, oy = {
  key: 3,
  class: "mt-4 flex flex-nowrap items-center justify-between gap-3 text-sm text-slate-500 whitespace-nowrap"
}, sy = { class: "flex flex-nowrap items-center gap-3" }, iy = { class: "flex flex-nowrap items-center gap-2" }, uy = ["onClick"], qb = /* @__PURE__ */ Ce({
  __name: "FDataGrid",
  props: {
    pageSize: { default: 10 },
    pageSizeOptions: { default: () => [10, 20, 30, 50] },
    enableSorting: { type: Boolean, default: !0 },
    enableFiltering: { type: Boolean, default: !1 },
    enablePagination: { type: Boolean, default: !0 },
    enableRowSelection: { type: Boolean, default: !1 },
    enableGrouping: { type: Boolean, default: !1 },
    enableExpanding: { type: Boolean },
    grouping: { default: () => [] },
    expanded: {},
    manualPagination: { type: Boolean, default: !1 },
    pageCount: {},
    pagination: {},
    columns: {},
    data: {},
    title: {},
    description: {},
    loading: { type: Boolean, default: !1 },
    emptyText: { default: "Kayıt Bulunamadı" },
    zebra: { type: Boolean, default: !0 },
    density: { default: "comfortable" },
    showToolbar: { type: Boolean, default: !0 },
    enableSearch: { type: Boolean, default: !1 },
    searchPlaceholder: { default: "Ara" },
    stickyHeader: { type: Boolean, default: !0 },
    enableDynamicColumns: { type: Boolean, default: !1 },
    enableFilterTemplates: { type: Boolean, default: !1 },
    gridStorageKey: { default: "" },
    gridUserKey: { default: "" },
    initialHiddenColumnIds: { default: () => [] },
    showPageSizeSelector: { type: Boolean, default: !0 },
    showPageNavigation: { type: Boolean, default: !0 },
    contextMenuItems: {}
  },
  emits: ["row-click", "row-contextmenu", "update:pagination", "pagination-change", "update:sorting", "update:grouping"],
  setup(e, { emit: n }) {
    const t = e, a = n, r = ee(""), l = ee(!1), o = ee(!1), i = ee(""), s = ee(""), u = ee(""), c = ee([]), f = ee(""), d = ee(!1);
    let m = null;
    const y = mr({
      visible: !1,
      x: 0,
      y: 0,
      row: null
    }), v = k(() => Array.isArray(t.contextMenuItems) && t.contextMenuItems.length > 0), S = k(() => t.enableDynamicColumns || t.enableFilterTemplates), g = k(() => {
      if (!t.gridStorageKey) return "";
      const I = t.gridUserKey ? String(t.gridUserKey) : "anonymous";
      return `finmony:fdatagrid:${t.gridStorageKey}:${I}`;
    }), b = k(() => {
      var G;
      if (!t.enableSearch) return [...t.data];
      const I = (G = r.value) == null ? void 0 : G.trim().toLowerCase();
      return I ? t.data.filter(
        (se) => Object.values(se ?? {}).some((W) => W == null ? !1 : String(W).toLowerCase().includes(I))
      ) : [...t.data];
    }), h = (I) => {
      var G;
      (G = I.column.getToggleGroupingHandler()) == null || G();
    }, x = (I, G) => {
      var se, W;
      I.column.getCanSort() && ((se = G.target) != null && se.closest(".f-datagrid__filter-input") || (W = I.column.getToggleSortingHandler()) == null || W(G));
    }, F = (I) => {
      var se;
      const G = (se = I.getFilterValue) == null ? void 0 : se.call(I);
      return G == null ? "" : typeof G == "string" ? G : String(G);
    }, C = (I) => I instanceof Date ? I.toISOString().toLowerCase() : String(I).toLowerCase(), A = (I, G, se) => {
      if (se == null || se === "") return !0;
      const W = I.getValue(G);
      return W == null ? !1 : C(W).includes(C(se));
    }, O = (I) => {
      const G = { ...I };
      return "columns" in G && Array.isArray(G.columns) && (G.columns = G.columns.map(O)), ("accessorKey" in G || typeof G.accessorFn == "function") && !G.filterFn && (G.filterFn = A), G;
    }, $ = k(() => (t.columns ?? []).map(O)), L = Ud({
      columns: $,
      data: b,
      pageSize: t.pageSize,
      pageSizeOptions: t.pageSizeOptions,
      pagination: k(() => D(t.pagination)),
      enableSorting: t.enableSorting,
      enableFiltering: t.enableFiltering,
      enablePagination: t.enablePagination,
      enableRowSelection: t.enableRowSelection,
      enableGrouping: t.enableGrouping,
      grouping: Ea(t, "grouping"),
      manualPagination: t.manualPagination,
      pageCount: k(() => D(t.pageCount)),
      onPaginationChange: (I) => {
        a("update:pagination", I), a("pagination-change", I);
      },
      onGroupingChange: (I) => {
        a("update:grouping", I);
      },
      onExpandedChange: (I) => {
      }
    }), N = L.table, K = L.pageSizeOptions, ue = (I) => {
      var W, ne, Ne;
      const G = (W = I == null ? void 0 : I.columnDef) == null ? void 0 : W.header, se = (Ne = (ne = I == null ? void 0 : I.columnDef) == null ? void 0 : ne.meta) == null ? void 0 : Ne.label;
      return typeof se == "string" && se.trim() ? se : typeof G == "string" && G.trim() ? G : (I == null ? void 0 : I.id) ?? "";
    }, B = k(() => N.getAllLeafColumns().map((I) => I.id)), Z = k(() => {
      const I = L.columnOrder.value.filter((se) => B.value.includes(se)), G = B.value.filter((se) => !I.includes(se));
      return [...I, ...G];
    }), R = k(() => {
      const I = new Map(N.getAllLeafColumns().map((G) => [G.id, G]));
      return Z.value.map((G) => I.get(G)).filter(Boolean).map((G) => ({
        id: G.id,
        label: ue(G),
        visible: G.getIsVisible()
      }));
    }), M = () => {
      const I = {};
      return (t.initialHiddenColumnIds ?? []).forEach((G) => {
        I[G] = !1;
      }), I;
    }, z = (I) => {
      const G = (I ?? []).filter((W) => B.value.includes(W)), se = B.value.filter((W) => !G.includes(W));
      return [...G, ...se];
    }, J = () => {
      if (!g.value || typeof window > "u") return null;
      try {
        const I = window.localStorage.getItem(g.value);
        return I ? JSON.parse(I) : null;
      } catch {
        return null;
      }
    }, H = (I) => {
      !g.value || typeof window > "u" || window.localStorage.setItem(g.value, JSON.stringify(I));
    }, le = () => ({
      searchQuery: r.value,
      columnFilters: [...L.columnFilters.value],
      columnVisibility: { ...L.columnVisibility.value },
      columnOrder: z(L.columnOrder.value),
      sorting: [...L.sorting.value],
      pageSize: N.getState().pagination.pageSize
    }), j = (I) => {
      d.value = !0;
      const G = {
        ...M(),
        ...(I == null ? void 0 : I.columnVisibility) ?? {}
      };
      r.value = (I == null ? void 0 : I.searchQuery) ?? "", L.columnFilters.value = I != null && I.columnFilters ? [...I.columnFilters] : [], N.setColumnFilters(L.columnFilters.value), L.columnVisibility.value = G, N.setColumnVisibility(G), L.columnOrder.value = z(I == null ? void 0 : I.columnOrder), N.setColumnOrder(L.columnOrder.value), L.sorting.value = I != null && I.sorting ? [...I.sorting] : [], N.setSorting(L.sorting.value), I != null && I.pageSize && L.setPageSize(Number(I.pageSize)), requestAnimationFrame(() => {
        d.value = !1;
      });
    }, q = () => {
      !g.value || d.value || H({
        version: 1,
        state: le(),
        activeTemplateName: s.value,
        templates: c.value
      });
    }, P = () => {
      const I = J();
      c.value = (I == null ? void 0 : I.templates) ?? [], s.value = (I == null ? void 0 : I.activeTemplateName) ?? "", I != null && I.state ? j(I.state) : (t.initialHiddenColumnIds ?? []).length > 0 ? j({ columnVisibility: M() }) : N.setColumnOrder(z());
    }, Q = (I) => {
      const G = N.getColumn(I);
      G && G.toggleVisibility(!G.getIsVisible());
    }, ce = (I) => {
      f.value = I;
    }, U = (I) => {
      const G = f.value;
      if (f.value = "", !G || G === I) return;
      const se = [...Z.value], W = se.indexOf(G), ne = se.indexOf(I);
      W < 0 || ne < 0 || (se.splice(W, 1), se.splice(ne, 0, G), L.columnOrder.value = se, N.setColumnOrder(se));
    }, ye = () => {
      const I = i.value.trim();
      if (!I) return;
      const G = {
        name: I,
        state: le(),
        updatedAt: (/* @__PURE__ */ new Date()).toISOString()
      };
      c.value = [
        ...c.value.filter((se) => se.name !== I),
        G
      ].sort((se, W) => se.name.localeCompare(W.name)), s.value = I, i.value = "", q();
    }, Ee = (I) => {
      u.value = I, m && clearTimeout(m), m = setTimeout(() => {
        u.value = "", m = null;
      }, 2500);
    }, qe = () => {
      const I = s.value.trim();
      if (!I) return;
      const G = le(), se = {
        name: I,
        state: G,
        updatedAt: (/* @__PURE__ */ new Date()).toISOString()
      };
      c.value = [
        ...c.value.filter((W) => W.name !== I),
        se
      ].sort((W, ne) => W.name.localeCompare(ne.name)), H({
        version: 1,
        state: G,
        activeTemplateName: I,
        templates: c.value
      }), Ee("Güncellendi");
    }, ie = (I) => {
      s.value = I.name, j(I.state), H({
        version: 1,
        state: I.state,
        activeTemplateName: s.value,
        templates: c.value
      });
    }, pe = (I) => {
      c.value = c.value.filter((G) => G.name !== I), s.value === I && (s.value = ""), q();
    }, fe = () => {
      s.value = "";
      const I = { columnVisibility: M(), columnOrder: B.value };
      j(I), H({
        version: 1,
        state: I,
        activeTemplateName: "",
        templates: c.value
      });
    }, ae = k(() => {
      var G, se;
      return (G = L.grouping) == null || G.value, (se = L.expanded) == null || se.value, N.getRowModel().rows;
    }), T = k(() => t.density === "compact" ? "px-3 py-2 text-sm" : "px-4 py-3 text-base"), te = k(() => {
      const I = ["transition-colors duration-150 !text-text-primary"];
      return t.zebra && I.push("even:!bg-gray-50 dark:even:!bg-gray-900"), I.push("hover:!bg-gray-100 dark:hover:!bg-gray-950"), I.join(" ");
    }), ke = (I) => {
      a("row-click", I.original);
    }, E = (I, G) => {
      a("row-contextmenu", I.original, G), v.value && (G.preventDefault(), y.value = {
        visible: !0,
        x: G.clientX,
        y: G.clientY,
        row: I.original
      });
    }, V = () => {
      y.value.visible && (y.value = { visible: !1, x: 0, y: 0, row: null });
    }, oe = (I) => {
      typeof I == "function" && I(y.value.row), V();
    }, Y = (I) => {
      const G = I.target;
      (l.value || o.value) && !G.closest(".f-datagrid__dynamic-tools") && (l.value = !1, o.value = !1), y.value.visible && (G.closest(".f-datagrid__context-menu") || V());
    };
    return He(() => {
      document.addEventListener("click", Y, !0), P();
    }), wt(() => {
      document.removeEventListener("click", Y, !0), m && clearTimeout(m);
    }), Be(r, () => {
      t.enableSearch && N.setPageIndex(0), q();
    }), Be(
      L.columnFilters,
      () => {
        t.enableFiltering && N.setPageIndex(0), q();
      },
      { deep: !0 }
    ), Be(
      L.sorting,
      (I) => {
        a("update:sorting", I), q();
      },
      { deep: !0 }
    ), Be(
      L.columnVisibility,
      () => {
        q();
      },
      { deep: !0 }
    ), Be(
      L.columnOrder,
      () => {
        q();
      },
      { deep: !0 }
    ), Be(
      L.pagination,
      () => {
        q();
      },
      { deep: !0 }
    ), L.grouping && Be(
      L.grouping,
      (I) => {
        a("update:grouping", I);
      },
      { deep: !0 }
    ), (I, G) => (p(), w("div", x2, [
      e.title || e.description ? (p(), w("div", k2, [
        _("p", C2, he(e.title), 1),
        e.description ? (p(), w("p", S2, he(e.description), 1)) : X("", !0)
      ])) : X("", !0),
      e.showToolbar || e.enableSearch || I.$slots.toolbar ? (p(), w("div", M2, [
        ge(I.$slots, "toolbar", {
          table: D(N),
          selection: D(L).rowSelection
        }),
        e.enableSearch ? (p(), w("div", E2, [
          Ae(Vr, {
            modelValue: r.value,
            "onUpdate:modelValue": G[0] || (G[0] = (se) => r.value = se),
            placeholder: e.searchPlaceholder,
            size: "sm"
          }, null, 8, ["modelValue", "placeholder"])
        ])) : X("", !0),
        S.value ? (p(), w("div", P2, [
          e.enableDynamicColumns ? (p(), w("div", $2, [
            Ae(on, {
              size: "sm",
              variant: "outline",
              onClick: G[1] || (G[1] = ot((se) => {
                l.value = !l.value, o.value = !1;
              }, ["stop"]))
            }, {
              default: xe(() => [...G[11] || (G[11] = [
                Qe(" Kolonlar ", -1)
              ])]),
              _: 1
            }),
            l.value ? (p(), w("div", {
              key: 0,
              class: "absolute left-0 top-full z-40 mt-2 w-[32rem] max-w-[calc(100vw-2rem)] rounded-lg border border-slate-200 bg-bg-primary p-3 shadow-lg dark:border-slate-700",
              onClick: G[3] || (G[3] = ot(() => {
              }, ["stop"]))
            }, [
              _("div", A2, [
                G[13] || (G[13] = _("span", { class: "text-sm font-semibold text-text-primary" }, "Kolonlar", -1)),
                Ae(on, {
                  size: "sm",
                  variant: "ghost",
                  onClick: fe
                }, {
                  default: xe(() => [...G[12] || (G[12] = [
                    Qe(" Sıfırla ", -1)
                  ])]),
                  _: 1
                })
              ]),
              _("div", T2, [
                (p(!0), w(_e, null, Ie(R.value, (se) => (p(), w("div", {
                  key: se.id,
                  class: "flex cursor-move items-start gap-2 rounded-md border border-slate-100 px-2 py-1.5 text-sm hover:bg-slate-50 dark:border-slate-800 dark:hover:bg-slate-900",
                  draggable: "true",
                  onDragstart: (W) => ce(se.id),
                  onDragover: G[2] || (G[2] = ot(() => {
                  }, ["prevent"])),
                  onDrop: ot((W) => U(se.id), ["prevent"])
                }, [
                  G[14] || (G[14] = _("span", { class: "select-none text-slate-400" }, "::", -1)),
                  _("input", {
                    type: "checkbox",
                    class: "mt-0.5 h-4 w-4",
                    checked: se.visible,
                    onChange: (W) => Q(se.id)
                  }, null, 40, R2),
                  _("span", O2, he(se.label), 1)
                ], 40, D2))), 128))
              ])
            ])) : X("", !0)
          ])) : X("", !0),
          e.enableFilterTemplates ? (p(), w("div", I2, [
            Ae(on, {
              size: "sm",
              variant: "outline",
              onClick: G[4] || (G[4] = ot((se) => {
                o.value = !o.value, l.value = !1;
              }, ["stop"]))
            }, {
              default: xe(() => [...G[15] || (G[15] = [
                Qe(" Şablonlar ", -1)
              ])]),
              _: 1
            }),
            o.value ? (p(), w("div", {
              key: 0,
              class: "absolute left-0 top-full z-40 mt-2 w-96 rounded-lg border border-slate-200 bg-bg-primary p-3 shadow-lg dark:border-slate-700",
              onClick: G[6] || (G[6] = ot(() => {
              }, ["stop"]))
            }, [
              _("div", F2, [
                Ae(Vr, {
                  modelValue: i.value,
                  "onUpdate:modelValue": G[5] || (G[5] = (se) => i.value = se),
                  placeholder: "Şablon adı",
                  size: "sm"
                }, null, 8, ["modelValue"]),
                Ae(on, {
                  size: "sm",
                  variant: "primary",
                  onClick: ye
                }, {
                  default: xe(() => [...G[16] || (G[16] = [
                    Qe(" Kaydet ", -1)
                  ])]),
                  _: 1
                })
              ]),
              s.value ? (p(), w("div", L2, [
                _("div", N2, [
                  _("span", V2, "Aktif: " + he(s.value), 1),
                  u.value ? (p(), w("span", B2, he(u.value), 1)) : X("", !0)
                ]),
                _("button", {
                  type: "button",
                  class: me(["inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border transition", u.value ? "border-green-200 bg-green-50 text-green-600 dark:border-green-800 dark:bg-green-950/30 dark:text-green-400" : "border-slate-200 text-slate-600 hover:border-primary hover:text-primary dark:border-slate-700 dark:text-slate-300"]),
                  title: "Seçili şablonu güncelle",
                  "aria-label": "Seçili şablonu güncelle",
                  onClick: qe
                }, [
                  Ae(ar, {
                    name: u.value ? "heroicons:check-20-solid" : "heroicons:pencil-square-20-solid",
                    class: "h-4 w-4"
                  }, null, 8, ["name"])
                ], 2)
              ])) : X("", !0),
              c.value.length === 0 ? (p(), w("div", H2, " Kayıtlı şablon yok. ")) : (p(), w("div", z2, [
                (p(!0), w(_e, null, Ie(c.value, (se) => (p(), w("div", {
                  key: se.name,
                  class: "flex items-center gap-2 rounded-md border border-slate-100 px-2 py-1.5 text-sm dark:border-slate-800"
                }, [
                  _("button", {
                    type: "button",
                    class: "min-w-0 flex-1 truncate text-left text-text-primary hover:text-primary",
                    onClick: (W) => ie(se)
                  }, he(se.name), 9, U2),
                  _("button", {
                    type: "button",
                    class: "inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-slate-500 transition hover:bg-red-50 hover:text-red-600 dark:text-slate-300 dark:hover:bg-red-950/30 dark:hover:text-red-300",
                    title: "Şablonu sil",
                    "aria-label": "Şablonu sil",
                    onClick: (W) => pe(se.name)
                  }, [
                    Ae(ar, {
                      name: "heroicons:trash-20-solid",
                      class: "h-4 w-4"
                    })
                  ], 8, Y2)
                ]))), 128))
              ]))
            ])) : X("", !0)
          ])) : X("", !0)
        ])) : X("", !0)
      ])) : X("", !0),
      _("div", j2, [
        _("table", Z2, [
          _("thead", {
            class: me(["bg-bg-secondary text-sm font-semibold text-text-primary", { "sticky top-0 z-10 shadow-sm": e.stickyHeader }])
          }, [
            (p(!0), w(_e, null, Ie(D(N).getHeaderGroups(), (se) => (p(), w("tr", {
              key: se.id
            }, [
              (p(!0), w(_e, null, Ie(se.headers, (W) => (p(), w("th", {
                key: W.id,
                colspan: W.colSpan,
                style: tt({
                  width: W.getSize() !== 150 ? `${W.getSize()}px` : void 0
                }),
                class: me(["border-b border-slate-200 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 dark:border-slate-700 dark:text-slate-300", { "cursor-pointer select-none": W.column.getCanSort() }]),
                onClick: (ne) => x(W, ne)
              }, [
                _("div", W2, [
                  _("div", q2, [
                    W.isPlaceholder ? X("", !0) : (p(), w("span", K2, [
                      Ae(D(Ma), {
                        render: W.column.columnDef.header,
                        props: W.getContext()
                      }, null, 8, ["render", "props"])
                    ])),
                    W.column.getIsSorted() ? (p(), w("span", X2, he(W.column.getIsSorted() === "asc" ? "▲" : "▼"), 1)) : X("", !0),
                    e.enableGrouping && W.column.getCanGroup() ? (p(), w("button", {
                      key: 2,
                      type: "button",
                      class: "ml-auto rounded px-1.5 py-0.5 text-[11px] font-medium text-slate-400 transition hover:bg-slate-100 hover:text-slate-600 dark:hover:bg-slate-700",
                      onClick: ot((ne) => h(W), ["stop"])
                    }, he(W.column.getIsGrouped() ? "Grup Kaldir" : "Grupla"), 9, Q2)) : X("", !0)
                  ]),
                  e.enableFiltering && W.column.getCanFilter() ? (p(), w("div", {
                    key: 0,
                    class: "f-datagrid__filter-input",
                    onClick: G[7] || (G[7] = ot(() => {
                    }, ["stop"]))
                  }, [
                    Ae(Vr, {
                      size: "sm",
                      "model-value": F(W.column),
                      placeholder: e.searchPlaceholder,
                      "input-class": "px-3 py-1.5 text-xs",
                      "onUpdate:modelValue": (ne) => W.column.setFilterValue(ne)
                    }, null, 8, ["model-value", "placeholder", "onUpdate:modelValue"])
                  ])) : X("", !0)
                ])
              ], 14, G2))), 128))
            ]))), 128))
          ], 2),
          _("tbody", null, [
            (p(!0), w(_e, null, Ie(ae.value, (se) => (p(), w("tr", {
              key: se.id,
              class: me(te.value),
              onClick: (W) => ke(se),
              onContextmenu: ot((W) => E(se, W), ["prevent", "stop"])
            }, [
              (p(!0), w(_e, null, Ie(se.getVisibleCells(), (W) => {
                var ne;
                return p(), w("td", {
                  key: W.id,
                  class: me(["border-b border-slate-100 dark:border-slate-800", T.value])
                }, [
                  W.getIsGrouped() ? (p(), w("div", ey, [
                    _("button", {
                      type: "button",
                      class: "rounded border border-slate-200 px-1 text-[11px] text-slate-500 transition hover:bg-slate-100 dark:border-slate-700 dark:hover:bg-slate-800",
                      onClick: ot((Ne) => {
                        var Ve;
                        return (Ve = se.getToggleExpandedHandler()) == null ? void 0 : Ve();
                      }, ["stop"])
                    }, he(se.getIsExpanded() ? "−" : "+"), 9, ty),
                    _("span", ny, [
                      Ae(D(Ma), {
                        render: W.column.columnDef.cell,
                        props: W.getContext()
                      }, null, 8, ["render", "props"])
                    ]),
                    _("span", ay, " (" + he(((ne = se.subRows) == null ? void 0 : ne.length) ?? 0) + ") ", 1)
                  ])) : W.getIsAggregated() ? (p(), Pe(D(Ma), {
                    key: 1,
                    render: W.column.columnDef.aggregatedCell ?? W.column.columnDef.cell,
                    props: W.getContext()
                  }, null, 8, ["render", "props"])) : W.getIsPlaceholder() ? (p(), w(_e, { key: 2 }, [], 64)) : (p(), Pe(D(Ma), {
                    key: 3,
                    render: W.column.columnDef.cell,
                    props: W.getContext()
                  }, null, 8, ["render", "props"]))
                ], 2);
              }), 128))
            ], 42, J2))), 128))
          ])
        ]),
        e.loading ? (p(), w("div", ry, [...G[17] || (G[17] = [
          _("span", { class: "text-sm font-medium text-slate-500" }, "Veriler yükleniyor...", -1)
        ])])) : X("", !0)
      ]),
      D(N).getRowModel().rows.length === 0 && !e.loading ? (p(), w("div", ly, he(e.emptyText), 1)) : X("", !0),
      e.enablePagination ? (p(), w("div", oy, [
        _("div", sy, [
          _("span", null, " Sayfa " + he(D(N).getState().pagination.pageIndex + 1) + " / " + he(Math.max(D(N).getPageCount(), 1)), 1),
          G[18] || (G[18] = _("span", { "aria-hidden": "true" }, "•", -1)),
          _("span", null, he(D(N).getFilteredSelectedRowModel().rows.length) + " seçildi", 1)
        ]),
        _("div", iy, [
          e.showPageSizeSelector ? (p(), Pe(oo, {
            key: 0,
            size: "sm",
            "options-placement": "top",
            "model-value": D(N).getState().pagination.pageSize,
            options: D(K).map((se) => ({ label: `${se} / sayfa`, value: se })),
            "onUpdate:modelValue": G[8] || (G[8] = (se) => D(L).setPageSize(Number(se)))
          }, null, 8, ["model-value", "options"])) : X("", !0),
          e.showPageNavigation ? (p(), w(_e, { key: 1 }, [
            Ae(on, {
              size: "sm",
              variant: "ghost",
              disabled: !D(N).getCanPreviousPage(),
              onClick: G[9] || (G[9] = (se) => D(N).previousPage())
            }, {
              default: xe(() => [...G[19] || (G[19] = [
                Qe(" Geri ", -1)
              ])]),
              _: 1
            }, 8, ["disabled"]),
            Ae(on, {
              size: "sm",
              variant: "ghost",
              disabled: !D(N).getCanNextPage(),
              onClick: G[10] || (G[10] = (se) => D(N).nextPage())
            }, {
              default: xe(() => [...G[20] || (G[20] = [
                Qe(" İleri ", -1)
              ])]),
              _: 1
            }, 8, ["disabled"])
          ], 64)) : X("", !0)
        ])
      ])) : X("", !0),
      y.value.visible && v.value ? (p(), w("div", {
        key: 4,
        class: "f-datagrid__context-menu fixed z-50 min-w-[180px] rounded-lg border border-slate-200 bg-bg-secondary py-1 shadow-lg",
        style: tt({ top: `${y.value.y}px`, left: `${y.value.x}px` })
      }, [
        (p(!0), w(_e, null, Ie(t.contextMenuItems, (se, W) => (p(), w("button", {
          key: W,
          type: "button",
          class: "flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-text-primary hover:bg-bg-primary",
          onClick: ot((ne) => oe(se == null ? void 0 : se.handler), ["stop"])
        }, [
          se != null && se.icon ? (p(), w("span", {
            key: 0,
            class: me(se.icon)
          }, null, 2)) : X("", !0),
          _("span", null, he(se == null ? void 0 : se.label), 1)
        ], 8, uy))), 128))
      ], 4)) : X("", !0)
    ]));
  }
}), dy = { class: "f-editable-grid rounded-3xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900" }, cy = { class: "relative overflow-x-auto rounded-2xl border border-slate-200 dark:border-slate-800" }, fy = { class: "w-full border-collapse text-left" }, my = ["colspan"], py = {
  key: 3,
  class: "mt-1 text-xs text-red-500"
}, vy = { class: "border-b border-slate-100 px-4 py-3 text-sm dark:border-slate-800" }, gy = { class: "flex items-center gap-2" }, hy = {
  key: 0,
  class: "mt-4 flex flex-wrap items-center justify-between gap-3 text-sm text-slate-500"
}, yy = { class: "flex flex-wrap items-center gap-2" }, Kb = /* @__PURE__ */ Ce({
  __name: "FEditableGrid",
  props: {
    pageSize: {},
    pageSizeOptions: {},
    enableSorting: { type: Boolean, default: !0 },
    enableFiltering: { type: Boolean, default: !1 },
    enablePagination: { type: Boolean, default: !0 },
    enableRowSelection: { type: Boolean, default: !1 },
    enableGrouping: { type: Boolean },
    enableExpanding: { type: Boolean },
    grouping: {},
    expanded: {},
    manualPagination: { type: Boolean, default: !1 },
    pageCount: {},
    pagination: {},
    columns: {},
    modelValue: {},
    rowKey: {},
    editableColumns: { default: () => [] },
    validators: { default: () => ({}) },
    stickyHeader: { type: Boolean, default: !0 },
    saveLabel: { default: "Kaydet" },
    cancelLabel: { default: "İptal" },
    editLabel: { default: "Düzenle" },
    saveIcon: {},
    cancelIcon: {},
    editIcon: {}
  },
  emits: ["update:modelValue", "row-save", "row-cancel", "update:pagination", "pagination-change"],
  setup(e, { emit: n }) {
    const t = e, a = n, r = Ud({
      columns: k(() => t.columns),
      data: k(() => t.modelValue),
      pageSize: t.pageSize,
      pageSizeOptions: t.pageSizeOptions,
      pagination: t.pagination,
      enableSorting: t.enableSorting,
      enableFiltering: t.enableFiltering,
      enablePagination: t.enablePagination,
      enableRowSelection: t.enableRowSelection,
      manualPagination: t.manualPagination,
      pageCount: t.pageCount,
      onPaginationChange: (O) => {
        a("update:pagination", O), a("pagination-change", O);
      }
    }), l = r.table, o = r.pageSizeOptions, i = ee(null), s = mr(null), u = ee({}), c = (O, $, L) => typeof t.rowKey == "function" ? t.rowKey(O, $) : typeof t.rowKey == "string" && t.rowKey in O ? O[t.rowKey] : L, f = (O, $) => {
      i.value = c(O.original, $, O.id), s.value = { ...O.original }, u.value = {};
    }, d = () => {
      i.value !== null && a("row-cancel", i.value), i.value = null, s.value = null, u.value = {};
    }, m = (O) => {
      const $ = F(O);
      return $ != null && $.valueType ? $.valueType : ($ == null ? void 0 : $.editor) === "number" ? "number" : "string";
    }, y = (O, $) => {
      const L = F(O);
      if (typeof L.parser == "function")
        return L.parser($, O);
      const N = m(O);
      if ($ === "" || $ === void 0 || $ === null)
        return N === "string" ? "" : null;
      switch (N) {
        case "number": {
          if (typeof $ == "number") return $;
          const K = Number($);
          return Number.isNaN(K) ? null : K;
        }
        case "boolean":
          return typeof $ == "boolean" ? $ : $ === "true" || $ === "1" || $ === 1 ? !0 : $ === "false" || $ === "0" || $ === 0 ? !1 : !!$;
        case "date": {
          if ($ instanceof Date) return $;
          const K = new Date($);
          return Number.isNaN(K.getTime()) ? null : K;
        }
        case "json": {
          if (typeof $ == "string")
            try {
              return JSON.parse($);
            } catch {
              return $;
            }
          return $;
        }
        default:
          return N === "any" || typeof $ == "string" ? $ : String($);
      }
    }, v = (O, $) => {
      if (!s.value) return;
      const L = A(O);
      L && (s.value = {
        ...s.value,
        [L]: y(O, $)
      });
    }, S = () => {
      if (!s.value) return !1;
      const O = {}, $ = t.validators ?? {};
      return Object.entries($).forEach(([L, N]) => {
        var ue;
        if (typeof N != "function") return;
        const K = N((ue = s.value) == null ? void 0 : ue[L], s.value);
        K && (O[L] = K);
      }), u.value = O, Object.keys(O).length === 0;
    }, g = () => {
      if (!s.value || i.value === null || !S()) return;
      const O = t.modelValue.map(($, L) => c($, L, String(L)) === i.value ? s.value : $);
      a("update:modelValue", O), a("row-save", s.value), i.value = null, s.value = null, u.value = {};
    }, b = (O, $) => {
      const L = c(O.original, $, O.id);
      return i.value === L;
    }, h = (O) => {
      const $ = O.meta;
      if (($ == null ? void 0 : $.editable) === !1) return !1;
      if ($ != null && $.editable) return !0;
      if (t.editableColumns.length === 0) return !1;
      const L = A(O);
      return L ? t.editableColumns.includes(L) : !1;
    }, x = (O) => {
      const $ = O.meta;
      return ($ == null ? void 0 : $.editor) ?? "text";
    }, F = (O) => O.meta ?? {}, C = (O) => u.value[O], A = (O) => O.accessorKey;
    return Be(
      () => t.modelValue,
      () => {
        i.value = null, s.value = null, u.value = {};
      }
    ), (O, $) => (p(), w("div", dy, [
      _("div", cy, [
        _("table", fy, [
          _("thead", {
            class: me(["bg-slate-50 text-sm font-semibold text-slate-500 dark:bg-slate-800 dark:text-slate-300", { "sticky top-0 z-10 shadow-sm": e.stickyHeader }])
          }, [
            (p(!0), w(_e, null, Ie(D(l).getHeaderGroups(), (L) => (p(), w("tr", {
              key: L.id
            }, [
              (p(!0), w(_e, null, Ie(L.headers, (N) => (p(), w("th", {
                key: N.id,
                colspan: N.colSpan,
                class: "border-b border-slate-200 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 dark:border-slate-700 dark:text-slate-300"
              }, [
                N.isPlaceholder ? X("", !0) : (p(), Pe(D(Ma), {
                  key: 0,
                  render: N.column.columnDef.header,
                  props: N.getContext()
                }, null, 8, ["render", "props"]))
              ], 8, my))), 128)),
              $[3] || ($[3] = _("th", { class: "border-b border-slate-200 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-slate-500 dark:border-slate-700 dark:text-slate-300" }, " Aksiyonlar ", -1))
            ]))), 128))
          ], 2),
          _("tbody", null, [
            (p(!0), w(_e, null, Ie(D(l).getRowModel().rows, (L, N) => (p(), w("tr", {
              key: L.id,
              class: "transition-colors duration-150 hover:bg-slate-50 dark:hover:bg-slate-800"
            }, [
              (p(!0), w(_e, null, Ie(L.getVisibleCells(), (K) => {
                var ue, B, Z;
                return p(), w("td", {
                  key: K.id,
                  class: "border-b border-slate-100 px-4 py-3 text-sm text-slate-700 dark:border-slate-800 dark:text-slate-100"
                }, [
                  b(L, N) && A(K.column.columnDef) && h(K.column.columnDef) ? (p(), w(_e, { key: 0 }, [
                    x(K.column.columnDef) === "select" ? (p(), Pe(oo, {
                      key: 0,
                      size: "sm",
                      options: F(K.column.columnDef).options ?? [],
                      "model-value": (ue = s.value) == null ? void 0 : ue[A(K.column.columnDef)],
                      "onUpdate:modelValue": (R) => v(K.column.columnDef, R)
                    }, null, 8, ["options", "model-value", "onUpdate:modelValue"])) : x(K.column.columnDef) === "textarea" ? (p(), Pe(Lp, {
                      key: 1,
                      rows: 3,
                      "model-value": (B = s.value) == null ? void 0 : B[A(K.column.columnDef)],
                      "onUpdate:modelValue": (R) => v(K.column.columnDef, R)
                    }, null, 8, ["model-value", "onUpdate:modelValue"])) : (p(), Pe(Vr, {
                      key: 2,
                      size: "sm",
                      type: x(K.column.columnDef) === "number" ? "number" : "text",
                      placeholder: F(K.column.columnDef).placeholder,
                      "model-value": (Z = s.value) == null ? void 0 : Z[A(K.column.columnDef)],
                      "onUpdate:modelValue": (R) => v(K.column.columnDef, R)
                    }, null, 8, ["type", "placeholder", "model-value", "onUpdate:modelValue"])),
                    C(A(K.column.columnDef)) ? (p(), w("p", py, he(C(A(K.column.columnDef))), 1)) : X("", !0)
                  ], 64)) : (p(), Pe(D(Ma), {
                    key: 1,
                    render: K.column.columnDef.cell,
                    props: K.getContext()
                  }, null, 8, ["render", "props"]))
                ]);
              }), 128)),
              _("td", vy, [
                _("div", gy, [
                  b(L, N) ? (p(), w(_e, { key: 0 }, [
                    Ae(on, {
                      size: "sm",
                      variant: "primary",
                      onClick: g
                    }, {
                      default: xe(() => [
                        Qe(he(e.saveLabel), 1)
                      ]),
                      _: 1
                    }),
                    Ae(on, {
                      size: "sm",
                      variant: "ghost",
                      onClick: d
                    }, {
                      default: xe(() => [
                        Qe(he(e.cancelLabel), 1)
                      ]),
                      _: 1
                    })
                  ], 64)) : (p(), Pe(on, {
                    key: 1,
                    size: "sm",
                    variant: "ghost",
                    onClick: (K) => f(L, N)
                  }, {
                    default: xe(() => [
                      Qe(he(e.editLabel), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                ])
              ])
            ]))), 128))
          ])
        ])
      ]),
      e.enablePagination ? (p(), w("div", hy, [
        _("span", null, " Sayfa " + he(D(l).getState().pagination.pageIndex + 1) + " / " + he(Math.max(D(l).getPageCount(), 1)), 1),
        _("div", yy, [
          Ae(oo, {
            size: "sm",
            "model-value": D(l).getState().pagination.pageSize,
            options: D(o).map((L) => ({ label: `${L} / sayfa`, value: L })),
            "onUpdate:modelValue": $[0] || ($[0] = (L) => D(r).setPageSize(Number(L)))
          }, null, 8, ["model-value", "options"]),
          Ae(on, {
            size: "sm",
            variant: "ghost",
            disabled: !D(l).getCanPreviousPage(),
            onClick: $[1] || ($[1] = (L) => D(l).previousPage())
          }, {
            default: xe(() => [...$[4] || ($[4] = [
              Qe(" Previous ", -1)
            ])]),
            _: 1
          }, 8, ["disabled"]),
          Ae(on, {
            size: "sm",
            variant: "ghost",
            disabled: !D(l).getCanNextPage(),
            onClick: $[2] || ($[2] = (L) => D(l).nextPage())
          }, {
            default: xe(() => [...$[5] || ($[5] = [
              Qe(" Next ", -1)
            ])]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])) : X("", !0)
    ]));
  }
}), wy = { class: "mx-auto flex h-full max-w-[1440px] items-center justify-between px-4 sm:px-6 lg:px-8" }, by = { class: "flex items-center gap-4" }, _y = ["aria-label"], xy = ["src", "alt"], ky = { class: "hidden flex-1 items-center justify-center gap-6 md:flex" }, Cy = { class: "flex items-center gap-4" }, Sy = ["aria-label", "aria-expanded"], My = {
  key: 0,
  class: "h-6 w-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, Ey = {
  key: 1,
  class: "h-6 w-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, Py = {
  key: 0,
  class: "border-t border-primary/10 bg-bg-primary md:hidden"
}, $y = { class: "space-y-1 px-4 pb-3 pt-2" }, Ay = { class: "border-t border-primary/10 px-4 py-3" }, Xb = /* @__PURE__ */ Ce({
  __name: "FNavbar",
  props: {
    logoSrc: {},
    logoAlt: { default: "Logo" },
    fixed: { type: Boolean, default: !1 },
    transparent: { type: Boolean, default: !1 },
    bordered: { type: Boolean, default: !0 },
    height: { default: "64px" }
  },
  emits: ["logo-click"],
  setup(e, { emit: n }) {
    const t = n, a = ee(!1), r = () => {
      a.value = !a.value;
    }, l = () => {
      t("logo-click");
    };
    return (o, i) => (p(), w("nav", {
      class: me(["w-full transition-all duration-200", {
        "fixed left-0 right-0 top-0 z-50": e.fixed,
        "bg-transparent backdrop-blur-md": e.transparent,
        "bg-bg-primary": !e.transparent,
        "border-b border-primary/10": e.bordered
      }]),
      style: tt({ height: e.height })
    }, [
      _("div", wy, [
        _("div", by, [
          ge(o.$slots, "logo", {}, () => [
            e.logoSrc ? (p(), w("button", {
              key: 0,
              class: "flex items-center rounded-md focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 dark:focus:ring-offset-black",
              "aria-label": e.logoAlt,
              onClick: l
            }, [
              _("img", {
                src: e.logoSrc,
                alt: e.logoAlt,
                class: "h-8 w-auto object-contain"
              }, null, 8, xy)
            ], 8, _y)) : X("", !0)
          ])
        ]),
        _("div", ky, [
          ge(o.$slots, "nav")
        ]),
        _("div", Cy, [
          ge(o.$slots, "actions"),
          _("button", {
            class: me(["fnavbar-mobile-toggle rounded-md p-2 text-primary transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 dark:focus:ring-offset-black", { "md:hidden": !0 }]),
            "aria-label": a.value ? "Close menu" : "Open menu",
            "aria-expanded": a.value,
            onClick: r
          }, [
            a.value ? (p(), w("svg", Ey, [...i[1] || (i[1] = [
              _("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M6 18L18 6M6 6l12 12"
              }, null, -1)
            ])])) : (p(), w("svg", My, [...i[0] || (i[0] = [
              _("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 6h16M4 12h16M4 18h16"
              }, null, -1)
            ])]))
          ], 8, Sy)
        ])
      ]),
      a.value ? (p(), w("div", Py, [
        _("div", $y, [
          ge(o.$slots, "mobile-nav", {}, () => [
            ge(o.$slots, "nav")
          ])
        ]),
        _("div", Ay, [
          ge(o.$slots, "mobile-actions", {}, () => [
            ge(o.$slots, "actions")
          ])
        ])
      ])) : X("", !0)
    ], 6));
  }
}), Qb = /* @__PURE__ */ Ce({
  __name: "FContainer",
  props: {
    maxWidth: { default: "xl" },
    padding: { default: "md" },
    centered: { type: Boolean, default: !1 },
    fluid: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = {
      sm: "max-w-screen-sm",
      md: "max-w-screen-md",
      lg: "max-w-screen-lg",
      xl: "max-w-[1440px]",
      "2xl": "max-w-screen-2xl",
      full: "max-w-full"
    }, t = {
      none: "",
      sm: "p-4 sm:p-6",
      md: "p-4 sm:p-6 lg:p-8",
      lg: "p-6 sm:p-8 lg:p-12"
    };
    return (a, r) => (p(), w("div", {
      class: me(["w-full bg-bg-primary rounded-2xl space-y-6", [
        e.fluid ? "" : n[e.maxWidth],
        t[e.padding],
        { "mx-auto": e.centered }
      ]])
    }, [
      ge(a.$slots, "default")
    ], 2));
  }
}), Ty = ["aria-label"], Dy = {
  key: 0,
  class: "h-5 w-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}, Ry = { class: "text-lg font-medium" }, Jb = /* @__PURE__ */ Ce({
  __name: "FSupportButton",
  props: {
    text: { default: "Support" },
    position: { default: "bottom-right" },
    offset: { default: "24px" },
    icon: { type: Boolean, default: !0 }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = n, a = {
      "bottom-right": "bottom-6 right-6",
      "bottom-left": "bottom-6 left-6",
      "top-right": "top-6 right-6",
      "top-left": "top-6 left-6"
    }, r = () => {
      t("click");
    };
    return (l, o) => (p(), w("button", {
      class: me(["fixed z-50 flex items-center gap-2 rounded-full bg-brand-primary px-6 py-3 text-white shadow-lg transition-all duration-200 hover:scale-105 hover:bg-brand-primary/90 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 active:scale-95 dark:focus:ring-offset-black motion-reduce:transition-none motion-reduce:hover:scale-100 motion-reduce:active:scale-100", a[e.position]]),
      style: tt({ "--offset": e.offset }),
      "aria-label": e.text,
      onClick: r
    }, [
      e.icon ? (p(), w("svg", Dy, [...o[0] || (o[0] = [
        _("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
        }, null, -1)
      ])])) : X("", !0),
      _("span", Ry, he(e.text), 1)
    ], 14, Ty));
  }
}), Oy = ["id", "aria-expanded", "aria-controls", "disabled", "onClick", "onKeydown"], Iy = { class: "flex items-center gap-2 flex-1" }, Fy = ["id", "aria-labelledby"], Ly = /* @__PURE__ */ Ce({
  __name: "FAccordion",
  props: {
    items: {},
    multiple: { type: Boolean, default: !1 },
    variant: { default: "default" },
    size: { default: "md" },
    icon: { default: "chevron" },
    defaultOpenAll: { type: Boolean, default: !1 }
  },
  emits: ["update:openItems", "item-opened", "item-closed"],
  setup(e, { emit: n }) {
    const t = e, a = n, r = ee(/* @__PURE__ */ new Set()), l = () => {
      const N = /* @__PURE__ */ new Set();
      t.defaultOpenAll ? t.items.forEach((K, ue) => {
        K.disabled || N.add(K.id || ue);
      }) : t.items.forEach((K, ue) => {
        K.defaultOpen && !K.disabled && N.add(K.id || ue);
      }), r.value = N;
    };
    l(), Be(() => t.items, () => {
      l();
    }, { deep: !0 });
    const o = (N) => r.value.has(N), i = (N) => {
      const K = t.items.find((ue, B) => (ue.id || B) === N);
      K != null && K.disabled || (r.value.has(N) ? (r.value.delete(N), a("item-closed", N)) : (t.multiple || r.value.clear(), r.value.add(N), a("item-opened", N)), a("update:openItems", Array.from(r.value)));
    }, s = (N, K) => {
      const { key: ue } = N;
      ue === "ArrowDown" ? (N.preventDefault(), u(K)) : ue === "ArrowUp" ? (N.preventDefault(), c(K)) : ue === "Home" ? (N.preventDefault(), f()) : ue === "End" && (N.preventDefault(), d());
    }, u = (N) => {
      var Z;
      const K = (N + 1) % t.items.length, B = t.items[K].id || K;
      (Z = document.getElementById(`accordion-header-${B}`)) == null || Z.focus();
    }, c = (N) => {
      var Z;
      const K = N === 0 ? t.items.length - 1 : N - 1, B = t.items[K].id || K;
      (Z = document.getElementById(`accordion-header-${B}`)) == null || Z.focus();
    }, f = () => {
      var ue;
      const K = t.items[0].id || 0;
      (ue = document.getElementById(`accordion-header-${K}`)) == null || ue.focus();
    }, d = () => {
      var B;
      const N = t.items.length - 1, ue = t.items[N].id || N;
      (B = document.getElementById(`accordion-header-${ue}`)) == null || B.focus();
    }, m = (N) => {
      const K = N;
      K.style.height = "0", K.style.overflow = "hidden";
    }, y = (N) => {
      const K = N;
      K.style.height = "auto", K.style.overflow = "visible";
    }, v = (N) => {
      const K = N;
      K.style.height = `${K.scrollHeight}px`, K.offsetHeight, K.style.height = "0", K.style.overflow = "hidden";
    }, S = (N) => {
      const K = N;
      K.style.height = "auto", K.style.overflow = "visible";
    }, g = k(() => ({
      "space-y-2": t.variant === "default",
      "border border-gray-200 dark:border-[#374151] rounded-lg divide-y divide-gray-200": t.variant === "bordered",
      "space-y-3": t.variant === "card"
    })), b = (N, K) => ({
      "transition-all duration-200": !0,
      "border border-gray-200 dark:border-[#374151] rounded-lg bg-gray-50 dark:bg-bg-secondary": t.variant === "card",
      "bg-gray-50 dark:bg-bg-secondary rounded-lg": t.variant === "default",
      "ring-4 ring-indigo-50 dark:ring-indigo-900 border-indigo-200 dark:border-indigo-800 shadow-sm": o(N.id || K)
    }), h = (N, K) => ({
      "flex items-center justify-between w-full text-left transition-colors focus:outline-none transition-all": !0,
      "bg-gray-50 dark:bg-bg-primary": !0,
      "hover:bg-gray-100 dark:hover:bg-gray-800": !N.disabled,
      "cursor-not-allowed opacity-50": N.disabled,
      "cursor-pointer": !N.disabled,
      "bg-gray-100 dark:bg-gray-800": o(N.id || K),
      "font-semibold text-text-primary": o(N.id || K),
      // Variant styles
      "px-4 py-3": !0,
      "border border-gray-200 dark:border-[#374151] rounded-lg": t.variant === "default" && !o(N.id || K),
      "border border-gray-200 dark:border-[#374151] rounded-t-lg": t.variant === "default" && o(N.id || K),
      "rounded-t-lg": t.variant === "card" && o(N.id || K),
      "rounded-lg": t.variant === "card" && !o(N.id || K),
      "border-b border-gray-200 dark:border-[#374151]": (t.variant === "bordered" || t.variant === "card") && o(N.id || K),
      // Size styles
      "text-sm": t.size === "sm",
      "text-base": t.size === "md",
      "text-lg": t.size === "lg"
    }), x = k(() => ({
      "h-4 w-4": t.size === "sm",
      "h-5 w-5": t.size === "md",
      "h-6 w-6": t.size === "lg",
      "text-text-secondary": !0
    })), F = k(() => ({
      "font-medium text-text-primary": !0
    })), C = (N) => ({
      "transition-transform duration-200 text-text-secondary": !0,
      "h-4 w-4": t.size === "sm",
      "h-5 w-5": t.size === "md",
      "h-6 w-6": t.size === "lg",
      "transform rotate-180": o(N) && t.icon === "chevron",
      "transform rotate-45": o(N) && t.icon === "plus"
    }), A = k(() => {
      switch (t.icon) {
        case "chevron":
          return "heroicons:chevron-down-20-solid";
        case "plus":
          return "heroicons:plus-20-solid";
        case "arrow":
          return "heroicons:arrow-down-20-solid";
        default:
          return "heroicons:chevron-down-20-solid";
      }
    }), O = k(() => ({
      "border-x border-b border-gray-200 dark:border-[#374151] rounded-b-lg overflow-visible": t.variant === "default",
      "overflow-visible": t.variant !== "default"
    })), $ = k(() => ({
      // Variant styles
      "px-4 pb-4 pt-4": !0,
      // Size styles
      "text-sm": t.size === "sm",
      "text-base": t.size === "md",
      "text-lg": t.size === "lg",
      "text-text-primary": !0
    })), L = k(() => "accordion-slide");
    return (N, K) => {
      const ue = fr("FIcon");
      return p(), w("div", {
        class: me(g.value)
      }, [
        (p(!0), w(_e, null, Ie(e.items, (B, Z) => (p(), w("div", {
          key: B.id || Z,
          class: me(b(B, Z)),
          style: tt({ zIndex: o(B.id || Z) ? 100 + e.items.length - Z : e.items.length - Z, position: "relative" })
        }, [
          _("button", {
            id: `accordion-header-${B.id || Z}`,
            type: "button",
            class: me(h(B, Z)),
            "aria-expanded": o(B.id || Z),
            "aria-controls": `accordion-content-${B.id || Z}`,
            disabled: B.disabled,
            onClick: (R) => i(B.id || Z),
            onKeydown: (R) => s(R, Z)
          }, [
            ge(N.$slots, "title", {
              item: B,
              index: Z,
              isOpen: o(B.id || Z)
            }, () => [
              _("div", Iy, [
                B.icon ? (p(), Pe(ue, {
                  key: 0,
                  name: B.icon,
                  class: me(x.value)
                }, null, 8, ["name", "class"])) : X("", !0),
                _("span", {
                  class: me(F.value)
                }, he(B.title), 3)
              ])
            ], !0),
            Ae(ue, {
              name: A.value,
              class: me(C(B.id || Z))
            }, null, 8, ["name", "class"])
          ], 42, Oy),
          Ae(Pn, {
            name: L.value,
            onEnter: m,
            onAfterEnter: y,
            onLeave: v,
            onAfterLeave: S
          }, {
            default: xe(() => [
              On(_("div", {
                id: `accordion-content-${B.id || Z}`,
                class: me(O.value),
                role: "region",
                "aria-labelledby": `accordion-header-${B.id || Z}`
              }, [
                _("div", {
                  class: me($.value)
                }, [
                  ge(N.$slots, "content", {
                    item: B,
                    index: Z
                  }, () => [
                    Qe(he(B.content), 1)
                  ], !0)
                ], 2)
              ], 10, Fy), [
                [Qa, o(B.id || Z)]
              ])
            ]),
            _: 2
          }, 1032, ["name"])
        ], 6))), 128))
      ], 2);
    };
  }
}), e3 = /* @__PURE__ */ el(Ly, [["__scopeId", "data-v-b2534e90"]]);
/*!
  * shared v11.2.2
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function En(e, n) {
  typeof console < "u" && (console.warn("[intlify] " + e), n && console.warn(n.stack));
}
const Ai = {};
function Ny(e) {
  Ai[e] || (Ai[e] = !0, En(e));
}
const Fn = typeof window < "u";
let qt, pa;
if (process.env.NODE_ENV !== "production") {
  const e = Fn && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (qt = (n) => {
    e.mark(n);
  }, pa = (n, t, a) => {
    e.measure(n, t, a), e.clearMarks(t), e.clearMarks(a);
  });
}
const Vy = /\{([0-9a-zA-Z]+)\}/g;
function dl(e, ...n) {
  return n.length === 1 && Ge(n[0]) && (n = n[0]), (!n || !n.hasOwnProperty) && (n = {}), e.replace(Vy, (t, a) => n.hasOwnProperty(a) ? n[a] : "");
}
const Nn = (e, n = !1) => n ? Symbol.for(e) : Symbol(e), By = (e, n, t) => Hy({ l: e, k: n, s: t }), Hy = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), _t = (e) => typeof e == "number" && isFinite(e), zy = (e) => rs(e) === "[object Date]", Wr = (e) => rs(e) === "[object RegExp]", cl = (e) => Ze(e) && Object.keys(e).length === 0, St = Object.assign, Uy = Object.create, Je = (e = null) => Uy(e);
let Ti;
const da = () => Ti || (Ti = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : Je());
function Di(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function Ri(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Yy(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (a, r, l) => `${r}="${Ri(l)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (a, r, l) => `${r}='${Ri(l)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && En("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((a) => {
    e = e.replace(a, "$1javascript&#58;");
  }), e;
}
const jy = Object.prototype.hasOwnProperty;
function dn(e, n) {
  return jy.call(e, n);
}
const pt = Array.isArray, rt = (e) => typeof e == "function", Me = (e) => typeof e == "string", mt = (e) => typeof e == "boolean", Ge = (e) => e !== null && typeof e == "object", Zy = (e) => Ge(e) && rt(e.then) && rt(e.catch), Yd = Object.prototype.toString, rs = (e) => Yd.call(e), Ze = (e) => rs(e) === "[object Object]", Gy = (e) => e == null ? "" : pt(e) || Ze(e) && e.toString === Yd ? JSON.stringify(e, null, 2) : String(e);
function ls(e, n = "") {
  return e.reduce((t, a, r) => r === 0 ? t + a : t + n + a, "");
}
const Oi = 2;
function Wy(e, n = 0, t = e.length) {
  const a = e.split(/\r?\n/);
  let r = 0;
  const l = [];
  for (let o = 0; o < a.length; o++)
    if (r += a[o].length + 1, r >= n) {
      for (let i = o - Oi; i <= o + Oi || t > r; i++) {
        if (i < 0 || i >= a.length)
          continue;
        const s = i + 1;
        l.push(`${s}${" ".repeat(3 - String(s).length)}|  ${a[i]}`);
        const u = a[i].length;
        if (i === o) {
          const c = n - (r - u) + 1, f = Math.max(1, t > r ? u - c : t - n);
          l.push("   |  " + " ".repeat(c) + "^".repeat(f));
        } else if (i > o) {
          if (t > r) {
            const c = Math.max(Math.min(t - r, u), 1);
            l.push("   |  " + "^".repeat(c));
          }
          r += u + 1;
        }
      }
      break;
    }
  return l.join(`
`);
}
function qy() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(t, a) {
      const r = e.get(t);
      r && r.push(a) || e.set(t, [a]);
    },
    off(t, a) {
      const r = e.get(t);
      r && r.splice(r.indexOf(a) >>> 0, 1);
    },
    emit(t, a) {
      (e.get(t) || []).slice().map((r) => r(a)), (e.get("*") || []).slice().map((r) => r(t, a));
    }
  };
}
const Rr = (e) => !Ge(e) || pt(e);
function Hr(e, n) {
  if (Rr(e) || Rr(n))
    throw new Error("Invalid value");
  const t = [{ src: e, des: n }];
  for (; t.length; ) {
    const { src: a, des: r } = t.pop();
    Object.keys(a).forEach((l) => {
      l !== "__proto__" && (Ge(a[l]) && !Ge(r[l]) && (r[l] = Array.isArray(a[l]) ? [] : Je()), Rr(r[l]) || Rr(a[l]) ? r[l] = a[l] : t.push({ src: a[l], des: r[l] }));
    });
  }
}
/*!
  * message-compiler v11.2.2
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Ky(e, n, t) {
  return { line: e, column: n, offset: t };
}
function wo(e, n, t) {
  return { start: e, end: n };
}
const Fe = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, Xy = 17, Qy = {
  // tokenizer error messages
  [Fe.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [Fe.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [Fe.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [Fe.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [Fe.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [Fe.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [Fe.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [Fe.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [Fe.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [Fe.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [Fe.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [Fe.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [Fe.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [Fe.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [Fe.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [Fe.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Na(e, n, t = {}) {
  const { domain: a, messages: r, args: l } = t, o = process.env.NODE_ENV !== "production" ? dl((r || Qy)[e] || "", ...l || []) : e, i = new SyntaxError(String(o));
  return i.code = e, n && (i.location = n), i.domain = a, i;
}
function Jy(e) {
  throw e;
}
const e7 = /<\/?[\w\s="/.':;#-\/]+>/, t7 = (e) => e7.test(e), bn = " ", n7 = "\r", Dt = `
`, a7 = "\u2028", r7 = "\u2029";
function l7(e) {
  const n = e;
  let t = 0, a = 1, r = 1, l = 0;
  const o = (A) => n[A] === n7 && n[A + 1] === Dt, i = (A) => n[A] === Dt, s = (A) => n[A] === r7, u = (A) => n[A] === a7, c = (A) => o(A) || i(A) || s(A) || u(A), f = () => t, d = () => a, m = () => r, y = () => l, v = (A) => o(A) || s(A) || u(A) ? Dt : n[A], S = () => v(t), g = () => v(t + l);
  function b() {
    return l = 0, c(t) && (a++, r = 0), o(t) && t++, t++, r++, n[t];
  }
  function h() {
    return o(t + l) && l++, l++, n[t + l];
  }
  function x() {
    t = 0, a = 1, r = 1, l = 0;
  }
  function F(A = 0) {
    l = A;
  }
  function C() {
    const A = t + l;
    for (; A !== t; )
      b();
    l = 0;
  }
  return {
    index: f,
    line: d,
    column: m,
    peekOffset: y,
    charAt: v,
    currentChar: S,
    currentPeek: g,
    next: b,
    peek: h,
    reset: x,
    resetPeek: F,
    skipToPeek: C
  };
}
const $n = void 0, o7 = ".", Ii = "'", s7 = "tokenizer";
function i7(e, n = {}) {
  const t = n.location !== !1, a = l7(e), r = () => a.index(), l = () => Ky(a.line(), a.column(), a.index()), o = l(), i = r(), s = {
    currentType: 13,
    offset: i,
    startLoc: o,
    endLoc: o,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: o,
    lastEndLoc: o,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, u = () => s, { onError: c } = n;
  function f(E, V, oe, ...Y) {
    const I = u();
    if (V.column += oe, V.offset += oe, c) {
      const G = t ? wo(I.startLoc, V) : null, se = Na(E, G, {
        domain: s7,
        args: Y
      });
      c(se);
    }
  }
  function d(E, V, oe) {
    E.endLoc = l(), E.currentType = V;
    const Y = { type: V };
    return t && (Y.loc = wo(E.startLoc, E.endLoc)), oe != null && (Y.value = oe), Y;
  }
  const m = (E) => d(
    E,
    13
    /* TokenTypes.EOF */
  );
  function y(E, V) {
    return E.currentChar() === V ? (E.next(), V) : (f(Fe.EXPECTED_TOKEN, l(), 0, V), "");
  }
  function v(E) {
    let V = "";
    for (; E.currentPeek() === bn || E.currentPeek() === Dt; )
      V += E.currentPeek(), E.peek();
    return V;
  }
  function S(E) {
    const V = v(E);
    return E.skipToPeek(), V;
  }
  function g(E) {
    if (E === $n)
      return !1;
    const V = E.charCodeAt(0);
    return V >= 97 && V <= 122 || // a-z
    V >= 65 && V <= 90 || // A-Z
    V === 95;
  }
  function b(E) {
    if (E === $n)
      return !1;
    const V = E.charCodeAt(0);
    return V >= 48 && V <= 57;
  }
  function h(E, V) {
    const { currentType: oe } = V;
    if (oe !== 2)
      return !1;
    v(E);
    const Y = g(E.currentPeek());
    return E.resetPeek(), Y;
  }
  function x(E, V) {
    const { currentType: oe } = V;
    if (oe !== 2)
      return !1;
    v(E);
    const Y = E.currentPeek() === "-" ? E.peek() : E.currentPeek(), I = b(Y);
    return E.resetPeek(), I;
  }
  function F(E, V) {
    const { currentType: oe } = V;
    if (oe !== 2)
      return !1;
    v(E);
    const Y = E.currentPeek() === Ii;
    return E.resetPeek(), Y;
  }
  function C(E, V) {
    const { currentType: oe } = V;
    if (oe !== 7)
      return !1;
    v(E);
    const Y = E.currentPeek() === ".";
    return E.resetPeek(), Y;
  }
  function A(E, V) {
    const { currentType: oe } = V;
    if (oe !== 8)
      return !1;
    v(E);
    const Y = g(E.currentPeek());
    return E.resetPeek(), Y;
  }
  function O(E, V) {
    const { currentType: oe } = V;
    if (!(oe === 7 || oe === 11))
      return !1;
    v(E);
    const Y = E.currentPeek() === ":";
    return E.resetPeek(), Y;
  }
  function $(E, V) {
    const { currentType: oe } = V;
    if (oe !== 9)
      return !1;
    const Y = () => {
      const G = E.currentPeek();
      return G === "{" ? g(E.peek()) : G === "@" || G === "|" || G === ":" || G === "." || G === bn || !G ? !1 : G === Dt ? (E.peek(), Y()) : N(E, !1);
    }, I = Y();
    return E.resetPeek(), I;
  }
  function L(E) {
    v(E);
    const V = E.currentPeek() === "|";
    return E.resetPeek(), V;
  }
  function N(E, V = !0) {
    const oe = (I = !1, G = "") => {
      const se = E.currentPeek();
      return se === "{" || se === "@" || !se ? I : se === "|" ? !(G === bn || G === Dt) : se === bn ? (E.peek(), oe(!0, bn)) : se === Dt ? (E.peek(), oe(!0, Dt)) : !0;
    }, Y = oe();
    return V && E.resetPeek(), Y;
  }
  function K(E, V) {
    const oe = E.currentChar();
    return oe === $n ? $n : V(oe) ? (E.next(), oe) : null;
  }
  function ue(E) {
    const V = E.charCodeAt(0);
    return V >= 97 && V <= 122 || // a-z
    V >= 65 && V <= 90 || // A-Z
    V >= 48 && V <= 57 || // 0-9
    V === 95 || // _
    V === 36;
  }
  function B(E) {
    return K(E, ue);
  }
  function Z(E) {
    const V = E.charCodeAt(0);
    return V >= 97 && V <= 122 || // a-z
    V >= 65 && V <= 90 || // A-Z
    V >= 48 && V <= 57 || // 0-9
    V === 95 || // _
    V === 36 || // $
    V === 45;
  }
  function R(E) {
    return K(E, Z);
  }
  function M(E) {
    const V = E.charCodeAt(0);
    return V >= 48 && V <= 57;
  }
  function z(E) {
    return K(E, M);
  }
  function J(E) {
    const V = E.charCodeAt(0);
    return V >= 48 && V <= 57 || // 0-9
    V >= 65 && V <= 70 || // A-F
    V >= 97 && V <= 102;
  }
  function H(E) {
    return K(E, J);
  }
  function le(E) {
    let V = "", oe = "";
    for (; V = z(E); )
      oe += V;
    return oe;
  }
  function j(E) {
    let V = "";
    for (; ; ) {
      const oe = E.currentChar();
      if (oe === "{" || oe === "}" || oe === "@" || oe === "|" || !oe)
        break;
      if (oe === bn || oe === Dt)
        if (N(E))
          V += oe, E.next();
        else {
          if (L(E))
            break;
          V += oe, E.next();
        }
      else
        V += oe, E.next();
    }
    return V;
  }
  function q(E) {
    S(E);
    let V = "", oe = "";
    for (; V = R(E); )
      oe += V;
    const Y = E.currentChar();
    if (Y && Y !== "}" && Y !== $n && Y !== bn && Y !== Dt && Y !== "　") {
      const I = qe(E);
      return f(Fe.INVALID_TOKEN_IN_PLACEHOLDER, l(), 0, oe + I), oe + I;
    }
    return E.currentChar() === $n && f(Fe.UNTERMINATED_CLOSING_BRACE, l(), 0), oe;
  }
  function P(E) {
    S(E);
    let V = "";
    return E.currentChar() === "-" ? (E.next(), V += `-${le(E)}`) : V += le(E), E.currentChar() === $n && f(Fe.UNTERMINATED_CLOSING_BRACE, l(), 0), V;
  }
  function Q(E) {
    return E !== Ii && E !== Dt;
  }
  function ce(E) {
    S(E), y(E, "'");
    let V = "", oe = "";
    for (; V = K(E, Q); )
      V === "\\" ? oe += U(E) : oe += V;
    const Y = E.currentChar();
    return Y === Dt || Y === $n ? (f(Fe.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, l(), 0), Y === Dt && (E.next(), y(E, "'")), oe) : (y(E, "'"), oe);
  }
  function U(E) {
    const V = E.currentChar();
    switch (V) {
      case "\\":
      case "'":
        return E.next(), `\\${V}`;
      case "u":
        return ye(E, V, 4);
      case "U":
        return ye(E, V, 6);
      default:
        return f(Fe.UNKNOWN_ESCAPE_SEQUENCE, l(), 0, V), "";
    }
  }
  function ye(E, V, oe) {
    y(E, V);
    let Y = "";
    for (let I = 0; I < oe; I++) {
      const G = H(E);
      if (!G) {
        f(Fe.INVALID_UNICODE_ESCAPE_SEQUENCE, l(), 0, `\\${V}${Y}${E.currentChar()}`);
        break;
      }
      Y += G;
    }
    return `\\${V}${Y}`;
  }
  function Ee(E) {
    return E !== "{" && E !== "}" && E !== bn && E !== Dt;
  }
  function qe(E) {
    S(E);
    let V = "", oe = "";
    for (; V = K(E, Ee); )
      oe += V;
    return oe;
  }
  function ie(E) {
    let V = "", oe = "";
    for (; V = B(E); )
      oe += V;
    return oe;
  }
  function pe(E) {
    const V = (oe) => {
      const Y = E.currentChar();
      return Y === "{" || Y === "@" || Y === "|" || Y === "(" || Y === ")" || !Y || Y === bn ? oe : (oe += Y, E.next(), V(oe));
    };
    return V("");
  }
  function fe(E) {
    S(E);
    const V = y(
      E,
      "|"
      /* TokenChars.Pipe */
    );
    return S(E), V;
  }
  function ae(E, V) {
    let oe = null;
    switch (E.currentChar()) {
      case "{":
        return V.braceNest >= 1 && f(Fe.NOT_ALLOW_NEST_PLACEHOLDER, l(), 0), E.next(), oe = d(
          V,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), S(E), V.braceNest++, oe;
      case "}":
        return V.braceNest > 0 && V.currentType === 2 && f(Fe.EMPTY_PLACEHOLDER, l(), 0), E.next(), oe = d(
          V,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), V.braceNest--, V.braceNest > 0 && S(E), V.inLinked && V.braceNest === 0 && (V.inLinked = !1), oe;
      case "@":
        return V.braceNest > 0 && f(Fe.UNTERMINATED_CLOSING_BRACE, l(), 0), oe = T(E, V) || m(V), V.braceNest = 0, oe;
      default: {
        let I = !0, G = !0, se = !0;
        if (L(E))
          return V.braceNest > 0 && f(Fe.UNTERMINATED_CLOSING_BRACE, l(), 0), oe = d(V, 1, fe(E)), V.braceNest = 0, V.inLinked = !1, oe;
        if (V.braceNest > 0 && (V.currentType === 4 || V.currentType === 5 || V.currentType === 6))
          return f(Fe.UNTERMINATED_CLOSING_BRACE, l(), 0), V.braceNest = 0, te(E, V);
        if (I = h(E, V))
          return oe = d(V, 4, q(E)), S(E), oe;
        if (G = x(E, V))
          return oe = d(V, 5, P(E)), S(E), oe;
        if (se = F(E, V))
          return oe = d(V, 6, ce(E)), S(E), oe;
        if (!I && !G && !se)
          return oe = d(V, 12, qe(E)), f(Fe.INVALID_TOKEN_IN_PLACEHOLDER, l(), 0, oe.value), S(E), oe;
        break;
      }
    }
    return oe;
  }
  function T(E, V) {
    const { currentType: oe } = V;
    let Y = null;
    const I = E.currentChar();
    switch ((oe === 7 || oe === 8 || oe === 11 || oe === 9) && (I === Dt || I === bn) && f(Fe.INVALID_LINKED_FORMAT, l(), 0), I) {
      case "@":
        return E.next(), Y = d(
          V,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), V.inLinked = !0, Y;
      case ".":
        return S(E), E.next(), d(
          V,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return S(E), E.next(), d(
          V,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return L(E) ? (Y = d(V, 1, fe(E)), V.braceNest = 0, V.inLinked = !1, Y) : C(E, V) || O(E, V) ? (S(E), T(E, V)) : A(E, V) ? (S(E), d(V, 11, ie(E))) : $(E, V) ? (S(E), I === "{" ? ae(E, V) || Y : d(V, 10, pe(E))) : (oe === 7 && f(Fe.INVALID_LINKED_FORMAT, l(), 0), V.braceNest = 0, V.inLinked = !1, te(E, V));
    }
  }
  function te(E, V) {
    let oe = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (V.braceNest > 0)
      return ae(E, V) || m(V);
    if (V.inLinked)
      return T(E, V) || m(V);
    switch (E.currentChar()) {
      case "{":
        return ae(E, V) || m(V);
      case "}":
        return f(Fe.UNBALANCED_CLOSING_BRACE, l(), 0), E.next(), d(
          V,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return T(E, V) || m(V);
      default: {
        if (L(E))
          return oe = d(V, 1, fe(E)), V.braceNest = 0, V.inLinked = !1, oe;
        if (N(E))
          return d(V, 0, j(E));
        break;
      }
    }
    return oe;
  }
  function ke() {
    const { currentType: E, offset: V, startLoc: oe, endLoc: Y } = s;
    return s.lastType = E, s.lastOffset = V, s.lastStartLoc = oe, s.lastEndLoc = Y, s.offset = r(), s.startLoc = l(), a.currentChar() === $n ? d(
      s,
      13
      /* TokenTypes.EOF */
    ) : te(a, s);
  }
  return {
    nextToken: ke,
    currentOffset: r,
    currentPosition: l,
    context: u
  };
}
const u7 = "parser", d7 = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function c7(e, n, t) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const a = parseInt(n || t, 16);
      return a <= 55295 || a >= 57344 ? String.fromCodePoint(a) : "�";
    }
  }
}
function f7(e = {}) {
  const n = e.location !== !1, { onError: t } = e;
  function a(g, b, h, x, ...F) {
    const C = g.currentPosition();
    if (C.offset += x, C.column += x, t) {
      const A = n ? wo(h, C) : null, O = Na(b, A, {
        domain: u7,
        args: F
      });
      t(O);
    }
  }
  function r(g, b, h) {
    const x = { type: g };
    return n && (x.start = b, x.end = b, x.loc = { start: h, end: h }), x;
  }
  function l(g, b, h, x) {
    n && (g.end = b, g.loc && (g.loc.end = h));
  }
  function o(g, b) {
    const h = g.context(), x = r(3, h.offset, h.startLoc);
    return x.value = b, l(x, g.currentOffset(), g.currentPosition()), x;
  }
  function i(g, b) {
    const h = g.context(), { lastOffset: x, lastStartLoc: F } = h, C = r(5, x, F);
    return C.index = parseInt(b, 10), g.nextToken(), l(C, g.currentOffset(), g.currentPosition()), C;
  }
  function s(g, b) {
    const h = g.context(), { lastOffset: x, lastStartLoc: F } = h, C = r(4, x, F);
    return C.key = b, g.nextToken(), l(C, g.currentOffset(), g.currentPosition()), C;
  }
  function u(g, b) {
    const h = g.context(), { lastOffset: x, lastStartLoc: F } = h, C = r(9, x, F);
    return C.value = b.replace(d7, c7), g.nextToken(), l(C, g.currentOffset(), g.currentPosition()), C;
  }
  function c(g) {
    const b = g.nextToken(), h = g.context(), { lastOffset: x, lastStartLoc: F } = h, C = r(8, x, F);
    return b.type !== 11 ? (a(g, Fe.UNEXPECTED_EMPTY_LINKED_MODIFIER, h.lastStartLoc, 0), C.value = "", l(C, x, F), {
      nextConsumeToken: b,
      node: C
    }) : (b.value == null && a(g, Fe.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, _n(b)), C.value = b.value || "", l(C, g.currentOffset(), g.currentPosition()), {
      node: C
    });
  }
  function f(g, b) {
    const h = g.context(), x = r(7, h.offset, h.startLoc);
    return x.value = b, l(x, g.currentOffset(), g.currentPosition()), x;
  }
  function d(g) {
    const b = g.context(), h = r(6, b.offset, b.startLoc);
    let x = g.nextToken();
    if (x.type === 8) {
      const F = c(g);
      h.modifier = F.node, x = F.nextConsumeToken || g.nextToken();
    }
    switch (x.type !== 9 && a(g, Fe.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, _n(x)), x = g.nextToken(), x.type === 2 && (x = g.nextToken()), x.type) {
      case 10:
        x.value == null && a(g, Fe.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, _n(x)), h.key = f(g, x.value || "");
        break;
      case 4:
        x.value == null && a(g, Fe.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, _n(x)), h.key = s(g, x.value || "");
        break;
      case 5:
        x.value == null && a(g, Fe.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, _n(x)), h.key = i(g, x.value || "");
        break;
      case 6:
        x.value == null && a(g, Fe.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, _n(x)), h.key = u(g, x.value || "");
        break;
      default: {
        a(g, Fe.UNEXPECTED_EMPTY_LINKED_KEY, b.lastStartLoc, 0);
        const F = g.context(), C = r(7, F.offset, F.startLoc);
        return C.value = "", l(C, F.offset, F.startLoc), h.key = C, l(h, F.offset, F.startLoc), {
          nextConsumeToken: x,
          node: h
        };
      }
    }
    return l(h, g.currentOffset(), g.currentPosition()), {
      node: h
    };
  }
  function m(g) {
    const b = g.context(), h = b.currentType === 1 ? g.currentOffset() : b.offset, x = b.currentType === 1 ? b.endLoc : b.startLoc, F = r(2, h, x);
    F.items = [];
    let C = null;
    do {
      const $ = C || g.nextToken();
      switch (C = null, $.type) {
        case 0:
          $.value == null && a(g, Fe.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, _n($)), F.items.push(o(g, $.value || ""));
          break;
        case 5:
          $.value == null && a(g, Fe.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, _n($)), F.items.push(i(g, $.value || ""));
          break;
        case 4:
          $.value == null && a(g, Fe.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, _n($)), F.items.push(s(g, $.value || ""));
          break;
        case 6:
          $.value == null && a(g, Fe.UNEXPECTED_LEXICAL_ANALYSIS, b.lastStartLoc, 0, _n($)), F.items.push(u(g, $.value || ""));
          break;
        case 7: {
          const L = d(g);
          F.items.push(L.node), C = L.nextConsumeToken || null;
          break;
        }
      }
    } while (b.currentType !== 13 && b.currentType !== 1);
    const A = b.currentType === 1 ? b.lastOffset : g.currentOffset(), O = b.currentType === 1 ? b.lastEndLoc : g.currentPosition();
    return l(F, A, O), F;
  }
  function y(g, b, h, x) {
    const F = g.context();
    let C = x.items.length === 0;
    const A = r(1, b, h);
    A.cases = [], A.cases.push(x);
    do {
      const O = m(g);
      C || (C = O.items.length === 0), A.cases.push(O);
    } while (F.currentType !== 13);
    return C && a(g, Fe.MUST_HAVE_MESSAGES_IN_PLURAL, h, 0), l(A, g.currentOffset(), g.currentPosition()), A;
  }
  function v(g) {
    const b = g.context(), { offset: h, startLoc: x } = b, F = m(g);
    return b.currentType === 13 ? F : y(g, h, x, F);
  }
  function S(g) {
    const b = i7(g, St({}, e)), h = b.context(), x = r(0, h.offset, h.startLoc);
    return n && x.loc && (x.loc.source = g), x.body = v(b), e.onCacheKey && (x.cacheKey = e.onCacheKey(g)), h.currentType !== 13 && a(b, Fe.UNEXPECTED_LEXICAL_ANALYSIS, h.lastStartLoc, 0, g[h.offset] || ""), l(x, b.currentOffset(), b.currentPosition()), x;
  }
  return { parse: S };
}
function _n(e) {
  if (e.type === 13)
    return "EOF";
  const n = (e.value || "").replace(/\r?\n/gu, "\\n");
  return n.length > 10 ? n.slice(0, 9) + "…" : n;
}
function m7(e, n = {}) {
  const t = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => t, helper: (l) => (t.helpers.add(l), l) };
}
function Fi(e, n) {
  for (let t = 0; t < e.length; t++)
    os(e[t], n);
}
function os(e, n) {
  switch (e.type) {
    case 1:
      Fi(e.cases, n), n.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Fi(e.items, n);
      break;
    case 6: {
      os(e.key, n), n.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), n.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      n.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), n.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      n.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), n.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function p7(e, n = {}) {
  const t = m7(e);
  t.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && os(e.body, t);
  const a = t.context();
  e.helpers = Array.from(a.helpers);
}
function v7(e) {
  const n = e.body;
  return n.type === 2 ? Li(n) : n.cases.forEach((t) => Li(t)), e;
}
function Li(e) {
  if (e.items.length === 1) {
    const n = e.items[0];
    (n.type === 3 || n.type === 9) && (e.static = n.value, delete n.value);
  } else {
    const n = [];
    for (let t = 0; t < e.items.length; t++) {
      const a = e.items[t];
      if (!(a.type === 3 || a.type === 9) || a.value == null)
        break;
      n.push(a.value);
    }
    if (n.length === e.items.length) {
      e.static = ls(n);
      for (let t = 0; t < e.items.length; t++) {
        const a = e.items[t];
        (a.type === 3 || a.type === 9) && delete a.value;
      }
    }
  }
}
const g7 = "minifier";
function Ca(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const n = e;
      Ca(n.body), n.b = n.body, delete n.body;
      break;
    }
    case 1: {
      const n = e, t = n.cases;
      for (let a = 0; a < t.length; a++)
        Ca(t[a]);
      n.c = t, delete n.cases;
      break;
    }
    case 2: {
      const n = e, t = n.items;
      for (let a = 0; a < t.length; a++)
        Ca(t[a]);
      n.i = t, delete n.items, n.static && (n.s = n.static, delete n.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const n = e;
      n.value && (n.v = n.value, delete n.value);
      break;
    }
    case 6: {
      const n = e;
      Ca(n.key), n.k = n.key, delete n.key, n.modifier && (Ca(n.modifier), n.m = n.modifier, delete n.modifier);
      break;
    }
    case 5: {
      const n = e;
      n.i = n.index, delete n.index;
      break;
    }
    case 4: {
      const n = e;
      n.k = n.key, delete n.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw Na(Fe.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: g7,
          args: [e.type]
        });
  }
  delete e.type;
}
const h7 = "parser";
function y7(e, n) {
  const { filename: t, breakLineCode: a, needIndent: r } = n, l = n.location !== !1, o = {
    filename: t,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: a,
    needIndent: r,
    indentLevel: 0
  };
  l && e.loc && (o.source = e.loc.source);
  const i = () => o;
  function s(v, S) {
    o.code += v;
  }
  function u(v, S = !0) {
    const g = S ? a : "";
    s(r ? g + "  ".repeat(v) : g);
  }
  function c(v = !0) {
    const S = ++o.indentLevel;
    v && u(S);
  }
  function f(v = !0) {
    const S = --o.indentLevel;
    v && u(S);
  }
  function d() {
    u(o.indentLevel);
  }
  return {
    context: i,
    push: s,
    indent: c,
    deindent: f,
    newline: d,
    helper: (v) => `_${v}`,
    needIndent: () => o.needIndent
  };
}
function w7(e, n) {
  const { helper: t } = e;
  e.push(`${t(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Ia(e, n.key), n.modifier ? (e.push(", "), Ia(e, n.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function b7(e, n) {
  const { helper: t, needIndent: a } = e;
  e.push(`${t(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(a());
  const r = n.items.length;
  for (let l = 0; l < r && (Ia(e, n.items[l]), l !== r - 1); l++)
    e.push(", ");
  e.deindent(a()), e.push("])");
}
function _7(e, n) {
  const { helper: t, needIndent: a } = e;
  if (n.cases.length > 1) {
    e.push(`${t(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(a());
    const r = n.cases.length;
    for (let l = 0; l < r && (Ia(e, n.cases[l]), l !== r - 1); l++)
      e.push(", ");
    e.deindent(a()), e.push("])");
  }
}
function x7(e, n) {
  n.body ? Ia(e, n.body) : e.push("null");
}
function Ia(e, n) {
  const { helper: t } = e;
  switch (n.type) {
    case 0:
      x7(e, n);
      break;
    case 1:
      _7(e, n);
      break;
    case 2:
      b7(e, n);
      break;
    case 6:
      w7(e, n);
      break;
    case 8:
      e.push(JSON.stringify(n.value), n);
      break;
    case 7:
      e.push(JSON.stringify(n.value), n);
      break;
    case 5:
      e.push(`${t(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${t(
        "list"
        /* HelperNameMap.LIST */
      )}(${n.index}))`, n);
      break;
    case 4:
      e.push(`${t(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${t(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(n.key)}))`, n);
      break;
    case 9:
      e.push(JSON.stringify(n.value), n);
      break;
    case 3:
      e.push(JSON.stringify(n.value), n);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw Na(Fe.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: h7,
          args: [n.type]
        });
  }
}
const k7 = (e, n = {}) => {
  const t = Me(n.mode) ? n.mode : "normal", a = Me(n.filename) ? n.filename : "message.intl";
  n.sourceMap;
  const r = n.breakLineCode != null ? n.breakLineCode : t === "arrow" ? ";" : `
`, l = n.needIndent ? n.needIndent : t !== "arrow", o = e.helpers || [], i = y7(e, {
    filename: a,
    breakLineCode: r,
    needIndent: l
  });
  i.push(t === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(l), o.length > 0 && (i.push(`const { ${ls(o.map((c) => `${c}: _${c}`), ", ")} } = ctx`), i.newline()), i.push("return "), Ia(i, e), i.deindent(l), i.push("}"), delete e.helpers;
  const { code: s, map: u } = i.context();
  return {
    ast: e,
    code: s,
    map: u ? u.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function C7(e, n = {}) {
  const t = St({}, n), a = !!t.jit, r = !!t.minify, l = t.optimize == null ? !0 : t.optimize, i = f7(t).parse(e);
  return a ? (l && v7(i), r && Ca(i), { ast: i, code: "" }) : (p7(i, t), k7(i, t));
}
/*!
  * core-base v11.2.2
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function S7() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (da().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (da().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function mn(e) {
  return Ge(e) && ss(e) === 0 && (dn(e, "b") || dn(e, "body"));
}
const jd = ["b", "body"];
function M7(e) {
  return ta(e, jd);
}
const Zd = ["c", "cases"];
function E7(e) {
  return ta(e, Zd, []);
}
const Gd = ["s", "static"];
function P7(e) {
  return ta(e, Gd);
}
const Wd = ["i", "items"];
function $7(e) {
  return ta(e, Wd, []);
}
const qd = ["t", "type"];
function ss(e) {
  return ta(e, qd);
}
const Kd = ["v", "value"];
function Or(e, n) {
  const t = ta(e, Kd);
  if (t != null)
    return t;
  throw ir(n);
}
const Xd = ["m", "modifier"];
function A7(e) {
  return ta(e, Xd);
}
const Qd = ["k", "key"];
function T7(e) {
  const n = ta(e, Qd);
  if (n)
    return n;
  throw ir(
    6
    /* NodeTypes.Linked */
  );
}
function ta(e, n, t) {
  for (let a = 0; a < n.length; a++) {
    const r = n[a];
    if (dn(e, r) && e[r] != null)
      return e[r];
  }
  return t;
}
const Jd = [
  ...jd,
  ...Zd,
  ...Gd,
  ...Wd,
  ...Qd,
  ...Xd,
  ...Kd,
  ...qd
];
function ir(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Wl(e) {
  return (t) => D7(t, e);
}
function D7(e, n) {
  const t = M7(n);
  if (t == null)
    throw ir(
      0
      /* NodeTypes.Resource */
    );
  if (ss(t) === 1) {
    const l = E7(t);
    return e.plural(l.reduce((o, i) => [
      ...o,
      Ni(e, i)
    ], []));
  } else
    return Ni(e, t);
}
function Ni(e, n) {
  const t = P7(n);
  if (t != null)
    return e.type === "text" ? t : e.normalize([t]);
  {
    const a = $7(n).reduce((r, l) => [...r, bo(e, l)], []);
    return e.normalize(a);
  }
}
function bo(e, n) {
  const t = ss(n);
  switch (t) {
    case 3:
      return Or(n, t);
    case 9:
      return Or(n, t);
    case 4: {
      const a = n;
      if (dn(a, "k") && a.k)
        return e.interpolate(e.named(a.k));
      if (dn(a, "key") && a.key)
        return e.interpolate(e.named(a.key));
      throw ir(t);
    }
    case 5: {
      const a = n;
      if (dn(a, "i") && _t(a.i))
        return e.interpolate(e.list(a.i));
      if (dn(a, "index") && _t(a.index))
        return e.interpolate(e.list(a.index));
      throw ir(t);
    }
    case 6: {
      const a = n, r = A7(a), l = T7(a);
      return e.linked(bo(e, l), r ? bo(e, r) : void 0, e.type);
    }
    case 7:
      return Or(n, t);
    case 8:
      return Or(n, t);
    default:
      throw new Error(`unhandled node on format message part: ${t}`);
  }
}
const R7 = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function O7(e, n) {
  n && t7(e) && En(dl(R7, { source: e }));
}
const I7 = (e) => e;
let Ir = Je();
function F7(e, n = {}) {
  let t = !1;
  const a = n.onError || Jy;
  return n.onError = (r) => {
    t = !0, a(r);
  }, { ...C7(e, n), detectError: t };
}
// @__NO_SIDE_EFFECTS__
function L7(e, n) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && Me(e)) {
    const t = mt(n.warnHtmlMessage) ? n.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && O7(e, t);
    const r = (n.onCacheKey || I7)(e), l = Ir[r];
    if (l)
      return l;
    const { ast: o, detectError: i } = F7(e, {
      ...n,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), s = Wl(o);
    return i ? s : Ir[r] = s;
  } else {
    if (process.env.NODE_ENV !== "production" && !mn(e))
      return En(`the message that is resolve with key '${n.key}' is not supported for jit compilation`), () => e;
    const t = e.cacheKey;
    if (t) {
      const a = Ir[t];
      return a || (Ir[t] = Wl(e));
    } else
      return Wl(e);
  }
}
let ur = null;
function N7(e) {
  ur = e;
}
function V7(e, n, t) {
  ur && ur.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: n,
    meta: t
  });
}
const B7 = /* @__PURE__ */ H7("function:translate");
function H7(e) {
  return (n) => ur && ur.emit(e, n);
}
const Ot = {
  INVALID_ARGUMENT: Xy,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, z7 = 24;
function Rn(e) {
  return Na(e, null, process.env.NODE_ENV !== "production" ? { messages: U7 } : void 0);
}
const U7 = {
  [Ot.INVALID_ARGUMENT]: "Invalid arguments",
  [Ot.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Ot.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Ot.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Ot.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Ot.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Ot.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function is(e, n) {
  return n.locale != null ? Vi(n.locale) : Vi(e.locale);
}
let ql;
function Vi(e) {
  if (Me(e))
    return e;
  if (rt(e)) {
    if (e.resolvedOnce && ql != null)
      return ql;
    if (e.constructor.name === "Function") {
      const n = e();
      if (Zy(n))
        throw Rn(Ot.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return ql = n;
    } else
      throw Rn(Ot.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Rn(Ot.NOT_SUPPORT_LOCALE_TYPE);
}
function Y7(e, n, t) {
  return [.../* @__PURE__ */ new Set([
    t,
    ...pt(n) ? n : Ge(n) ? Object.keys(n) : Me(n) ? [n] : [t]
  ])];
}
function ec(e, n, t) {
  const a = Me(t) ? t : qr, r = e;
  r.__localeChainCache || (r.__localeChainCache = /* @__PURE__ */ new Map());
  let l = r.__localeChainCache.get(a);
  if (!l) {
    l = [];
    let o = [t];
    for (; pt(o); )
      o = Bi(l, o, n);
    const i = pt(n) || !Ze(n) ? n : n.default ? n.default : null;
    o = Me(i) ? [i] : i, pt(o) && Bi(l, o, !1), r.__localeChainCache.set(a, l);
  }
  return l;
}
function Bi(e, n, t) {
  let a = !0;
  for (let r = 0; r < n.length && mt(a); r++) {
    const l = n[r];
    Me(l) && (a = j7(e, n[r], t));
  }
  return a;
}
function j7(e, n, t) {
  let a;
  const r = n.split("-");
  do {
    const l = r.join("-");
    a = Z7(e, l, t), r.splice(-1, 1);
  } while (r.length && a === !0);
  return a;
}
function Z7(e, n, t) {
  let a = !1;
  if (!e.includes(n) && (a = !0, n)) {
    a = n[n.length - 1] !== "!";
    const r = n.replace(/!/g, "");
    e.push(r), (pt(t) || Ze(t)) && t[r] && (a = t[r]);
  }
  return a;
}
const na = [];
na[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
na[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
na[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
na[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
na[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
na[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
na[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const G7 = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function W7(e) {
  return G7.test(e);
}
function q7(e) {
  const n = e.charCodeAt(0), t = e.charCodeAt(e.length - 1);
  return n === t && (n === 34 || n === 39) ? e.slice(1, -1) : e;
}
function K7(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function X7(e) {
  const n = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : W7(n) ? q7(n) : "*" + n;
}
function Q7(e) {
  const n = [];
  let t = -1, a = 0, r = 0, l, o, i, s, u, c, f;
  const d = [];
  d[
    0
    /* Actions.APPEND */
  ] = () => {
    o === void 0 ? o = i : o += i;
  }, d[
    1
    /* Actions.PUSH */
  ] = () => {
    o !== void 0 && (n.push(o), o = void 0);
  }, d[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    d[
      0
      /* Actions.APPEND */
    ](), r++;
  }, d[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (r > 0)
      r--, a = 4, d[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (r = 0, o === void 0 || (o = X7(o), o === !1))
        return !1;
      d[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function m() {
    const y = e[t + 1];
    if (a === 5 && y === "'" || a === 6 && y === '"')
      return t++, i = "\\" + y, d[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; a !== null; )
    if (t++, l = e[t], !(l === "\\" && m())) {
      if (s = K7(l), f = na[a], u = f[s] || f.l || 8, u === 8 || (a = u[0], u[1] !== void 0 && (c = d[u[1]], c && (i = l, c() === !1))))
        return;
      if (a === 7)
        return n;
    }
}
const Hi = /* @__PURE__ */ new Map();
function J7(e, n) {
  return Ge(e) ? e[n] : null;
}
function ew(e, n) {
  if (!Ge(e))
    return null;
  let t = Hi.get(n);
  if (t || (t = Q7(n), t && Hi.set(n, t)), !t)
    return null;
  const a = t.length;
  let r = e, l = 0;
  for (; l < a; ) {
    const o = t[l];
    if (Jd.includes(o) && mn(r))
      return null;
    const i = r[o];
    if (i === void 0 || rt(r))
      return null;
    r = i, l++;
  }
  return r;
}
const Ut = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7
}, tw = 8, nw = {
  [Ut.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Ut.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Ut.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Ut.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Ut.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Ut.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Ut.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function va(e, ...n) {
  return dl(nw[e], ...n);
}
const aw = "11.2.2", fl = -1, qr = "en-US", Kr = "", zi = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function rw() {
  return {
    upper: (e, n) => n === "text" && Me(e) ? e.toUpperCase() : n === "vnode" && Ge(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, n) => n === "text" && Me(e) ? e.toLowerCase() : n === "vnode" && Ge(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, n) => n === "text" && Me(e) ? zi(e) : n === "vnode" && Ge(e) && "__v_isVNode" in e ? zi(e.children) : e
  };
}
let tc;
function lw(e) {
  tc = e;
}
let nc;
function ow(e) {
  nc = e;
}
let ac;
function sw(e) {
  ac = e;
}
let rc = null;
const iw = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  rc = e;
}, uw = /* @__NO_SIDE_EFFECTS__ */ () => rc;
let lc = null;
const Ui = (e) => {
  lc = e;
}, dw = () => lc;
let Yi = 0;
function cw(e = {}) {
  const n = rt(e.onWarn) ? e.onWarn : En, t = Me(e.version) ? e.version : aw, a = Me(e.locale) || rt(e.locale) ? e.locale : qr, r = rt(a) ? qr : a, l = pt(e.fallbackLocale) || Ze(e.fallbackLocale) || Me(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : r, o = Ze(e.messages) ? e.messages : Kl(r), i = Ze(e.datetimeFormats) ? e.datetimeFormats : Kl(r), s = Ze(e.numberFormats) ? e.numberFormats : Kl(r), u = St(Je(), e.modifiers, rw()), c = e.pluralRules || Je(), f = rt(e.missing) ? e.missing : null, d = mt(e.missingWarn) || Wr(e.missingWarn) ? e.missingWarn : !0, m = mt(e.fallbackWarn) || Wr(e.fallbackWarn) ? e.fallbackWarn : !0, y = !!e.fallbackFormat, v = !!e.unresolving, S = rt(e.postTranslation) ? e.postTranslation : null, g = Ze(e.processor) ? e.processor : null, b = mt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, h = !!e.escapeParameter, x = rt(e.messageCompiler) ? e.messageCompiler : tc;
  process.env.NODE_ENV !== "production" && rt(e.messageCompiler) && Ny(va(Ut.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const F = rt(e.messageResolver) ? e.messageResolver : nc || J7, C = rt(e.localeFallbacker) ? e.localeFallbacker : ac || Y7, A = Ge(e.fallbackContext) ? e.fallbackContext : void 0, O = e, $ = Ge(O.__datetimeFormatters) ? O.__datetimeFormatters : /* @__PURE__ */ new Map(), L = Ge(O.__numberFormatters) ? O.__numberFormatters : /* @__PURE__ */ new Map(), N = Ge(O.__meta) ? O.__meta : {};
  Yi++;
  const K = {
    version: t,
    cid: Yi,
    locale: a,
    fallbackLocale: l,
    messages: o,
    modifiers: u,
    pluralRules: c,
    missing: f,
    missingWarn: d,
    fallbackWarn: m,
    fallbackFormat: y,
    unresolving: v,
    postTranslation: S,
    processor: g,
    warnHtmlMessage: b,
    escapeParameter: h,
    messageCompiler: x,
    messageResolver: F,
    localeFallbacker: C,
    fallbackContext: A,
    onWarn: n,
    __meta: N
  };
  return K.datetimeFormats = i, K.numberFormats = s, K.__datetimeFormatters = $, K.__numberFormatters = L, process.env.NODE_ENV !== "production" && (K.__v_emitter = O.__v_emitter != null ? O.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && V7(K, t, N), K;
}
const Kl = (e) => ({ [e]: Je() });
function ml(e, n) {
  return e instanceof RegExp ? e.test(n) : e;
}
function oc(e, n) {
  return e instanceof RegExp ? e.test(n) : e;
}
function us(e, n, t, a, r) {
  const { missing: l, onWarn: o } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: t,
      key: n,
      type: r,
      groupId: `${r}:${n}`
    });
  }
  if (l !== null) {
    const i = l(e, t, n, r);
    return Me(i) ? i : n;
  } else
    return process.env.NODE_ENV !== "production" && oc(a, n) && o(va(Ut.NOT_FOUND_KEY, { key: n, locale: t })), n;
}
function Ga(e, n, t) {
  const a = e;
  a.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, t, n);
}
function sc(e, n) {
  return e === n ? !1 : e.split("-")[0] === n.split("-")[0];
}
function fw(e, n) {
  const t = n.indexOf(e);
  if (t === -1)
    return !1;
  for (let a = t + 1; a < n.length; a++)
    if (sc(e, n[a]))
      return !0;
  return !1;
}
const ji = typeof Intl < "u", ic = {
  dateTimeFormat: ji && typeof Intl.DateTimeFormat < "u",
  numberFormat: ji && typeof Intl.NumberFormat < "u"
};
function Zi(e, ...n) {
  const { datetimeFormats: t, unresolving: a, fallbackLocale: r, onWarn: l, localeFallbacker: o } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !ic.dateTimeFormat)
    return l(va(Ut.CANNOT_FORMAT_DATE)), Kr;
  const [s, u, c, f] = _o(...n), d = mt(c.missingWarn) ? c.missingWarn : e.missingWarn, m = mt(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, y = !!c.part, v = is(e, c), S = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    v
  );
  if (!Me(s) || s === "")
    return new Intl.DateTimeFormat(v, f).format(u);
  let g = {}, b, h = null, x = v, F = null;
  const C = "datetime format";
  for (let $ = 0; $ < S.length; $++) {
    if (b = F = S[$], process.env.NODE_ENV !== "production" && v !== b && ml(m, s) && l(va(Ut.FALLBACK_TO_DATE_FORMAT, {
      key: s,
      target: b
    })), process.env.NODE_ENV !== "production" && v !== b) {
      const L = e.__v_emitter;
      L && L.emit("fallback", {
        type: C,
        key: s,
        from: x,
        to: F,
        groupId: `${C}:${s}`
      });
    }
    if (g = t[b] || {}, h = g[s], Ze(h))
      break;
    us(e, s, b, d, C), x = F;
  }
  if (!Ze(h) || !Me(b))
    return a ? fl : s;
  let A = `${b}__${s}`;
  cl(f) || (A = `${A}__${JSON.stringify(f)}`);
  let O = i.get(A);
  return O || (O = new Intl.DateTimeFormat(b, St({}, h, f)), i.set(A, O)), y ? O.formatToParts(u) : O.format(u);
}
const uc = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function _o(...e) {
  const [n, t, a, r] = e, l = Je();
  let o = Je(), i;
  if (Me(n)) {
    const s = n.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!s)
      throw Rn(Ot.INVALID_ISO_DATE_ARGUMENT);
    const u = s[3] ? s[3].trim().startsWith("T") ? `${s[1].trim()}${s[3].trim()}` : `${s[1].trim()}T${s[3].trim()}` : s[1].trim();
    i = new Date(u);
    try {
      i.toISOString();
    } catch {
      throw Rn(Ot.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (zy(n)) {
    if (isNaN(n.getTime()))
      throw Rn(Ot.INVALID_DATE_ARGUMENT);
    i = n;
  } else if (_t(n))
    i = n;
  else
    throw Rn(Ot.INVALID_ARGUMENT);
  return Me(t) ? l.key = t : Ze(t) && Object.keys(t).forEach((s) => {
    uc.includes(s) ? o[s] = t[s] : l[s] = t[s];
  }), Me(a) ? l.locale = a : Ze(a) && (o = a), Ze(r) && (o = r), [l.key || "", i, l, o];
}
function Gi(e, n, t) {
  const a = e;
  for (const r in t) {
    const l = `${n}__${r}`;
    a.__datetimeFormatters.has(l) && a.__datetimeFormatters.delete(l);
  }
}
function Wi(e, ...n) {
  const { numberFormats: t, unresolving: a, fallbackLocale: r, onWarn: l, localeFallbacker: o } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !ic.numberFormat)
    return l(va(Ut.CANNOT_FORMAT_NUMBER)), Kr;
  const [s, u, c, f] = xo(...n), d = mt(c.missingWarn) ? c.missingWarn : e.missingWarn, m = mt(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, y = !!c.part, v = is(e, c), S = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    v
  );
  if (!Me(s) || s === "")
    return new Intl.NumberFormat(v, f).format(u);
  let g = {}, b, h = null, x = v, F = null;
  const C = "number format";
  for (let $ = 0; $ < S.length; $++) {
    if (b = F = S[$], process.env.NODE_ENV !== "production" && v !== b && ml(m, s) && l(va(Ut.FALLBACK_TO_NUMBER_FORMAT, {
      key: s,
      target: b
    })), process.env.NODE_ENV !== "production" && v !== b) {
      const L = e.__v_emitter;
      L && L.emit("fallback", {
        type: C,
        key: s,
        from: x,
        to: F,
        groupId: `${C}:${s}`
      });
    }
    if (g = t[b] || {}, h = g[s], Ze(h))
      break;
    us(e, s, b, d, C), x = F;
  }
  if (!Ze(h) || !Me(b))
    return a ? fl : s;
  let A = `${b}__${s}`;
  cl(f) || (A = `${A}__${JSON.stringify(f)}`);
  let O = i.get(A);
  return O || (O = new Intl.NumberFormat(b, St({}, h, f)), i.set(A, O)), y ? O.formatToParts(u) : O.format(u);
}
const dc = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function xo(...e) {
  const [n, t, a, r] = e, l = Je();
  let o = Je();
  if (!_t(n))
    throw Rn(Ot.INVALID_ARGUMENT);
  const i = n;
  return Me(t) ? l.key = t : Ze(t) && Object.keys(t).forEach((s) => {
    dc.includes(s) ? o[s] = t[s] : l[s] = t[s];
  }), Me(a) ? l.locale = a : Ze(a) && (o = a), Ze(r) && (o = r), [l.key || "", i, l, o];
}
function qi(e, n, t) {
  const a = e;
  for (const r in t) {
    const l = `${n}__${r}`;
    a.__numberFormatters.has(l) && a.__numberFormatters.delete(l);
  }
}
const mw = (e) => e, pw = (e) => "", vw = "text", gw = (e) => e.length === 0 ? "" : ls(e), hw = Gy;
function Ki(e, n) {
  return e = Math.abs(e), n === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function yw(e) {
  const n = _t(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (_t(e.named.count) || _t(e.named.n)) ? _t(e.named.count) ? e.named.count : _t(e.named.n) ? e.named.n : n : n;
}
function ww(e, n) {
  n.count || (n.count = e), n.n || (n.n = e);
}
function bw(e = {}) {
  const n = e.locale, t = yw(e), a = Ge(e.pluralRules) && Me(n) && rt(e.pluralRules[n]) ? e.pluralRules[n] : Ki, r = Ge(e.pluralRules) && Me(n) && rt(e.pluralRules[n]) ? Ki : void 0, l = (g) => g[a(t, g.length, r)], o = e.list || [], i = (g) => o[g], s = e.named || Je();
  _t(e.pluralIndex) && ww(t, s);
  const u = (g) => s[g];
  function c(g, b) {
    const h = rt(e.messages) ? e.messages(g, !!b) : Ge(e.messages) ? e.messages[g] : !1;
    return h || (e.parent ? e.parent.message(g) : pw);
  }
  const f = (g) => e.modifiers ? e.modifiers[g] : mw, d = Ze(e.processor) && rt(e.processor.normalize) ? e.processor.normalize : gw, m = Ze(e.processor) && rt(e.processor.interpolate) ? e.processor.interpolate : hw, y = Ze(e.processor) && Me(e.processor.type) ? e.processor.type : vw, S = {
    list: i,
    named: u,
    plural: l,
    linked: (g, ...b) => {
      const [h, x] = b;
      let F = "text", C = "";
      b.length === 1 ? Ge(h) ? (C = h.modifier || C, F = h.type || F) : Me(h) && (C = h || C) : b.length === 2 && (Me(h) && (C = h || C), Me(x) && (F = x || F));
      const A = c(g, !0)(S), O = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        F === "vnode" && pt(A) && C ? A[0] : A
      );
      return C ? f(C)(O, F) : O;
    },
    message: c,
    type: y,
    interpolate: m,
    normalize: d,
    values: St(Je(), o, s)
  };
  return S;
}
const Xi = () => "", Qt = (e) => rt(e);
function Qi(e, ...n) {
  const { fallbackFormat: t, postTranslation: a, unresolving: r, messageCompiler: l, fallbackLocale: o, messages: i } = e, [s, u] = ko(...n), c = mt(u.missingWarn) ? u.missingWarn : e.missingWarn, f = mt(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, d = mt(u.escapeParameter) ? u.escapeParameter : e.escapeParameter, m = !!u.resolvedMessage, y = Me(u.default) || mt(u.default) ? mt(u.default) ? l ? s : () => s : u.default : t ? l ? s : () => s : null, v = t || y != null && (Me(y) || rt(y)), S = is(e, u);
  d && _w(u);
  let [g, b, h] = m ? [
    s,
    S,
    i[S] || Je()
  ] : cc(e, s, S, o, f, c), x = g, F = s;
  if (!m && !(Me(x) || mn(x) || Qt(x)) && v && (x = y, F = x), !m && (!(Me(x) || mn(x) || Qt(x)) || !Me(b)))
    return r ? fl : s;
  if (process.env.NODE_ENV !== "production" && Me(x) && e.messageCompiler == null)
    return En(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${s}'.`), s;
  let C = !1;
  const A = () => {
    C = !0;
  }, O = Qt(x) ? x : fc(e, s, b, x, F, A);
  if (C)
    return x;
  const $ = Sw(e, b, h, u), L = bw($), N = xw(e, O, L);
  let K = a ? a(N, s) : N;
  if (d && Me(K) && (K = Yy(K)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const ue = {
      timestamp: Date.now(),
      key: Me(s) ? s : Qt(x) ? x.key : "",
      locale: b || (Qt(x) ? x.locale : ""),
      format: Me(x) ? x : Qt(x) ? x.source : "",
      message: K
    };
    ue.meta = St({}, e.__meta, /* @__PURE__ */ uw() || {}), B7(ue);
  }
  return K;
}
function _w(e) {
  pt(e.list) ? e.list = e.list.map((n) => Me(n) ? Di(n) : n) : Ge(e.named) && Object.keys(e.named).forEach((n) => {
    Me(e.named[n]) && (e.named[n] = Di(e.named[n]));
  });
}
function cc(e, n, t, a, r, l) {
  const { messages: o, onWarn: i, messageResolver: s, localeFallbacker: u } = e, c = u(e, a, t);
  let f = Je(), d, m = null, y = t, v = null;
  const S = "translate";
  for (let g = 0; g < c.length; g++) {
    if (d = v = c[g], process.env.NODE_ENV !== "production" && t !== d && !sc(t, d) && ml(r, n) && i(va(Ut.FALLBACK_TO_TRANSLATE, {
      key: n,
      target: d
    })), process.env.NODE_ENV !== "production" && t !== d) {
      const F = e.__v_emitter;
      F && F.emit("fallback", {
        type: S,
        key: n,
        from: y,
        to: v,
        groupId: `${S}:${n}`
      });
    }
    f = o[d] || Je();
    let b = null, h, x;
    if (process.env.NODE_ENV !== "production" && Fn && (b = window.performance.now(), h = "intlify-message-resolve-start", x = "intlify-message-resolve-end", qt && qt(h)), (m = s(f, n)) === null && (m = f[n]), process.env.NODE_ENV !== "production" && Fn) {
      const F = window.performance.now(), C = e.__v_emitter;
      C && b && m && C.emit("message-resolve", {
        type: "message-resolve",
        key: n,
        message: m,
        time: F - b,
        groupId: `${S}:${n}`
      }), h && x && qt && pa && (qt(x), pa("intlify message resolve", h, x));
    }
    if (Me(m) || mn(m) || Qt(m))
      break;
    if (!fw(d, c)) {
      const F = us(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        n,
        d,
        l,
        S
      );
      F !== n && (m = F);
    }
    y = v;
  }
  return [m, d, f];
}
function fc(e, n, t, a, r, l) {
  const { messageCompiler: o, warnHtmlMessage: i } = e;
  if (Qt(a)) {
    const d = a;
    return d.locale = d.locale || t, d.key = d.key || n, d;
  }
  if (o == null) {
    const d = () => a;
    return d.locale = t, d.key = n, d;
  }
  let s = null, u, c;
  process.env.NODE_ENV !== "production" && Fn && (s = window.performance.now(), u = "intlify-message-compilation-start", c = "intlify-message-compilation-end", qt && qt(u));
  const f = o(a, kw(e, t, r, a, i, l));
  if (process.env.NODE_ENV !== "production" && Fn) {
    const d = window.performance.now(), m = e.__v_emitter;
    m && s && m.emit("message-compilation", {
      type: "message-compilation",
      message: a,
      time: d - s,
      groupId: `translate:${n}`
    }), u && c && qt && pa && (qt(c), pa("intlify message compilation", u, c));
  }
  return f.locale = t, f.key = n, f.source = a, f;
}
function xw(e, n, t) {
  let a = null, r, l;
  process.env.NODE_ENV !== "production" && Fn && (a = window.performance.now(), r = "intlify-message-evaluation-start", l = "intlify-message-evaluation-end", qt && qt(r));
  const o = n(t);
  if (process.env.NODE_ENV !== "production" && Fn) {
    const i = window.performance.now(), s = e.__v_emitter;
    s && a && s.emit("message-evaluation", {
      type: "message-evaluation",
      value: o,
      time: i - a,
      groupId: `translate:${n.key}`
    }), r && l && qt && pa && (qt(l), pa("intlify message evaluation", r, l));
  }
  return o;
}
function ko(...e) {
  const [n, t, a] = e, r = Je();
  if (!Me(n) && !_t(n) && !Qt(n) && !mn(n))
    throw Rn(Ot.INVALID_ARGUMENT);
  const l = _t(n) ? String(n) : (Qt(n), n);
  return _t(t) ? r.plural = t : Me(t) ? r.default = t : Ze(t) && !cl(t) ? r.named = t : pt(t) && (r.list = t), _t(a) ? r.plural = a : Me(a) ? r.default = a : Ze(a) && St(r, a), [l, r];
}
function kw(e, n, t, a, r, l) {
  return {
    locale: n,
    key: t,
    warnHtmlMessage: r,
    onError: (o) => {
      if (l && l(o), process.env.NODE_ENV !== "production") {
        const i = Cw(a), s = `Message compilation error: ${o.message}`, u = o.location && i && Wy(i, o.location.start.offset, o.location.end.offset), c = e.__v_emitter;
        c && i && c.emit("compile-error", {
          message: i,
          error: o.message,
          start: o.location && o.location.start.offset,
          end: o.location && o.location.end.offset,
          groupId: `translate:${t}`
        }), console.error(u ? `${s}
${u}` : s);
      } else
        throw o;
    },
    onCacheKey: (o) => By(n, t, o)
  };
}
function Cw(e) {
  if (Me(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function Sw(e, n, t, a) {
  const { modifiers: r, pluralRules: l, messageResolver: o, fallbackLocale: i, fallbackWarn: s, missingWarn: u, fallbackContext: c } = e, d = {
    locale: n,
    modifiers: r,
    pluralRules: l,
    messages: (m, y) => {
      let v = o(t, m);
      if (v == null && (c || y)) {
        const [, , S] = cc(
          c || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          m,
          n,
          i,
          s,
          u
        );
        v = o(S, m);
      }
      if (Me(v) || mn(v)) {
        let S = !1;
        const b = fc(e, m, n, v, m, () => {
          S = !0;
        });
        return S ? Xi : b;
      } else return Qt(v) ? v : Xi;
    }
  };
  return e.processor && (d.processor = e.processor), a.list && (d.list = a.list), a.named && (d.named = a.named), _t(a.plural) && (d.pluralIndex = a.plural), d;
}
S7();
/*!
  * vue-i18n v11.2.2
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const Mw = "11.2.2";
function Ew() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (da().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (da().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (da().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (da().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Pt = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: z7,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function dr(e, ...n) {
  return Na(e, null, process.env.NODE_ENV !== "production" ? { messages: Pw, args: n } : void 0);
}
const Pw = {
  [Pt.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Pt.INVALID_ARGUMENT]: "Invalid argument",
  [Pt.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Pt.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Pt.UNEXPECTED_ERROR]: "Unexpected error",
  [Pt.REQUIRED_VALUE]: "Required in value: {0}",
  [Pt.INVALID_VALUE]: "Invalid value",
  [Pt.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Pt.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Pt.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Pt.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Co = /* @__PURE__ */ Nn("__translateVNode"), So = /* @__PURE__ */ Nn("__datetimeParts"), Mo = /* @__PURE__ */ Nn("__numberParts"), Eo = /* @__PURE__ */ Nn("__enableEmitter"), Po = /* @__PURE__ */ Nn("__disableEmitter"), $w = Nn("__setPluralRules"), mc = /* @__PURE__ */ Nn("__injectWithOption"), $o = /* @__PURE__ */ Nn("__dispose"), xn = {
  FALLBACK_TO_ROOT: tw,
  // 8
  NOT_FOUND_PARENT_SCOPE: 9,
  IGNORE_OBJ_FLATTEN: 10,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: 11,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: 12,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: 13
}, Aw = {
  [xn.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [xn.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [xn.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [xn.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [xn.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [xn.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function Xr(e, ...n) {
  return dl(Aw[e], ...n);
}
function cr(e) {
  if (!Ge(e) || mn(e))
    return e;
  for (const n in e)
    if (dn(e, n))
      if (!n.includes("."))
        Ge(e[n]) && cr(e[n]);
      else {
        const t = n.split("."), a = t.length - 1;
        let r = e, l = !1;
        for (let o = 0; o < a; o++) {
          if (t[o] === "__proto__")
            throw new Error(`unsafe key: ${t[o]}`);
          if (t[o] in r || (r[t[o]] = Je()), !Ge(r[t[o]])) {
            process.env.NODE_ENV !== "production" && En(Xr(xn.IGNORE_OBJ_FLATTEN, {
              key: t[o]
            })), l = !0;
            break;
          }
          r = r[t[o]];
        }
        if (l || (mn(r) ? Jd.includes(t[a]) || delete e[n] : (r[t[a]] = e[n], delete e[n])), !mn(r)) {
          const o = r[t[a]];
          Ge(o) && cr(o);
        }
      }
  return e;
}
function pc(e, n) {
  const { messages: t, __i18n: a, messageResolver: r, flatJson: l } = n, o = Ze(t) ? t : pt(a) ? Je() : { [e]: Je() };
  if (pt(a) && a.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: s, resource: u } = i;
      s ? (o[s] = o[s] || Je(), Hr(u, o[s])) : Hr(u, o);
    } else
      Me(i) && Hr(JSON.parse(i), o);
  }), r == null && l)
    for (const i in o)
      dn(o, i) && cr(o[i]);
  return o;
}
function vc(e) {
  return e.type;
}
function Tw(e, n, t) {
  let a = Ge(n.messages) ? n.messages : Je();
  "__i18nGlobal" in t && (a = pc(e.locale.value, {
    messages: a,
    __i18n: t.__i18nGlobal
  }));
  const r = Object.keys(a);
  r.length && r.forEach((l) => {
    e.mergeLocaleMessage(l, a[l]);
  });
  {
    if (Ge(n.datetimeFormats)) {
      const l = Object.keys(n.datetimeFormats);
      l.length && l.forEach((o) => {
        e.mergeDateTimeFormat(o, n.datetimeFormats[o]);
      });
    }
    if (Ge(n.numberFormats)) {
      const l = Object.keys(n.numberFormats);
      l.length && l.forEach((o) => {
        e.mergeNumberFormat(o, n.numberFormats[o]);
      });
    }
  }
}
function Ji(e) {
  return Ae(Pc, null, e, 0);
}
function ds() {
  return "currentInstance" in Xa ? Xa["currentInstance"] : Xa.getCurrentInstance();
}
const eu = "__INTLIFY_META__", tu = () => [], Dw = () => !1;
let nu = 0;
function au(e) {
  return (n, t, a, r) => e(t, a, ds() || void 0, r);
}
const Rw = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = ds();
  let n = null;
  return e && (n = vc(e)[eu]) ? { [eu]: n } : null;
};
function Ow(e = {}) {
  const { __root: n, __injectWithOption: t } = e, a = n === void 0, r = e.flatJson, l = Fn ? ee : mr;
  let o = mt(e.inheritLocale) ? e.inheritLocale : !0;
  const i = l(
    // prettier-ignore
    n && o ? n.locale.value : Me(e.locale) ? e.locale : qr
  ), s = l(
    // prettier-ignore
    n && o ? n.fallbackLocale.value : Me(e.fallbackLocale) || pt(e.fallbackLocale) || Ze(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), u = l(pc(i.value, e)), c = l(Ze(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), f = l(Ze(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let d = n ? n.missingWarn : mt(e.missingWarn) || Wr(e.missingWarn) ? e.missingWarn : !0, m = n ? n.fallbackWarn : mt(e.fallbackWarn) || Wr(e.fallbackWarn) ? e.fallbackWarn : !0, y = n ? n.fallbackRoot : mt(e.fallbackRoot) ? e.fallbackRoot : !0, v = !!e.fallbackFormat, S = rt(e.missing) ? e.missing : null, g = rt(e.missing) ? au(e.missing) : null, b = rt(e.postTranslation) ? e.postTranslation : null, h = n ? n.warnHtmlMessage : mt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, x = !!e.escapeParameter;
  const F = n ? n.modifiers : Ze(e.modifiers) ? e.modifiers : {};
  let C = e.pluralRules || n && n.pluralRules, A;
  A = (() => {
    a && Ui(null);
    const W = {
      version: Mw,
      locale: i.value,
      fallbackLocale: s.value,
      messages: u.value,
      modifiers: F,
      pluralRules: C,
      missing: g === null ? void 0 : g,
      missingWarn: d,
      fallbackWarn: m,
      fallbackFormat: v,
      unresolving: !0,
      postTranslation: b === null ? void 0 : b,
      warnHtmlMessage: h,
      escapeParameter: x,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    W.datetimeFormats = c.value, W.numberFormats = f.value, W.__datetimeFormatters = Ze(A) ? A.__datetimeFormatters : void 0, W.__numberFormatters = Ze(A) ? A.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (W.__v_emitter = Ze(A) ? A.__v_emitter : void 0);
    const ne = cw(W);
    return a && Ui(ne), ne;
  })(), Ga(A, i.value, s.value);
  function $() {
    return [
      i.value,
      s.value,
      u.value,
      c.value,
      f.value
    ];
  }
  const L = k({
    get: () => i.value,
    set: (W) => {
      A.locale = W, i.value = W;
    }
  }), N = k({
    get: () => s.value,
    set: (W) => {
      A.fallbackLocale = W, s.value = W, Ga(A, i.value, W);
    }
  }), K = k(() => u.value), ue = /* @__PURE__ */ k(() => c.value), B = /* @__PURE__ */ k(() => f.value);
  function Z() {
    return rt(b) ? b : null;
  }
  function R(W) {
    b = W, A.postTranslation = W;
  }
  function M() {
    return S;
  }
  function z(W) {
    W !== null && (g = au(W)), S = W, A.missing = g;
  }
  function J(W, ne) {
    return W !== "translate" || !ne.resolvedMessage;
  }
  const H = (W, ne, Ne, Ve, Jt, Vn) => {
    $();
    let en;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (A.fallbackContext = n ? dw() : void 0), en = W(A);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (A.fallbackContext = void 0);
    }
    if (Ne !== "translate exists" && // for not `te` (e.g `t`)
    _t(en) && en === fl || Ne === "translate exists" && !en) {
      const [tn, Va] = ne();
      if (process.env.NODE_ENV !== "production" && n && Me(tn) && J(Ne, Va) && (y && (ml(m, tn) || oc(d, tn)) && En(Xr(xn.FALLBACK_TO_ROOT, {
        key: tn,
        type: Ne
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: ha } = A;
        ha && y && ha.emit("fallback", {
          type: Ne,
          key: tn,
          to: "global",
          groupId: `${Ne}:${tn}`
        });
      }
      return n && y ? Ve(n) : Jt(tn);
    } else {
      if (Vn(en))
        return en;
      throw dr(Pt.UNEXPECTED_RETURN_TYPE);
    }
  };
  function le(...W) {
    return H((ne) => Reflect.apply(Qi, null, [ne, ...W]), () => ko(...W), "translate", (ne) => Reflect.apply(ne.t, ne, [...W]), (ne) => ne, (ne) => Me(ne));
  }
  function j(...W) {
    const [ne, Ne, Ve] = W;
    if (Ve && !Ge(Ve))
      throw dr(Pt.INVALID_ARGUMENT);
    return le(ne, Ne, St({ resolvedMessage: !0 }, Ve || {}));
  }
  function q(...W) {
    return H((ne) => Reflect.apply(Zi, null, [ne, ...W]), () => _o(...W), "datetime format", (ne) => Reflect.apply(ne.d, ne, [...W]), () => Kr, (ne) => Me(ne) || pt(ne));
  }
  function P(...W) {
    return H((ne) => Reflect.apply(Wi, null, [ne, ...W]), () => xo(...W), "number format", (ne) => Reflect.apply(ne.n, ne, [...W]), () => Kr, (ne) => Me(ne) || pt(ne));
  }
  function Q(W) {
    return W.map((ne) => Me(ne) || _t(ne) || mt(ne) ? Ji(String(ne)) : ne);
  }
  const U = {
    normalize: Q,
    interpolate: (W) => W,
    type: "vnode"
  };
  function ye(...W) {
    return H((ne) => {
      let Ne;
      const Ve = ne;
      try {
        Ve.processor = U, Ne = Reflect.apply(Qi, null, [Ve, ...W]);
      } finally {
        Ve.processor = null;
      }
      return Ne;
    }, () => ko(...W), "translate", (ne) => ne[Co](...W), (ne) => [Ji(ne)], (ne) => pt(ne));
  }
  function Ee(...W) {
    return H((ne) => Reflect.apply(Wi, null, [ne, ...W]), () => xo(...W), "number format", (ne) => ne[Mo](...W), tu, (ne) => Me(ne) || pt(ne));
  }
  function qe(...W) {
    return H((ne) => Reflect.apply(Zi, null, [ne, ...W]), () => _o(...W), "datetime format", (ne) => ne[So](...W), tu, (ne) => Me(ne) || pt(ne));
  }
  function ie(W) {
    C = W, A.pluralRules = C;
  }
  function pe(W, ne) {
    return H(() => {
      if (!W)
        return !1;
      const Ne = Me(ne) ? ne : i.value, Ve = T(Ne), Jt = A.messageResolver(Ve, W);
      return mn(Jt) || Qt(Jt) || Me(Jt);
    }, () => [W], "translate exists", (Ne) => Reflect.apply(Ne.te, Ne, [W, ne]), Dw, (Ne) => mt(Ne));
  }
  function fe(W) {
    let ne = null;
    const Ne = ec(A, s.value, i.value);
    for (let Ve = 0; Ve < Ne.length; Ve++) {
      const Jt = u.value[Ne[Ve]] || {}, Vn = A.messageResolver(Jt, W);
      if (Vn != null) {
        ne = Vn;
        break;
      }
    }
    return ne;
  }
  function ae(W) {
    const ne = fe(W);
    return ne ?? (n ? n.tm(W) || {} : {});
  }
  function T(W) {
    return u.value[W] || {};
  }
  function te(W, ne) {
    if (r) {
      const Ne = { [W]: ne };
      for (const Ve in Ne)
        dn(Ne, Ve) && cr(Ne[Ve]);
      ne = Ne[W];
    }
    u.value[W] = ne, A.messages = u.value;
  }
  function ke(W, ne) {
    u.value[W] = u.value[W] || {};
    const Ne = { [W]: ne };
    if (r)
      for (const Ve in Ne)
        dn(Ne, Ve) && cr(Ne[Ve]);
    ne = Ne[W], Hr(ne, u.value[W]), A.messages = u.value;
  }
  function E(W) {
    return c.value[W] || {};
  }
  function V(W, ne) {
    c.value[W] = ne, A.datetimeFormats = c.value, Gi(A, W, ne);
  }
  function oe(W, ne) {
    c.value[W] = St(c.value[W] || {}, ne), A.datetimeFormats = c.value, Gi(A, W, ne);
  }
  function Y(W) {
    return f.value[W] || {};
  }
  function I(W, ne) {
    f.value[W] = ne, A.numberFormats = f.value, qi(A, W, ne);
  }
  function G(W, ne) {
    f.value[W] = St(f.value[W] || {}, ne), A.numberFormats = f.value, qi(A, W, ne);
  }
  nu++, n && Fn && (Be(n.locale, (W) => {
    o && (i.value = W, A.locale = W, Ga(A, i.value, s.value));
  }), Be(n.fallbackLocale, (W) => {
    o && (s.value = W, A.fallbackLocale = W, Ga(A, i.value, s.value));
  }));
  const se = {
    id: nu,
    locale: L,
    fallbackLocale: N,
    get inheritLocale() {
      return o;
    },
    set inheritLocale(W) {
      o = W, W && n && (i.value = n.locale.value, s.value = n.fallbackLocale.value, Ga(A, i.value, s.value));
    },
    get availableLocales() {
      return Object.keys(u.value).sort();
    },
    messages: K,
    get modifiers() {
      return F;
    },
    get pluralRules() {
      return C || {};
    },
    get isGlobal() {
      return a;
    },
    get missingWarn() {
      return d;
    },
    set missingWarn(W) {
      d = W, A.missingWarn = d;
    },
    get fallbackWarn() {
      return m;
    },
    set fallbackWarn(W) {
      m = W, A.fallbackWarn = m;
    },
    get fallbackRoot() {
      return y;
    },
    set fallbackRoot(W) {
      y = W;
    },
    get fallbackFormat() {
      return v;
    },
    set fallbackFormat(W) {
      v = W, A.fallbackFormat = v;
    },
    get warnHtmlMessage() {
      return h;
    },
    set warnHtmlMessage(W) {
      h = W, A.warnHtmlMessage = W;
    },
    get escapeParameter() {
      return x;
    },
    set escapeParameter(W) {
      x = W, A.escapeParameter = W;
    },
    t: le,
    getLocaleMessage: T,
    setLocaleMessage: te,
    mergeLocaleMessage: ke,
    getPostTranslationHandler: Z,
    setPostTranslationHandler: R,
    getMissingHandler: M,
    setMissingHandler: z,
    [$w]: ie
  };
  return se.datetimeFormats = ue, se.numberFormats = B, se.rt = j, se.te = pe, se.tm = ae, se.d = q, se.n = P, se.getDateTimeFormat = E, se.setDateTimeFormat = V, se.mergeDateTimeFormat = oe, se.getNumberFormat = Y, se.setNumberFormat = I, se.mergeNumberFormat = G, se[mc] = t, se[Co] = ye, se[So] = qe, se[Mo] = Ee, process.env.NODE_ENV !== "production" && (se[Eo] = (W) => {
    A.__v_emitter = W;
  }, se[Po] = () => {
    A.__v_emitter = void 0;
  }), se;
}
function ru(e, n) {
}
const cs = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Iw({ slots: e }, n) {
  return n.length === 1 && n[0] === "default" ? (e.default ? e.default() : []).reduce((a, r) => [
    ...a,
    // prettier-ignore
    ...r.type === _e ? r.children : [r]
  ], []) : n.reduce((t, a) => {
    const r = e[a];
    return r && (t[a] = r()), t;
  }, Je());
}
function gc() {
  return _e;
}
St({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => _t(e) || !isNaN(e)
  }
}, cs);
function Fw(e) {
  return pt(e) && !Me(e[0]);
}
function hc(e, n, t, a) {
  const { slots: r, attrs: l } = n;
  return () => {
    const o = { part: !0 };
    let i = Je();
    e.locale && (o.locale = e.locale), Me(e.format) ? o.key = e.format : Ge(e.format) && (Me(e.format.key) && (o.key = e.format.key), i = Object.keys(e.format).reduce((d, m) => t.includes(m) ? St(Je(), d, { [m]: e.format[m] }) : d, Je()));
    const s = a(e.value, o, i);
    let u = [o.key];
    pt(s) ? u = s.map((d, m) => {
      const y = r[d.type], v = y ? y({ [d.type]: d.value, index: m, parts: s }) : [d.value];
      return Fw(v) && (v[0].key = `${d.type}-${m}`), v;
    }) : Me(s) && (u = [s]);
    const c = St(Je(), l), f = Me(e.tag) || Ge(e.tag) ? e.tag : gc();
    return je(f, c, u);
  };
}
St({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, cs);
const Lw = /* @__PURE__ */ Nn("global-vue-i18n");
function pl(e = {}) {
  const n = ds();
  if (n == null)
    throw dr(Pt.MUST_BE_CALL_SETUP_TOP);
  if (!n.isCE && n.appContext.app != null && !n.appContext.app.__VUE_I18N_SYMBOL__)
    throw dr(Pt.NOT_INSTALLED);
  const t = Nw(n), a = Bw(t), r = vc(n), l = Vw(e, r);
  if (l === "global")
    return Tw(a, e, r), a;
  if (l === "parent") {
    let s = Hw(t, n, e.__useComponent);
    return s == null && (process.env.NODE_ENV !== "production" && En(Xr(xn.NOT_FOUND_PARENT_SCOPE)), s = a), s;
  }
  const o = t;
  let i = o.__getInstance(n);
  if (i == null) {
    const s = St({}, e);
    "__i18n" in r && (s.__i18n = r.__i18n), a && (s.__root = a), i = Ow(s), o.__composerExtend && (i[$o] = o.__composerExtend(i)), Uw(o, n, i), o.__setInstance(n, i);
  } else
    process.env.NODE_ENV !== "production" && l === "local" && En(Xr(xn.DUPLICATE_USE_I18N_CALLING));
  return i;
}
function Nw(e) {
  const n = Ft(e.isCE ? Lw : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!n)
    throw dr(e.isCE ? Pt.NOT_INSTALLED_WITH_PROVIDE : Pt.UNEXPECTED_ERROR);
  return n;
}
function Vw(e, n) {
  return cl(e) ? "__i18n" in n ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Bw(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Hw(e, n, t = !1) {
  let a = null;
  const r = n.root;
  let l = zw(n, t);
  for (; l != null; ) {
    const o = e;
    if (e.mode === "composition")
      a = o.__getInstance(l);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = o.__getInstance(l);
      i != null && (a = i.__composer, t && a && !a[mc] && (a = null));
    }
    if (a != null || r === l)
      break;
    l = l.parent;
  }
  return a;
}
function zw(e, n = !1) {
  return e == null ? null : n && e.vnode.ctx || e.parent;
}
function Uw(e, n, t) {
  let a = null;
  He(() => {
    if (process.env.NODE_ENV !== "production") {
      n.__VUE_I18N__ = t, a = qy();
      const r = t;
      r[Eo] && r[Eo](a), a.on("*", ru);
    }
  }, n), wt(() => {
    const r = t;
    process.env.NODE_ENV !== "production" && (a && a.off("*", ru), r[Po] && r[Po](), delete n.__VUE_I18N__), e.__deleteInstance(n);
    const l = r[$o];
    l && (l(), delete r[$o]);
  }, n);
}
St({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, cs);
Ew();
lw(L7);
ow(ew);
sw(ec);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = da();
  e.__INTLIFY__ = !0, N7(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const Yw = { class: "relative z-10 flex items-start justify-between gap-3 px-4 py-4 md:px-5" }, jw = { class: "flex items-start gap-3" }, Zw = ["src", "alt"], Gw = { key: 1 }, Ww = { class: "min-w-0 space-y-1" }, qw = { class: "flex items-center gap-3" }, Kw = ["title"], Xw = {
  key: 0,
  class: "inline-flex items-center gap-2 rounded-full bg-white/80 px-3 py-1 text-[11px] font-semibold text-text-primary shadow-sm dark:bg-surface-100/80 dark:text-text-primary"
}, Qw = { key: 0 }, Jw = { key: 1 }, eb = { class: "flex flex-col items-end gap-2" }, tb = ["title", "disabled"], nb = {
  key: 0,
  class: "pointer-events-none absolute right-2 top-2 h-56 w-56 opacity-95 transition-opacity duration-300 group-hover:opacity-85 z-0"
}, ab = ["src", "alt"], rb = {
  key: 1,
  class: "relative z-10 grid grid-cols-1 gap-3 text-sm"
}, lb = ["title"], ob = { class: "mt-0.5 text-base font-semibold text-white leading-tight" }, sb = { class: "relative z-10 mt-auto flex flex-col gap-4 text-sm text-white/80" }, ib = {
  key: 0,
  class: "grid grid-cols-1 gap-4 sm:grid-cols-2"
}, ub = { class: "flex flex-col leading-tight" }, db = { class: "text-xs uppercase tracking-wide text-white/60" }, cb = { class: "text-sm font-medium" }, fb = {
  key: 1,
  class: "flex items-center gap-2 text-xs text-white/70"
}, mb = {
  key: 0,
  class: "absolute inset-0 z-20 flex items-center justify-center rounded-2xl bg-white/75 backdrop-blur-sm dark:bg-surface-50/80"
}, pb = { class: "flex items-start justify-between gap-3" }, vb = { class: "text-md font-semibold leading-snug" }, gb = { class: "mt-2 text-sm text-slate-600 leading-relaxed" }, hb = { class: "mt-3 text-sm pt-2 text-slate-600" }, yb = { class: "flex justify-end gap-2" }, t3 = /* @__PURE__ */ Ce({
  __name: "ProductCard",
  props: {
    product: {},
    loading: { type: Boolean, default: !1 },
    portalBaseUrl: { default: "" },
    showSummaryMetrics: { type: Boolean, default: !0 }
  },
  emits: ["click", "view-details", "info-click"],
  setup(e, { emit: n }) {
    const t = e, { locale: a, t: r } = pl(), l = (ae) => (ae || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, ""), o = (ae) => (ae || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, ""), i = n, s = ee(null), u = k(
      () => s.value ? "hover:translate-y-0 hover:shadow-none" : "hover:-translate-y-0.5 hover:shadow-[0_24px_48px_-28px_rgba(15,23,42,0.4)]"
    ), c = k(() => (t.portalBaseUrl || "").replace(/\/$/, "")), f = k(() => {
      try {
        return new Intl.NumberFormat(a.value || "en-US");
      } catch {
        return new Intl.NumberFormat("en-US");
      }
    }), d = (ae) => {
      try {
        return f.value.format(ae);
      } catch {
        return ae.toString();
      }
    }, m = k(() => {
      const ae = t.product.productCode || t.product.productName || t.product.name || "";
      return ae ? ae.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z0-9]/g, "") : "";
    }), y = k(() => t.product.displayName || t.product.productName || t.product.name || ""), v = k(() => {
      var T, te;
      if ((T = b.value) != null && T.name)
        return b.value.name;
      const ae = (te = y.value) == null ? void 0 : te.trim();
      return ae || t.product.name || "";
    }), S = k(() => {
      var ae, T, te;
      return t.product.logo ? t.product.logo : (ae = b.value) != null && ae.logo ? b.value.logo : (te = (T = b.value) == null ? void 0 : T.logos) != null && te.light ? b.value.logos.light : "";
    }), g = k(() => {
      const ae = [
        t.product.id,
        t.product.productCode,
        t.product.productName,
        t.product.name,
        t.product.displayName
      ];
      return new Set(ae.map(l).filter(Boolean));
    }), b = k(() => {
      const ae = g.value;
      for (const T of Object.values(Vt))
        if ([
          T.id,
          T.code,
          T.platformProductName,
          T.name,
          ...T.aliases ?? []
        ].map(l).some((ke) => ae.has(ke)))
          return T;
      return null;
    }), h = k(() => {
      const ae = t.product.productDescription ?? t.product.description ?? "";
      return typeof ae == "string" ? ae.trim() : "";
    }), x = k(() => h.value ? h.value : v.value), F = k(() => {
      const ae = v.value;
      return ae ? ae.split(/\s+/).filter(Boolean).slice(0, 2).map((ke) => ke[0]).join("").toUpperCase() : "—";
    }), C = (ae) => {
      if (!ae) return null;
      const T = new Date(ae);
      if (Number.isNaN(T.getTime()))
        return null;
      try {
        return new Intl.DateTimeFormat(a.value || "en-US", {
          dateStyle: "medium"
        }).format(T);
      } catch {
        return null;
      }
    }, A = (ae) => {
      var E;
      const T = (E = t.product) == null ? void 0 : E.packages;
      if (!Array.isArray(T) || !T.length)
        return null;
      const te = T.find((V) => V == null ? void 0 : V.isActive) ?? T[0], ke = te == null ? void 0 : te[ae];
      return typeof ke == "string" ? ke : null;
    }, O = k(() => t.product.effectiveFrom || t.product.activatedAt || A("startDate") || t.product.createdAt || null), $ = k(() => t.product.effectiveUntil || t.product.deactivatedAt || A("endDate") || null), L = k(() => C(O.value)), N = k(() => C($.value)), K = k(() => C(t.product.updatedAt ?? null)), ue = k(() => {
      var T;
      const ae = (T = t.product) == null ? void 0 : T.packages;
      return Array.isArray(ae) ? ae : [];
    }), B = k(() => {
      if (!ue.value.length) return [];
      const ae = ue.value.filter((T) => T == null ? !1 : T.isActive === void 0 ? !0 : !!T.isActive);
      return ae.length ? ae : ue.value;
    }), Z = k(() => {
      if (!B.value.length) return [];
      const ae = B.value.map(
        (te) => typeof (te == null ? void 0 : te.packageName) == "string" ? te.packageName : typeof (te == null ? void 0 : te.name) == "string" ? te.name : null
      ).filter((te) => !!(te && te.trim())).map((te) => te.trim());
      return Array.from(new Set(ae)).slice(0, 3);
    }), R = k(() => t.product.isActive !== void 0 ? !!t.product.isActive : t.product.isCurrentlyEffective !== void 0 ? !!t.product.isCurrentlyEffective : !1), M = k(() => t.product.isOwned === void 0 ? !0 : !!t.product.isOwned), z = k(() => {
      var ae;
      return !!(t.product.comingSoon === !0 || (ae = b.value) != null && ae.comingSoon || t.product.isActive === !1);
    }), J = k(() => z.value ? "comingSoon" : t.product.hasPermission === !1 ? "noPermission" : M.value ? "owned" : "noAccess"), H = k(() => J.value !== "owned"), le = k(() => K.value ? `${r("common.updatedAt", "Updated At")}: ${K.value}` : null), j = () => {
      var I, G, se;
      const ae = t.product.infoUrl || t.product.infoPath || ((I = b.value) == null ? void 0 : I.infoUrl) || ((G = b.value) == null ? void 0 : G.infoPath) || "", T = o(
        ((se = b.value) == null ? void 0 : se.id) || t.product.productCode || t.product.productName || t.product.name || t.product.id
      ), te = c.value, E = (T ? `/urunler/${T}` : "/urunler").replace(/\/{2,}/g, "/");
      if (!ae)
        return te ? `${te}${E}` : E;
      const V = ae.trim();
      if (/^https?:\/\//i.test(V)) return V;
      const Y = `/${V}`.replace(/\/{2,}/g, "/");
      return te ? `${te}${Y}` : Y;
    }, q = k(() => !s.value || s.value.type === "noPermission" ? "" : s.value.infoUrl ? s.value.infoUrl : j()), P = (ae) => {
      const T = v.value || t.product.name || "", te = ae === "noPermission" ? void 0 : j();
      if (ae === "comingSoon") {
        s.value = {
          title: T,
          message: r("product.comingSoonMessage", "Bu modül geliştirme aşamasındadır. Yakında kullanımınıza açılacaktır."),
          type: ae,
          infoUrl: te
        };
        return;
      }
      if (ae === "noPermission") {
        s.value = {
          title: T,
          message: r("product.noPermissionMessage", "Bu çözüme erişim yetkiniz bulunmamaktadır. Lütfen sistem yöneticiniz ile iletişime geçiniz."),
          type: ae
        };
        return;
      }
      s.value = {
        title: "Bu Ürün Henüz Paketinizde Aktif Değil",
        message: t.product.description || "Bu ürünü henüz satın almadınız.",
        footermessage: "Bu ürünü paketinizde aktif etmek için bizimle kolayca iletişime geçebilirsiniz.",
        type: ae,
        infoUrl: te
      };
    }, Q = () => {
      s.value = null;
    }, ce = (ae) => {
      i("info-click", t.product.id || ""), Q();
    }, U = (ae) => {
      const T = ae.label ?? (ae.labelKey ? r(ae.labelKey) : ""), te = T == null ? void 0 : T.toString().trim();
      if (!te) return null;
      const ke = ae.value;
      if (ke == null)
        return {
          id: ae.id,
          label: te,
          value: "—"
        };
      if (typeof ke == "number")
        return {
          id: ae.id,
          label: te,
          value: d(ke)
        };
      const E = String(ke).trim();
      return {
        id: ae.id,
        label: te,
        value: E.length ? E : "—"
      };
    }, ye = k(() => Z.value.length ? {
      id: "packageNames",
      label: r("companyProducts.activePackages", "Active Packages"),
      value: Z.value.join(" · ")
    } : null), Ee = k(() => {
      var te;
      const ae = /* @__PURE__ */ new Map();
      ye.value && ae.set(ye.value.id, ye.value);
      const T = (te = t.product.summaryMetrics) == null ? void 0 : te.map(U).filter((ke) => !!ke);
      return T == null || T.forEach((ke) => {
        ae.set(ke.id, ke);
      }), Array.from(ae.values());
    }), qe = k(() => {
      const ae = r("companyAdmin.userProductAuth.unlimited", "Unlimited"), T = r("common.na", "N/A");
      return [
        {
          id: "membership-start",
          label: r("companyProducts.startDate", "Start Date"),
          value: L.value ?? T,
          icon: Y0
        },
        {
          id: "membership-end",
          label: r("companyProducts.endDate", "End Date"),
          value: N.value ?? ae,
          icon: U0
        }
      ];
    }), ie = [
      {
        keys: ["EBANK", "EBANKA", "EHESAPOZETI"],
        accentTextClass: "text-e-hesap-ozeti",
        iconClass: "text-white",
        bannerClass: "bg-e-hesap-ozeti text-white",
        accentImage: null
      },
      {
        keys: ["EINVOICEPAYMENT", "EINVOICE", "ETAHSILAT", "EKOLAYTAHSILATINVOICE", "EKOLAYTAHSILAT"],
        accentTextClass: "text-e-tahsilat",
        iconClass: "text-white",
        bannerClass: "bg-e-tahsilat text-white",
        accentImage: null
      },
      {
        keys: ["EODEME"],
        accentTextClass: "text-e-odeme",
        iconClass: "text-white",
        bannerClass: "bg-e-odeme text-white",
        accentImage: null
      },
      {
        keys: ["EPOS", "POSMUTABAKAT"],
        accentTextClass: "text-e-pos",
        iconClass: "text-white",
        bannerClass: "bg-e-pos text-white",
        accentImage: null
      },
      {
        keys: ["EDBS"],
        accentTextClass: "text-e-dbs",
        iconClass: "text-white",
        bannerClass: "bg-e-dbs text-white",
        accentImage: null
      },
      {
        keys: ["ERAPOR"],
        accentTextClass: "text-e-rapor",
        iconClass: "text-white",
        bannerClass: "bg-e-rapor text-white",
        accentImage: null
      }
    ], pe = k(() => {
      var E;
      const ae = ((E = b.value) == null ? void 0 : E.accentImage) || null, T = {
        accentTextClass: "text-primary-600 dark:text-primary-300",
        iconClass: "text-white",
        bannerClass: "bg-brand-primary text-white",
        accentImage: ae
      }, te = m.value;
      if (!te) return T;
      const ke = ie.find((V) => V.keys.includes(te));
      return ke ? {
        accentTextClass: ke.accentTextClass,
        iconClass: ke.iconClass,
        bannerClass: ke.bannerClass,
        accentImage: ae
      } : T;
    }), fe = () => {
      if (t.loading) return;
      const ae = J.value;
      if (ae === "owned" && R.value) {
        i("click", t.product.id || "");
        return;
      }
      if (ae === "comingSoon") {
        P("comingSoon");
        return;
      }
      if (ae === "noPermission") {
        P("noPermission");
        return;
      }
      ae === "noAccess" && P("noAccess");
    };
    return Be(
      () => [t.product.id, t.product.isActive, t.product.isOwned],
      () => {
        s.value && (s.value = null);
      }
    ), (ae, T) => (p(), w("div", {
      class: me(["group relative flex h-full w-full min-h-[340px] md:min-h-[380px] cursor-pointer flex-col overflow-hidden rounded-xl border border-border-subtle bg-surface-100 transition-all duration-300 dark:border-surface-700 dark:bg-surface-50", [u.value, { "opacity-70": !R.value || H.value, "pointer-events-none": e.loading, "cursor-not-allowed": H.value }]]),
      onClick: fe
    }, [
      _("header", Yw, [
        _("div", jw, [
          _("div", {
            class: me(["flex h-14 w-14 shrink-0 items-center justify-center rounded-xl text-lg font-semibold text-white shadow-inner ring-2 ring-white/40 transition-all duration-300 group-hover:scale-105 dark:ring-surface-100/30", pe.value.iconClass])
          }, [
            S.value ? (p(), w("img", {
              key: 0,
              src: S.value,
              alt: v.value,
              class: "h-full w-full rounded-xl object-contain bg-white p-1.5",
              loading: "lazy"
            }, null, 8, Zw)) : (p(), w("span", Gw, he(F.value), 1))
          ], 2),
          _("div", Ww, [
            _("div", qw, [
              _("h3", {
                class: me(["truncate text-xl font-semibold text-text-primary transition-colors duration-200 leading-tight", pe.value.accentTextClass]),
                title: x.value
              }, he(v.value), 11, Kw)
            ]),
            H.value ? (p(), w("div", Xw, [
              Ae(D(cu), { class: "h-4 w-4" }),
              z.value ? (p(), w("span", Qw, he(D(r)("product.comingSoon", "Yakında")), 1)) : (p(), w("span", Jw, he(D(r)("product.locked", "Kilitli")), 1))
            ])) : X("", !0)
          ])
        ]),
        _("div", eb, [
          _("button", {
            class: "inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/50 bg-white/80 text-brand-primary transition-all duration-200 hover:scale-110 hover:border-white/80 hover:bg-white dark:border-surface-200 dark:bg-surface-100/70 dark:text-text-primary disabled:cursor-not-allowed disabled:opacity-60",
            title: D(r)("product.openProduct"),
            disabled: e.loading,
            onClick: ot(fe, ["stop"])
          }, [...T[3] || (T[3] = [
            _("svg", {
              class: "h-5 w-5",
              viewBox: "0 0 24 24",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _("path", {
                d: "M8.91 19.9201L15.43 13.4001C16.2 12.6301 16.2 11.3701 15.43 10.6001L8.91 4.08008",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-miterlimit": "10",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ])], 8, tb)
        ])
      ]),
      _("section", {
        class: me(["relative z-10 flex flex-1 flex-col gap-5 px-4 pb-4 pt-3 text-white md:px-5", pe.value.bannerClass])
      }, [
        pe.value.accentImage ? (p(), w("div", nb, [
          _("img", {
            src: pe.value.accentImage,
            alt: v.value,
            class: "h-full w-full object-contain",
            loading: "lazy"
          }, null, 8, ab)
        ])) : X("", !0),
        e.showSummaryMetrics && Ee.value.length ? (p(), w("div", rb, [
          (p(!0), w(_e, null, Ie(Ee.value, (te) => (p(), w("div", {
            key: te.id,
            class: "text-white/90"
          }, [
            _("div", {
              class: "text-xs uppercase tracking-wide text-white/70",
              title: te.label
            }, he(te.label), 9, lb),
            _("div", ob, he(te.value), 1)
          ]))), 128))
        ])) : X("", !0),
        _("div", sb, [
          qe.value.length ? (p(), w("div", ib, [
            (p(!0), w(_e, null, Ie(qe.value, (te) => (p(), w("div", {
              key: te.id,
              class: "flex items-center gap-3"
            }, [
              (p(), Pe(Ln(te.icon), { class: "h-5 w-5" })),
              _("div", ub, [
                _("span", db, he(te.label), 1),
                _("span", cb, he(te.value), 1)
              ])
            ]))), 128))
          ])) : X("", !0),
          le.value ? (p(), w("div", fb, [
            Ae(D(j0), { class: "h-3.5 w-3.5" }),
            _("span", null, he(le.value), 1)
          ])) : X("", !0)
        ])
      ], 2),
      T[5] || (T[5] = _("div", { class: "pointer-events-none absolute inset-0 rounded-2xl border border-white/10 opacity-0 transition-opacity duration-300 group-hover:opacity-100" }, null, -1)),
      e.loading ? (p(), w("div", mb, [...T[4] || (T[4] = [
        _("div", { class: "h-6 w-6 animate-spin rounded-full border-2 border-white border-t-transparent" }, null, -1)
      ])])) : X("", !0),
      (p(), Pe(Jr, { to: "body" }, [
        s.value ? (p(), w("div", {
          key: 0,
          class: "fixed inset-0 z-[60] flex items-center justify-center bg-black/40",
          role: "dialog",
          "aria-modal": "true",
          onClick: [
            T[2] || (T[2] = ot(() => {
            }, ["stop"])),
            ot(Q, ["self"])
          ]
        }, [
          _("div", {
            class: "w-[90%] max-w-md rounded-2xl bg-bg-primary p-5 text-text-primary shadow-xl space-y-3",
            onClick: T[1] || (T[1] = ot(() => {
            }, ["stop"]))
          }, [
            _("div", pb, [
              _("div", null, [
                _("p", vb, he(s.value.title), 1),
                _("p", gb, he(s.value.message), 1),
                _("p", hb, he(s.value.footermessage), 1)
              ]),
              _("button", {
                class: "text-text-secondary hover:text-text-primary",
                onClick: Q,
                "aria-label": "Kapat"
              }, " X ")
            ]),
            _("div", yb, [
              _("button", {
                class: "rounded-lg bg-bg-secondary px-3 py-2 text-sm text-text-primary hover:bg-bg-tertiary",
                onClick: Q
              }, " Kapat "),
              q.value && s.value.type != "comingSoon" ? (p(), w("button", {
                key: 0,
                class: "rounded-lg bg-brand-primary px-3 py-2 text-sm text-white hover:opacity-90",
                onClick: T[0] || (T[0] = (te) => ce(q.value))
              }, " Bilgi almak istiyorum ")) : X("", !0)
            ])
          ])
        ])) : X("", !0)
      ]))
    ], 2));
  }
}), Fr = "finmony-theme-mode", Lr = "finmony-theme-product", Et = ee("light"), Gt = ee(null);
let Xl = !1, _a = null, zt = null, la = null, xa = null, Nr = 0;
function lu() {
  if (typeof document > "u") return null;
  const e = document.documentElement, n = e.getAttribute("data-theme");
  return n === "dark" || n === "light" ? n : e.classList.contains("dark") ? "dark" : e.classList.contains("light") ? "light" : null;
}
function n3() {
  const e = () => {
    Et.value = Et.value === "light" ? "dark" : "light";
  }, n = (s) => {
    Et.value = s;
  }, t = (s) => {
    Gt.value = s;
  }, a = k(() => Gt.value ? Xt.products[Gt.value] : null), r = k(() => Et.value === "dark"), l = () => {
    if (typeof document > "u") return;
    const s = document.documentElement;
    try {
      if (Xl = !0, s.classList.remove("light", "dark"), s.classList.add(Et.value), s.setAttribute("data-theme", Et.value), s.style.colorScheme = Et.value, Gt.value) {
        s.setAttribute("data-product", Gt.value);
        const u = a.value || "";
        s.style.setProperty("--product-color", String(u));
      } else
        s.removeAttribute("data-product"), s.style.removeProperty("--product-color");
    } finally {
      queueMicrotask(() => {
        Xl = !1;
      });
    }
  }, o = () => {
    var s;
    if (!(typeof window > "u"))
      try {
        const u = localStorage.getItem(Fr);
        if (u === "light" || u === "dark")
          Et.value = u;
        else {
          const f = lu();
          if (f)
            Et.value = f;
          else {
            const d = (s = window.matchMedia) == null ? void 0 : s.call(window, "(prefers-color-scheme: dark)").matches;
            Et.value = d ? "dark" : "light";
          }
        }
        const c = localStorage.getItem(Lr);
        c && c in Xt.products ? Gt.value = c : Gt.value = null;
      } catch (u) {
        console.warn("Failed to load theme from localStorage:", u);
      }
  }, i = () => {
    if (!(typeof window > "u"))
      try {
        localStorage.setItem(Fr, Et.value), Gt.value ? localStorage.setItem(Lr, Gt.value) : localStorage.removeItem(Lr);
      } catch (s) {
        console.warn("Failed to save theme to localStorage:", s);
      }
  };
  return Be([Et, Gt], () => {
    l(), i();
  }), He(() => {
    var s;
    Nr++, o(), l(), typeof document < "u" && !_a && (_a = new MutationObserver(() => {
      if (Xl) return;
      const u = lu();
      u && u !== Et.value && (Et.value = u);
    }), _a.observe(document.documentElement, {
      attributes: !0,
      attributeFilter: ["class", "data-theme", "data-product"]
    })), typeof window < "u" && !zt && (zt = window.matchMedia("(prefers-color-scheme: dark)"), la = (u) => {
      localStorage.getItem(Fr) || (Et.value = u.matches ? "dark" : "light");
    }, zt.addEventListener ? zt.addEventListener("change", la) : (s = zt.addListener) == null || s.call(zt, la)), typeof window < "u" && !xa && (xa = (u) => {
      u.key === Fr && (u.newValue === "light" || u.newValue === "dark") && (Et.value = u.newValue), u.key === Lr && (u.newValue && u.newValue in Xt.products ? Gt.value = u.newValue : u.newValue === null && (Gt.value = null));
    }, window.addEventListener("storage", xa));
  }), Ao(() => {
    var s;
    Nr--, Nr <= 0 && (_a && (_a.disconnect(), _a = null), zt && la && (zt.removeEventListener ? zt.removeEventListener("change", la) : (s = zt.removeListener) == null || s.call(zt, la), zt = null, la = null), typeof window < "u" && xa && (window.removeEventListener("storage", xa), xa = null), Nr = 0);
  }), {
    // State
    mode: Et,
    productTheme: Gt,
    isDark: r,
    productColor: a,
    // Methods
    toggleMode: e,
    setMode: n,
    setProductTheme: t,
    applyTheme: l,
    loadTheme: o
  };
}
function a3(e) {
  const { initialValues: n, validationSchema: t = {}, validateOnMount: a = !1 } = e, r = qn({ ...n }), l = qn({}), o = ee(!1), i = ee(0);
  Object.keys(n).forEach((C) => {
    l[C] = {
      value: n[C],
      error: null,
      touched: !1,
      dirty: !1,
      validating: !1
    };
  });
  const s = async (C) => {
    const A = C, O = l[A];
    if (!O) return !0;
    const $ = t[A];
    if (!($ != null && $.rules) || $.rules.length === 0)
      return O.error = null, !0;
    O.validating = !0;
    try {
      for (const L of $.rules) {
        const N = r[C];
        if (!await L.validator(N))
          return O.error = L.message, O.validating = !1, !1;
      }
      return O.error = null, O.validating = !1, !0;
    } catch {
      return O.error = "Validation error occurred", O.validating = !1, !1;
    }
  }, u = async () => {
    const C = Object.keys(l).map(
      (O) => s(O)
    );
    return (await Promise.all(C)).every((O) => O === !0);
  }, c = async (C, A) => {
    r[C] = A;
    const O = C, $ = l[O];
    if ($) {
      $.value = A, $.dirty = !0;
      const L = t[O];
      (L == null ? void 0 : L.validateOn) === "change" && await s(C);
    }
  }, f = async (C, A = !0) => {
    const O = C, $ = l[O];
    if ($) {
      $.touched = A;
      const L = t[O];
      A && (L == null ? void 0 : L.validateOn) === "blur" && await s(C);
    }
  }, d = (C, A) => {
    const $ = l[C];
    $ && ($.error = A);
  }, m = () => {
    Object.keys(n).forEach((C) => {
      r[C] = n[C], l[C] = {
        value: n[C],
        error: null,
        touched: !1,
        dirty: !1,
        validating: !1
      };
    }), o.value = !1, i.value = 0;
  }, y = (C) => {
    const O = l[C];
    O && (r[C] = n[C], O.value = n[C], O.error = null, O.touched = !1, O.dirty = !1, O.validating = !1);
  }, v = (C) => async (A) => {
    if (A && A.preventDefault(), i.value++, Object.keys(l).forEach(($) => {
      l[$].touched = !0;
    }), !!await u()) {
      o.value = !0;
      try {
        await C({ ...r });
      } catch ($) {
        throw console.error("Form submission error:", $), $;
      } finally {
        o.value = !1;
      }
    }
  }, S = (C) => {
    var O;
    const A = C;
    return {
      modelValue: r[C],
      "onUpdate:modelValue": ($) => c(C, $),
      onBlur: () => f(C, !0),
      error: ((O = l[A]) == null ? void 0 : O.error) || void 0,
      disabled: o.value
    };
  }, g = k(() => {
    const C = {};
    return Object.keys(l).forEach((A) => {
      const O = l[A];
      O.error && (C[A] = O.error);
    }), C;
  }), b = k(() => Object.values(l).every((C) => !C.error)), h = k(() => Object.values(l).some((C) => C.dirty)), x = k(() => Object.values(l).some((C) => C.touched)), F = k(() => Object.values(l).some((C) => C.validating));
  return a && u(), {
    // State
    values: r,
    fields: l,
    errors: g,
    isSubmitting: o,
    submitCount: i,
    // Computed
    isValid: b,
    isDirty: h,
    isTouched: x,
    isValidating: F,
    // Methods
    validateField: s,
    validateForm: u,
    setFieldValue: c,
    setFieldTouched: f,
    setFieldError: d,
    resetForm: m,
    resetField: y,
    handleSubmit: v,
    getFieldProps: S
  };
}
const r3 = {
  required: (e = "Bu alan zorunlu bir alandır") => ({
    message: e,
    validator: (n) => typeof n == "string" ? n.trim().length > 0 : Array.isArray(n) ? n.length > 0 : n != null
  }),
  email: (e = "Geçerli bir e-posta adresi giriniz") => ({
    message: e,
    validator: (n) => n ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(n) : !0
  }),
  minLength: (e, n) => ({
    message: n || `En az ${e} karakter olmalıdır`,
    validator: (t) => t ? t.length >= e : !0
  }),
  maxLength: (e, n) => ({
    message: n || `En fazla ${e} karakter olmalıdır`,
    validator: (t) => t ? t.length <= e : !0
  }),
  min: (e, n) => ({
    message: n || `En az ${e}`,
    validator: (t) => t == null ? !0 : t >= e
  }),
  max: (e, n) => ({
    message: n || `En fazla ${e}`,
    validator: (t) => t == null ? !0 : t <= e
  }),
  pattern: (e, n = "Geçersiz format") => ({
    message: n,
    validator: (t) => t ? e.test(t) : !0
  }),
  url: (e = "Geçersiz URL") => ({
    message: e,
    validator: (n) => {
      if (!n) return !0;
      try {
        return new URL(n), !0;
      } catch {
        return !1;
      }
    }
  }),
  custom: (e, n) => ({
    message: n,
    validator: e
  })
}, Qr = "finmony_product_access", wb = 8 * 60 * 60, bb = 8 * 60 * 60 * 1e3, xr = () => typeof document < "u" && typeof window < "u", yc = (e) => {
  if (e && e.trim()) return e.trim();
  if (!xr()) return null;
  const n = window.location.hostname;
  if (!n || n === "localhost" || /^[\d.]+$/.test(n))
    return null;
  const t = n.split(".").filter(Boolean);
  return t.length < 2 ? null : `.${t.slice(-2).join(".")}`;
}, _b = (e) => {
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}, xb = () => {
  if (!xr()) return null;
  const e = document.cookie.split("; ").find((r) => r.startsWith(`${Qr}=`));
  if (!e) return null;
  const n = e.slice(Qr.length + 1), t = decodeURIComponent(n), a = _b(t);
  return !a || a.v !== 1 || typeof a.map != "object" ? null : a;
}, l3 = (e, n = {}) => {
  if (!xr()) return;
  const t = {
    v: 1,
    map: e,
    comingSoon: n.comingSoon,
    at: Date.now()
  }, a = encodeURIComponent(JSON.stringify(t)), r = n.maxAgeSeconds ?? wb, l = yc(n.domain), o = window.location.protocol === "https:" ? "; Secure" : "", i = l ? `; Domain=${l}` : "";
  document.cookie = `${Qr}=${a}; Path=/; Max-Age=${r}; SameSite=Lax${i}${o}`;
}, o3 = (e) => {
  if (!xr()) return;
  const n = yc(e), t = n ? `; Domain=${n}` : "";
  document.cookie = `${Qr}=; Path=/; Max-Age=0; SameSite=Lax${t}`;
}, s3 = () => {
  const e = ee({}), n = ee(void 0), t = ee(!0), a = () => {
    const r = xb();
    if (!r) {
      e.value = {}, n.value = void 0, t.value = !0;
      return;
    }
    e.value = r.map, n.value = r.comingSoon, t.value = Date.now() - r.at > bb;
  };
  if (a(), xr()) {
    const r = () => a(), l = () => {
      document.visibilityState === "visible" && a();
    };
    window.addEventListener("focus", r), document.addEventListener("visibilitychange", l), uu() && du(() => {
      window.removeEventListener("focus", r), document.removeEventListener("visibilitychange", l);
    });
  }
  return {
    productAccessMap: e,
    comingSoonProducts: n,
    isStale: t,
    refresh: a
  };
};
function kb() {
  if (typeof window < "u")
    try {
      if (typeof NuxtLink < "u")
        return "nuxt";
    } catch {
    }
  try {
    if (typeof useRouter < "u")
      return "vue-router";
  } catch {
  }
  return "vanilla";
}
function Cb() {
  switch (kb()) {
    case "nuxt":
      return {
        component: "NuxtLink",
        framework: "nuxt",
        useHref: !1
      };
    case "vue-router":
      return {
        component: "RouterLink",
        framework: "vue-router",
        useHref: !1
      };
    case "vanilla":
    default:
      return {
        component: "a",
        framework: "vanilla",
        useHref: !0
      };
  }
}
function i3() {
  const e = Cb();
  return {
    /**
     * The component to use for rendering links
     */
    linkComponent: e.component,
    /**
     * The detected framework
     */
    framework: e.framework,
    /**
     * Whether to use href attribute (for anchor tags)
     */
    useHref: e.useHref,
    /**
     * Get props for the link component based on the target
     * @param to - The target route/URL
     */
    getLinkProps: (n) => n ? e.useHref ? { href: n } : { to: n } : {}
  };
}
const ou = /* @__PURE__ */ new Set([
  "portal",
  "api",
  "portaltest",
  "apitest",
  "portalpreprod",
  "apipreprod",
  "hesap",
  "hesap-api",
  "hesap-store",
  "tahsilat",
  "tahsilat-api",
  "tahsilat-fatura",
  "tahsilat-fatura-api",
  "hesap-test",
  "hesap-api-test",
  "hesap-store-test",
  "hesap-preprod",
  "hesap-api-preprod",
  "hesap-store-preprod",
  "tahsilat-test",
  "tahsilat-api-test",
  "tahsilat-fatura-test",
  "tahsilat-fatura-api-test",
  "tahsilat-preprod",
  "tahsilat-api-preprod",
  "tahsilat-fatura-preprod",
  "tahsilat-fatura-api-preprod"
]), Sb = [
  "tahsilat-fatura-api-preprod",
  "tahsilat-fatura-preprod",
  "tahsilat-fatura-api-test",
  "tahsilat-fatura-test",
  "tahsilat-fatura-api",
  "tahsilat-fatura",
  "tahsilat-api-preprod",
  "tahsilat-preprod",
  "tahsilat-api-test",
  "tahsilat-test",
  "tahsilat-api",
  "tahsilat",
  "hesap-api-preprod",
  "hesap-store-preprod",
  "hesap-preprod",
  "hesap-api-test",
  "hesap-store-test",
  "hesap-test",
  "hesap-api",
  "hesap-store",
  "hesap"
], Mb = "finmony.com";
function Eb(e) {
  const n = String(e ?? "").trim().toLowerCase();
  if (!n || ou.has(n)) return null;
  for (const t of Sb) {
    const a = `-${t}`;
    if (!n.endsWith(a)) continue;
    const r = n.slice(0, -a.length).replace(/^-+|-+$/g, "");
    return !r || ou.has(r) ? null : r;
  }
  return n;
}
function u3(e, n = Mb) {
  if (!e) return null;
  const t = e.trim().toLowerCase(), a = n.trim().replace(/^\.+|\.+$/g, "").toLowerCase();
  if (!t || !a || !t.endsWith(`.${a}`)) return null;
  const r = t.slice(0, -(a.length + 1));
  if (!r) return null;
  const l = r.split(".").filter(Boolean);
  return l.length === 0 ? null : Eb(l[0]);
}
export {
  Mb as DEFAULT_TENANT_ROOT_DOMAIN,
  e3 as FAccordion,
  Nb as FBadge,
  on as FButton,
  Db as FCard,
  zb as FCheckbox,
  Qb as FContainer,
  qb as FDataGrid,
  Yb as FDatePicker,
  Kb as FEditableGrid,
  jb as FFinanceInput,
  Zb as FForm,
  Gb as FFormFooter,
  Wb as FFormHeader,
  ar as FIcon,
  Vr as FInput,
  bf as FLabel,
  Lb as FModal,
  Hb as FMultiSelect,
  Xb as FNavbar,
  Ub as FRadio,
  oo as FSelect,
  Ib as FSplitButton,
  Jb as FSupportButton,
  Ob as FTab,
  Lp as FTextarea,
  Rb as FTitle,
  Vb as FToast,
  Bb as FTooltip,
  t3 as ProductCard,
  ou as RESERVED_TENANT_LABELS,
  Sb as TENANT_PRODUCT_SUFFIXES,
  Tc as borders,
  o3 as clearProductAccessCookie,
  Xt as colors,
  kb as detectFramework,
  Eb as extractTenantCandidate,
  Cb as getLinkComponent,
  u3 as resolveTenantSlug,
  Dc as shadows,
  Ac as spacing,
  Ab as tokens,
  $c as typography,
  Ud as useFinmonyDataGrid,
  a3 as useForm,
  s3 as useProductAccessMap,
  n3 as useTheme,
  Bm as useToast,
  i3 as useUniversalLink,
  r3 as validators,
  l3 as writeProductAccessCookie
};
